(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.braintree = f();
  }
})(function () {
  var define, module, exports;
  return function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof require && require;
            if (!f && c) return c(i, !0);
            if (u) return u(i, !0);
            var a = new Error("Cannot find module '" + i + "'");
            throw a.code = "MODULE_NOT_FOUND", a;
          }
          var p = n[i] = {
            exports: {}
          };
          e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];
            return o(n || r);
          }, p, p.exports, r, e, n, t);
        }
        return n[i].exports;
      }
      for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
      return o;
    }
    return r;
  }()({
    1: [function (_dereq_, module, exports) {
      "use strict";

      var scriptPromiseCache = {};
      function loadScript(options) {
        var scriptLoadPromise;
        var stringifiedOptions = JSON.stringify(options);
        if (!options.forceScriptReload) {
          scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
          if (scriptLoadPromise) {
            return scriptLoadPromise;
          }
        }
        var script = document.createElement("script");
        var attrs = options.dataAttributes || {};
        var container = options.container || document.head;
        script.src = options.src;
        script.id = options.id || "";
        script.async = true;
        if (options.type) {
          script.setAttribute("type", "".concat(options.type));
        }
        if (options.crossorigin) {
          script.setAttribute("crossorigin", "".concat(options.crossorigin));
        }
        Object.keys(attrs).forEach(function (key) {
          script.setAttribute("data-".concat(key), "".concat(attrs[key]));
        });
        scriptLoadPromise = new Promise(function (resolve, reject) {
          script.addEventListener("load", function () {
            resolve(script);
          });
          script.addEventListener("error", function () {
            reject(new Error("".concat(options.src, " failed to load.")));
          });
          script.addEventListener("abort", function () {
            reject(new Error("".concat(options.src, " has aborted.")));
          });
          container.appendChild(script);
        });
        scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
        return scriptLoadPromise;
      }
      loadScript.clearCache = function () {
        scriptPromiseCache = {};
      };
      module.exports = loadScript;
    }, {}],
    2: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/load-script");
    }, {
      "./dist/load-script": 1
    }],
    3: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isAndroid(ua) {
        ua = ua || window.navigator.userAgent;
        return /Android/i.test(ua);
      };
    }, {}],
    4: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isChromeOS(ua) {
        ua = ua || window.navigator.userAgent;
        return /CrOS/i.test(ua);
      };
    }, {}],
    5: [function (_dereq_, module, exports) {
      "use strict";

      var isEdge = _dereq_("./is-edge");
      var isSamsung = _dereq_("./is-samsung");
      var isDuckDuckGo = _dereq_("./is-duckduckgo");
      var isOpera = _dereq_("./is-opera");
      var isSilk = _dereq_("./is-silk");
      module.exports = function isChrome(ua) {
        ua = ua || window.navigator.userAgent;
        return (ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) && !isEdge(ua) && !isSamsung(ua) && !isDuckDuckGo(ua) && !isOpera(ua) && !isSilk(ua);
      };
    }, {
      "./is-duckduckgo": 6,
      "./is-edge": 7,
      "./is-opera": 16,
      "./is-samsung": 17,
      "./is-silk": 18
    }],
    6: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isDuckDuckGo(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("DuckDuckGo/") !== -1;
      };
    }, {}],
    7: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isEdge(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("Edge/") !== -1 || ua.indexOf("Edg/") !== -1;
      };
    }, {}],
    8: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isFirefox(ua) {
        ua = ua || window.navigator.userAgent;
        return /Firefox/i.test(ua);
      };
    }, {}],
    9: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isIosFirefox(ua) {
        ua = ua || window.navigator.userAgent;
        return /FxiOS/i.test(ua);
      };
    }, {}],
    10: [function (_dereq_, module, exports) {
      "use strict";

      var isIos = _dereq_("./is-ios");
      function isGoogleSearchApp(ua) {
        return /\bGSA\b/.test(ua);
      }
      module.exports = function isIosGoogleSearchApp(ua) {
        ua = ua || window.navigator.userAgent;
        return isIos(ua) && isGoogleSearchApp(ua);
      };
    }, {
      "./is-ios": 14
    }],
    11: [function (_dereq_, module, exports) {
      "use strict";

      var isIos = _dereq_("./is-ios");
      var isIosFirefox = _dereq_("./is-ios-firefox");
      var webkitRegexp = /webkit/i;
      function isWebkit(ua) {
        return webkitRegexp.test(ua);
      }
      function isIosChrome(ua) {
        return ua.indexOf("CriOS") > -1;
      }
      function isFacebook(ua) {
        return ua.indexOf("FBAN") > -1;
      }
      module.exports = function isIosSafari(ua) {
        ua = ua || window.navigator.userAgent;
        return isIos(ua) && isWebkit(ua) && !isIosChrome(ua) && !isIosFirefox(ua) && !isFacebook(ua);
      };
    }, {
      "./is-ios": 14,
      "./is-ios-firefox": 9
    }],
    12: [function (_dereq_, module, exports) {
      "use strict";

      var isIos = _dereq_("./is-ios");
      var isIosGoogleSearchApp = _dereq_("./is-ios-google-search-app");
      module.exports = function isIosWebview(ua) {
        ua = ua || window.navigator.userAgent;
        if (isIos(ua)) {
          // The Google Search iOS app is technically a webview and doesn't support popups.
          if (isIosGoogleSearchApp(ua)) {
            return true;
          }
          // Historically, a webview could be identified by the presence of AppleWebKit and _no_ presence of Safari after.
          return /.+AppleWebKit(?!.*Safari)/i.test(ua);
        }
        return false;
      };
    }, {
      "./is-ios": 14,
      "./is-ios-google-search-app": 10
    }],
    13: [function (_dereq_, module, exports) {
      "use strict";

      var isIosWebview = _dereq_("./is-ios-webview");
      module.exports = function isIosWKWebview(ua, statusBarVisible) {
        statusBarVisible = typeof statusBarVisible !== "undefined" ? statusBarVisible : window.statusbar.visible;
        return isIosWebview(ua) && statusBarVisible;
      };
    }, {
      "./is-ios-webview": 12
    }],
    14: [function (_dereq_, module, exports) {
      "use strict";

      var isIpadOS = _dereq_("./is-ipados");
      module.exports = function isIos(ua, checkIpadOS, document) {
        if (checkIpadOS === void 0) {
          checkIpadOS = true;
        }
        ua = ua || window.navigator.userAgent;
        var iOsTest = /iPhone|iPod|iPad/i.test(ua);
        return checkIpadOS ? iOsTest || isIpadOS(ua, document) : iOsTest;
      };
    }, {
      "./is-ipados": 15
    }],
    15: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isIpadOS(ua, document) {
        ua = ua || window.navigator.userAgent;
        document = document || window.document;
        // "ontouchend" is used to determine if a browser is on an iPad, otherwise
        // user-agents for iPadOS behave/identify as a desktop browser
        return /Mac|iPad/i.test(ua) && "ontouchend" in document;
      };
    }, {}],
    16: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isOpera(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("OPR/") !== -1 || ua.indexOf("Opera/") !== -1 || ua.indexOf("OPT/") !== -1;
      };
    }, {}],
    17: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isSamsungBrowser(ua) {
        ua = ua || window.navigator.userAgent;
        return /SamsungBrowser/i.test(ua);
      };
    }, {}],
    18: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isSilk(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("Silk/") !== -1;
      };
    }, {}],
    19: [function (_dereq_, module, exports) {
      "use strict";

      var MINIMUM_SUPPORTED_CHROME_IOS_VERSION = 48;
      var isAndroid = _dereq_("./is-android");
      var isIosFirefox = _dereq_("./is-ios-firefox");
      var isIosWebview = _dereq_("./is-ios-webview");
      var isChrome = _dereq_("./is-chrome");
      var isSamsungBrowser = _dereq_("./is-samsung");
      var isDuckDuckGo = _dereq_("./is-duckduckgo");
      function isUnsupportedIosChrome(ua) {
        ua = ua || window.navigator.userAgent;
        var match = ua.match(/CriOS\/(\d+)\./);
        if (!match) {
          return false;
        }
        var version = parseInt(match[1], 10);
        return version < MINIMUM_SUPPORTED_CHROME_IOS_VERSION;
      }
      function isOperaMini(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("Opera Mini") > -1;
      }
      function isAndroidWebview(ua) {
        var androidWebviewRegExp = /Version\/[\d.]+/i;
        ua = ua || window.navigator.userAgent;
        if (isAndroid(ua)) {
          return androidWebviewRegExp.test(ua) && !isOperaMini(ua) && !isDuckDuckGo(ua);
        }
        return false;
      }
      function isOldSamsungBrowserOrSamsungWebview(ua) {
        return !isChrome(ua) && !isSamsungBrowser(ua) && /samsung/i.test(ua);
      }
      module.exports = function supportsPopups(ua) {
        ua = ua || window.navigator.userAgent;
        return !(isIosWebview(ua) || isIosFirefox(ua) || isAndroidWebview(ua) || isOperaMini(ua) || isUnsupportedIosChrome(ua) || isOldSamsungBrowserOrSamsungWebview(ua));
      };
    }, {
      "./is-android": 3,
      "./is-chrome": 5,
      "./is-duckduckgo": 6,
      "./is-ios-firefox": 9,
      "./is-ios-webview": 12,
      "./is-samsung": 17
    }],
    20: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-android");
    }, {
      "./dist/is-android": 3
    }],
    21: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-chrome-os");
    }, {
      "./dist/is-chrome-os": 4
    }],
    22: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-chrome");
    }, {
      "./dist/is-chrome": 5
    }],
    23: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-firefox");
    }, {
      "./dist/is-firefox": 8
    }],
    24: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-ios-safari");
    }, {
      "./dist/is-ios-safari": 11
    }],
    25: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-ios-webview");
    }, {
      "./dist/is-ios-webview": 12
    }],
    26: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-ios-wkwebview");
    }, {
      "./dist/is-ios-wkwebview": 13
    }],
    27: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-ios");
    }, {
      "./dist/is-ios": 14
    }],
    28: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-samsung");
    }, {
      "./dist/is-samsung": 17
    }],
    29: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/supports-popups");
    }, {
      "./dist/supports-popups": 19
    }],
    30: [function (_dereq_, module, exports) {
      "use strict";

      var EventEmitter = /** @class */function () {
        function EventEmitter() {
          this._events = {};
        }
        EventEmitter.prototype.on = function (event, callback) {
          if (this._events[event]) {
            this._events[event].push(callback);
          } else {
            this._events[event] = [callback];
          }
        };
        EventEmitter.prototype.off = function (event, callback) {
          var eventCallbacks = this._events[event];
          if (!eventCallbacks) {
            return;
          }
          var indexOfCallback = eventCallbacks.indexOf(callback);
          eventCallbacks.splice(indexOfCallback, 1);
        };
        EventEmitter.prototype._emit = function (event) {
          var args = [];
          for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
          }
          var eventCallbacks = this._events[event];
          if (!eventCallbacks) {
            return;
          }
          eventCallbacks.forEach(function (callback) {
            callback.apply(void 0, args);
          });
        };
        EventEmitter.prototype.hasListener = function (event) {
          var eventCallbacks = this._events[event];
          if (!eventCallbacks) {
            return false;
          }
          return eventCallbacks.length > 0;
        };
        EventEmitter.createChild = function (ChildObject) {
          ChildObject.prototype = Object.create(EventEmitter.prototype, {
            constructor: ChildObject
          });
        };
        return EventEmitter;
      }();
      module.exports = EventEmitter;
    }, {}],
    31: [function (_dereq_, module, exports) {
      "use strict";

      var GlobalPromise = typeof Promise !== "undefined" ? Promise // eslint-disable-line no-undef
      : null;
      var ExtendedPromise = /** @class */function () {
        function ExtendedPromise(options) {
          var _this = this;
          if (typeof options === "function") {
            this._promise = new ExtendedPromise.Promise(options);
            return;
          }
          this._promise = new ExtendedPromise.Promise(function (resolve, reject) {
            _this._resolveFunction = resolve;
            _this._rejectFunction = reject;
          });
          options = options || {};
          this._onResolve = options.onResolve || ExtendedPromise.defaultOnResolve;
          this._onReject = options.onReject || ExtendedPromise.defaultOnReject;
          if (ExtendedPromise.shouldCatchExceptions(options)) {
            this._promise.catch(function () {
              // prevents unhandled promise rejection warning
              // in the console for extended promises that
              // that catch the error in an asynchronous manner
            });
          }
          this._resetState();
        }
        ExtendedPromise.defaultOnResolve = function (result) {
          return ExtendedPromise.Promise.resolve(result);
        };
        ExtendedPromise.defaultOnReject = function (err) {
          return ExtendedPromise.Promise.reject(err);
        };
        ExtendedPromise.setPromise = function (PromiseClass) {
          ExtendedPromise.Promise = PromiseClass;
        };
        ExtendedPromise.shouldCatchExceptions = function (options) {
          if (options.hasOwnProperty("suppressUnhandledPromiseMessage")) {
            return Boolean(options.suppressUnhandledPromiseMessage);
          }
          return Boolean(ExtendedPromise.suppressUnhandledPromiseMessage);
        };
        // start Promise methods documented in:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#Methods
        ExtendedPromise.all = function (args) {
          return ExtendedPromise.Promise.all(args);
        };
        ExtendedPromise.allSettled = function (args) {
          return ExtendedPromise.Promise.allSettled(args);
        };
        ExtendedPromise.race = function (args) {
          return ExtendedPromise.Promise.race(args);
        };
        ExtendedPromise.reject = function (arg) {
          return ExtendedPromise.Promise.reject(arg);
        };
        ExtendedPromise.resolve = function (arg) {
          return ExtendedPromise.Promise.resolve(arg);
        };
        ExtendedPromise.prototype.then = function () {
          var _a;
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return (_a = this._promise).then.apply(_a, args);
        };
        ExtendedPromise.prototype.catch = function () {
          var _a;
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return (_a = this._promise).catch.apply(_a, args);
        };
        ExtendedPromise.prototype.resolve = function (arg) {
          var _this = this;
          if (this.isFulfilled) {
            return this;
          }
          this._setResolved();
          ExtendedPromise.Promise.resolve().then(function () {
            return _this._onResolve(arg);
          }).then(function (argForResolveFunction) {
            _this._resolveFunction(argForResolveFunction);
          }).catch(function (err) {
            _this._resetState();
            _this.reject(err);
          });
          return this;
        };
        ExtendedPromise.prototype.reject = function (arg) {
          var _this = this;
          if (this.isFulfilled) {
            return this;
          }
          this._setRejected();
          ExtendedPromise.Promise.resolve().then(function () {
            return _this._onReject(arg);
          }).then(function (result) {
            _this._setResolved();
            _this._resolveFunction(result);
          }).catch(function (err) {
            return _this._rejectFunction(err);
          });
          return this;
        };
        ExtendedPromise.prototype._resetState = function () {
          this.isFulfilled = false;
          this.isResolved = false;
          this.isRejected = false;
        };
        ExtendedPromise.prototype._setResolved = function () {
          this.isFulfilled = true;
          this.isResolved = true;
          this.isRejected = false;
        };
        ExtendedPromise.prototype._setRejected = function () {
          this.isFulfilled = true;
          this.isResolved = false;
          this.isRejected = true;
        };
        ExtendedPromise.Promise = GlobalPromise;
        return ExtendedPromise;
      }();
      module.exports = ExtendedPromise;
    }, {}],
    32: [function (_dereq_, module, exports) {
      "use strict";

      var set_attributes_1 = _dereq_("./lib/set-attributes");
      var default_attributes_1 = _dereq_("./lib/default-attributes");
      var assign_1 = _dereq_("./lib/assign");
      module.exports = function createFrame(options) {
        if (options === void 0) {
          options = {};
        }
        var iframe = document.createElement("iframe");
        var config = (0, assign_1.assign)({}, default_attributes_1.defaultAttributes, options);
        if (config.style && typeof config.style !== "string") {
          (0, assign_1.assign)(iframe.style, config.style);
          delete config.style;
        }
        (0, set_attributes_1.setAttributes)(iframe, config);
        if (!iframe.getAttribute("id")) {
          iframe.id = iframe.name;
        }
        return iframe;
      };
    }, {
      "./lib/assign": 33,
      "./lib/default-attributes": 34,
      "./lib/set-attributes": 35
    }],
    33: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.assign = void 0;
      function assign(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      target) {
        var objs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          objs[_i - 1] = arguments[_i];
        }
        objs.forEach(function (obj) {
          if (typeof obj !== "object") {
            return;
          }
          Object.keys(obj).forEach(function (key) {
            target[key] = obj[key];
          });
        });
        return target;
      }
      exports.assign = assign;
    }, {}],
    34: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.defaultAttributes = void 0;
      exports.defaultAttributes = {
        src: "about:blank",
        frameBorder: 0,
        allowtransparency: true,
        scrolling: "no"
      };
    }, {}],
    35: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.setAttributes = void 0;
      function setAttributes(element,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      attributes) {
        for (var key in attributes) {
          if (attributes.hasOwnProperty(key)) {
            var value = attributes[key];
            if (value == null) {
              element.removeAttribute(key);
            } else {
              element.setAttribute(key, value);
            }
          }
        }
      }
      exports.setAttributes = setAttributes;
    }, {}],
    36: [function (_dereq_, module, exports) {
      "use strict";

      function uuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          var v = c === "x" ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
      module.exports = uuid;
    }, {}],
    37: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      function deferred(fn) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          setTimeout(function () {
            try {
              fn.apply(void 0, args);
            } catch (err) {
              /* eslint-disable no-console */
              console.log("Error in callback function");
              console.log(err);
              /* eslint-enable no-console */
            }
          }, 1);
        };
      }
      exports.deferred = deferred;
    }, {}],
    38: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      function once(fn) {
        var called = false;
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          if (!called) {
            called = true;
            fn.apply(void 0, args);
          }
        };
      }
      exports.once = once;
    }, {}],
    39: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /* eslint-disable consistent-return */
      function promiseOrCallback(promise, callback) {
        if (!callback) {
          return promise;
        }
        promise.then(function (data) {
          return callback(null, data);
        }).catch(function (err) {
          return callback(err);
        });
      }
      exports.promiseOrCallback = promiseOrCallback;
    }, {}],
    40: [function (_dereq_, module, exports) {
      "use strict";

      var deferred_1 = _dereq_("./lib/deferred");
      var once_1 = _dereq_("./lib/once");
      var promise_or_callback_1 = _dereq_("./lib/promise-or-callback");
      function wrapPromise(fn) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var callback;
          var lastArg = args[args.length - 1];
          if (typeof lastArg === "function") {
            callback = args.pop();
            callback = once_1.once(deferred_1.deferred(callback));
          }
          // I know, I know, this looks bad. But it's a quirk of the library that
          // we need to allow passing the this context to the original function
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore: this has an implicit any
          return promise_or_callback_1.promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
        };
      }
      wrapPromise.wrapPrototype = function (target, options) {
        if (options === void 0) {
          options = {};
        }
        var ignoreMethods = options.ignoreMethods || [];
        var includePrivateMethods = options.transformPrivateMethods === true;
        var methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
          var isNotPrivateMethod;
          var isNonConstructorFunction = method !== "constructor" && typeof target.prototype[method] === "function";
          var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
          if (includePrivateMethods) {
            isNotPrivateMethod = true;
          } else {
            isNotPrivateMethod = method.charAt(0) !== "_";
          }
          return isNonConstructorFunction && isNotPrivateMethod && isNotAnIgnoredMethod;
        });
        methods.forEach(function (method) {
          var original = target.prototype[method];
          target.prototype[method] = wrapPromise(original);
        });
        return target;
      };
      module.exports = wrapPromise;
    }, {
      "./lib/deferred": 37,
      "./lib/once": 38,
      "./lib/promise-or-callback": 39
    }],
    41: [function (_dereq_, module, exports) {
      (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.loadAxo = {}));
      })(this, function (exports) {
        'use strict';

        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.
          Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */
        /* global Reflect, Promise */
        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }
        function __generator(thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }
        var dist = {};
        var scriptPromiseCache = {};
        function loadScript$1(options) {
          var scriptLoadPromise;
          var stringifiedOptions = JSON.stringify(options);
          if (!options.forceScriptReload) {
            scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
            if (scriptLoadPromise) {
              return scriptLoadPromise;
            }
          }
          var script = document.createElement("script");
          var attrs = options.dataAttributes || {};
          var container = options.container || document.head;
          script.src = options.src;
          script.id = options.id || "";
          script.async = true;
          if (options.type) {
            script.setAttribute("type", "".concat(options.type));
          }
          if (options.crossorigin) {
            script.setAttribute("crossorigin", "".concat(options.crossorigin));
          }
          Object.keys(attrs).forEach(function (key) {
            script.setAttribute("data-".concat(key), "".concat(attrs[key]));
          });
          scriptLoadPromise = new Promise(function (resolve, reject) {
            script.addEventListener("load", function () {
              resolve(script);
            });
            script.addEventListener("error", function () {
              reject(new Error("".concat(options.src, " failed to load.")));
            });
            script.addEventListener("abort", function () {
              reject(new Error("".concat(options.src, " has aborted.")));
            });
            container.appendChild(script);
          });
          scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
          return scriptLoadPromise;
        }
        loadScript$1.clearCache = function () {
          scriptPromiseCache = {};
        };
        var loadScript_1$1 = loadScript$1;
        var loadStylesheet$1 = function loadStylesheet(options) {
          var stylesheet = document.querySelector("link[href=\"".concat(options.href, "\"]"));
          if (stylesheet) {
            return Promise.resolve(stylesheet);
          }
          stylesheet = document.createElement("link");
          var container = options.container || document.head;
          stylesheet.setAttribute("rel", "stylesheet");
          stylesheet.setAttribute("type", "text/css");
          stylesheet.setAttribute("href", options.href);
          stylesheet.setAttribute("id", options.id);
          if (container.firstChild) {
            container.insertBefore(stylesheet, container.firstChild);
          } else {
            container.appendChild(stylesheet);
          }
          return Promise.resolve(stylesheet);
        };
        Object.defineProperty(dist, "__esModule", {
          value: true
        });
        dist.loadStylesheet = loadScript_1 = dist.loadScript = void 0;
        var loadScript = loadScript_1$1;
        var loadScript_1 = dist.loadScript = loadScript;
        var loadStylesheet = loadStylesheet$1;
        dist.loadStylesheet = loadStylesheet;
        var CDNX_PROD = "https://www.paypalobjects.com";
        var ASSET_NAME = {
          minified: "axo.min",
          unminified: "axo"
        };
        var FL_NAMESPACE = "fastlane";
        var ASSET_PATH = "connect-boba";
        var LOCALE_PATH = "".concat(ASSET_PATH, "/locales/");
        var constants = {
          AXO_ASSET_NAME: ASSET_NAME,
          AXO_ASSET_PATH: ASSET_PATH,
          LOCALE_PATH: LOCALE_PATH,
          CDNX_PROD: CDNX_PROD
        };
        var AxoSupportedPlatforms = {
          BT: "BT",
          PPCP: "PPCP"
        };

        /**
         * Checks if the current environment is an AMD environment.
         *
         * @returns {boolean} True if the environment is AMD, false otherwise.
         */
        function isAmdEnv() {
          return typeof window.define === "function" && !!window.define.amd;
        }
        /**
         * Checks if the current environment is a RequireJS environment.
         *
         * @returns {boolean} True if the environment is RequireJS, false otherwise.
         */
        function isRequireJsEnv() {
          return isAmdEnv() && typeof window.requirejs === "function" && typeof window.requirejs.config === "function";
        }

        /**
         * Safely loads BT modules by checking if the module already exists and verifying if versions mismatch
         *
         * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
         * @param version <string> version that should be passed from the client getVersion
         * @returns Promise<HTMLScriptElement>
         * @returns Promise<true> when BT module with same version already exists
         * @returns Promise.reject(err) when BT module already exists but versions mismatch or empty version passed in
         */
        function safeLoadBtModule(loadConfig, version, minified) {
          var _a, _b;
          if (minified === void 0) {
            minified = true;
          }
          return __awaiter(this, void 0, void 0, function () {
            var bt, existingVersion;
            return __generator(this, function (_c) {
              bt = getBraintree();
              if (bt && bt[loadConfig.module]) {
                if (version && ((_a = bt[loadConfig.module]) === null || _a === void 0 ? void 0 : _a.VERSION) !== version) {
                  existingVersion = (_b = bt[loadConfig.module]) === null || _b === void 0 ? void 0 : _b.VERSION;
                  throw new Error("".concat(loadConfig.module, " already loaded with version ").concat(existingVersion, " cannot load version ").concat(version));
                } else {
                  return [2 /*return*/, true];
                }
              }
              if (!version) {
                throw new Error("Attempted to load ".concat(loadConfig.module, " without specifying version"));
              }
              return [2 /*return*/, loadBtModule(loadConfig, version, minified)];
            });
          });
        }
        /**
         * Reads the version and to load the correct version of Bt module
         *
         * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
         * @param version <string> Bt module version
         * @returns Promise<HTMLScriptElement> or
         */
        function loadBtModule(loadConfig, version, minified) {
          if (minified === void 0) {
            minified = true;
          }
          if (isAmdEnv()) {
            var module_1 = minified ? loadConfig.amdModule.minified : loadConfig.amdModule.unminified;
            return new Promise(function (resolve, reject) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.require([module_1], resolve, reject);
            });
          }
          var script = minified ? loadConfig.script.minified : loadConfig.script.unminified;
          return loadScript_1({
            id: "".concat(loadConfig.id, "-").concat(version),
            src: "https://js.braintreegateway.com/web/".concat(version, "/js/").concat(script)
          });
        }
        /**
         * Looks for the Braintree web sdk on the window object
         *
         * @returns Braintree web sdk
         */
        function getBraintree() {
          return window === null || window === void 0 ? void 0 : window.braintree;
        }
        var _a, _b;
        /**
         * Maps to the BT module namespace created on the window.braintree object
         */
        var BtModule = {
          Client: "client",
          HostedCardFields: "hostedFields"
        };
        var BT_NAMESPACE = "braintree";
        var BT_ASSET_NAME = (_a = {}, _a[BtModule.Client] = "client", _a[BtModule.HostedCardFields] = "hosted-fields", _a);
        var btModulesLoadConfig = (_b = {}, _b[BtModule.Client] = {
          id: "client",
          module: BtModule.Client,
          amdModule: {
            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client]),
            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client], ".min")
          },
          script: {
            unminified: "".concat(BT_ASSET_NAME[BtModule.Client], ".js"),
            minified: "".concat(BT_ASSET_NAME[BtModule.Client], ".min.js")
          }
        }, _b[BtModule.HostedCardFields] = {
          id: "hcf",
          module: BtModule.HostedCardFields,
          amdModule: {
            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields]),
            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min")
          },
          script: {
            unminified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".js"),
            minified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min.js")
          }
        }, _b);

        /**
         * Loads accelerated checkout components.
         * @param options object with a minified parameter to determine if the script that is loaded should be minified or not (defaults to true if)
         * @returns an object with metadata with a localeUrl parameter to be read by AXO SDK
         */
        function loadAxo(options) {
          return __awaiter(this, void 0, void 0, function () {
            var btSdkVersion, minified, assetUrl, localeUrl;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  performance.mark("pp_axo_sdk_init_invoked");
                  btSdkVersion = options.btSdkVersion, minified = options.minified;
                  assetUrl = getAssetsUrl(options);
                  localeUrl = getLocaleUrl(options);
                  if (!(options.platform === AxoSupportedPlatforms.BT)) return [3 /*break*/, 2];
                  return [4 /*yield*/, Promise.all([safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified), loadAXOScript(assetUrl, minified)])];
                case 1:
                  _a.sent();
                  return [3 /*break*/, 5];
                case 2:
                  if (!(options.platform === AxoSupportedPlatforms.PPCP)) return [3 /*break*/, 4];
                  return [4 /*yield*/, Promise.all([safeLoadBtModule(btModulesLoadConfig.client, btSdkVersion, minified), safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified), loadAXOScript(assetUrl, minified)])];
                case 3:
                  _a.sent();
                  return [3 /*break*/, 5];
                case 4:
                  throw new Error("unsupported axo platform");
                case 5:
                  return [2 /*return*/, {
                    metadata: {
                      localeUrl: localeUrl
                    }
                  }];
              }
            });
          });
        }
        /**
         * Reads the url and to load the axo bundle script
         * @param url (Required) string url for the correct axo asset
         * @returns Promise<HTMLScriptElement>
         */
        function loadAXOScript(url, minified) {
          var _a;
          if (minified === void 0) {
            minified = true;
          }
          if (isAmdEnv()) {
            // AMD environment
            if (isRequireJsEnv()) {
              // Let's configure RequireJS
              requirejs.config({
                paths: (_a = {}, _a[FL_NAMESPACE] = url, _a)
              });
            }
            var moduleName_1 = "".concat(FL_NAMESPACE, "/").concat(minified ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified);
            return new Promise(function (resolve, reject) {
              window.require([moduleName_1], resolve, reject);
            });
          }
          // Not an AMD environment
          return loadScript_1({
            id: "axo-id",
            src: url,
            forceScriptReload: true
          });
        }
        /**
         * Prepends the domain to the asset url
         * @param options object with assetUrl and bundleid parameters to determine which URL to return
         * @returns full domain and assets URL as string
         */
        function generateAssetUrl(_a) {
          var assetUrl = _a.assetUrl,
            bundleId = _a.bundleId;
          return bundleId ? "https://cdn-".concat(bundleId, ".static.engineering.dev.paypalinc.com/").concat(assetUrl) : "".concat(constants.CDNX_PROD, "/").concat(assetUrl);
        }
        /**
         * Retrieves either the minified or unminified assets URL as specified
         * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
         * @returns assets URL as string
         */
        function getAssetsUrl(options) {
          var _a;
          var assetName = (options === null || options === void 0 ? void 0 : options.minified) !== false ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified;
          var assetUrl = isAmdEnv() ? constants.AXO_ASSET_PATH : "".concat(constants.AXO_ASSET_PATH, "/").concat(assetName, ".js");
          return generateAssetUrl({
            assetUrl: assetUrl,
            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
          });
        }
        /**
         * Retrieves the Locales URL, the path to our language files
         * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
         * @returns locale URL as string
         */
        function getLocaleUrl(options) {
          var _a;
          return generateAssetUrl({
            assetUrl: constants.LOCALE_PATH,
            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
          });
        }
        exports.constants = constants;
        exports.loadAxo = loadAxo;
      });
    }, {}],
    42: [function (_dereq_, module, exports) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
        };
        return __assign.apply(this, arguments);
      };
      var cardTypes = _dereq_("./lib/card-types");
      var add_matching_cards_to_results_1 = _dereq_("./lib/add-matching-cards-to-results");
      var is_valid_input_type_1 = _dereq_("./lib/is-valid-input-type");
      var find_best_match_1 = _dereq_("./lib/find-best-match");
      var clone_1 = _dereq_("./lib/clone");
      var customCards = {};
      var cardNames = {
        VISA: "visa",
        MASTERCARD: "mastercard",
        AMERICAN_EXPRESS: "american-express",
        DINERS_CLUB: "diners-club",
        DISCOVER: "discover",
        JCB: "jcb",
        UNIONPAY: "unionpay",
        MAESTRO: "maestro",
        ELO: "elo",
        MIR: "mir",
        HIPER: "hiper",
        HIPERCARD: "hipercard"
      };
      var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
      var testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
      function findType(cardType) {
        return customCards[cardType] || cardTypes[cardType];
      }
      function getAllCardTypes() {
        return testOrder.map(function (cardType) {
          return (0, clone_1.clone)(findType(cardType));
        });
      }
      function getCardPosition(name, ignoreErrorForNotExisting) {
        if (ignoreErrorForNotExisting === void 0) {
          ignoreErrorForNotExisting = false;
        }
        var position = testOrder.indexOf(name);
        if (!ignoreErrorForNotExisting && position === -1) {
          throw new Error('"' + name + '" is not a supported card type.');
        }
        return position;
      }
      function creditCardType(cardNumber) {
        var results = [];
        if (!(0, is_valid_input_type_1.isValidInputType)(cardNumber)) {
          return results;
        }
        if (cardNumber.length === 0) {
          return getAllCardTypes();
        }
        testOrder.forEach(function (cardType) {
          var cardConfiguration = findType(cardType);
          (0, add_matching_cards_to_results_1.addMatchingCardsToResults)(cardNumber, cardConfiguration, results);
        });
        var bestMatch = (0, find_best_match_1.findBestMatch)(results);
        if (bestMatch) {
          return [bestMatch];
        }
        return results;
      }
      creditCardType.getTypeInfo = function (cardType) {
        return (0, clone_1.clone)(findType(cardType));
      };
      creditCardType.removeCard = function (name) {
        var position = getCardPosition(name);
        testOrder.splice(position, 1);
      };
      creditCardType.addCard = function (config) {
        var existingCardPosition = getCardPosition(config.type, true);
        customCards[config.type] = config;
        if (existingCardPosition === -1) {
          testOrder.push(config.type);
        }
      };
      creditCardType.updateCard = function (cardType, updates) {
        var originalObject = customCards[cardType] || cardTypes[cardType];
        if (!originalObject) {
          throw new Error("\"".concat(cardType, "\" is not a recognized type. Use `addCard` instead.'"));
        }
        if (updates.type && originalObject.type !== updates.type) {
          throw new Error("Cannot overwrite type parameter.");
        }
        var clonedCard = (0, clone_1.clone)(originalObject);
        clonedCard = __assign(__assign({}, clonedCard), updates);
        customCards[clonedCard.type] = clonedCard;
      };
      creditCardType.changeOrder = function (name, position) {
        var currentPosition = getCardPosition(name);
        testOrder.splice(currentPosition, 1);
        testOrder.splice(position, 0, name);
      };
      creditCardType.resetModifications = function () {
        testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
        customCards = {};
      };
      creditCardType.types = cardNames;
      module.exports = creditCardType;
    }, {
      "./lib/add-matching-cards-to-results": 43,
      "./lib/card-types": 44,
      "./lib/clone": 45,
      "./lib/find-best-match": 46,
      "./lib/is-valid-input-type": 47
    }],
    43: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.addMatchingCardsToResults = void 0;
      var clone_1 = _dereq_("./clone");
      var matches_1 = _dereq_("./matches");
      function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
        var i, patternLength;
        for (i = 0; i < cardConfiguration.patterns.length; i++) {
          var pattern = cardConfiguration.patterns[i];
          if (!(0, matches_1.matches)(cardNumber, pattern)) {
            continue;
          }
          var clonedCardConfiguration = (0, clone_1.clone)(cardConfiguration);
          if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
          } else {
            patternLength = String(pattern).length;
          }
          if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
          }
          results.push(clonedCardConfiguration);
          break;
        }
      }
      exports.addMatchingCardsToResults = addMatchingCardsToResults;
    }, {
      "./clone": 45,
      "./matches": 48
    }],
    44: [function (_dereq_, module, exports) {
      "use strict";

      var cardTypes = {
        visa: {
          niceType: "Visa",
          type: "visa",
          patterns: [4],
          gaps: [4, 8, 12],
          lengths: [16, 18, 19],
          code: {
            name: "CVV",
            size: 3
          }
        },
        mastercard: {
          niceType: "Mastercard",
          type: "mastercard",
          patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
          gaps: [4, 8, 12],
          lengths: [16],
          code: {
            name: "CVC",
            size: 3
          }
        },
        "american-express": {
          niceType: "American Express",
          type: "american-express",
          patterns: [34, 37],
          gaps: [4, 10],
          lengths: [15],
          code: {
            name: "CID",
            size: 4
          }
        },
        "diners-club": {
          niceType: "Diners Club",
          type: "diners-club",
          patterns: [[300, 305], 36, 38, 39],
          gaps: [4, 10],
          lengths: [14, 16, 19],
          code: {
            name: "CVV",
            size: 3
          }
        },
        discover: {
          niceType: "Discover",
          type: "discover",
          patterns: [6011, [644, 649], 65],
          gaps: [4, 8, 12],
          lengths: [16, 19],
          code: {
            name: "CID",
            size: 3
          }
        },
        jcb: {
          niceType: "JCB",
          type: "jcb",
          patterns: [2131, 1800, [3528, 3589]],
          gaps: [4, 8, 12],
          lengths: [16, 17, 18, 19],
          code: {
            name: "CVV",
            size: 3
          }
        },
        unionpay: {
          niceType: "UnionPay",
          type: "unionpay",
          patterns: [620, [62100, 62182], [62184, 62187], [62185, 62197], [62200, 62205], [622010, 622999], 622018, [62207, 62209], [623, 626], 6270, 6272, 6276, [627700, 627779], [627781, 627799], [6282, 6289], 6291, 6292, 810, [8110, 8131], [8132, 8151], [8152, 8163], [8164, 8171]],
          gaps: [4, 8, 12],
          lengths: [14, 15, 16, 17, 18, 19],
          code: {
            name: "CVN",
            size: 3
          }
        },
        maestro: {
          niceType: "Maestro",
          type: "maestro",
          patterns: [493698, [500000, 504174], [504176, 506698], [506779, 508999], [56, 59], 63, 67, 6],
          gaps: [4, 8, 12],
          lengths: [12, 13, 14, 15, 16, 17, 18, 19],
          code: {
            name: "CVC",
            size: 3
          }
        },
        elo: {
          niceType: "Elo",
          type: "elo",
          patterns: [401178, 401179, 438935, 457631, 457632, 431274, 451416, 457393, 504175, [506699, 506778], [509000, 509999], 627780, 636297, 636368, [650031, 650033], [650035, 650051], [650405, 650439], [650485, 650538], [650541, 650598], [650700, 650718], [650720, 650727], [650901, 650978], [651652, 651679], [655000, 655019], [655021, 655058]],
          gaps: [4, 8, 12],
          lengths: [16],
          code: {
            name: "CVE",
            size: 3
          }
        },
        mir: {
          niceType: "Mir",
          type: "mir",
          patterns: [[2200, 2204]],
          gaps: [4, 8, 12],
          lengths: [16, 17, 18, 19],
          code: {
            name: "CVP2",
            size: 3
          }
        },
        hiper: {
          niceType: "Hiper",
          type: "hiper",
          patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
          gaps: [4, 8, 12],
          lengths: [16],
          code: {
            name: "CVC",
            size: 3
          }
        },
        hipercard: {
          niceType: "Hipercard",
          type: "hipercard",
          patterns: [606282],
          gaps: [4, 8, 12],
          lengths: [16],
          code: {
            name: "CVC",
            size: 3
          }
        }
      };
      module.exports = cardTypes;
    }, {}],
    45: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.clone = void 0;
      function clone(originalObject) {
        if (!originalObject) {
          return null;
        }
        return JSON.parse(JSON.stringify(originalObject));
      }
      exports.clone = clone;
    }, {}],
    46: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.findBestMatch = void 0;
      function hasEnoughResultsToDetermineBestMatch(results) {
        var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
          return result.matchStrength;
        }).length;
        /*
         * if all possible results have a maxStrength property that means the card
         * number is sufficiently long enough to determine conclusively what the card
         * type is
         * */
        return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
      }
      function findBestMatch(results) {
        if (!hasEnoughResultsToDetermineBestMatch(results)) {
          return null;
        }
        return results.reduce(function (bestMatch, result) {
          if (!bestMatch) {
            return result;
          }
          /*
           * If the current best match pattern is less specific than this result, set
           * the result as the new best match
           * */
          if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
          }
          return bestMatch;
        });
      }
      exports.findBestMatch = findBestMatch;
    }, {}],
    47: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isValidInputType = void 0;
      function isValidInputType(cardNumber) {
        return typeof cardNumber === "string" || cardNumber instanceof String;
      }
      exports.isValidInputType = isValidInputType;
    }, {}],
    48: [function (_dereq_, module, exports) {
      "use strict";

      /*
       * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
       * */
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.matches = void 0;
      function matchesRange(cardNumber, min, max) {
        var maxLengthToCheck = String(min).length;
        var substr = cardNumber.substr(0, maxLengthToCheck);
        var integerRepresentationOfCardNumber = parseInt(substr, 10);
        min = parseInt(String(min).substr(0, substr.length), 10);
        max = parseInt(String(max).substr(0, substr.length), 10);
        return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
      }
      function matchesPattern(cardNumber, pattern) {
        pattern = String(pattern);
        return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
      }
      function matches(cardNumber, pattern) {
        if (Array.isArray(pattern)) {
          return matchesRange(cardNumber, pattern[0], pattern[1]);
        }
        return matchesPattern(cardNumber, pattern);
      }
      exports.matches = matches;
    }, {}],
    49: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Framebus = void 0;
      var lib_1 = _dereq_("./lib");
      var DefaultPromise = typeof window !== "undefined" && window.Promise;
      var Framebus = /** @class */function () {
        function Framebus(options) {
          if (options === void 0) {
            options = {};
          }
          this.origin = options.origin || "*";
          this.channel = options.channel || "";
          this.verifyDomain = options.verifyDomain;
          // if a targetFrames configuration is not passed in,
          // the default behavior is to broadcast the payload
          // to the top level window or to the frame itself.
          // By default, the broadcast function will loop through
          // all the known siblings and children of the window.
          // If a targetFrames array is passed, it will instead
          // only broadcast to those specified targetFrames
          this.targetFrames = options.targetFrames || [];
          this.limitBroadcastToFramesArray = Boolean(options.targetFrames);
          this.isDestroyed = false;
          this.listeners = [];
          this.hasAdditionalChecksForOnListeners = Boolean(this.verifyDomain || this.limitBroadcastToFramesArray);
        }
        Framebus.setPromise = function (PromiseGlobal) {
          Framebus.Promise = PromiseGlobal;
        };
        Framebus.target = function (options) {
          return new Framebus(options);
        };
        Framebus.prototype.addTargetFrame = function (frame) {
          if (!this.limitBroadcastToFramesArray) {
            return;
          }
          this.targetFrames.push(frame);
        };
        Framebus.prototype.include = function (childWindow) {
          if (childWindow == null) {
            return false;
          }
          if (childWindow.Window == null) {
            return false;
          }
          if (childWindow.constructor !== childWindow.Window) {
            return false;
          }
          lib_1.childWindows.push(childWindow);
          return true;
        };
        Framebus.prototype.target = function (options) {
          return Framebus.target(options);
        };
        Framebus.prototype.emit = function (eventName, data, reply) {
          if (this.isDestroyed) {
            return false;
          }
          var origin = this.origin;
          eventName = this.namespaceEvent(eventName);
          if ((0, lib_1.isntString)(eventName)) {
            return false;
          }
          if ((0, lib_1.isntString)(origin)) {
            return false;
          }
          if (typeof data === "function") {
            reply = data;
            data = undefined; // eslint-disable-line no-undefined
          }
          var payload = (0, lib_1.packagePayload)(eventName, origin, data, reply);
          if (!payload) {
            return false;
          }
          if (this.limitBroadcastToFramesArray) {
            this.targetFramesAsWindows().forEach(function (frame) {
              (0, lib_1.sendMessage)(frame, payload, origin);
            });
          } else {
            (0, lib_1.broadcast)(payload, {
              origin: origin,
              frame: window.top || window.self
            });
          }
          return true;
        };
        Framebus.prototype.emitAsPromise = function (eventName, data) {
          var _this = this;
          return new Framebus.Promise(function (resolve, reject) {
            var didAttachListener = _this.emit(eventName, data, function (payload) {
              resolve(payload);
            });
            if (!didAttachListener) {
              reject(new Error("Listener not added for \"".concat(eventName, "\"")));
            }
          });
        };
        Framebus.prototype.on = function (eventName, originalHandler) {
          if (this.isDestroyed) {
            return false;
          }
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          var self = this;
          var origin = this.origin;
          var handler = originalHandler;
          eventName = this.namespaceEvent(eventName);
          if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) {
            return false;
          }
          if (this.hasAdditionalChecksForOnListeners) {
            /* eslint-disable no-invalid-this, @typescript-eslint/ban-ts-comment */
            handler = function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              // @ts-ignore
              if (!self.passesVerifyDomainCheck(this && this.origin)) {
                return;
              }
              // @ts-ignore
              if (!self.hasMatchingTargetFrame(this && this.source)) {
                return;
              }
              originalHandler.apply(void 0, args);
            };
            /* eslint-enable no-invalid-this, @typescript-eslint/ban-ts-comment */
          }
          this.listeners.push({
            eventName: eventName,
            handler: handler,
            originalHandler: originalHandler
          });
          lib_1.subscribers[origin] = lib_1.subscribers[origin] || {};
          lib_1.subscribers[origin][eventName] = lib_1.subscribers[origin][eventName] || [];
          lib_1.subscribers[origin][eventName].push(handler);
          return true;
        };
        Framebus.prototype.off = function (eventName, originalHandler) {
          var handler = originalHandler;
          if (this.isDestroyed) {
            return false;
          }
          if (this.hasAdditionalChecksForOnListeners) {
            for (var i = 0; i < this.listeners.length; i++) {
              var listener = this.listeners[i];
              if (listener.originalHandler === originalHandler) {
                handler = listener.handler;
              }
            }
          }
          eventName = this.namespaceEvent(eventName);
          var origin = this.origin;
          if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) {
            return false;
          }
          var subscriberList = lib_1.subscribers[origin] && lib_1.subscribers[origin][eventName];
          if (!subscriberList) {
            return false;
          }
          for (var i = 0; i < subscriberList.length; i++) {
            if (subscriberList[i] === handler) {
              subscriberList.splice(i, 1);
              return true;
            }
          }
          return false;
        };
        Framebus.prototype.teardown = function () {
          if (this.isDestroyed) {
            return;
          }
          this.isDestroyed = true;
          for (var i = 0; i < this.listeners.length; i++) {
            var listener = this.listeners[i];
            this.off(listener.eventName, listener.handler);
          }
          this.listeners.length = 0;
        };
        Framebus.prototype.passesVerifyDomainCheck = function (origin) {
          if (!this.verifyDomain) {
            // always pass this check if no verifyDomain option was set
            return true;
          }
          return this.checkOrigin(origin);
        };
        Framebus.prototype.targetFramesAsWindows = function () {
          if (!this.limitBroadcastToFramesArray) {
            return [];
          }
          return this.targetFrames.map(function (frame) {
            // we can't pull off the contentWindow
            // when the iframe is originally added
            // to the array, because if it is not
            // in the DOM at that time, it will have
            // a contentWindow of `null`
            if (frame instanceof HTMLIFrameElement) {
              return frame.contentWindow;
            }
            return frame;
          }).filter(function (win) {
            // just in case an iframe element
            // was removed from the DOM
            // and the contentWindow property
            // is null
            return win;
          });
        };
        Framebus.prototype.hasMatchingTargetFrame = function (source) {
          if (!this.limitBroadcastToFramesArray) {
            // always pass this check if we aren't limiting to the target frames
            return true;
          }
          var matchingFrame = this.targetFramesAsWindows().find(function (frame) {
            return frame === source;
          });
          return Boolean(matchingFrame);
        };
        Framebus.prototype.checkOrigin = function (postMessageOrigin) {
          var merchantHost;
          var a = document.createElement("a");
          a.href = location.href;
          if (a.protocol === "https:") {
            merchantHost = a.host.replace(/:443$/, "");
          } else if (a.protocol === "http:") {
            merchantHost = a.host.replace(/:80$/, "");
          } else {
            merchantHost = a.host;
          }
          var merchantOrigin = a.protocol + "//" + merchantHost;
          if (merchantOrigin === postMessageOrigin) {
            return true;
          }
          if (this.verifyDomain) {
            return this.verifyDomain(postMessageOrigin);
          }
          return true;
        };
        Framebus.prototype.namespaceEvent = function (eventName) {
          if (!this.channel) {
            return eventName;
          }
          return "".concat(this.channel, ":").concat(eventName);
        };
        Framebus.Promise = DefaultPromise;
        return Framebus;
      }();
      exports.Framebus = Framebus;
    }, {
      "./lib": 57
    }],
    50: [function (_dereq_, module, exports) {
      "use strict";

      var lib_1 = _dereq_("./lib");
      var framebus_1 = _dereq_("./framebus");
      (0, lib_1.attach)();
      module.exports = framebus_1.Framebus;
    }, {
      "./framebus": 49,
      "./lib": 57
    }],
    51: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.detach = exports.attach = void 0;
      var _1 = _dereq_("./");
      var isAttached = false;
      function attach() {
        if (isAttached || typeof window === "undefined") {
          return;
        }
        isAttached = true;
        window.addEventListener("message", _1.onMessage, false);
      }
      exports.attach = attach;
      // removeIf(production)
      function detach() {
        isAttached = false;
        window.removeEventListener("message", _1.onMessage, false);
      }
      exports.detach = detach;
      // endRemoveIf(production)
    }, {
      "./": 57
    }],
    52: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.broadcastToChildWindows = void 0;
      var _1 = _dereq_("./");
      function broadcastToChildWindows(payload, origin, source) {
        for (var i = _1.childWindows.length - 1; i >= 0; i--) {
          var childWindow = _1.childWindows[i];
          if (childWindow.closed) {
            _1.childWindows.splice(i, 1);
          } else if (source !== childWindow) {
            (0, _1.broadcast)(payload, {
              origin: origin,
              frame: childWindow.top
            });
          }
        }
      }
      exports.broadcastToChildWindows = broadcastToChildWindows;
    }, {
      "./": 57
    }],
    53: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.broadcast = void 0;
      var _1 = _dereq_("./");
      function broadcast(payload, options) {
        var i = 0;
        var frameToBroadcastTo;
        var origin = options.origin,
          frame = options.frame;
        try {
          frame.postMessage(payload, origin);
          if ((0, _1.hasOpener)(frame) && frame.opener.top !== window.top) {
            broadcast(payload, {
              origin: origin,
              frame: frame.opener.top
            });
          }
          // previously, our max value was frame.frames.length
          // but frames.length inherits from window.length
          // which can be overwritten if a developer does
          // `var length = value;` outside of a function
          // scope, it'll prevent us from looping through
          // all the frames. With this, we loop through
          // until there are no longer any frames
          // eslint-disable-next-line no-cond-assign
          while (frameToBroadcastTo = frame.frames[i]) {
            broadcast(payload, {
              origin: origin,
              frame: frameToBroadcastTo
            });
            i++;
          }
        } catch (_) {
          /* ignored */
        }
      }
      exports.broadcast = broadcast;
    }, {
      "./": 57
    }],
    54: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.subscribers = exports.childWindows = exports.prefix = void 0;
      exports.prefix = "/*framebus*/";
      exports.childWindows = [];
      exports.subscribers = {};
    }, {}],
    55: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.dispatch = void 0;
      var _1 = _dereq_("./");
      function dispatch(origin, event, data, reply, e) {
        if (!_1.subscribers[origin]) {
          return;
        }
        if (!_1.subscribers[origin][event]) {
          return;
        }
        var args = [];
        if (data) {
          args.push(data);
        }
        if (reply) {
          args.push(reply);
        }
        for (var i = 0; i < _1.subscribers[origin][event].length; i++) {
          _1.subscribers[origin][event][i].apply(e, args);
        }
      }
      exports.dispatch = dispatch;
    }, {
      "./": 57
    }],
    56: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.hasOpener = void 0;
      function hasOpener(frame) {
        if (frame.top !== frame) {
          return false;
        }
        if (frame.opener == null) {
          return false;
        }
        if (frame.opener === frame) {
          return false;
        }
        if (frame.opener.closed === true) {
          return false;
        }
        return true;
      }
      exports.hasOpener = hasOpener;
    }, {}],
    57: [function (_dereq_, module, exports) {
      "use strict";

      var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            }
          };
        }
        Object.defineProperty(o, k2, desc);
      } : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
      var __exportStar = this && this.__exportStar || function (m, exports) {
        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
      };
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      __exportStar(_dereq_("./attach"), exports);
      __exportStar(_dereq_("./broadcast-to-child-windows"), exports);
      __exportStar(_dereq_("./broadcast"), exports);
      __exportStar(_dereq_("./constants"), exports);
      __exportStar(_dereq_("./dispatch"), exports);
      __exportStar(_dereq_("./has-opener"), exports);
      __exportStar(_dereq_("./is-not-string"), exports);
      __exportStar(_dereq_("./message"), exports);
      __exportStar(_dereq_("./package-payload"), exports);
      __exportStar(_dereq_("./send-message"), exports);
      __exportStar(_dereq_("./subscribe-replier"), exports);
      __exportStar(_dereq_("./subscription-args-invalid"), exports);
      __exportStar(_dereq_("./types"), exports);
      __exportStar(_dereq_("./unpack-payload"), exports);
    }, {
      "./attach": 51,
      "./broadcast": 53,
      "./broadcast-to-child-windows": 52,
      "./constants": 54,
      "./dispatch": 55,
      "./has-opener": 56,
      "./is-not-string": 58,
      "./message": 59,
      "./package-payload": 60,
      "./send-message": 61,
      "./subscribe-replier": 62,
      "./subscription-args-invalid": 63,
      "./types": 64,
      "./unpack-payload": 65
    }],
    58: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isntString = void 0;
      function isntString(str) {
        return typeof str !== "string";
      }
      exports.isntString = isntString;
    }, {}],
    59: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.onMessage = void 0;
      var _1 = _dereq_("./");
      function onMessage(e) {
        if ((0, _1.isntString)(e.data)) {
          return;
        }
        var payload = (0, _1.unpackPayload)(e);
        if (!payload) {
          return;
        }
        var data = payload.eventData;
        var reply = payload.reply;
        (0, _1.dispatch)("*", payload.event, data, reply, e);
        (0, _1.dispatch)(e.origin, payload.event, data, reply, e);
        (0, _1.broadcastToChildWindows)(e.data, payload.origin, e.source);
      }
      exports.onMessage = onMessage;
    }, {
      "./": 57
    }],
    60: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.packagePayload = void 0;
      var _1 = _dereq_("./");
      function packagePayload(event, origin, data, reply) {
        var packaged;
        var payload = {
          event: event,
          origin: origin
        };
        if (typeof reply === "function") {
          payload.reply = (0, _1.subscribeReplier)(reply, origin);
        }
        payload.eventData = data;
        try {
          packaged = _1.prefix + JSON.stringify(payload);
        } catch (e) {
          throw new Error("Could not stringify event: ".concat(e.message));
        }
        return packaged;
      }
      exports.packagePayload = packagePayload;
    }, {
      "./": 57
    }],
    61: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sendMessage = void 0;
      /**
       * A basic function for wrapping the sending of postMessages to frames.
       */
      function sendMessage(frame, payload, origin) {
        try {
          frame.postMessage(payload, origin);
        } catch (error) {
          /* ignored */
        }
      }
      exports.sendMessage = sendMessage;
    }, {}],
    62: [function (_dereq_, module, exports) {
      "use strict";

      var __importDefault = this && this.__importDefault || function (mod) {
        return mod && mod.__esModule ? mod : {
          "default": mod
        };
      };
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.subscribeReplier = void 0;
      var framebus_1 = _dereq_("../framebus");
      var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
      function subscribeReplier(fn, origin) {
        var uuid = (0, uuid_1.default)();
        function replier(data, replyOriginHandler) {
          fn(data, replyOriginHandler);
          framebus_1.Framebus.target({
            origin: origin
          }).off(uuid, replier);
        }
        framebus_1.Framebus.target({
          origin: origin
        }).on(uuid, replier);
        return uuid;
      }
      exports.subscribeReplier = subscribeReplier;
    }, {
      "../framebus": 49,
      "@braintree/uuid": 36
    }],
    63: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.subscriptionArgsInvalid = void 0;
      var _1 = _dereq_("./");
      function subscriptionArgsInvalid(event, fn, origin) {
        if ((0, _1.isntString)(event)) {
          return true;
        }
        if (typeof fn !== "function") {
          return true;
        }
        return (0, _1.isntString)(origin);
      }
      exports.subscriptionArgsInvalid = subscriptionArgsInvalid;
    }, {
      "./": 57
    }],
    64: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
    }, {}],
    65: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.unpackPayload = void 0;
      var _1 = _dereq_("./");
      function unpackPayload(e) {
        var payload;
        if (e.data.slice(0, _1.prefix.length) !== _1.prefix) {
          return false;
        }
        try {
          payload = JSON.parse(e.data.slice(_1.prefix.length));
        } catch (err) {
          return false;
        }
        if (payload.reply) {
          var replyOrigin_1 = e.origin;
          var replySource_1 = e.source;
          var replyEvent_1 = payload.reply;
          payload.reply = function reply(replyData) {
            if (!replySource_1) {
              return;
            }
            var replyPayload = (0, _1.packagePayload)(replyEvent_1, replyOrigin_1, replyData);
            if (!replyPayload) {
              return;
            }
            replySource_1.postMessage(replyPayload, replyOrigin_1);
          };
        }
        return payload;
      }
      exports.unpackPayload = unpackPayload;
    }, {
      "./": 57
    }],
    66: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.isIos = exports.isIE9 = exports.isSamsungBrowser = exports.isAndroidChrome = exports.isKitKatWebview = void 0;
      // server side rendering check
      var UA = typeof window !== "undefined" && window.navigator && window.navigator.userAgent;
      // TODO remove this when browser detection is converted to typescript
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      var isAndroid = _dereq_("@braintree/browser-detection/is-android");
      // @ts-ignore
      var isChromeOs = _dereq_("@braintree/browser-detection/is-chrome-os");
      // @ts-ignore
      var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
      // @ts-ignore
      var isIos = _dereq_("@braintree/browser-detection/is-ios");
      exports.isIos = isIos;
      // @ts-ignore
      var isIE9 = _dereq_("@braintree/browser-detection/is-ie9");
      exports.isIE9 = isIE9;
      /* eslint-enable @typescript-eslint/ban-ts-comment */
      // Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
      // https://developer.chrome.com/multidevice/user-agent#webview_user_agent
      var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;
      function isOldSamsungBrowserOrSamsungWebview(ua) {
        return !isChrome(ua) && ua.indexOf("Samsung") > -1;
      }
      function isKitKatWebview(ua) {
        if (ua === void 0) {
          ua = UA;
        }
        return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
      }
      exports.isKitKatWebview = isKitKatWebview;
      function isAndroidChrome(ua) {
        if (ua === void 0) {
          ua = UA;
        }
        return (isAndroid(ua) || isChromeOs(ua)) && isChrome(ua);
      }
      exports.isAndroidChrome = isAndroidChrome;
      function isSamsungBrowser(ua) {
        if (ua === void 0) {
          ua = UA;
        }
        return /SamsungBrowser/.test(ua) || isOldSamsungBrowserOrSamsungWebview(ua);
      }
      exports.isSamsungBrowser = isSamsungBrowser;
    }, {
      "@braintree/browser-detection/is-android": 79,
      "@braintree/browser-detection/is-chrome": 81,
      "@braintree/browser-detection/is-chrome-os": 80,
      "@braintree/browser-detection/is-ie9": 82,
      "@braintree/browser-detection/is-ios": 83
    }],
    67: [function (_dereq_, module, exports) {
      "use strict";

      var device_1 = _dereq_("./lib/device");
      module.exports = function supportsInputFormatting() {
        // Digits get dropped in samsung browser
        return !(0, device_1.isSamsungBrowser)();
      };
    }, {
      "./lib/device": 66
    }],
    68: [function (_dereq_, module, exports) {
      arguments[4][3][0].apply(exports, arguments);
    }, {
      "dup": 3
    }],
    69: [function (_dereq_, module, exports) {
      arguments[4][4][0].apply(exports, arguments);
    }, {
      "dup": 4
    }],
    70: [function (_dereq_, module, exports) {
      arguments[4][5][0].apply(exports, arguments);
    }, {
      "./is-duckduckgo": 71,
      "./is-edge": 72,
      "./is-opera": 76,
      "./is-samsung": 77,
      "./is-silk": 78,
      "dup": 5
    }],
    71: [function (_dereq_, module, exports) {
      arguments[4][6][0].apply(exports, arguments);
    }, {
      "dup": 6
    }],
    72: [function (_dereq_, module, exports) {
      arguments[4][7][0].apply(exports, arguments);
    }, {
      "dup": 7
    }],
    73: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function isIe9(ua) {
        ua = ua || window.navigator.userAgent;
        return ua.indexOf("MSIE 9") !== -1;
      };
    }, {}],
    74: [function (_dereq_, module, exports) {
      arguments[4][14][0].apply(exports, arguments);
    }, {
      "./is-ipados": 75,
      "dup": 14
    }],
    75: [function (_dereq_, module, exports) {
      arguments[4][15][0].apply(exports, arguments);
    }, {
      "dup": 15
    }],
    76: [function (_dereq_, module, exports) {
      arguments[4][16][0].apply(exports, arguments);
    }, {
      "dup": 16
    }],
    77: [function (_dereq_, module, exports) {
      arguments[4][17][0].apply(exports, arguments);
    }, {
      "dup": 17
    }],
    78: [function (_dereq_, module, exports) {
      arguments[4][18][0].apply(exports, arguments);
    }, {
      "dup": 18
    }],
    79: [function (_dereq_, module, exports) {
      arguments[4][20][0].apply(exports, arguments);
    }, {
      "./dist/is-android": 68,
      "dup": 20
    }],
    80: [function (_dereq_, module, exports) {
      arguments[4][21][0].apply(exports, arguments);
    }, {
      "./dist/is-chrome-os": 69,
      "dup": 21
    }],
    81: [function (_dereq_, module, exports) {
      arguments[4][22][0].apply(exports, arguments);
    }, {
      "./dist/is-chrome": 70,
      "dup": 22
    }],
    82: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/is-ie9");
    }, {
      "./dist/is-ie9": 73
    }],
    83: [function (_dereq_, module, exports) {
      arguments[4][27][0].apply(exports, arguments);
    }, {
      "./dist/is-ios": 74,
      "dup": 27
    }],
    84: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/supports-input-formatting");
    }, {
      "./dist/supports-input-formatting": 67
    }],
    85: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./errors");
      var assign = _dereq_("../lib/assign").assign;
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @class
       * @param {object} options Options
       * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/american-express.create|braintree.american-express.create} instead.</strong>
       * @classdesc This class allows you use a nonce to interact with American Express Checkout. To accept American Express cards, use Hosted Fields.
       */
      function AmericanExpress(options) {
        this._client = options.client;
      }

      /**
       * Gets the rewards balance associated with a Braintree nonce.
       * @public
       * @param {object} options Request options
       * @param {string} options.nonce An existing Braintree nonce.
       * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getRewardsBalance` returns a promise that resolves with the server data.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var americanExpress = require('braintree-web/american-express');
       *
       * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
       *   var options = {nonce: existingBraintreeNonce};
       *   americanExpressInstance.getRewardsBalance(options, function (getErr, payload) {
       *     if (getErr || payload.error) {
       *       // Handle error
       *       return;
       *     }
       *
       *     console.log('Rewards amount: ' + payload.rewardsAmount);
       *   });
       * });
       */
      AmericanExpress.prototype.getRewardsBalance = function (options) {
        var nonce = options.nonce;
        var data;
        if (!nonce) {
          return Promise.reject(new BraintreeError({
            type: errors.AMEX_NONCE_REQUIRED.type,
            code: errors.AMEX_NONCE_REQUIRED.code,
            message: "getRewardsBalance must be called with a nonce."
          }));
        }
        data = assign({
          _meta: {
            source: "american-express"
          },
          paymentMethodNonce: nonce
        }, options);
        delete data.nonce;
        return this._client.request({
          method: "get",
          endpoint: "payment_methods/amex_rewards_balance",
          data: data
        }).catch(function (err) {
          return Promise.reject(new BraintreeError({
            type: errors.AMEX_NETWORK_ERROR.type,
            code: errors.AMEX_NETWORK_ERROR.code,
            message: "A network error occurred when getting the American Express rewards balance.",
            details: {
              originalError: err
            }
          }));
        });
      };

      /**
       * Gets the Express Checkout nonce profile given a nonce from American Express.
       * @public
       * @param {object} options Request options
       * @param {string} options.nonce An existing nonce from American Express (note that this is <em>not</em> a nonce from Braintree).
       * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getExpressCheckoutProfile` returns a promise that resolves with the server data.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var americanExpress = require('braintree-web/american-express');
       *
       * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
       *   var options = {nonce: existingAmericanExpressNonce};
       *   americanExpressInstance.getExpressCheckoutProfile(options, function (getErr, payload) {
       *     if (getErr) {
       *       // Handle error
       *       return;
       *     }
       *
       *     console.log('Number of cards: ' + payload.amexExpressCheckoutCards.length);
       *   });
       * });
       */
      AmericanExpress.prototype.getExpressCheckoutProfile = function (options) {
        if (!options.nonce) {
          return Promise.reject(new BraintreeError({
            type: errors.AMEX_NONCE_REQUIRED.type,
            code: errors.AMEX_NONCE_REQUIRED.code,
            message: "getExpressCheckoutProfile must be called with a nonce."
          }));
        }
        return this._client.request({
          method: "get",
          endpoint: "payment_methods/amex_express_checkout_cards/" + options.nonce,
          data: {
            _meta: {
              source: "american-express"
            },
            paymentMethodNonce: options.nonce
          }
        }).catch(function (err) {
          return Promise.reject(new BraintreeError({
            type: errors.AMEX_NETWORK_ERROR.type,
            code: errors.AMEX_NETWORK_ERROR.code,
            message: "A network error occurred when getting the American Express Checkout nonce profile.",
            details: {
              originalError: err
            }
          }));
        });
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/american-express.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * americanExpressInstance.teardown();
       * @example <caption>With callback</caption>
       * americanExpressInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      AmericanExpress.prototype.teardown = function () {
        convertMethodsToError(this, methods(AmericanExpress.prototype));
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(AmericanExpress);
    }, {
      "../lib/assign": 137,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/methods": 172,
      "./errors": 86,
      "@braintree/wrap-promise": 40
    }],
    86: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.American Express - getRewardsBalance Error Codes
       * @description Errors that occur when creating components.
       * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
       * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
       */

      /**
       * @name BraintreeError.American Express - getExpressCheckoutProfile Error Codes
       * @description Errors that occur when creating components.
       * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
       * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        AMEX_NONCE_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "AMEX_NONCE_REQUIRED"
        },
        AMEX_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "AMEX_NETWORK_ERROR"
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    87: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/american-express
       * @description This module is for use with Amex Express Checkout. To accept American Express cards, use Hosted Fields.
       */
      var AmericanExpress = _dereq_("./american-express");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link AmericanExpress} instance. If no callback is provided, `create` returns a promise that resolves with the {@link AmericanExpress} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "American Express";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          options.client = client;
          return new AmericanExpress(options);
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./american-express": 85,
      "@braintree/wrap-promise": 40
    }],
    88: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./errors");
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @typedef {object} ApplePay~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {object} details Additional details.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.cardHolderName The name of the card holder.
       * @property {string} details.dpanLastTwo Last two digits of card number.
       * @property {boolean} details.isDeviceToken Whether this tokenized card is a
       * device-specific account number (DPAN) ('true') or merchant/cloud token (MPAN) ('false').
       * @property {string} description A human-readable description.
       * @property {string} type The payment method type, always `ApplePayCard`.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * An Apple Pay Payment Authorization Event object.
       * @typedef {object} ApplePayPaymentAuthorizedEvent
       * @external ApplePayPaymentAuthorizedEvent
       * @see {@link https://developer.apple.com/reference/applepayjs/applepaypaymentauthorizedevent ApplePayPaymentAuthorizedEvent}
       */

      /**
       * An Apple Pay Payment Request object.
       * @typedef {object} ApplePayPaymentRequest
       * @external ApplePayPaymentRequest
       * @see {@link https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest PaymentRequest}
       */

      /**
       * @class
       * @param {object} options Options
       * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/apple-pay.create|braintree.applePay.create} instead.</strong>
       * @classdesc This class represents an Apple Pay component. Instances of this class have methods for validating the merchant server and tokenizing payments.
       */
      function ApplePay(options) {
        this._instantiatedWithClient = Boolean(!options.useDeferredClient);
        this._client = options.client;
        this._createPromise = options.createPromise;
        if (this._client) {
          this._setMerchantIdentifier();
        }
      }
      ApplePay.prototype._waitForClient = function () {
        if (this._client) {
          return Promise.resolve();
        }
        return this._createPromise.then(function (client) {
          this._client = client;
          this._setMerchantIdentifier();
        }.bind(this));
      };
      ApplePay.prototype._setMerchantIdentifier = function () {
        var applePayConfig = this._client.getConfiguration().gatewayConfiguration.applePayWeb;
        if (!applePayConfig) {
          return;
        }
        /**
         * @name ApplePay#merchantIdentifier
         * @description A special merchant ID which represents the merchant association with Braintree. Required when using `ApplePaySession.canMakePaymentsWithActiveCard`.
         * @example
         * var promise = ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier);
         * promise.then(function (canMakePaymentsWithActiveCard) {
         *   if (canMakePaymentsWithActiveCard) {
         *     // Set up Apple Pay buttons
         *   }
         * });
         */
        Object.defineProperty(this, "merchantIdentifier", {
          value: applePayConfig.merchantIdentifier,
          configurable: false,
          writable: false
        });
      };

      /**
       * Merges a payment request with Braintree defaults to return an {external:ApplePayPaymentRequest}.
       *
       * The following properties are assigned to `paymentRequest` if not already defined. Their default values come from the Braintree gateway.
       * - `countryCode`
       * - `currencyCode`
       * - `merchantCapabilities`
       * - `supportedNetworks`
       * @public
       * @param {external:ApplePayPaymentRequest} paymentRequest The payment request details to apply on top of those from Braintree.
       * @returns {external:ApplePayPaymentRequest|Promise} The decorated `paymentRequest` object. If `useDeferredClient` is used along with an `authorization`, this method will return a promise that resolves with the `paymentRequest` object.
       * @example
       * var applePay = require('braintree-web/apple-pay');
       *
       * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
       *   if (applePayErr) {
       *     // Handle error here
       *     return;
       *   }
       *
       *   var paymentRequest = applePayInstance.createPaymentRequest({
       *     total: {
       *       label: 'My Company',
       *       amount: '19.99'
       *     }
       *   });
       *
       *   var session = new ApplePaySession(3, paymentRequest);
       *
       *   // ...
       * @example <caption>With deferred client</caption>
       * var applePay = require('braintree-web/apple-pay');
       *
       * applePay.create({
       *   authorization: 'client-token-or-tokenization-key',
       *   useDeferredClient: true
       * }, function (applePayErr, applePayInstance) {
       *   if (applePayErr) {
       *     // Handle error here
       *     return;
       *   }
       *
       *   applePayInstance.createPaymentRequest({
       *     total: {
       *       label: 'My Company',
       *       amount: '19.99'
       *     }
       *   }).then(function (paymentRequest) {
       *     var session = new ApplePaySession(3, paymentRequest);
       *
       *     // ...
       *   });
       */
      ApplePay.prototype.createPaymentRequest = function (paymentRequest) {
        if (this._instantiatedWithClient) {
          return this._createPaymentRequestSynchronously(paymentRequest);
        }
        return this._waitForClient().then(function () {
          return this._createPaymentRequestSynchronously(paymentRequest);
        }.bind(this));
      };
      ApplePay.prototype._createPaymentRequestSynchronously = function (paymentRequest) {
        var applePay = this._client.getConfiguration().gatewayConfiguration.applePayWeb;
        var defaults = {
          countryCode: applePay.countryCode,
          currencyCode: applePay.currencyCode,
          merchantCapabilities: applePay.merchantCapabilities || ["supports3DS"],
          supportedNetworks: applePay.supportedNetworks.map(function (network) {
            return network === "mastercard" ? "masterCard" : network;
          })
        };
        return Object.assign({}, defaults, paymentRequest);
      };

      /**
       * Validates your merchant website, as required by `ApplePaySession` before payment can be authorized.
       * @public
       * @param {object} options Options
       * @param {string} options.validationURL The validationURL from an `ApplePayValidateMerchantEvent`.
       * @param {string} options.displayName The canonical name for your store. Use a non-localized name. This parameter should be a UTF-8 string that is a maximum of 64 characters. The system may display this name to the user.
       * @param {callback} [callback] The second argument, <code>data</code>, is the Apple Pay merchant session object. If no callback is provided, `performValidation` returns a promise.
       * Pass the merchant session to your Apple Pay session's `completeMerchantValidation` method.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var applePay = require('braintree-web/apple-pay');
       *
       * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
       *   if (applePayErr) {
       *     // Handle error here
       *     return;
       *   }
       *
       *   var paymentRequest = applePayInstance.createPaymentRequest({
       *     total: {
       *       label: 'My Company',
       *       amount: '19.99'
       *     }
       *   });
       *   var session = new ApplePaySession(3, paymentRequest);
       *
       *   session.onvalidatemerchant = function (event) {
       *     applePayInstance.performValidation({
       *       validationURL: event.validationURL,
       *       displayName: 'My Great Store'
       *     }, function (validationErr, validationData) {
       *       if (validationErr) {
       *         console.error(validationErr);
       *         session.abort();
       *         return;
       *       }
       *
       *       session.completeMerchantValidation(validationData);
       *     });
       *   };
       * });
       */
      ApplePay.prototype.performValidation = function (options) {
        var self = this;
        if (!options || !options.validationURL) {
          return Promise.reject(new BraintreeError(errors.APPLE_PAY_VALIDATION_URL_REQUIRED));
        }
        return this._waitForClient().then(function () {
          var applePayWebSession = {
            validationUrl: options.validationURL,
            domainName: options.domainName || window.location.hostname,
            merchantIdentifier: options.merchantIdentifier || self.merchantIdentifier
          };
          if (options.displayName != null) {
            applePayWebSession.displayName = options.displayName;
          }
          return self._client.request({
            method: "post",
            endpoint: "apple_pay_web/sessions",
            data: {
              _meta: {
                source: "apple-pay"
              },
              applePayWebSession: applePayWebSession
            }
          });
        }).then(function (response) {
          analytics.sendEvent(self._client, "applepay.performValidation.succeeded");
          return Promise.resolve(response);
        }).catch(function (err) {
          analytics.sendEvent(self._client, "applepay.performValidation.failed");
          if (err.code === "CLIENT_REQUEST_ERROR") {
            return Promise.reject(new BraintreeError({
              type: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.type,
              code: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.code,
              message: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.message,
              details: {
                originalError: err.details.originalError
              }
            }));
          }
          return Promise.reject(new BraintreeError({
            type: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.type,
            code: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.code,
            message: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.message,
            details: {
              originalError: err
            }
          }));
        });
      };

      /**
       * Tokenizes an Apple Pay payment. This will likely be called in your `ApplePaySession`'s `onpaymentauthorized` callback.
       * @public
       * @param {object} options Options
       * @param {object} options.token The `payment.token` property of an {@link external:ApplePayPaymentAuthorizedEvent}.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ApplePay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link ApplePay~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var applePay = require('braintree-web/apple-pay');
       *
       * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
       *   if (applePayErr) {
       *     // Handle error here
       *     return;
       *   }
       *
       *   var paymentRequest = applePayInstance.createPaymentRequest({
       *     total: {
       *       label: 'My Company',
       *       amount: '19.99'
       *     }
       *   });
       *   var session = new ApplePaySession(3, paymentRequest);
       *
       *   session.onpaymentauthorized = function (event) {
       *     applePayInstance.tokenize({
       *       token: event.payment.token
       *     }, function (tokenizeErr, tokenizedPayload) {
       *       if (tokenizeErr) {
       *         session.completePayment(ApplePaySession.STATUS_FAILURE);
       *         return;
       *       }
       *       // Send the tokenizedPayload to your server here!
       *
       *       // Once the transaction is complete, call completePayment
       *       // to close the Apple Pay sheet
       *       session.completePayment(ApplePaySession.STATUS_SUCCESS);
       *     });
       *   };
       *
       *   // ...
       * });
       */
      ApplePay.prototype.tokenize = function (options) {
        var self = this;
        if (!options.token) {
          return Promise.reject(new BraintreeError(errors.APPLE_PAY_PAYMENT_TOKEN_REQUIRED));
        }
        return this._waitForClient().then(function () {
          return self._client.request({
            method: "post",
            endpoint: "payment_methods/apple_payment_tokens",
            data: {
              _meta: {
                source: "apple-pay"
              },
              applePaymentToken: Object.assign({}, options.token, {
                // The gateway requires this key to be base64-encoded.
                paymentData: btoa(JSON.stringify(options.token.paymentData))
              })
            }
          });
        }).then(function (response) {
          analytics.sendEvent(self._client, "applepay.tokenize.succeeded");
          return Promise.resolve(response.applePayCards[0]);
        }).catch(function (err) {
          analytics.sendEvent(self._client, "applepay.tokenize.failed");
          return Promise.reject(new BraintreeError({
            type: errors.APPLE_PAY_TOKENIZATION.type,
            code: errors.APPLE_PAY_TOKENIZATION.code,
            message: errors.APPLE_PAY_TOKENIZATION.message,
            details: {
              originalError: err
            }
          }));
        });
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/apple-pay.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * applePayInstance.teardown();
       * @example <caption>With callback</caption>
       * applePayInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      ApplePay.prototype.teardown = function () {
        convertMethodsToError(this, methods(ApplePay.prototype));
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(ApplePay);
    }, {
      "../lib/analytics": 135,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/methods": 172,
      "./errors": 89,
      "@braintree/wrap-promise": 40
    }],
    89: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Apple Pay - Creation Error Codes
       * @description Errors that occur when [creating the Apple Pay component](./module-braintree-web_apple-pay.html#.create).
       * @property {MERCHANT} APPLE_PAY_NOT_ENABLED Occurs when the authorization used is not authorized to process Apple Pay.
       */

      /**
       * @name BraintreeError.Apple Pay - performValidation Error Codes
       * @description Errors that occur when [validating](./ApplePay.html#performValidation).
       * @property {MERCHANT} APPLE_PAY_VALIDATION_URL_REQUIRED Occurs when the `validationURL` option is not passed in.
       * @property {MERCHANT} APPLE_PAY_MERCHANT_VALIDATION_FAILED Occurs when the website domain has not been registered in the Braintree control panel.
       * @property {NETWORK} APPLE_PAY_MERCHANT_VALIDATION_NETWORK Occurs when an unknown network error occurs.
       */

      /**
       * @name BraintreeError.Apple Pay - tokenize Error Codes
       * @description Errors that occur when [tokenizing](./ApplePay.html#tokenize).
       * @property {MERCHANT} APPLE_PAY_PAYMENT_TOKEN_REQUIRED Occurs when the `token` option is not passed in.
       * @property {NETWORK} APPLE_PAY_TOKENIZATION Occurs when an unknown network error occurs.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        APPLE_PAY_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "APPLE_PAY_NOT_ENABLED",
          message: "Apple Pay is not enabled for this merchant."
        },
        APPLE_PAY_VALIDATION_URL_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "APPLE_PAY_VALIDATION_URL_REQUIRED",
          message: "performValidation must be called with a validationURL."
        },
        APPLE_PAY_MERCHANT_VALIDATION_NETWORK: {
          type: BraintreeError.types.NETWORK,
          code: "APPLE_PAY_MERCHANT_VALIDATION_NETWORK",
          message: "A network error occurred when validating the Apple Pay merchant."
        },
        APPLE_PAY_MERCHANT_VALIDATION_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "APPLE_PAY_MERCHANT_VALIDATION_FAILED",
          message: "Make sure you have registered your domain name in the Braintree Control Panel."
        },
        APPLE_PAY_PAYMENT_TOKEN_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "APPLE_PAY_PAYMENT_TOKEN_REQUIRED",
          message: "tokenize must be called with a payment token."
        },
        APPLE_PAY_TOKENIZATION: {
          type: BraintreeError.types.NETWORK,
          code: "APPLE_PAY_TOKENIZATION",
          message: "A network error occurred when processing the Apple Pay payment."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    90: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/apple-pay
       * @description Accept Apple Pay on the Web. *This component is currently in beta and is subject to change.*
       */
      var ApplePay = _dereq_("./apple-pay");
      var analytics = _dereq_("../lib/analytics");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var errors = _dereq_("./errors");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Apple Pay instance to be available right away by fetching the client configuration in the background. When this option is used, {@link ApplePay#createPaymentRequest} will return a promise that resolves with the configuration instead of returning synchronously.
       * @param {callback} [callback] The second argument, `data`, is the {@link ApplePay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link ApplePay} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "Apple Pay";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var applePayInstance;
          var createPromise = createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          }).then(function (client) {
            if (!client.getConfiguration().gatewayConfiguration.applePayWeb) {
              return Promise.reject(new BraintreeError(errors.APPLE_PAY_NOT_ENABLED));
            }
            analytics.sendEvent(client, "applepay.initialized");
            return client;
          });
          options.createPromise = createPromise;
          applePayInstance = new ApplePay(options);
          if (!options.useDeferredClient) {
            return createPromise.then(function (client) {
              applePayInstance._client = client;
              return applePayInstance;
            });
          }
          return applePayInstance;
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./apple-pay": 88,
      "./errors": 89,
      "@braintree/wrap-promise": 40
    }],
    91: [function (_dereq_, module, exports) {
      "use strict";

      var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
      var GraphQL = _dereq_("./request/graphql");
      var request = _dereq_("./request");
      var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
      var getGatewayConfiguration = _dereq_("./get-configuration").getConfiguration;
      var createAuthorizationData = _dereq_("../lib/create-authorization-data");
      var metadata = _dereq_("../lib/add-metadata");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var once = _dereq_("../lib/once");
      var deferred = _dereq_("../lib/deferred");
      var assign = _dereq_("../lib/assign").assign;
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./errors");
      var VERSION = _dereq_("../lib/constants").VERSION;
      var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var assets = _dereq_("../lib/assets");
      var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
      var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
      var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
      var cachedClients = {};

      /**
       * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
       * @typedef {object} Client~configuration
       * @property {object} client The braintree-web/client parameters.
       * @property {string} client.authorization A tokenizationKey or clientToken.
       * @property {object} gatewayConfiguration Gateway-supplied configuration.
       * @property {object} analyticsMetadata Analytics-specific data.
       * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
       * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
       * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
       */

      /**
       * @class
       * @param {Client~configuration} configuration Options
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
       * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
       */
      function Client(configuration) {
        var configurationJSON, gatewayConfiguration;
        configuration = configuration || {};
        configurationJSON = JSON.stringify(configuration);
        gatewayConfiguration = configuration.gatewayConfiguration;
        if (!gatewayConfiguration) {
          throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
        }
        ["assetsUrl", "clientApiUrl", "configUrl"].forEach(function (property) {
          if (property in gatewayConfiguration && !isVerifiedDomain(gatewayConfiguration[property])) {
            throw new BraintreeError({
              type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
              code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
              message: property + " property is on an invalid domain."
            });
          }
        });

        /**
         * Returns a copy of the configuration values.
         * @public
         * @returns {Client~configuration} configuration
         */
        this.getConfiguration = function () {
          return JSON.parse(configurationJSON);
        };
        this._request = request;
        this._configuration = this.getConfiguration();
        this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + "/v1/";
        if (gatewayConfiguration.graphQL) {
          if (!isVerifiedDomain(gatewayConfiguration.graphQL.url)) {
            throw new BraintreeError({
              type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
              code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
              message: "graphQL.url property is on an invalid domain."
            });
          }
          this._graphQL = new GraphQL({
            graphQL: gatewayConfiguration.graphQL
          });
        }
      }
      Client.initialize = function (options) {
        var clientInstance, authData;
        var promise = cachedClients[options.authorization];
        if (promise) {
          analytics.sendEvent(promise, "custom.client.load.cached");
          return promise;
        }
        try {
          authData = createAuthorizationData(options.authorization);
        } catch (err) {
          return Promise.reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));
        }
        promise = getGatewayConfiguration(authData, options.sessionId).then(function (configuration) {
          if (options.debug) {
            configuration.isDebug = true;
          }
          configuration.authorization = options.authorization;
          clientInstance = new Client(configuration);
          return clientInstance;
        });
        cachedClients[options.authorization] = promise;
        analytics.sendEvent(promise, "custom.client.load.initialized");
        return promise.then(function (client) {
          analytics.sendEvent(clientInstance, "custom.client.load.succeeded");
          return client;
        }).catch(function (err) {
          delete cachedClients[options.authorization];
          return Promise.reject(err);
        });
      };

      // Primarily used for testing the client initalization call
      Client.clearCache = function () {
        cachedClients = {};
      };
      Client.prototype._findOrCreateFraudnetJSON = function (clientMetadataId) {
        var el = document.querySelector('script[fncls="' + FRAUDNET_FNCLS + '"]');
        var config, additionalData, authorizationFingerprint, parameters;
        if (!el) {
          el = document.body.appendChild(document.createElement("script"));
          el.type = "application/json";
          el.setAttribute("fncls", FRAUDNET_FNCLS);
        }
        config = this.getConfiguration();
        additionalData = {
          rda_tenant: "bt_card",
          // eslint-disable-line camelcase
          mid: config.gatewayConfiguration.merchantId
        };
        authorizationFingerprint = config.authorizationFingerprint;
        if (authorizationFingerprint) {
          authorizationFingerprint.split("&").forEach(function (pieces) {
            var component = pieces.split("=");
            if (component[0] === "customer_id" && component.length > 1) {
              additionalData.cid = component[1];
            }
          });
        }
        parameters = {
          f: clientMetadataId.substr(0, 32),
          fp: additionalData,
          bu: false,
          s: FRAUDNET_SOURCE
        };
        el.text = JSON.stringify(parameters);
      };

      /**
       * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
       * @public
       * @param {object} options Request options:
       * @param {string} options.method HTTP method, e.g. "get" or "post".
       * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
       * @param {object} options.data Data to send with the request.
       * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
       * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
       * @example
       * <caption>Direct Credit Card Tokenization</caption>
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   var form = document.getElementById('my-form-id');
       *   var data = {
       *     creditCard: {
       *       number: form['cc-number'].value,
       *       cvv: form['cc-cvv'].value,
       *       expirationDate: form['cc-expiration-date'].value,
       *       billingAddress: {
       *         postalCode: form['cc-postal-code'].value
       *       },
       *       options: {
       *         validate: false
       *       }
       *     }
       *   };
       *
       *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
       *   // payment fields cannot be hosted on your checkout page.
       *   // For an alternative to the following, use Hosted Fields.
       *   clientInstance.request({
       *     endpoint: 'payment_methods/credit_cards',
       *     method: 'post',
       *     data: data
       *   }, function (requestErr, response) {
       *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
       *     if (requestErr) { throw new Error(requestErr); }
       *
       *     console.log('Got nonce:', response.creditCards[0].nonce);
       *   });
       * });
       * @example
       * <caption>Tokenizing Fields for AVS Checks</caption>
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   var form = document.getElementById('my-form-id');
       *   var data = {
       *     creditCard: {
       *       number: form['cc-number'].value,
       *       cvv: form['cc-cvv'].value,
       *       expirationDate: form['cc-date'].value,
       *       // The billing address can be checked with AVS rules.
       *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
       *       billingAddress: {
       *         postalCode: form['cc-postal-code'].value,
       *         streetAddress: form['cc-street-address'].value,
       *         countryName: form['cc-country-name'].value,
       *         countryCodeAlpha2: form['cc-country-alpha2'].value,
       *         countryCodeAlpha3: form['cc-country-alpha3'].value,
       *         countryCodeNumeric: form['cc-country-numeric'].value
       *       },
       *       options: {
       *         validate: false
       *       }
       *     }
       *   };
       *
       *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
       *   // payment fields cannot be hosted on your checkout page.
       *   // For an alternative to the following, use Hosted Fields.
       *   clientInstance.request({
       *     endpoint: 'payment_methods/credit_cards',
       *     method: 'post',
       *     data: data
       *   }, function (requestErr, response) {
       *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
       *     if (requestErr) { throw new Error(requestErr); }
       *
       *     console.log('Got nonce:', response.creditCards[0].nonce);
       *   });
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Client.prototype.request = function (options, callback) {
        var self = this; // eslint-disable-line no-invalid-this
        var requestPromise = new Promise(function (resolve, reject) {
          var optionName, api, baseUrl, requestOptions;
          var shouldCollectData = Boolean(options.endpoint === "payment_methods/credit_cards" && self.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);
          if (options.api !== "graphQLApi") {
            if (!options.method) {
              optionName = "options.method";
            } else if (!options.endpoint) {
              optionName = "options.endpoint";
            }
          }
          if (optionName) {
            throw new BraintreeError({
              type: errors.CLIENT_OPTION_REQUIRED.type,
              code: errors.CLIENT_OPTION_REQUIRED.code,
              message: optionName + " is required when making a request."
            });
          }
          if ("api" in options) {
            api = options.api;
          } else {
            api = "clientApi";
          }
          requestOptions = {
            method: options.method,
            graphQL: self._graphQL,
            timeout: options.timeout,
            metadata: self._configuration.analyticsMetadata
          };
          if (api === "clientApi") {
            baseUrl = self._clientApiBaseUrl;
            requestOptions.data = metadata.addMetadata(self._configuration, options.data);
          } else if (api === "graphQLApi") {
            baseUrl = GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
            options.endpoint = "";
            requestOptions.method = "post";
            requestOptions.data = assign({
              clientSdkMetadata: {
                platform: self._configuration.analyticsMetadata.platform,
                source: self._configuration.analyticsMetadata.source,
                integration: self._configuration.analyticsMetadata.integration,
                sessionId: self._configuration.analyticsMetadata.sessionId,
                version: VERSION
              }
            }, options.data);
            requestOptions.headers = getAuthorizationHeadersForGraphQL(self._configuration);
          } else {
            throw new BraintreeError({
              type: errors.CLIENT_OPTION_INVALID.type,
              code: errors.CLIENT_OPTION_INVALID.code,
              message: "options.api is invalid."
            });
          }
          requestOptions.url = baseUrl + options.endpoint;
          requestOptions.sendAnalyticsEvent = function (kind) {
            analytics.sendEvent(self, kind);
          };
          self._request(requestOptions, function (err, data, status) {
            var resolvedData, requestError;
            requestError = formatRequestError(status, err);
            if (requestError) {
              reject(requestError);
              return;
            }
            if (api === "graphQLApi" && data.errors) {
              reject(convertToBraintreeError(data.errors, {
                type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
                code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
                message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message
              }));
              return;
            }
            resolvedData = assign({
              _httpStatus: status
            }, data);
            if (shouldCollectData && resolvedData.creditCards && resolvedData.creditCards.length > 0) {
              self._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);
              assets.loadScript({
                src: FRAUDNET_URL,
                forceScriptReload: true
              });
            }
            resolve(resolvedData);
          });
        });
        if (typeof callback === "function") {
          callback = once(deferred(callback));
          requestPromise.then(function (response) {
            callback(null, response, response._httpStatus);
          }).catch(function (err) {
            var status = err && err.details && err.details.httpStatus;
            callback(err, null, status);
          });
          return;
        }
        return requestPromise; // eslint-disable-line consistent-return
      };

      // eslint-disable-next-line consistent-return
      function formatRequestError(status, err) {
        var requestError;
        if (status === -1) {
          requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
        } else if (status === 401) {
          requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INVALID);
        } else if (status === 403) {
          requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
        } else if (status === 429) {
          requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
        } else if (status >= 500) {
          requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
        } else if (status < 200 || status >= 400) {
          requestError = convertToBraintreeError(err, {
            type: errors.CLIENT_REQUEST_ERROR.type,
            code: errors.CLIENT_REQUEST_ERROR.code,
            message: errors.CLIENT_REQUEST_ERROR.message
          });
        }
        if (requestError) {
          requestError.details = requestError.details || {};
          requestError.details.httpStatus = status;
          return requestError;
        }
      }
      Client.prototype.toJSON = function () {
        return this.getConfiguration();
      };

      /**
       * Returns the Client version.
       * @public
       * @returns {String} The created client's version.
       * @example
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
       * });
       * @returns {void}
       */
      Client.prototype.getVersion = function () {
        return VERSION;
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * clientInstance.teardown();
       * @example <caption>With callback</caption>
       * clientInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Client.prototype.teardown = wrapPromise(function () {
        var self = this; // eslint-disable-line no-invalid-this

        delete cachedClients[self.getConfiguration().authorization];
        convertMethodsToError(self, methods(Client.prototype));
        return Promise.resolve();
      });
      function getAuthorizationHeadersForGraphQL(configuration) {
        var token = configuration.authorizationFingerprint || configuration.authorization;
        return {
          Authorization: "Bearer " + token,
          "Braintree-Version": BRAINTREE_VERSION
        };
      }
      module.exports = Client;
    }, {
      "../lib/add-metadata": 134,
      "../lib/analytics": 135,
      "../lib/assets": 136,
      "../lib/assign": 137,
      "../lib/braintree-error": 140,
      "../lib/constants": 142,
      "../lib/convert-methods-to-error": 143,
      "../lib/convert-to-braintree-error": 144,
      "../lib/create-authorization-data": 146,
      "../lib/deferred": 148,
      "../lib/is-verified-domain": 170,
      "../lib/methods": 172,
      "../lib/once": 173,
      "./constants": 92,
      "./errors": 93,
      "./get-configuration": 94,
      "./request": 107,
      "./request/graphql": 105,
      "@braintree/wrap-promise": 40
    }],
    92: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        BRAINTREE_VERSION: "2018-05-10"
      };
    }, {}],
    93: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Client - Internal Error Codes
       * @ignore
       * @description These codes should never be experienced by the merchant directly.
       * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
       * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
       */

      /**
       * @name BraintreeError.Client - Create Error Codes
       * @description Errors that may occur when [creating the client](./module-braintree-web_client.html#.create)
       * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
       */

      /**
       * @name BraintreeError.Client - Request Error Codes
       * @description Errors that may occur when [using the request method](./Client.html#request)
       * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
       * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
       * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
       * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
       * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
       * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
       * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
       * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user associated with the client token or tokenization key does not have permissions to make the request.
       * @property {MERCHANT} CLIENT_AUTHORIZATION_INVALID The provided authorization could not be found. Either the client token has expired and a new client token must be generated or the tokenization key used is set to be inactive or has been deleted.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN"
        },
        CLIENT_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_OPTION_REQUIRED"
        },
        CLIENT_OPTION_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_OPTION_INVALID"
        },
        CLIENT_MISSING_GATEWAY_CONFIGURATION: {
          type: BraintreeError.types.INTERNAL,
          code: "CLIENT_MISSING_GATEWAY_CONFIGURATION",
          message: "Missing gatewayConfiguration."
        },
        CLIENT_INVALID_AUTHORIZATION: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_INVALID_AUTHORIZATION",
          message: "Authorization is invalid. Make sure your client token or tokenization key is valid."
        },
        CLIENT_GATEWAY_NETWORK: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_GATEWAY_NETWORK",
          message: "Cannot contact the gateway at this time."
        },
        CLIENT_REQUEST_TIMEOUT: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_REQUEST_TIMEOUT",
          message: "Request timed out waiting for a reply."
        },
        CLIENT_REQUEST_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_REQUEST_ERROR",
          message: "There was a problem with your request."
        },
        CLIENT_GRAPHQL_REQUEST_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_GRAPHQL_REQUEST_ERROR",
          message: "There was a problem with your request."
        },
        CLIENT_RATE_LIMITED: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_RATE_LIMITED",
          message: "You are being rate-limited; please try again in a few minutes."
        },
        CLIENT_AUTHORIZATION_INSUFFICIENT: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_AUTHORIZATION_INSUFFICIENT",
          message: "The authorization used has insufficient privileges."
        },
        CLIENT_AUTHORIZATION_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_AUTHORIZATION_INVALID",
          message: "Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    94: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var request = _dereq_("./request");
      var uuid = _dereq_("@braintree/uuid");
      var constants = _dereq_("../lib/constants");
      var errors = _dereq_("./errors");
      var GraphQL = _dereq_("./request/graphql");
      var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
      var isDateStringBeforeOrOn = _dereq_("../lib/is-date-string-before-or-on");
      var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
      function getConfiguration(authData, inputSessionId) {
        return new Promise(function (resolve, reject) {
          var configuration, attrs, configUrl, reqOptions;
          var sessionId = inputSessionId || uuid();
          var analyticsMetadata = {
            merchantAppId: window.location.host,
            platform: constants.PLATFORM,
            sdkVersion: constants.VERSION,
            source: constants.SOURCE,
            // NEXT_MAJOR_VERSION remove one of these to not duplicate data. Target parity with mobile platforms approach.
            integration: constants.INTEGRATION,
            integrationType: constants.INTEGRATION,
            sessionId: sessionId
          };
          attrs = authData.attrs;
          configUrl = authData.configUrl;
          attrs._meta = analyticsMetadata;
          attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
          attrs.configVersion = "3";
          reqOptions = {
            url: configUrl,
            method: "GET",
            data: attrs
          };
          if (attrs.authorizationFingerprint && authData.graphQL) {
            if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) {
              reqOptions.graphQL = new GraphQL({
                graphQL: {
                  url: authData.graphQL.url,
                  features: ["configuration"]
                }
              });
            }
            reqOptions.metadata = analyticsMetadata;
          } else if (attrs.tokenizationKey) {
            reqOptions.graphQL = new GraphQL({
              graphQL: {
                url: GRAPHQL_URLS[authData.environment],
                features: ["configuration"]
              }
            });
            reqOptions.metadata = analyticsMetadata;
          }
          request(reqOptions, function (err, response, status) {
            var errorTemplate;
            if (err) {
              if (status === 403) {
                errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
              } else if (status === 401) {
                errorTemplate = errors.CLIENT_AUTHORIZATION_INVALID;
              } else {
                errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
              }
              reject(new BraintreeError({
                type: errorTemplate.type,
                code: errorTemplate.code,
                message: errorTemplate.message,
                details: {
                  originalError: err
                }
              }));
              return;
            }
            configuration = {
              authorizationType: attrs.tokenizationKey ? "TOKENIZATION_KEY" : "CLIENT_TOKEN",
              authorizationFingerprint: attrs.authorizationFingerprint,
              analyticsMetadata: analyticsMetadata,
              gatewayConfiguration: response
            };
            resolve(configuration);
          });
        });
      }
      module.exports = {
        getConfiguration: wrapPromise(getConfiguration)
      };
    }, {
      "../lib/braintree-error": 140,
      "../lib/constants": 142,
      "../lib/is-date-string-before-or-on": 167,
      "./constants": 92,
      "./errors": 93,
      "./request": 107,
      "./request/graphql": 105,
      "@braintree/uuid": 36,
      "@braintree/wrap-promise": 40
    }],
    95: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var Client = _dereq_("./client");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var sharedErrors = _dereq_("../lib/errors");

      /** @module braintree-web/client */

      /**
       * @function create
       * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
       * @param {object} options Object containing all {@link Client} options:
       * @param {string} options.authorization A tokenizationKey or clientToken.
       * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   if (createErr) {
       *     if (createErr.code === 'CLIENT_AUTHORIZATION_INVALID') {
       *       // either the client token has expired, and a new one should be generated
       *       // or the tokenization key was deactivated or deleted
       *     } else {
       *       console.log('something went wrong creating the client instance', createErr);
       *     }
       *     return;
       *   }
       *
       *  // set up other components
       * });
       * @static
       */
      function create(options) {
        if (!options.authorization) {
          return Promise.reject(new BraintreeError({
            type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
            code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
            message: "options.authorization is required when instantiating a client."
          }));
        }
        return Client.initialize(options);
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/braintree-error": 140,
      "../lib/errors": 151,
      "./client": 91,
      "@braintree/wrap-promise": 40
    }],
    96: [function (_dereq_, module, exports) {
      "use strict";

      var querystring = _dereq_("../../lib/querystring");
      var assign = _dereq_("../../lib/assign").assign;
      var prepBody = _dereq_("./prep-body");
      var parseBody = _dereq_("./parse-body");
      var xhr = _dereq_("./xhr");
      var isXHRAvailable = xhr.isAvailable;
      var GraphQLRequest = _dereq_("./graphql/request");
      var DefaultRequest = _dereq_("./default-request");
      var MAX_TCP_RETRYCOUNT = 1;
      var TCP_PRECONNECT_BUG_STATUS_CODE = 408;
      function requestShouldRetry(status) {
        return !status || status === TCP_PRECONNECT_BUG_STATUS_CODE;
      }
      function graphQLRequestShouldRetryWithClientApi(body) {
        var errorClass = !body.data && body.errors && body.errors[0] && body.errors[0].extensions && body.errors[0].extensions.errorClass;
        return errorClass === "UNKNOWN" || errorClass === "INTERNAL";
      }
      function _requestWithRetry(options, tcpRetryCount, cb) {
        var status, resBody, ajaxRequest, body, method, headers, parsedBody;
        var url = options.url;
        var graphQL = options.graphQL;
        var timeout = options.timeout;
        var req = xhr.getRequestObject();
        var callback = cb;
        var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));
        options.headers = assign({
          "Content-Type": "application/json"
        }, options.headers);
        if (isGraphQLRequest) {
          ajaxRequest = new GraphQLRequest(options);
        } else {
          ajaxRequest = new DefaultRequest(options);
        }
        url = ajaxRequest.getUrl();
        body = ajaxRequest.getBody();
        method = ajaxRequest.getMethod();
        headers = ajaxRequest.getHeaders();
        if (method === "GET") {
          url = querystring.queryify(url, body);
          body = null;
        }
        if (isXHRAvailable) {
          req.onreadystatechange = function () {
            if (req.readyState !== 4) {
              return;
            }
            if (req.status === 0 && isGraphQLRequest) {
              // If a merchant experiences a connection
              // issue to the GraphQL endpoint (possibly
              // due to a Content Security Policy), retry
              // the request against the old client API.
              delete options.graphQL;
              _requestWithRetry(options, tcpRetryCount, cb);
              return;
            }
            parsedBody = parseBody(req.responseText);
            resBody = ajaxRequest.adaptResponseBody(parsedBody);
            status = ajaxRequest.determineStatus(req.status, parsedBody);
            if (status >= 400 || status < 200) {
              if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
                delete options.graphQL;
                _requestWithRetry(options, tcpRetryCount, cb);
                return;
              }
              if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
                tcpRetryCount++;
                _requestWithRetry(options, tcpRetryCount, cb);
                return;
              }
              callback(resBody || "error", null, status || 500);
            } else {
              callback(null, resBody, status);
            }
          };
        } else {
          if (options.headers) {
            url = querystring.queryify(url, headers);
          }
          req.onload = function () {
            callback(null, parseBody(req.responseText), req.status);
          };
          req.onerror = function () {
            // XDomainRequest does not report a body or status for errors, so
            // hardcode to 'error' and 500, respectively
            callback("error", null, 500);
          };

          // This must remain for IE9 to work
          req.onprogress = function () {};
          req.ontimeout = function () {
            callback("timeout", null, -1);
          };
        }
        try {
          req.open(method, url, true);
        } catch (requestOpenError) {
          // If a merchant has a Content Security Policy and they have
          // not allowed our endpoints, some browsers may
          // synchronously throw an error. If it is not a GraphQL
          // request, we throw the error. If it is a GraphQL request
          // we remove the GraphQL option and try the request against
          // the old client API.
          if (!isGraphQLRequest) {
            throw requestOpenError;
          }
          delete options.graphQL;
          _requestWithRetry(options, tcpRetryCount, cb);
          return;
        }
        req.timeout = timeout;
        if (isXHRAvailable) {
          Object.keys(headers).forEach(function (headerKey) {
            req.setRequestHeader(headerKey, headers[headerKey]);
          });
        }
        try {
          req.send(prepBody(method, body));
        } catch (e) {
          /* ignored */
        }
      }
      function request(options, cb) {
        _requestWithRetry(options, 0, cb);
      }
      module.exports = {
        request: request
      };
    }, {
      "../../lib/assign": 137,
      "../../lib/querystring": 174,
      "./default-request": 97,
      "./graphql/request": 106,
      "./parse-body": 108,
      "./prep-body": 109,
      "./xhr": 110
    }],
    97: [function (_dereq_, module, exports) {
      "use strict";

      function DefaultRequest(options) {
        this._url = options.url;
        this._data = options.data;
        this._method = options.method;
        this._headers = options.headers;
      }
      DefaultRequest.prototype.getUrl = function () {
        return this._url;
      };
      DefaultRequest.prototype.getBody = function () {
        return this._data;
      };
      DefaultRequest.prototype.getMethod = function () {
        return this._method;
      };
      DefaultRequest.prototype.getHeaders = function () {
        return this._headers;
      };
      DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
        return parsedBody;
      };
      DefaultRequest.prototype.determineStatus = function (status) {
        return status;
      };
      module.exports = DefaultRequest;
    }, {}],
    98: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var assign = _dereq_("../../../../lib/assign").assign;

      /* eslint-disable camelcase */
      var cardTypeTransforms = {
        creditCard: {
          AMERICAN_EXPRESS: "American Express",
          DISCOVER: "Discover",
          INTERNATIONAL_MAESTRO: "Maestro",
          JCB: "JCB",
          MASTERCARD: "MasterCard",
          SOLO: "Solo",
          UK_MAESTRO: "UK Maestro",
          UNION_PAY: "UnionPay",
          VISA: "Visa",
          ELO: "Elo",
          HIPER: "Hiper",
          HIPERCARD: "Hipercard"
        },
        applePayWeb: {
          VISA: "visa",
          MASTERCARD: "mastercard",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          INTERNATIONAL_MAESTRO: "maestro",
          ELO: "elo"
        },
        visaCheckout: {
          VISA: "Visa",
          MASTERCARD: "MasterCard",
          DISCOVER: "Discover",
          AMERICAN_EXPRESS: "American Express"
        },
        googlePay: {
          VISA: "visa",
          MASTERCARD: "mastercard",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          INTERNATIONAL_MAESTRO: "maestro",
          ELO: "elo"
        },
        masterpass: {
          VISA: "visa",
          MASTERCARD: "master",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          DINERS: "diners",
          INTERNATIONAL_MAESTRO: "maestro",
          JCB: "jcb"
        }
      };
      /* eslint-enable camelcase */

      function configurationResponseAdapter(responseBody, ctx) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptConfigurationResponseBody(body, ctx) {
        var configuration = body.data.clientConfiguration;
        var response;
        response = {
          environment: configuration.environment.toLowerCase(),
          clientApiUrl: configuration.clientApiUrl,
          assetsUrl: configuration.assetsUrl,
          analytics: {
            url: configuration.analyticsUrl
          },
          merchantId: configuration.merchantId,
          venmo: "off"
        };
        if (configuration.supportedFeatures) {
          response.graphQL = {
            url: ctx._graphQL._config.url,
            features: configuration.supportedFeatures.map(function (feature) {
              return feature.toLowerCase();
            })
          };
        }
        if (configuration.braintreeApi) {
          response.braintreeApi = configuration.braintreeApi;
        }
        if (configuration.applePayWeb) {
          response.applePayWeb = configuration.applePayWeb;
          response.applePayWeb.supportedNetworks = mapCardTypes(configuration.applePayWeb.supportedCardBrands, cardTypeTransforms.applePayWeb);
          delete response.applePayWeb.supportedCardBrands;
        }
        if (configuration.fastlane) {
          response.fastlane = configuration.fastlane;
        }
        if (configuration.ideal) {
          response.ideal = configuration.ideal;
        }
        if (configuration.creditCard) {
          response.challenges = configuration.creditCard.challenges.map(function (challenge) {
            return challenge.toLowerCase();
          });
          response.creditCards = {
            supportedCardTypes: mapCardTypes(configuration.creditCard.supportedCardBrands, cardTypeTransforms.creditCard)
          };
          response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
          response.threeDSecure = configuration.creditCard.threeDSecure;
        } else {
          response.challenges = [];
          response.creditCards = {
            supportedCardTypes: []
          };
          response.threeDSecureEnabled = false;
        }
        if (configuration.googlePay) {
          response.androidPay = {
            displayName: configuration.googlePay.displayName,
            enabled: true,
            environment: configuration.googlePay.environment.toLowerCase(),
            googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
            paypalClientId: configuration.googlePay.paypalClientId,
            supportedNetworks: mapCardTypes(configuration.googlePay.supportedCardBrands, cardTypeTransforms.googlePay)
          };
        }
        if (configuration.venmo) {
          response.payWithVenmo = {
            merchantId: configuration.venmo.merchantId,
            accessToken: configuration.venmo.accessToken,
            environment: configuration.venmo.environment.toLowerCase(),
            enrichedCustomerDataEnabled: configuration.venmo.enrichedCustomerDataEnabled
          };
        }
        if (configuration.paypal) {
          response.paypalEnabled = true;
          response.paypal = assign({}, configuration.paypal);
          response.paypal.currencyIsoCode = response.paypal.currencyCode;
          response.paypal.environment = response.paypal.environment.toLowerCase();
          delete response.paypal.currencyCode;
        } else {
          response.paypalEnabled = false;
        }
        if (configuration.unionPay) {
          response.unionPay = {
            enabled: true,
            merchantAccountId: configuration.unionPay.merchantAccountId
          };
        }
        if (configuration.visaCheckout) {
          response.visaCheckout = {
            apikey: configuration.visaCheckout.apiKey,
            encryptionKey: configuration.visaCheckout.encryptionKey,
            externalClientId: configuration.visaCheckout.externalClientId,
            supportedCardTypes: mapCardTypes(configuration.visaCheckout.supportedCardBrands, cardTypeTransforms.visaCheckout)
          };
        }
        if (configuration.masterpass) {
          response.masterpass = {
            merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
            supportedNetworks: mapCardTypes(configuration.masterpass.supportedCardBrands, cardTypeTransforms.masterpass)
          };
        }
        if (configuration.usBankAccount) {
          response.usBankAccount = {
            routeId: configuration.usBankAccount.routeId,
            plaid: {
              publicKey: configuration.usBankAccount.plaidPublicKey
            }
          };
        }
        return response;
      }
      function mapCardTypes(cardTypes, cardTypeTransformMap) {
        return cardTypes.reduce(function (acc, type) {
          if (cardTypeTransformMap.hasOwnProperty(type)) {
            return acc.concat(cardTypeTransformMap[type]);
          }
          return acc;
        }, []);
      }
      module.exports = configurationResponseAdapter;
    }, {
      "../../../../lib/assign": 137,
      "./error": 101
    }],
    99: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var CARD_BRAND_MAP = {
        /* eslint-disable camelcase */
        AMERICAN_EXPRESS: "American Express",
        DINERS: "Discover",
        DISCOVER: "Discover",
        ELO: "Elo",
        HIPER: "Hiper",
        HIPERCARD: "Hipercard",
        INTERNATIONAL_MAESTRO: "Maestro",
        JCB: "JCB",
        MASTERCARD: "MasterCard",
        UK_MAESTRO: "Maestro",
        UNION_PAY: "UnionPay",
        VISA: "Visa"
        /* eslint-enable camelcase */
      };
      var BIN_DATA_MAP = {
        YES: "Yes",
        NO: "No",
        UNKNOWN: "Unknown"
      };
      var AUTHENTICATION_INSIGHT_MAP = {
        PSDTWO: "psd2"
      };
      function creditCardTokenizationFastlaneResponseAdapter(responseBody) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptTokenizeCreditCardForFastlaneResponseBody(responseBody);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptTokenizeCreditCardForFastlaneResponseBody(body) {
        var data = body.data.tokenizeCreditCardForPayPalConnect;
        var creditCard = data.paymentMethod.details;
        var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
        var binData = creditCard.binData;
        var response, regulationEnvironment;
        if (binData) {
          ["commercial", "debit", "durbinRegulated", "healthcare", "payroll", "prepaid"].forEach(function (key) {
            if (binData[key]) {
              binData[key] = BIN_DATA_MAP[binData[key]];
            } else {
              binData[key] = "Unknown";
            }
          });
          ["issuingBank", "countryOfIssuance", "productId"].forEach(function (key) {
            if (!binData[key]) {
              binData[key] = "Unknown";
            }
          });
        }
        response = {
          creditCards: [{
            binData: binData,
            consumed: false,
            description: lastTwo ? "ending in " + lastTwo : "",
            nonce: data.paymentMethod.id,
            details: {
              cardholderName: creditCard.cardholderName,
              expirationMonth: creditCard.expirationMonth,
              expirationYear: creditCard.expirationYear,
              bin: creditCard.bin || "",
              cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
              lastFour: creditCard.last4 || "",
              lastTwo: lastTwo
            },
            type: "CreditCard",
            threeDSecureInfo: null
          }]
        };
        if (data.authenticationInsight) {
          regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
          response.creditCards[0].authenticationInsight = {
            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
          };
        }
        return response;
      }
      module.exports = creditCardTokenizationFastlaneResponseAdapter;
    }, {
      "./error": 101
    }],
    100: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var CARD_BRAND_MAP = {
        /* eslint-disable camelcase */
        AMERICAN_EXPRESS: "American Express",
        DINERS: "Discover",
        DISCOVER: "Discover",
        ELO: "Elo",
        HIPER: "Hiper",
        HIPERCARD: "Hipercard",
        INTERNATIONAL_MAESTRO: "Maestro",
        JCB: "JCB",
        MASTERCARD: "MasterCard",
        UK_MAESTRO: "Maestro",
        UNION_PAY: "UnionPay",
        VISA: "Visa"
        /* eslint-enable camelcase */
      };
      var BIN_DATA_MAP = {
        YES: "Yes",
        NO: "No",
        UNKNOWN: "Unknown"
      };
      var AUTHENTICATION_INSIGHT_MAP = {
        PSDTWO: "psd2"
      };
      function creditCardTokenizationResponseAdapter(responseBody) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptTokenizeCreditCardResponseBody(body) {
        var data = body.data.tokenizeCreditCard;
        var creditCard = data.creditCard;
        var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
        var binData = creditCard.binData;
        var response, regulationEnvironment;
        if (binData) {
          ["commercial", "debit", "durbinRegulated", "healthcare", "payroll", "prepaid"].forEach(function (key) {
            if (binData[key]) {
              binData[key] = BIN_DATA_MAP[binData[key]];
            } else {
              binData[key] = "Unknown";
            }
          });
          ["issuingBank", "countryOfIssuance", "productId"].forEach(function (key) {
            if (!binData[key]) {
              binData[key] = "Unknown";
            }
          });
        }
        response = {
          creditCards: [{
            binData: binData,
            consumed: false,
            description: lastTwo ? "ending in " + lastTwo : "",
            nonce: data.token,
            details: {
              cardholderName: creditCard.cardholderName,
              expirationMonth: creditCard.expirationMonth,
              expirationYear: creditCard.expirationYear,
              bin: creditCard.bin || "",
              cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
              lastFour: creditCard.last4 || "",
              lastTwo: lastTwo
            },
            type: "CreditCard",
            threeDSecureInfo: null
          }]
        };
        if (data.authenticationInsight) {
          regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
          response.creditCards[0].authenticationInsight = {
            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
          };
        }
        return response;
      }
      module.exports = creditCardTokenizationResponseAdapter;
    }, {
      "./error": 101
    }],
    101: [function (_dereq_, module, exports) {
      "use strict";

      function errorResponseAdapter(responseBody) {
        var response;
        var errorClass = responseBody.errors && responseBody.errors[0] && responseBody.errors[0].extensions && responseBody.errors[0].extensions.errorClass;
        if (errorClass === "VALIDATION") {
          response = userErrorResponseAdapter(responseBody);
        } else if (errorClass) {
          response = errorWithClassResponseAdapter(responseBody);
        } else {
          response = {
            error: {
              message: "There was a problem serving your request"
            },
            fieldErrors: []
          };
        }
        return response;
      }
      function errorWithClassResponseAdapter(responseBody) {
        return {
          error: {
            message: responseBody.errors[0].message
          },
          fieldErrors: []
        };
      }
      function userErrorResponseAdapter(responseBody) {
        var fieldErrors = buildFieldErrors(responseBody.errors);
        if (fieldErrors.length === 0) {
          return {
            error: {
              message: responseBody.errors[0].message
            }
          };
        }
        return {
          error: {
            message: getLegacyMessage(fieldErrors)
          },
          fieldErrors: fieldErrors
        };
      }
      function buildFieldErrors(errors) {
        var fieldErrors = [];
        errors.forEach(function (error) {
          if (!(error.extensions && error.extensions.inputPath)) {
            return;
          }
          addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
        });
        return fieldErrors;
      }
      function addFieldError(inputPath, errorDetail, fieldErrors) {
        var fieldError;
        var legacyCode = errorDetail.extensions.legacyCode;
        var inputField = inputPath[0];
        if (inputPath.length === 1) {
          fieldErrors.push({
            code: legacyCode,
            field: inputField,
            message: errorDetail.message
          });
          return;
        }
        fieldErrors.forEach(function (candidate) {
          if (candidate.field === inputField) {
            fieldError = candidate;
          }
        });
        if (!fieldError) {
          fieldError = {
            field: inputField,
            fieldErrors: []
          };
          fieldErrors.push(fieldError);
        }
        addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
      }
      function getLegacyMessage(errors) {
        var legacyMessages = {
          creditCard: "Credit card is invalid"
        };
        var field = errors[0].field;
        return legacyMessages[field];
      }
      module.exports = errorResponseAdapter;
    }, {}],
    102: [function (_dereq_, module, exports) {
      "use strict";

      var CONFIGURATION_QUERY = "query ClientConfiguration { " + "  clientConfiguration { " + "    analyticsUrl " + "    environment " + "    merchantId " + "    assetsUrl " + "    clientApiUrl " + "    creditCard { " + "      supportedCardBrands " + "      challenges " + "      threeDSecureEnabled " + "      threeDSecure { " + "        cardinalAuthenticationJWT " + "      } " + "    } " + "    applePayWeb { " + "      countryCode " + "      currencyCode " + "      merchantIdentifier " + "      supportedCardBrands " + "    } " + "    fastlane { " + "      enabled " + "    } " + "    googlePay { " + "      displayName " + "      supportedCardBrands " + "      environment " + "      googleAuthorization " + "      paypalClientId " + "    } " + "    ideal { " + "      routeId " + "      assetsUrl " + "    } " + "    masterpass { " + "      merchantCheckoutId " + "      supportedCardBrands " + "    } " + "    paypal { " + "      displayName " + "      clientId " + "      assetsUrl " + "      environment " + "      environmentNoNetwork " + "      unvettedMerchant " + "      braintreeClientId " + "      billingAgreementsEnabled " + "      merchantAccountId " + "      currencyCode " + "      payeeEmail " + "    } " + "    unionPay { " + "      merchantAccountId " + "    } " + "    usBankAccount { " + "      routeId " + "      plaidPublicKey " + "    } " + "    venmo { " + "      merchantId " + "      accessToken " + "      environment " + "      enrichedCustomerDataEnabled" + "    } " + "    visaCheckout { " + "      apiKey " + "      externalClientId " + "      supportedCardBrands " + "    } " + "    braintreeApi { " + "      accessToken " + "      url " + "    } " + "    supportedFeatures " + "  } " + "}";
      function configuration() {
        return {
          query: CONFIGURATION_QUERY,
          operationName: "ClientConfiguration"
        };
      }
      module.exports = configuration;
    }, {}],
    103: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../../../lib/assign").assign;
      function createMutation(config) {
        var hasAuthenticationInsight = config.hasAuthenticationInsight;
        var mutation = "mutation TokenizeCreditCardForPayPalConnect($input: TokenizeCreditCardForPayPalConnectInput!";
        if (hasAuthenticationInsight) {
          mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
        }
        mutation += ") { " + "  tokenizeCreditCardForPayPalConnect(input: $input) { " + "    clientMutationId " + "    paymentMethod { " + "      id " + "      details { " + "        ... on CreditCardDetails { " + "      bin " + "      brandCode " + "      last4 " + "      cardholderName " + "      expirationMonth" + "      expirationYear" + "      binData { " + "        prepaid " + "        healthcare " + "        debit " + "        durbinRegulated " + "        commercial " + "        payroll " + "        issuingBank " + "        countryOfIssuance " + "        productId " + "      } " + "        } " + "      } " + "    }";
        if (hasAuthenticationInsight) {
          mutation += "    authenticationInsight(input: $authenticationInsightInput) {" + "      customerAuthenticationRegulationEnvironment" + "    }";
        }
        mutation += "  } }";
        return mutation;
      }
      function createCreditCardForFastlaneTokenizationBody(body, options) {
        var creditCard = body.creditCard;
        var fastlane = creditCard.fastlane || {};
        var termsAndConditionsVersion = "fastlane" in creditCard && "termsAndConditionsVersion" in creditCard.fastlane && creditCard.fastlane.termsAndConditionsVersion;
        var email = creditCard.email;
        var optIn = "hasBuyerConsent" in fastlane && fastlane.hasBuyerConsent;
        var shippingAddress = creditCard.shippingAddress;
        var variables = createCreditCardTokenizationBody(body, options);
        var ccpcVariables = assign({}, variables.input, {
          email: email,
          optIn: optIn,
          phone: creditCard.phone,
          termsAndConditionsVersion: termsAndConditionsVersion
        });
        if ("authAssertion" in fastlane) {
          ccpcVariables.authAssertion = fastlane.authAssertion;
        }
        if (shippingAddress) {
          ccpcVariables.shippingAddress = shippingAddress;
        }
        return {
          input: ccpcVariables
        };
      }
      function createCreditCardTokenizationBody(body, options) {
        var cc = body.creditCard;
        var billingAddress = cc && cc.billingAddress;
        var expDate = cc && cc.expirationDate;
        var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
        var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
        var variables = {
          input: {
            creditCard: {
              number: cc && cc.number,
              expirationMonth: expirationMonth,
              expirationYear: expirationYear,
              cvv: cc && cc.cvv,
              cardholderName: cc && cc.cardholderName
            },
            options: {}
          }
        };
        if (options.hasAuthenticationInsight) {
          variables.authenticationInsightInput = {
            merchantAccountId: body.merchantAccountId
          };
        }
        if (billingAddress) {
          variables.input.creditCard.billingAddress = billingAddress;
        }
        variables.input = addValidationRule(body, variables.input);
        return variables;
      }
      function addValidationRule(body, input) {
        var validate;
        if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") {
          validate = body.creditCard.options.validate;
        } else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) {
          validate = true;
        } else if (body.tokenizationKey) {
          validate = false;
        }
        if (typeof validate === "boolean") {
          input.options = assign({
            validate: validate
          }, input.options);
        }
        return input;
      }
      function creditCardForFastlaneTokenization(body) {
        var options = {
          hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
        };
        return {
          query: createMutation(options),
          variables: createCreditCardForFastlaneTokenizationBody(body, options),
          operationName: "TokenizeCreditCardForPayPalConnect"
        };
      }
      module.exports = creditCardForFastlaneTokenization;
    }, {
      "../../../../lib/assign": 137
    }],
    104: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../../../lib/assign").assign;
      function createMutation(config) {
        var hasAuthenticationInsight = config.hasAuthenticationInsight;
        var mutation = "mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";
        if (hasAuthenticationInsight) {
          mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
        }
        mutation += ") { " + "  tokenizeCreditCard(input: $input) { " + "    token " + "    creditCard { " + "      bin " + "      brandCode " + "      last4 " + "      cardholderName " + "      expirationMonth" + "      expirationYear" + "      binData { " + "        prepaid " + "        healthcare " + "        debit " + "        durbinRegulated " + "        commercial " + "        payroll " + "        issuingBank " + "        countryOfIssuance " + "        productId " + "      } " + "    } ";
        if (hasAuthenticationInsight) {
          mutation += "    authenticationInsight(input: $authenticationInsightInput) {" + "      customerAuthenticationRegulationEnvironment" + "    }";
        }
        mutation += "  } }";
        return mutation;
      }
      function createCreditCardTokenizationBody(body, options) {
        var cc = body.creditCard;
        var billingAddress = cc && cc.billingAddress;
        var expDate = cc && cc.expirationDate;
        var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
        var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
        var variables = {
          input: {
            creditCard: {
              number: cc && cc.number,
              expirationMonth: expirationMonth,
              expirationYear: expirationYear,
              cvv: cc && cc.cvv,
              cardholderName: cc && cc.cardholderName
            },
            options: {}
          }
        };
        if (options.hasAuthenticationInsight) {
          variables.authenticationInsightInput = {
            merchantAccountId: body.merchantAccountId
          };
        }
        if (billingAddress) {
          variables.input.creditCard.billingAddress = billingAddress;
        }
        variables.input = addValidationRule(body, variables.input);
        return variables;
      }
      function addValidationRule(body, input) {
        var validate;
        if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") {
          validate = body.creditCard.options.validate;
        } else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) {
          validate = true;
        } else if (body.tokenizationKey) {
          validate = false;
        }
        if (typeof validate === "boolean") {
          input.options = assign({
            validate: validate
          }, input.options);
        }
        return input;
      }
      function creditCardTokenization(body) {
        var options = {
          hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
        };
        return {
          query: createMutation(options),
          variables: createCreditCardTokenizationBody(body, options),
          operationName: "TokenizeCreditCard"
        };
      }
      module.exports = creditCardTokenization;
    }, {
      "../../../../lib/assign": 137
    }],
    105: [function (_dereq_, module, exports) {
      "use strict";

      var features = {
        tokenize_credit_cards: "payment_methods/credit_cards",
        // eslint-disable-line camelcase
        configuration: "configuration"
      };
      var disallowedInputPaths = ["creditCard.options.unionPayEnrollment"];
      function GraphQL(config) {
        this._config = config.graphQL;
      }
      GraphQL.prototype.getGraphQLEndpoint = function () {
        return this._config.url;
      };
      GraphQL.prototype.isGraphQLRequest = function (url, body) {
        var featureEnabled;
        var path = this.getClientApiPath(url);
        if (!this._isGraphQLEnabled() || !path) {
          return false;
        }
        featureEnabled = this._config.features.some(function (feature) {
          return features[feature] === path;
        });
        if (containsDisallowedlistedKeys(body)) {
          return false;
        }
        return featureEnabled;
      };
      GraphQL.prototype.getClientApiPath = function (url) {
        var path;
        var clientApiPrefix = "/client_api/v1/";
        var pathParts = url.split(clientApiPrefix);
        if (pathParts.length > 1) {
          path = pathParts[1].split("?")[0];
        }
        return path;
      };
      GraphQL.prototype._isGraphQLEnabled = function () {
        return Boolean(this._config);
      };
      function containsDisallowedlistedKeys(body) {
        return disallowedInputPaths.some(function (keys) {
          var value = keys.split(".").reduce(function (accumulator, key) {
            return accumulator && accumulator[key];
          }, body);
          return value !== undefined; // eslint-disable-line no-undefined
        });
      }
      module.exports = GraphQL;
    }, {}],
    106: [function (_dereq_, module, exports) {
      "use strict";

      var BRAINTREE_VERSION = _dereq_("../../constants").BRAINTREE_VERSION;
      var assign = _dereq_("../../../lib/assign").assign;
      var snakeCaseToCamelCase = _dereq_("../../../lib/snake-case-to-camel-case");
      var isFastlaneCheckout = _dereq_("../../../lib/is-fastlane-checkout");
      var creditCardTokenizationBodyGenerator = _dereq_("./generators/credit-card-tokenization");
      var creditCardTokenizationResponseAdapter = _dereq_("./adapters/credit-card-tokenization");
      var creditCardTokenizationFastlaneResponseAdapter = _dereq_("./adapters/credit-card-tokenization-fastlane");
      var creditCardForFastlaneTokenizationBodyGenerator = _dereq_("./generators/credit-card-for-fastlane-tokenization");
      var configurationBodyGenerator = _dereq_("./generators/configuration");
      var configurationResponseAdapter = _dereq_("./adapters/configuration");
      var generators = {
        "payment_methods/credit_cards": function (data, isFastlane) {
          if (isFastlane) {
            // Only want to use this generator when using the Fastlane flow
            return creditCardForFastlaneTokenizationBodyGenerator(data);
          }
          return creditCardTokenizationBodyGenerator(data);
        },
        configuration: configurationBodyGenerator
      };
      var adapters = {
        "payment_methods/credit_cards": function (parsedBody, context, isFastlane) {
          if (isFastlane) {
            // Only want to use this adapter when using the Fastlane flow
            return creditCardTokenizationFastlaneResponseAdapter(parsedBody, context);
          }
          return creditCardTokenizationResponseAdapter(parsedBody, context);
        },
        configuration: configurationResponseAdapter
      };
      function GraphQLRequest(options) {
        var clientApiPath = options.graphQL.getClientApiPath(options.url);
        this._graphQL = options.graphQL;
        this._data = options.data;
        this._method = options.method;
        this._headers = options.headers;
        this._clientSdkMetadata = {
          source: options.metadata.source,
          integration: options.metadata.integration,
          sessionId: options.metadata.sessionId
        };
        this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;
        this._generator = generators[clientApiPath];
        this._adapter = adapters[clientApiPath];
        this._sendAnalyticsEvent("graphql.init");
      }
      GraphQLRequest.prototype.getUrl = function () {
        return this._graphQL.getGraphQLEndpoint();
      };
      GraphQLRequest.prototype.getBody = function () {
        var formattedBody = formatBodyKeys(this._data);
        var generatedBody = this._generator(formattedBody,
        // Since this is used for all GQL requests, we only want this if it's a Fastlane Tokenization request
        isFastlaneCheckout(this._data.creditCard));
        var body = assign({
          clientSdkMetadata: this._clientSdkMetadata
        }, generatedBody);
        return JSON.stringify(body);
      };
      GraphQLRequest.prototype.getMethod = function () {
        return "POST";
      };
      GraphQLRequest.prototype.getHeaders = function () {
        var authorization, headers;
        if (this._data.authorizationFingerprint) {
          this._sendAnalyticsEvent("graphql.authorization-fingerprint");
          authorization = this._data.authorizationFingerprint;
        } else {
          this._sendAnalyticsEvent("graphql.tokenization-key");
          authorization = this._data.tokenizationKey;
        }
        headers = {
          Authorization: "Bearer " + authorization,
          "Braintree-Version": BRAINTREE_VERSION
        };
        return assign({}, this._headers, headers);
      };
      GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
        return this._adapter(parsedBody, this,
        // Since this is used for all GQL requests, we only want this if it's a Fastlane Checkout Tokenization request
        "creditCard" in this._data && isFastlaneCheckout(this._data.creditCard));
      };
      GraphQLRequest.prototype.determineStatus = function (httpStatus, parsedResponse) {
        var status, errorClass;
        if (httpStatus === 200) {
          errorClass = parsedResponse.errors && parsedResponse.errors[0] && parsedResponse.errors[0].extensions && parsedResponse.errors[0].extensions.errorClass;
          if (parsedResponse.data && !parsedResponse.errors) {
            status = 200;
          } else if (errorClass === "VALIDATION") {
            status = 422;
          } else if (errorClass === "AUTHORIZATION") {
            status = 403;
          } else if (errorClass === "AUTHENTICATION") {
            status = 401;
          } else if (isGraphQLError(errorClass, parsedResponse)) {
            status = 403;
          } else {
            status = 500;
          }
        } else if (!httpStatus) {
          status = 500;
        } else {
          status = httpStatus;
        }
        this._sendAnalyticsEvent("graphql.status." + httpStatus);
        this._sendAnalyticsEvent("graphql.determinedStatus." + status);
        return status;
      };
      function isGraphQLError(errorClass, parsedResponse) {
        return !errorClass && parsedResponse.errors[0].message;
      }

      /**
       * @ignore
       * This function formats the body consistently so _everything_ is camelCase.
       * @param {object} originalBody the body to format
       * @returns {object} The formatted object
       */
      function formatBodyKeys(originalBody) {
        var body = {};
        Object.keys(originalBody).forEach(function (key) {
          var camelCaseKey = snakeCaseToCamelCase(key);
          if (typeof originalBody[key] === "object") {
            body[camelCaseKey] = formatBodyKeys(originalBody[key]);
          } else if (typeof originalBody[key] === "number") {
            body[camelCaseKey] = String(originalBody[key]);
          } else {
            body[camelCaseKey] = originalBody[key];
          }
        });
        return body;
      }
      module.exports = GraphQLRequest;
    }, {
      "../../../lib/assign": 137,
      "../../../lib/is-fastlane-checkout": 168,
      "../../../lib/snake-case-to-camel-case": 176,
      "../../constants": 92,
      "./adapters/configuration": 98,
      "./adapters/credit-card-tokenization": 100,
      "./adapters/credit-card-tokenization-fastlane": 99,
      "./generators/configuration": 102,
      "./generators/credit-card-for-fastlane-tokenization": 103,
      "./generators/credit-card-tokenization": 104
    }],
    107: [function (_dereq_, module, exports) {
      "use strict";

      var once = _dereq_("../../lib/once");
      var AJAXDriver = _dereq_("./ajax-driver");
      module.exports = function (options, cb) {
        cb = once(cb || Function.prototype);
        options.method = (options.method || "GET").toUpperCase();
        options.timeout = options.timeout == null ? 60000 : options.timeout;
        options.data = options.data || {};
        AJAXDriver.request(options, cb);
      };
    }, {
      "../../lib/once": 173,
      "./ajax-driver": 96
    }],
    108: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (body) {
        try {
          body = JSON.parse(body);
        } catch (e) {
          /* ignored */
        }
        return body;
      };
    }, {}],
    109: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (method, body) {
        if (typeof method !== "string") {
          throw new Error("Method must be a string");
        }
        if (method.toLowerCase() !== "get" && body != null) {
          body = typeof body === "string" ? body : JSON.stringify(body);
        }
        return body;
      };
    }, {}],
    110: [function (_dereq_, module, exports) {
      "use strict";

      var isXHRAvailable = typeof window !== "undefined" && window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest();
      function getRequestObject() {
        return isXHRAvailable ? new window.XMLHttpRequest() : new window.XDomainRequest();
      }
      module.exports = {
        isAvailable: isXHRAvailable,
        getRequestObject: getRequestObject
      };
    }, {}],
    111: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Data Collector - Creation Error Codes
       * @description Errors that occur when [creating the Data Collector component](./module-braintree-web_data-collector.html#.create).
       * @property {MERCHANT} DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS Occurs when PayPal Fraudnet could not be enabled.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS: {
          type: BraintreeError.types.MERCHANT,
          code: "DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS",
          message: "Data Collector must be created with Kount and/or PayPal."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    112: [function (_dereq_, module, exports) {
      "use strict";

      var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
      var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
      var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
      var loadScript = _dereq_("../lib/assets").loadScript;
      var TRUNCATION_LENGTH = 32;
      var cachedSessionId;
      function setup(options) {
        var fraudNet = new Fraudnet();
        options = options || {};
        if (!options.sessionId && cachedSessionId) {
          fraudNet.sessionId = cachedSessionId;
          return Promise.resolve(fraudNet);
        }
        return fraudNet.initialize(options);
      }
      function clearSessionIdCache() {
        cachedSessionId = null;
      }
      function Fraudnet() {}
      Fraudnet.prototype.initialize = function (options) {
        var environment = options.environment;
        var self = this;
        this.sessionId = options.sessionId || options.clientSessionId;
        if (this.sessionId) {
          this.sessionId = this.sessionId.substring(0, TRUNCATION_LENGTH);
        }
        if (!options.sessionId) {
          cachedSessionId = this.sessionId;
        }
        this._beaconId = _generateBeaconId(this.sessionId);
        this._parameterBlock = _createParameterBlock(this.sessionId, this._beaconId, environment);
        return loadScript({
          src: FRAUDNET_URL
        }).then(function (block) {
          self._thirdPartyBlock = block;
          return self;
        }).catch(function () {
          // if the fraudnet script fails to load
          // we just resolve with nothing
          // and data collector ignores it
          return null;
        });
      };
      Fraudnet.prototype.teardown = function () {
        removeElementIfOnPage(document.querySelector('iframe[title="ppfniframe"]'));
        removeElementIfOnPage(document.querySelector('iframe[title="pbf"]'));
        removeElementIfOnPage(this._parameterBlock);
        removeElementIfOnPage(this._thirdPartyBlock);
      };
      function removeElementIfOnPage(element) {
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }
      function _generateBeaconId(sessionId) {
        var timestamp = new Date().getTime() / 1000;
        return "https://b.stats.paypal.com/counter.cgi" + "?i=127.0.0.1" + "&p=" + sessionId + "&t=" + timestamp + "&a=14";
      }
      function _createParameterBlock(sessionId, beaconId, environment) {
        var el = document.body.appendChild(document.createElement("script"));
        var config = {
          f: sessionId,
          s: FRAUDNET_SOURCE,
          b: beaconId
        };

        // for some reason, the presence of the sandbox
        // attribute in a production environment causes
        // some weird behavior with what url paths are
        // hit, so instead, we only apply this attribute
        // when it is not a production environment
        if (environment !== "production") {
          config.sandbox = true;
        }
        el.type = "application/json";
        el.setAttribute("fncls", FRAUDNET_FNCLS);
        el.text = JSON.stringify(config);
        return el;
      }
      module.exports = {
        setup: setup,
        clearSessionIdCache: clearSessionIdCache
      };
    }, {
      "../lib/assets": 136,
      "../lib/constants": 142
    }],
    113: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/data-collector */
      var fraudnet = _dereq_("./fraudnet");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var errors = _dereq_("./errors");

      /**
       * @class
       * @global
       * @name DataCollector
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/data-collector.create|braintree-web.data-collector.create} instead.</strong>
       * @classdesc This class is used for fraud integration with PayPal. Instances of this class have {@link DataCollector#deviceData|deviceData} which is used to correlate user sessions with server transactions.
       */

      /**
       * @memberof DataCollector
       * @name deviceData
       * @type string
       * @description JSON string to pass with server transactions.
       * @instance
       */

      /**
       * @memberof DataCollector
       * @name rawDeviceData
       * @type object
       * @description The device data as an object instead of a string.
       * @instance
       */

      /**
       * @memberof DataCollector
       * @name teardown
       * @function
       * @description Cleanly remove anything set up by {@link module:braintree-web/data-collector.create|create}.
       * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
       * @instance
       * @example
       * dataCollectorInstance.teardown();
       * @example <caption>With callback</caption>
       * dataCollectorInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */

      /**
       * @memberof DataCollector
       * @name getDeviceData
       * @function
       * @description Resolves with device data once it is ready.
       * @param {object} [options] Options for how device data is resolved.
       * @param {boolean} [options.raw=false] When set to true, the device data will resolve as an object instead of a JSON string.
       * @param {callback} [callback] Called on completion. If no callback is provided, `getDeviceData` returns a promise.
       * @instance
       * @example
       * dataCollectorInstance.getDeviceData();
       * @example <caption>Without options</caption>
       * dataCollectorInstance.getDeviceData().then(function (deviceData) {
       *   // typeof deviceData === 'string'
       *   // pass onto your server with the payment method nonce
       * });
       * @example <caption>With options</caption>
       * dataCollectorInstance.getDeviceData({
       *   raw: true
       * }).then(function (deviceData) {
       *   // typeof deviceData === 'object'
       *   // for if you'd like to parse the data before sending it to your server
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */

      /**
       * @static
       * @function create
       * @description Creates a DataCollector instance and collects device data based on your merchant configuration. We recommend that you call this method as early as possible, e.g. as soon as your website loads. If that's too early, call it at the beginning of customer checkout.
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Data Collector instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#getDeviceData} must be used to collect the device data.
       * @param {boolean} [options.paypal] *Deprecated:* PayPal fraud data collection will occur when the DataCollector instance is created.
       * @param {string} [options.riskCorrelationId] Pass a custom risk correlation id when creating the data collector.
       * @param {string} [options.clientMetadataId] Deprecated. Use `options.riskCorrelationId` instead.
       * @param {string} [options.correlationId] Deprecated. Use `options.riskCorrelationId` instead.
       * @param {callback} [callback] The second argument, `data`, is the {@link DataCollector} instance.
       * @returns {(Promise|void)} Returns a promise that resolves the {@link DataCollector} instance if no callback is provided.
       */
      function create(options) {
        var name = "Data Collector";
        var result = {
          _instances: []
        };
        var data = {};
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          result._instantiatedWithAClient = !options.useDeferredClient;
          result._createPromise = createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          }).then(function (client) {
            var clientConfiguration = client.getConfiguration();
            return fraudnet.setup({
              sessionId: options.riskCorrelationId || options.clientMetadataId || options.correlationId,
              clientSessionId: clientConfiguration.analyticsMetadata.sessionId,
              environment: clientConfiguration.gatewayConfiguration.environment
            }).then(function (fraudnetInstance) {
              if (fraudnetInstance) {
                data.correlation_id = fraudnetInstance.sessionId; // eslint-disable-line camelcase
                result._instances.push(fraudnetInstance);
              }
            });
          }).then(function () {
            if (result._instances.length === 0) {
              // NEXT_MAJOR_VERSION either this should error with a specific error that
              // no data collector instances could be set up, or we should just swallow
              // the error and document that no device data will be returned if
              // data collector cannot be instantiated. We can't change the error code here
              // without possibly breaking merchant integrations relying on this inccorrect
              // behavior.
              return Promise.reject(new BraintreeError(errors.DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS));
            }
            result.deviceData = JSON.stringify(data);
            result.rawDeviceData = data;
            return result;
          });
          result.teardown = createTeardownMethod(result);
          result.getDeviceData = createGetDeviceDataMethod(result);
          if (result._instantiatedWithAClient) {
            return result._createPromise;
          }
          return result;
        });
      }
      function createTeardownMethod(result) {
        return wrapPromise(function teardown() {
          return result._createPromise.then(function () {
            result._instances.forEach(function (instance) {
              if (instance) {
                instance.teardown();
              }
            });
            convertMethodsToError(result, methods(result));
          });
        });
      }
      function createGetDeviceDataMethod(result) {
        return wrapPromise(function getDeviceData(options) {
          options = options || {};
          return result._createPromise.then(function () {
            if (options.raw) {
              return Promise.resolve(result.rawDeviceData);
            }
            return Promise.resolve(result.deviceData);
          });
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "../lib/methods": 172,
      "./errors": 111,
      "./fraudnet": 112,
      "@braintree/wrap-promise": 40
    }],
    114: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        FASTLANE_SDK_LOAD_ERROR: {
          type: BraintreeError.types.MERCHANT,
          code: "FASTLANE_SDK_LOAD_ERROR"
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    115: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./errors");
      var loadFastlane = _dereq_("../lib/assets").loadFastlane;
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var assign = _dereq_("../lib/assign").assign;
      function fastlane(options) {
        var config = options.client.getConfiguration();
        var sdkVersion = options.client.getVersion();
        var environment = config.gatewayConfiguration.environment;
        var minified = true;
        if (environment !== "production") {
          minified = false;
        }
        return loadFastlane(assign({
          platform: "BT",
          btSdkVersion: sdkVersion,
          minified: minified
        }, options)).then(function (result) {
          var platformOptions = {
            platform: "BT",
            authorization: options.authorization,
            client: options.client,
            deviceData: options.deviceData
          };

          // We need the following options to be nested inside platformOptions rather than
          // top level
          delete options.authorization;
          delete options.client;
          delete options.deviceData;

          // The following are options that we know are needed for the Fastlane Loader, but which
          // we know are not needed for initializing the fastlane sdk.
          delete options.minified;
          delete options.btSdkVersion;
          return window.braintree.fastlane.create(assign({
            platformOptions: platformOptions
          }, options, result.metadata));
        }).catch(function (err) {
          return Promise.reject(new BraintreeError({
            type: errors.FASTLANE_SDK_LOAD_ERROR.type,
            code: errors.FASTLANE_SDK_LOAD_ERROR.code,
            message: err.message
          }));
        });
      }
      module.exports = wrapPromise(fastlane);
    }, {
      "../lib/assets": 136,
      "../lib/assign": 137,
      "../lib/braintree-error": 140,
      "./errors": 114,
      "@braintree/wrap-promise": 40
    }],
    116: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/fastlane */
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var fastlane = _dereq_("./fastlane");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var VERSION = "3.115.2";
      var assign = _dereq_("../lib/assign").assign;

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {string} [options.deviceData] A {@link DataCollector} instance.
       * @example
       * braintree.fastlane.create({
       *   client: clientInstance,
       *   deviceData: dataCollectorInstance
       * }).then(function (fastlaneInstance) {
       *   // fastlaneInstance is ready to create an identity instance.
       *     identity = fastlaneInstance.identity
       * }).catch(function (createErr) {
       *   console.error('Error creating fastlane instance', createErr);
       * });
       * @example <caption>Creating a fastlane component</caption>
       * braintree.fastlane.create({
       *   client: clientInstance,
       *   deviceData: dataCollectorInstance
       * }).then(function (fastlaneInstance) {
       *   // fastlaneInstance is ready to create an identity instance.
       *     identity = fastlaneInstance.identity
       * }).catch(function (createErr) {
       *   console.error('Error creating fastlane instance', createErr);
       * });
       * @returns {(Promise|void)} Returns the fastlane instance.
       */

      function create(options) {
        var name = "fastlane";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          return fastlane(assign({
            client: client,
            deviceData: options.deviceData
          }, options));
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/assign": 137,
      "../lib/basic-component-verification": 138,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./fastlane": 115,
      "@braintree/wrap-promise": 40
    }],
    117: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Google Payment - Creation Error Codes
       * @description Errors that occur when [creating the Google Payment component](./module-braintree-web_google-payment.html#.create).
       * @property {MERCHANT} GOOGLE_PAYMENT_NOT_ENABLED Occurs when Google Pay is not enabled on the Braintree control panel.
       * @property {MERCHANT} GOOGLE_PAYMENT_UNSUPPORTED_VERSION Occurs when a Google Pay version is used that is not supported by the Braintree SDK.
       */

      /**
       * @name BraintreeError.Google Payment - parseResponse Error Codes
       * @description Errors that occur when [parsing the response from Google](./GooglePayment.html#parseResponse).
       * @property {UNKNOWN} GOOGLE_PAYMENT_GATEWAY_ERROR Occurs when Google Pay could not be tokenized.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        GOOGLE_PAYMENT_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "GOOGLE_PAYMENT_NOT_ENABLED",
          message: "Google Pay is not enabled for this merchant."
        },
        GOOGLE_PAYMENT_GATEWAY_ERROR: {
          code: "GOOGLE_PAYMENT_GATEWAY_ERROR",
          message: "There was an error when tokenizing the Google Pay payment method.",
          type: BraintreeError.types.UNKNOWN
        },
        GOOGLE_PAYMENT_UNSUPPORTED_VERSION: {
          code: "GOOGLE_PAYMENT_UNSUPPORTED_VERSION",
          type: BraintreeError.types.MERCHANT
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    118: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../lib/analytics");
      var assign = _dereq_("../lib/assign").assign;
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var find = _dereq_("../lib/find");
      var generateGooglePayConfiguration = _dereq_("../lib/generate-google-pay-configuration");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./errors");
      var methods = _dereq_("../lib/methods");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var CREATE_PAYMENT_DATA_REQUEST_METHODS = {
        1: "_createV1PaymentDataRequest",
        2: "_createV2PaymentDataRequest"
      };

      /**
       * @typedef {object} GooglePayment~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {object} details Additional account details.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {boolean} details.isNetworkTokenized True if the card is network tokenized.
       * @property {string} details.bin First six digits of card number.
       * @property {string} description A human-readable description.
       * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * @class GooglePayment
       * @param {object} options Google Payment {@link module:braintree-web/google-payment.create create} options.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/google-payment.create|braintree-web.google-payment.create} instead.</strong>
       * @classdesc This class represents a Google Payment component produced by {@link module:braintree-web/google-payment.create|braintree-web/google-payment.create}. Instances of this class have methods for initializing the Google Pay flow.
       */
      function GooglePayment(options) {
        this._createPromise = options.createPromise;
        this._client = options.client;
        this._useDeferredClient = options.useDeferredClient;
        // NEXT_MAJOR_VERSION this should be updated to 2 (or whatever the current latest version is)
        this._googlePayVersion = options.googlePayVersion || 1;
        this._googleMerchantId = options.googleMerchantId;
        if (this._isUnsupportedGooglePayAPIVersion()) {
          throw new BraintreeError({
            code: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.code,
            message: "The Braintree SDK does not support Google Pay version " + this._googlePayVersion + ". Please upgrade the version of your Braintree SDK and contact support if this error persists.",
            type: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.type
          });
        }
      }
      GooglePayment.prototype._waitForClient = function () {
        if (this._client) {
          return Promise.resolve();
        }
        return this._createPromise.then(function (client) {
          this._client = client;
        }.bind(this));
      };
      GooglePayment.prototype._isUnsupportedGooglePayAPIVersion = function () {
        // if we don't have createPaymentDatqRequest method for the specific
        // API version, then the version is not supported
        return !(this._googlePayVersion in CREATE_PAYMENT_DATA_REQUEST_METHODS);
      };
      GooglePayment.prototype._getDefaultConfig = function () {
        if (!this._defaultConfig) {
          this._defaultConfig = generateGooglePayConfiguration(this._client.getConfiguration(), this._googlePayVersion, this._googleMerchantId);
        }
        return this._defaultConfig;
      };
      GooglePayment.prototype._createV1PaymentDataRequest = function (paymentDataRequest) {
        var defaultConfig = this._getDefaultConfig();
        var overrideCardNetworks = paymentDataRequest.cardRequirements && paymentDataRequest.cardRequirements.allowedCardNetworks;
        var defaultConfigCardNetworks = defaultConfig.cardRequirements.allowedCardNetworks;
        var allowedCardNetworks = overrideCardNetworks || defaultConfigCardNetworks;
        paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);

        // this way we can preserve allowedCardNetworks from default integration
        // if merchant did not pass any in `cardRequirements`
        paymentDataRequest.cardRequirements.allowedCardNetworks = allowedCardNetworks;
        return paymentDataRequest;
      };
      GooglePayment.prototype._createV2PaymentDataRequest = function (paymentDataRequest) {
        var defaultConfig = this._getDefaultConfig();
        if (paymentDataRequest.allowedPaymentMethods) {
          paymentDataRequest.allowedPaymentMethods.forEach(function (paymentMethod) {
            var defaultPaymentMethod = find(defaultConfig.allowedPaymentMethods, "type", paymentMethod.type);
            if (defaultPaymentMethod) {
              applyDefaultsToPaymentMethodConfiguration(paymentMethod, defaultPaymentMethod);
            }
          });
        }
        paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);
        return paymentDataRequest;
      };

      /**
       * Create a configuration object for use in the `loadPaymentData` method.
       *
       * **Note**: Version 1 of the Google Pay Api is deprecated and will become unsupported in a future version. Until then, version 1 will continue to be used by default, and version 1 schema parameters and overrides will remain functional on existing integrations. However, new integrations and all following examples will be presented in the GooglePay version 2 schema. See [Google Pay's upgrade guide](https://developers.google.com/pay/api/web/guides/resources/update-to-latest-version) to see how to update your integration.
       *
       * If `options.googlePayVersion === 2` was set during the initial {@link module:braintree-web/google-payment.create|create} call, overrides must match the Google Pay v2 schema to be valid.
       *
       * @public
       * @param {object} overrides The supplied parameters for creating the PaymentDataRequest object. Required parameters are:
       *  @param {object} overrides.transactionInfo Object according to the [Google Pay Transaction Info](https://developers.google.com/pay/api/web/reference/object#TransactionInfo) spec.
       *  Optionally, any of the parameters in the [PaymentDataRequest](https://developers.google.com/pay/api/web/reference/object#PaymentDataRequest) parameters can be overridden, but note that it is recommended only to override top level parameters to avoid squashing deeply nested configuration objects. An example can be found below showing how to safely edit these deeply nested objects.
       * @example
       * var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
       *   merchantInfo: {
       *     merchantId: 'my-merchant-id-from-google'
       *   },
       *   transactionInfo: {
       *     currencyCode: 'USD',
       *     totalPriceStatus: 'FINAL',
       *     totalPrice: '100.00'
       *   }
       * });
       *
       * // Update card payment methods to require billing address
       * var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
       * cardPaymentMethod.parameters.billingAddressRequired = true;
       * cardPaymentMethod.parameters.billingAddressParameters = {
       *   format: 'FULL',
       *   phoneNumberRequired: true
       * };
       *
       * var paymentsClient = new google.payments.api.PaymentsClient({
       *   environment: 'TEST' // or 'PRODUCTION'
       * })
       *
       * paymentsClient.loadPaymentData(paymentDataRequest).then(function (response) {
       *   // handle response with googlePaymentInstance.parseResponse
       *   // (see below)
       * });
       * @example <caption>With deferred client</caption>
       * googlePaymentInstance.createPaymentDataRequest({
       *   merchantInfo: {
       *     merchantId: 'my-merchant-id-from-google'
       *   },
       *   transactionInfo: {
       *     currencyCode: 'USD',
       *     totalPriceStatus: 'FINAL',
       *     totalPrice: '100.00'
       *   }
       * }).then(function (paymentDataRequest) {
       *   // Update card payment methods to require billing address
       *   var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
       *   cardPaymentMethod.parameters.billingAddressRequired = true;
       *   cardPaymentMethod.parameters.billingAddressParameters = {
       *     format: 'FULL',
       *     phoneNumberRequired: true
       *   };
       *
       *   var paymentsClient = new google.payments.api.PaymentsClient({
       *     environment: 'TEST' // or 'PRODUCTION'
       *   })
       *
       *   return paymentsClient.loadPaymentData(paymentDataRequest);
       * }).then(function (response) {
       *   // handle response with googlePaymentInstance.parseResponse
       *   // (see below)
       * });
       * @returns {object|Promise} Returns a configuration object for Google PaymentDataRequest. If instantiated with `useDeferredClient` and an `authorization` it will return a promise that resolves with the configuration.
       */
      GooglePayment.prototype.createPaymentDataRequest = function (overrides) {
        if (!this._useDeferredClient) {
          return this._createPaymentDataRequestSyncronously(overrides);
        }
        return this._waitForClient().then(function () {
          return this._createPaymentDataRequestSyncronously(overrides);
        }.bind(this));
      };
      GooglePayment.prototype._createPaymentDataRequestSyncronously = function (overrides) {
        var paymentDataRequest = assign({}, overrides);
        var version = this._googlePayVersion;
        var createPaymentDataRequestMethod = CREATE_PAYMENT_DATA_REQUEST_METHODS[version];
        if (paymentDataRequest.transactionInfo && paymentDataRequest.transactionInfo.totalPrice) {
          paymentDataRequest.transactionInfo.totalPrice = paymentDataRequest.transactionInfo.totalPrice.toString();
        }
        analytics.sendEvent(this._createPromise, "google-payment.v" + version + ".createPaymentDataRequest");
        return this[createPaymentDataRequestMethod](paymentDataRequest);
      };

      /**
       * Parse the response from the tokenization.
       * @public
       * @param {object} response The response back from the Google Pay tokenization.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link GooglePay~tokenizePayload|tokenizePayload}. If no callback is provided, `parseResponse` returns a promise that resolves with a {@link GooglePayment~tokenizePayload|tokenizePayload}.
       * @example with callback
       * var paymentsClient = new google.payments.api.PaymentsClient({
       *   environment: 'TEST' // or 'PRODUCTION'
       * })
       *
       * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
       *   googlePaymentInstance.parseResponse(response, function (err, data) {
       *     if (err) {
       *       // handle errors
       *     }
       *     // send parsedResponse.nonce to your server
       *   });
       * });
       * @example with promise
       * var paymentsClient = new google.payments.api.PaymentsClient({
       *   environment: 'TEST' // or 'PRODUCTION'
       * })
       *
       * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
       *   return googlePaymentInstance.parseResponse(response);
       * }).then(function (parsedResponse) {
       *   // send parsedResponse.nonce to your server
       * }).catch(function (err) {
       *   // handle errors
       * });
       * @returns {(Promise|void)} Returns a promise that resolves the parsed response if no callback is provided.
       */
      GooglePayment.prototype.parseResponse = function (response) {
        var self = this;
        return Promise.resolve().then(function () {
          var payload;
          var rawResponse = response.apiVersion === 2 ? response.paymentMethodData.tokenizationData.token : response.paymentMethodToken.token;
          var parsedResponse = JSON.parse(rawResponse);
          var error = parsedResponse.error;
          if (error) {
            return Promise.reject(error);
          }
          analytics.sendEvent(self._createPromise, "google-payment.parseResponse.succeeded");
          if (parsedResponse.paypalAccounts) {
            payload = parsedResponse.paypalAccounts[0];
            analytics.sendEvent(self._createPromise, "google-payment.parseResponse.succeeded.paypal");
            return Promise.resolve({
              nonce: payload.nonce,
              type: payload.type,
              description: payload.description
            });
          }
          payload = parsedResponse.androidPayCards[0];
          analytics.sendEvent(self._createPromise, "google-payment.parseResponse.succeeded.google-payment");
          return Promise.resolve({
            nonce: payload.nonce,
            type: payload.type,
            description: payload.description,
            details: {
              cardType: payload.details.cardType,
              lastFour: payload.details.lastFour,
              lastTwo: payload.details.lastTwo,
              isNetworkTokenized: payload.details.isNetworkTokenized,
              bin: payload.details.bin
            },
            binData: payload.binData
          });
        }).catch(function (error) {
          analytics.sendEvent(self._createPromise, "google-payment.parseResponse.failed");
          return Promise.reject(new BraintreeError({
            code: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.code,
            message: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.message,
            type: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.type,
            details: {
              originalError: error
            }
          }));
        });
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/google-payment.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * googlePaymentInstance.teardown();
       * @example <caption>With callback</caption>
       * googlePaymentInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      GooglePayment.prototype.teardown = function () {
        convertMethodsToError(this, methods(GooglePayment.prototype));
        return Promise.resolve();
      };
      function applyDefaultsToPaymentMethodConfiguration(merchantSubmittedPaymentMethod, defaultPaymentMethod) {
        Object.keys(defaultPaymentMethod).forEach(function (parameter) {
          if (typeof defaultPaymentMethod[parameter] === "object") {
            merchantSubmittedPaymentMethod[parameter] = assign({}, defaultPaymentMethod[parameter], merchantSubmittedPaymentMethod[parameter]);
          } else {
            merchantSubmittedPaymentMethod[parameter] = merchantSubmittedPaymentMethod[parameter] || defaultPaymentMethod[parameter];
          }
        });
      }
      module.exports = wrapPromise.wrapPrototype(GooglePayment);
    }, {
      "../lib/analytics": 135,
      "../lib/assign": 137,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/find": 153,
      "../lib/generate-google-pay-configuration": 165,
      "../lib/methods": 172,
      "./errors": 117,
      "@braintree/wrap-promise": 40
    }],
    119: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/google-payment
       * @description A component to integrate with Google Pay. The majority of the integration uses [Google's pay.js JavaScript file](https://pay.google.com/gp/p/js/pay.js). The Braintree component generates the configuration object necessary for Google Pay to initiate the Payment Request and parse the returned data to retrieve the payment method nonce which is used to process the transaction on the server.
       */
      var GooglePayment = _dereq_("./google-payment");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var VERSION = "3.115.2";
      var errors = _dereq_("./errors");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Google Payment instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#createPaymentDataRequest} will return a promise that resolves with the configuration instead of returning synchronously.
       * @param {number} [options.googlePayVersion] The version of the Google Pay API to use. Value of 2 is required to accept parameters documented [by Google](https://developers.google.com/pay/api/web/reference/object). Omit this parameter to use the deprecated Google Pay Version 1.
       * @param {string} [options.googleMerchantId] A Google merchant identifier issued after your website is approved by Google. Required when PaymentsClient is initialized with an environment property of PRODUCTION, but may be omitted in TEST environment.
       * @param {callback} [callback] The second argument, `data`, is the {@link GooglePayment} instance. If no callback is provided, `create` returns a promise that resolves with the {@link GooglePayment} instance.
       * @example <caption>Simple Example</caption>
       * // include https://pay.google.com/gp/p/js/pay.js in a script tag
       * // on your page to load the `google.payments.api.PaymentsClient` global object.
       *
       * var paymentButton = document.querySelector('#google-pay-button');
       * var paymentsClient = new google.payments.api.PaymentsClient({
       *   environment: 'TEST' // or 'PRODUCTION'
       * });
       *
       * braintree.client.create({
       *   authorization: 'tokenization-key-or-client-token'
       * }).then(function (clientInstance) {
       *   return braintree.googlePayment.create({
       *     client: clientInstance,
       *      googlePayVersion: 2,
       *      googleMerchantId: 'your-merchant-id-from-google'
       *   });
       * }).then(function (googlePaymentInstance) {
       *   paymentButton.addEventListener('click', function (event) {
       *     var paymentDataRequest;
       *
       *     event.preventDefault();
       *
       *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
       *       transactionInfo: {
       *         currencyCode: 'USD',
       *         totalPriceStatus: 'FINAL',
       *         totalPrice: '100.00'
       *       }
       *     });
       *
       *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
       *       return googlePaymentInstance.parseResponse(paymentData);
       *     }).then(function (result) {
       *       // send result.nonce to your server
       *     }).catch(function (err) {
       *       // handle err
       *     });
       *   });
       * });
       * @example <caption>Check Browser and Customer Compatibility</caption>
       * var paymentsClient = new google.payments.api.PaymentsClient({
       *   environment: 'TEST' // or 'PRODUCTION'
       * });
       *
       * function setupGooglePayButton(googlePaymentInstance) {
       *   var button = document.createElement('button');
       *
       *   button.id = 'google-pay';
       *   button.appendChild(document.createTextNode('Google Pay'));
       *   button.addEventListener('click', function (event) {
       *     var paymentRequestData;
       *
       *     event.preventDefault();
       *
       *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
       *       transactionInfo: {
       *         currencyCode: 'USD',
       *         totalPriceStatus: 'FINAL',
       *         totalPrice: '100.00' // your amount
       *       }
       *     });
       *
       *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
       *       return googlePaymentInstance.parseResponse(paymentData);
       *       }).then(function (result) {
       *       // send result.nonce to your server
       *     }).catch(function (err) {
       *       // handle errors
       *     });
       *   });
       *
       *   document.getElementById('container').appendChild(button);
       * }
       *
       * braintree.client.create({
       *   authorization: 'tokenization-key-or-client-token'
       * }).then(function (clientInstance) {
       *   return braintree.googlePayment.create({
       *     client: clientInstance,
       *     googlePayVersion: 2,
       *     googleMerchantId: 'your-merchant-id-from-google'
       *   });
       * }).then(function (googlePaymentInstance) {
       *
       *   return paymentsClient.isReadyToPay({
       *     // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
       *     apiVersion: 2,
       *     apiVersionMinor: 0,
       *     allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
       *     existingPaymentMethodRequired: true
       *   });
       * }).then(function (response) {
       *   if (response.result) {
       *     setupGooglePayButton(googlePaymentInstance);
       *   }
       * }).catch(function (err) {
       *   // handle setup errors
       * });
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "Google Pay";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var createPromise, instance;
          createPromise = createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          }).then(function (client) {
            var configuration = client.getConfiguration();
            options.client = client;
            if (!configuration.gatewayConfiguration.androidPay) {
              return Promise.reject(new BraintreeError(errors.GOOGLE_PAYMENT_NOT_ENABLED));
            }
            return client;
          });
          options.createPromise = createPromise;
          instance = new GooglePayment(options);
          if (!options.useDeferredClient) {
            return createPromise.then(function (client) {
              instance._client = client;
              return instance;
            });
          }
          return instance;
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./errors": 117,
      "./google-payment": 118,
      "@braintree/wrap-promise": 40
    }],
    120: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../../lib/braintree-error");
      var errors = _dereq_("../shared/errors");
      var allowedAttributes = _dereq_("../shared/constants").allowedAttributes;
      function attributeValidationError(attribute, value) {
        var err;
        if (!allowedAttributes.hasOwnProperty(attribute)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
            code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
            message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
          });
        } else if (value != null && !_isValid(attribute, value)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
            code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
            message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
          });
        }
        return err;
      }
      function _isValid(attribute, value) {
        if (allowedAttributes[attribute] === "string") {
          return typeof value === "string" || typeof value === "number";
        } else if (allowedAttributes[attribute] === "boolean") {
          return String(value) === "true" || String(value) === "false";
        }
        return false;
      }
      module.exports = attributeValidationError;
    }, {
      "../../lib/braintree-error": 140,
      "../shared/constants": 128,
      "../shared/errors": 129
    }],
    121: [function (_dereq_, module, exports) {
      "use strict";

      var constants = _dereq_("../shared/constants");
      var useMin = _dereq_("../../lib/use-min");
      module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
        return assetsUrl + "/web/" + constants.VERSION + "/html/hosted-fields-frame" + useMin(isDebug) + ".html#" + componentId;
      };
    }, {
      "../../lib/use-min": 178,
      "../shared/constants": 128
    }],
    122: [function (_dereq_, module, exports) {
      "use strict";

      var directions = _dereq_("../shared/constants").navigationDirections;
      var browserDetection = _dereq_("../shared/browser-detection");
      var focusIntercept = _dereq_("../shared/focus-intercept");
      var findParentTags = _dereq_("../shared/find-parent-tags");
      var userFocusableTagNames = ["INPUT", "SELECT", "TEXTAREA"];
      // Devices with software keyboards do not or cannot focus on input types
      // that do not require keyboard-based interaction.
      var unfocusedInputTypes = ["hidden", "button", "reset", "submit", "checkbox", "radio", "file"];
      function _isUserFocusableElement(element) {
        if (!browserDetection.hasSoftwareKeyboard()) {
          // on desktop browsers, the only input type that isn't focusable
          // is the hidden input
          return element.type !== "hidden";
        }
        return userFocusableTagNames.indexOf(element.tagName) > -1 && unfocusedInputTypes.indexOf(element.type) < 0;
      }
      function _createNavigationHelper(direction, numberOfElementsInForm) {
        switch (direction) {
          case directions.BACK:
            return {
              checkIndexBounds: function (index) {
                return index < 0;
              },
              indexChange: -1
            };
          case directions.FORWARD:
            return {
              checkIndexBounds: function (index) {
                return index > numberOfElementsInForm - 1;
              },
              indexChange: 1
            };
          default:
        }
        return {};
      }
      function _findFirstFocusableElement(elementsInForm) {
        var elementsIndex, element;
        for (elementsIndex = 0; elementsIndex < elementsInForm.length; elementsIndex++) {
          element = elementsInForm[elementsIndex];
          if (_isUserFocusableElement(element)) {
            return element;
          }
        }
        return null;
      }
      module.exports = {
        removeExtraFocusElements: function (checkoutForm, onRemoveFocusIntercepts) {
          var elements = Array.prototype.slice.call(checkoutForm.elements);
          var firstFocusableInput = _findFirstFocusableElement(elements);
          var lastFocusableInput = _findFirstFocusableElement(elements.reverse());

          // these should never be identical, because there will at least be the
          // before and the after input
          [firstFocusableInput, lastFocusableInput].forEach(function (input) {
            if (!input) {
              return;
            }
            if (focusIntercept.matchFocusElement(input.getAttribute("id"))) {
              onRemoveFocusIntercepts(input.getAttribute("id"));
            }
          });
        },
        createFocusChangeHandler: function (hostedFieldsId, callbacks) {
          return function (data) {
            var currentIndex, targetElement, checkoutForm, navHelper;
            var sourceElement = document.getElementById("bt-" + data.field + "-" + data.direction + "-" + hostedFieldsId);
            if (!sourceElement) {
              return;
            }
            checkoutForm = findParentTags(sourceElement, "form")[0];
            if (document.forms.length < 1 || !checkoutForm) {
              callbacks.onRemoveFocusIntercepts();
              return;
            }
            checkoutForm = [].slice.call(checkoutForm.elements);
            currentIndex = checkoutForm.indexOf(sourceElement);
            navHelper = _createNavigationHelper(data.direction, checkoutForm.length);
            do {
              currentIndex += navHelper.indexChange;
              if (navHelper.checkIndexBounds(currentIndex)) {
                return;
              }
              targetElement = checkoutForm[currentIndex];
            } while (!_isUserFocusableElement(targetElement));
            if (focusIntercept.matchFocusElement(targetElement.getAttribute("id"))) {
              callbacks.onTriggerInputFocus(targetElement.getAttribute("data-braintree-type"));
            } else {
              targetElement.focus();
            }
          };
        }
      };
    }, {
      "../shared/browser-detection": 127,
      "../shared/constants": 128,
      "../shared/find-parent-tags": 130,
      "../shared/focus-intercept": 131
    }],
    123: [function (_dereq_, module, exports) {
      "use strict";

      var allowedStyles = _dereq_("../shared/constants").allowedStyles;
      module.exports = function getStylesFromClass(cssClass) {
        var element = document.createElement("input");
        var styles = {};
        var computedStyles;
        if (cssClass[0] === ".") {
          cssClass = cssClass.substring(1);
        }
        element.className = cssClass;
        element.style.display = "none !important";
        element.style.position = "fixed !important";
        element.style.left = "-99999px !important";
        element.style.top = "-99999px !important";
        document.body.appendChild(element);
        computedStyles = window.getComputedStyle(element);
        allowedStyles.forEach(function (style) {
          var value = computedStyles[style];
          if (value) {
            styles[style] = value;
          }
        });
        document.body.removeChild(element);
        return styles;
      };
    }, {
      "../shared/constants": 128
    }],
    124: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../lib/assign").assign;
      var createAssetsUrl = _dereq_("../../lib/create-assets-url");
      var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
      var Destructor = _dereq_("../../lib/destructor");
      var iFramer = _dereq_("@braintree/iframer");
      var Bus = _dereq_("framebus");
      var createDeferredClient = _dereq_("../../lib/create-deferred-client");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var composeUrl = _dereq_("./compose-url");
      var getStylesFromClass = _dereq_("./get-styles-from-class");
      var constants = _dereq_("../shared/constants");
      var errors = _dereq_("../shared/errors");
      var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
      var uuid = _dereq_("@braintree/uuid");
      var findParentTags = _dereq_("../shared/find-parent-tags");
      var browserDetection = _dereq_("../shared/browser-detection");
      var events = constants.events;
      var EventEmitter = _dereq_("@braintree/event-emitter");
      var injectFrame = _dereq_("./inject-frame");
      var analytics = _dereq_("../../lib/analytics");
      var allowedFields = constants.allowedFields;
      var methods = _dereq_("../../lib/methods");
      var shadow = _dereq_("../../lib/shadow");
      var findRootNode = _dereq_("../../lib/find-root-node");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var sharedErrors = _dereq_("../../lib/errors");
      var getCardTypes = _dereq_("../shared/get-card-types");
      var attributeValidationError = _dereq_("./attribute-validation-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var focusChange = _dereq_("./focus-change");
      var destroyFocusIntercept = _dereq_("../shared/focus-intercept").destroy;
      var SAFARI_FOCUS_TIMEOUT = 5;

      /**
       * @typedef {object} HostedFields~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {object} authenticationInsight Info about the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card. Only available if `authenticationInsight.merchantAccountId` is passed in the `tokenize` method options.
       * @property {string} authenticationInsight.regulationEnvironment The [regulation environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) for the tokenized card.
       * @property {object} details Additional account details.
       * @property {string} details.bin The BIN number of the card.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.expirationMonth The expiration month of the card.
       * @property {string} details.expirationYear The expiration year of the card.
       * @property {string} details.cardholderName The cardholder name tokenized with the card.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {string} description A human-readable description.
       * @property {string} type The payment method type, always `CreditCard`.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * @typedef {object} HostedFields~stateObject
       * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
       * @property {HostedFields~hostedFieldsCard[]} cards
       * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
       * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
       * an open-source card detection library.
       * @property {string} emittedBy
       * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
       * - `"number"`
       * - `"cvv"`
       * - `"expirationDate"`
       * - `"expirationMonth"`
       * - `"expirationYear"`
       * - `"postalCode"`
       * - `"cardholderName"`
       * @property {object} fields
       * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
       * @property {?HostedFields~hostedFieldsFieldData} fields.cardholderName {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the cardholder name field, if it is present.
       */

      /**
       * @typedef {object} HostedFields~binPayload
       * @description The event payload sent from {@link HostedFields#on|on} when the {@link HostedFields#event:binAvailable|binAvailable} event is emitted.
       * @property {string} bin The first 6 digits of the card number.
       */

      /**
       * @typedef {object} HostedFields~hostedFieldsFieldData
       * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
       * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
       * @property {boolean} isFocused Whether or not the input is currently focused.
       * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
       * @property {boolean} isPotentiallyValid
       * A determination based on the future validity of the input value.
       * This is helpful when a user is entering a card number and types <code>"41"</code>.
       * While that value is not valid for submission, it is still possible for
       * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
       * it is clear that the card number can never become valid and isPotentiallyValid will
       * return false.
       * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
       */

      /**
       * @typedef {object} HostedFields~hostedFieldsCard
       * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
       * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
       * - `american-express`
       * - `diners-club`
       * - `discover`
       * - `jcb`
       * - `maestro`
       * - `master-card`
       * - `unionpay`
       * - `visa`
       * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
       * - `American Express`
       * - `Diners Club`
       * - `Discover`
       * - `JCB`
       * - `Maestro`
       * - `MasterCard`
       * - `UnionPay`
       * - `Visa`
       * @property {object} code
       * This object contains data relevant to the security code requirements of the card brand.
       * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
       * American Express card requires a 4-digit <code>CID</code>.
       * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
       * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
       */

      /**
       * @name HostedFields#on
       * @function
       * @param {string} event The name of the event to which you are subscribing.
       * @param {function} handler A callback to handle the event.
       * @description Subscribes a handler function to a named event.
       *
       * **Events that emit a {@link HostedFields~stateObject|stateObject}.**
       * * {@link HostedFields#event:blur|blur}
       * * {@link HostedFields#event:focus|focus}
       * * {@link HostedFields#event:empty|empty}
       * * {@link HostedFields#event:notEmpty|notEmpty}
       * * {@link HostedFields#event:cardTypeChange|cardTypeChange}
       * * {@link HostedFields#event:validityChange|validityChange}
       * * {@link HostedFields#event:inputSubmitRequest|inputSubmitRequest}
       *
       * **Other Events**
       * * {@link HostedFields#event:binAvailable|binAvailable} - emits a {@link HostedFields~binPayload|bin payload}. Note: If you are using a [Referrer-Policy](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy) header that prevents the origin from being sent, this event will not fire.
       * @example
       * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('focus', function (event) {
       *     console.log(event.emittedBy, 'has been focused');
       *   });
       * });
       * @returns {void}
       */

      /**
       * @name HostedFields#off
       * @function
       * @param {string} event The name of the event to which you are unsubscribing.
       * @param {function} handler The callback for the event you are unsubscribing from.
       * @description Unsubscribes the handler function to a named event.
       * @example
       * <caption>Subscribing and then unsubscribing from a Hosted Field event, in this case 'focus'</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   var callback = function (event) {
       *     console.log(event.emittedBy, 'has been focused');
       *   };
       *   hostedFieldsInstance.on('focus', callback);
       *
       *   // later on
       *   hostedFieldsInstance.off('focus', callback);
       * });
       * @returns {void}
       */

      /**
       * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
       * @event HostedFields#inputSubmitRequest
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
       * var hostedFields = require('braintree-web/hosted-fields');
       * var submitButton = document.querySelector('input[type="submit"]');
       *
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('inputSubmitRequest', function () {
       *     // User requested submission, e.g. by pressing Enter or equivalent
       *     submitButton.click();
       *   });
       * });
       */

      /**
       * This event is emitted when a field transitions from having data to being empty.
       * @event HostedFields#empty
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to an empty event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('empty', function (event) {
       *     console.log(event.emittedBy, 'is now empty');
       *   });
       * });
       */

      /**
       * This event is emitted when a field transitions from being empty to having data.
       * @event HostedFields#notEmpty
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to an notEmpty event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('notEmpty', function (event) {
       *     console.log(event.emittedBy, 'is now not empty');
       *   });
       * });
       */

      /**
       * This event is emitted when a field loses focus.
       * @event HostedFields#blur
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to a blur event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('blur', function (event) {
       *     console.log(event.emittedBy, 'lost focus');
       *   });
       * });
       */

      /**
       * This event is emitted when a field gains focus.
       * @event HostedFields#focus
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to a focus event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('focus', function (event) {
       *     console.log(event.emittedBy, 'gained focus');
       *   });
       * });
       */

      /**
       * This event is emitted when activity within the number field has changed such that the possible card type has changed.
       * @event HostedFields#cardTypeChange
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to a cardTypeChange event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('cardTypeChange', function (event) {
       *     if (event.cards.length === 1) {
       *       console.log(event.cards[0].type);
       *     } else {
       *       console.log('Type of card not yet known');
       *     }
       *   });
       * });
       */

      /**
       * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
       * @event HostedFields#validityChange
       * @type {HostedFields~stateObject}
       * @example
       * <caption>Listening to a validityChange event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('validityChange', function (event) {
       *     var field = event.fields[event.emittedBy];
       *
       *     if (field.isValid) {
       *       console.log(event.emittedBy, 'is fully valid');
       *     } else if (field.isPotentiallyValid) {
       *       console.log(event.emittedBy, 'is potentially valid');
       *     } else {
       *       console.log(event.emittedBy, 'is not valid');
       *     }
       *   });
       * });
       */

      /**
       * This event is emitted when the first 6 digits of the card number have been entered by the customer.
       * @event HostedFields#binAvailable
       * @type {string}
       * @example
       * <caption>Listening to a `binAvailable` event</caption>
       * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
       *   hostedFieldsInstance.on('binAvailable', function (event) {
       *     event.bin // send bin to 3rd party bin service
       *   });
       * });
       */

      function createInputEventHandler(fields) {
        return function (eventData) {
          var field;
          var merchantPayload = eventData.merchantPayload;
          var emittedBy = merchantPayload.emittedBy;
          var container = fields[emittedBy].containerElement;
          Object.keys(merchantPayload.fields).forEach(function (key) {
            merchantPayload.fields[key].container = fields[key].containerElement;
          });
          field = merchantPayload.fields[emittedBy];
          container.classList.toggle(constants.externalClasses.FOCUSED, field.isFocused);
          container.classList.toggle(constants.externalClasses.VALID, field.isValid);
          container.classList.toggle(constants.externalClasses.INVALID, !field.isPotentiallyValid);

          // eslint-disable-next-line no-invalid-this
          this._state = {
            cards: merchantPayload.cards,
            fields: merchantPayload.fields
          };
          this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
        };
      }
      function isVisibleEnough(node) {
        var boundingBox = node.getBoundingClientRect();
        var verticalMidpoint = Math.floor(boundingBox.height / 2);
        var horizontalMidpoint = Math.floor(boundingBox.width / 2);
        return boundingBox.top < (window.innerHeight - verticalMidpoint || document.documentElement.clientHeight - verticalMidpoint) && boundingBox.right > horizontalMidpoint && boundingBox.bottom > verticalMidpoint && boundingBox.left < (window.innerWidth - horizontalMidpoint || document.documentElement.clientWidth - horizontalMidpoint);
      }

      /**
       * @class HostedFields
       * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
       * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
       */
      function HostedFields(options) {
        var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl;
        var self = this;
        var fields = {};
        var frameReadyPromiseResolveFunctions = {};
        var frameReadyPromises = [];
        var componentId = uuid();
        var sessionId = options.sessionId;
        this._merchantConfigurationOptions = assign({}, options);
        if (options.client) {
          clientConfig = options.client.getConfiguration(undefined, sessionId); // eslint-disable-line no-undefined
          assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
          isDebug = clientConfig.isDebug;
        } else {
          assetsUrl = createAssetsUrl.create(options.authorization);
          isDebug = Boolean(options.isDebug);
        }
        this._clientPromise = createDeferredClient.create({
          client: options.client,
          authorization: options.authorization,
          debug: isDebug,
          assetsUrl: assetsUrl,
          name: "Hosted Fields",
          sessionId: sessionId
        });
        hostedFieldsUrl = composeUrl(assetsUrl, componentId, isDebug);
        if (!options.fields || Object.keys(options.fields).length === 0) {
          throw new BraintreeError({
            type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
            code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
            message: "options.fields is required when instantiating Hosted Fields."
          });
        }
        EventEmitter.call(this);
        this._injectedNodes = [];
        this._destructor = new Destructor();
        this._fields = fields;
        this._state = {
          fields: {},
          cards: getCardTypes("")
        };
        this._bus = new Bus({
          channel: componentId,
          verifyDomain: isVerifiedDomain,
          targetFrames: [window]
        });
        this._destructor.registerFunctionForTeardown(function () {
          self._bus.teardown();
        });
        if (!options.client) {
          analytics.sendEvent(this._clientPromise, "custom.hosted-fields.initialized.deferred-client");
        } else {
          analytics.sendEvent(this._clientPromise, "custom.hosted-fields.initialized");
        }
        Object.keys(options.fields).forEach(function (key) {
          var field, externalContainer, internalContainer, frame, frameReadyPromise;
          if (!constants.allowedFields.hasOwnProperty(key)) {
            throw new BraintreeError({
              type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
              code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
              message: '"' + key + '" is not a valid field.'
            });
          }
          field = options.fields[key];
          // NEXT_MAJOR_VERSION remove selector as an option
          // and simply make the API take a container
          externalContainer = field.container || field.selector;
          if (typeof externalContainer === "string") {
            externalContainer = document.querySelector(externalContainer);
          }
          if (!externalContainer || externalContainer.nodeType !== 1) {
            throw new BraintreeError({
              type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
              code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
              message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
              details: {
                fieldSelector: field.selector,
                fieldContainer: field.container,
                fieldKey: key
              }
            });
          } else if (externalContainer.querySelector('iframe[name^="braintree-"]')) {
            throw new BraintreeError({
              type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
              code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
              message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
              details: {
                fieldSelector: field.selector,
                fieldContainer: field.container,
                fieldKey: key
              }
            });
          }
          internalContainer = externalContainer;
          if (shadow.isShadowElement(internalContainer)) {
            internalContainer = shadow.transformToSlot(internalContainer, "height: 100%");
          }
          if (field.maxlength && typeof field.maxlength !== "number") {
            throw new BraintreeError({
              type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
              code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
              message: "The value for maxlength must be a number.",
              details: {
                fieldKey: key
              }
            });
          }
          if (field.minlength && typeof field.minlength !== "number") {
            throw new BraintreeError({
              type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
              code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
              message: "The value for minlength must be a number.",
              details: {
                fieldKey: key
              }
            });
          }
          frame = iFramer({
            type: key,
            name: "braintree-hosted-field-" + key,
            style: constants.defaultIFrameStyle,
            title: field.iframeTitle || "Secure Credit Card Frame - " + constants.allowedFields[key].label
          });
          this._bus.addTargetFrame(frame);
          this._injectedNodes.push.apply(this._injectedNodes, injectFrame(componentId, frame, internalContainer, function () {
            self.focus(key);
          }));
          this._setupLabelFocus(key, externalContainer);
          fields[key] = {
            frameElement: frame,
            containerElement: externalContainer
          };
          frameReadyPromise = new Promise(function (resolve) {
            frameReadyPromiseResolveFunctions[key] = resolve;
          });
          frameReadyPromises.push(frameReadyPromise);
          this._state.fields[key] = {
            isEmpty: true,
            isValid: false,
            isPotentiallyValid: true,
            isFocused: false,
            container: externalContainer
          };

          // prevents loading the iframe from blocking the code
          setTimeout(function () {
            frame.src = hostedFieldsUrl;
          }, 0);
        }.bind(this));
        if (this._merchantConfigurationOptions.styles) {
          Object.keys(this._merchantConfigurationOptions.styles).forEach(function (selector) {
            var className = self._merchantConfigurationOptions.styles[selector];
            if (typeof className === "string") {
              self._merchantConfigurationOptions.styles[selector] = getStylesFromClass(className);
            }
          });
        }
        this._bus.on(events.REMOVE_FOCUS_INTERCEPTS, function (data) {
          destroyFocusIntercept(data && data.id);
        });
        this._bus.on(events.TRIGGER_FOCUS_CHANGE, focusChange.createFocusChangeHandler(componentId, {
          onRemoveFocusIntercepts: function (element) {
            self._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
              id: element
            });
          },
          onTriggerInputFocus: function (targetType) {
            self.focus(targetType);
          }
        }));
        this._bus.on(events.READY_FOR_CLIENT, function (reply) {
          self._clientPromise.then(function (client) {
            reply(client);
          });
        });
        this._bus.on(events.CARD_FORM_ENTRY_HAS_BEGUN, function () {
          analytics.sendEvent(self._clientPromise, "hosted-fields.input.started");
        });
        this._bus.on(events.BIN_AVAILABLE, function (bin) {
          self._emit("binAvailable", {
            bin: bin
          });
        });
        failureTimeout = setTimeout(function () {
          analytics.sendEvent(self._clientPromise, "custom.hosted-fields.load.timed-out");
          self._emit("timeout");
        }, INTEGRATION_TIMEOUT_MS);
        Promise.all(frameReadyPromises).then(function (results) {
          var reply = results[0];
          clearTimeout(failureTimeout);
          reply(formatMerchantConfigurationForIframes(self._merchantConfigurationOptions));
          self._cleanUpFocusIntercepts();
          self._emit("ready");
        });
        this._bus.on(events.FRAME_READY, function (data, reply) {
          frameReadyPromiseResolveFunctions[data.field](reply);
        });
        this._bus.on(events.INPUT_EVENT, createInputEventHandler(fields).bind(this));
        this._destructor.registerFunctionForTeardown(function () {
          var j, node, parent;
          for (j = 0; j < self._injectedNodes.length; j++) {
            node = self._injectedNodes[j];
            parent = node.parentNode;
            parent.removeChild(node);
            parent.classList.remove(constants.externalClasses.FOCUSED, constants.externalClasses.INVALID, constants.externalClasses.VALID);
          }
        });
        this._destructor.registerFunctionForTeardown(function () {
          destroyFocusIntercept();
        });
        this._destructor.registerFunctionForTeardown(function () {
          var methodNames = methods(HostedFields.prototype).concat(methods(EventEmitter.prototype));
          convertMethodsToError(self, methodNames);
        });
      }
      EventEmitter.createChild(HostedFields);
      HostedFields.prototype._setupLabelFocus = function (type, container) {
        var labels, i;
        var self = this;
        var rootNode = findRootNode(container);
        if (container.id == null) {
          return;
        }
        function triggerFocus() {
          self.focus(type);
        }

        // find any labels in the normal DOM
        labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
        if (rootNode !== document) {
          // find any labels within the shadow dom
          labels = labels.concat(Array.prototype.slice.call(rootNode.querySelectorAll('label[for="' + container.id + '"]')));
        }
        // find any labels surrounding the container that don't also have the `for` attribute
        labels = labels.concat(findParentTags(container, "label"));
        // filter out any accidental duplicates
        labels = labels.filter(function (label, index, arr) {
          return arr.indexOf(label) === index;
        });
        for (i = 0; i < labels.length; i++) {
          labels[i].addEventListener("click", triggerFocus, false);
        }
        this._destructor.registerFunctionForTeardown(function () {
          for (i = 0; i < labels.length; i++) {
            labels[i].removeEventListener("click", triggerFocus, false);
          }
        });
      };
      HostedFields.prototype._getAnyFieldContainer = function () {
        var self = this;
        return Object.keys(this._fields).reduce(function (found, field) {
          return found || self._fields[field].containerElement;
        }, null);
      };
      HostedFields.prototype._cleanUpFocusIntercepts = function () {
        var iframeContainer, checkoutForm;
        if (document.forms.length < 1) {
          this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
        } else {
          iframeContainer = this._getAnyFieldContainer();
          checkoutForm = findParentTags(iframeContainer, "form")[0];
          if (checkoutForm) {
            focusChange.removeExtraFocusElements(checkoutForm, function (id) {
              this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
                id: id
              });
            }.bind(this));
          } else {
            this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
          }
        }
      };
      HostedFields.prototype._attachInvalidFieldContainersToError = function (err) {
        if (!(err.details && err.details.invalidFieldKeys && err.details.invalidFieldKeys.length > 0)) {
          return;
        }
        err.details.invalidFields = {};
        err.details.invalidFieldKeys.forEach(function (field) {
          err.details.invalidFields[field] = this._fields[field].containerElement;
        }.bind(this));
      };

      /**
       * Get card verification challenges, such as requirements for cvv and postal code.
       * @public
       * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getChallenges` returns a promise.
       * @example
       * hostedFieldsInstance.getChallenges().then(function (challenges) {
       *   challenges // ['cvv', 'postal_code']
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.getChallenges = function () {
        return this._clientPromise.then(function (client) {
          return client.getConfiguration().gatewayConfiguration.challenges;
        });
      };

      /**
       * Get supported card types configured in the Braintree Control Panel
       * @public
       * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getSupportedCardTypes` returns a promise.
       * @example
       * hostedFieldsInstance.getSupportedCardTypes().then(function (cardTypes) {
       *   cardTypes // ['Visa', 'American Express', 'Mastercard']
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.getSupportedCardTypes = function () {
        return this._clientPromise.then(function (client) {
          var cards = client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes.map(function (cardType) {
            if (cardType === "MasterCard") {
              // Mastercard changed their branding. We can't update our
              // config without creating a breaking change, so we just
              // hard code the change here
              return "Mastercard";
            }
            return cardType;
          });
          return cards;
        });
      };

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
       * @public
       * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
       * @example
       * hostedFieldsInstance.teardown(function (teardownErr) {
       *   if (teardownErr) {
       *     console.error('Could not tear down Hosted Fields!');
       *   } else {
       *     console.info('Hosted Fields has been torn down!');
       *   }
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.teardown = function () {
        var self = this;
        return new Promise(function (resolve, reject) {
          self._destructor.teardown(function (err) {
            analytics.sendEvent(self._clientPromise, "custom.hosted-fields.teardown-completed");
            if (err) {
              reject(err);
            } else {
              resolve();
            }
          });
        });
      };

      /**
       * Tokenizes fields and returns a nonce payload.
       * @public
       * @param {object} [options] All tokenization options for the Hosted Fields component.
       * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID. Note: merchants using Advanced Fraud Tools should not use this option, as device data will not be included.
       * @param {object} [options.authenticationInsight] Options for checking authentication insight - the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card.
       * @param {string} options.authenticationInsight.merchantAccountId The Braintree merchant account id to use to look up the authentication insight information.
       * @param {array} [options.fieldsToTokenize] By default, all fields will be tokenized. You may specify which fields specifically you wish to tokenize with this property. Valid options are `'number'`, `'cvv'`, `'expirationDate'`, `'expirationMonth'`, `'expirationYear'`, `'postalCode'`, `'cardholderName'`.
       * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
       * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
       * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
       * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
       *
       * @param {callback} [callback] May be used as the only parameter of the function if no options are passed in. The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
       * @example <caption>Tokenize a card</caption>
       * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     switch (tokenizeErr.code) {
       *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
       *         // occurs when none of the fields are filled in
       *         console.error('All fields are empty! Please fill out the form.');
       *         break;
       *       case 'HOSTED_FIELDS_FIELDS_INVALID':
       *         // occurs when certain fields do not pass client side validation
       *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
       *
       *         // you can also programmatically access the field containers for the invalid fields
       *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
       *           fieldContainer.className = 'invalid';
       *         });
       *         break;
       *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
       *         // occurs when:
       *         //   * the client token used for client authorization was generated
       *         //     with a customer ID and the fail on duplicate payment method
       *         //     option is set to true
       *         //   * the card being tokenized has previously been vaulted (with any customer)
       *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.fail_on_duplicate_payment_method
       *         console.error('This payment method already exists in your vault.');
       *         break;
       *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
       *         // occurs when:
       *         //   * the client token used for client authorization was generated
       *         //     with a customer ID and the verify card option is set to true
       *         //     and you have credit card verification turned on in the Braintree
       *         //     control panel
       *         //   * the cvv does not pass verification (https://developer.paypal.com/braintree/docs/reference/general/testing#avs-and-cvv/cid-responses)
       *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.verify_card
       *         console.error('CVV did not pass verification');
       *         break;
       *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
       *         // occurs for any other tokenization error on the server
       *         console.error('Tokenization failed server side. Is the card valid?');
       *         break;
       *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
       *         // occurs when the Braintree gateway cannot be contacted
       *         console.error('Network error occurred when tokenizing.');
       *         break;
       *       default:
       *         console.error('Something bad happened!', tokenizeErr);
       *     }
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @example <caption>Tokenize and vault a card</caption>
       * hostedFieldsInstance.tokenize({
       *   vault: true
       * }, function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     console.error(tokenizeErr);
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @example <caption>Tokenize a card with non-Hosted Fields cardholder name</caption>
       * hostedFieldsInstance.tokenize({
       *   cardholderName: 'First Last'
       * }, function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     console.error(tokenizeErr);
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @example <caption>Tokenize a card with non-Hosted Fields postal code option</caption>
       * hostedFieldsInstance.tokenize({
       *   billingAddress: {
       *     postalCode: '11111'
       *   }
       * }, function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     console.error(tokenizeErr);
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @example <caption>Tokenize a card with additional billing address options</caption>
       * hostedFieldsInstance.tokenize({
       *   billingAddress: {
       *     firstName: 'First',
       *     lastName: 'Last',
       *     company: 'Company',
       *     streetAddress: '123 Street',
       *     extendedAddress: 'Unit 1',
       *     // passing just one of the country options is sufficient to
       *     // associate the card details with a particular country
       *     // valid country names and codes can be found here:
       *     // https://developer.paypal.com/braintree/docs/reference/general/countries/ruby#list-of-countries
       *     countryName: 'United States',
       *     countryCodeAlpha2: 'US',
       *     countryCodeAlpha3: 'USA',
       *     countryCodeNumeric: '840'
       *   }
       * }, function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     console.error(tokenizeErr);
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @example <caption>Allow tokenization with empty cardholder name field</caption>
       * var state = hostedFieldsInstance.getState();
       * var fields = Object.keys(state.fields);
       *
       * // normally, if you tried to tokenize an empty cardholder name field
       * // you would get an error, to allow making this field optional,
       * // tokenize all the fields except for the cardholder name field
       * // when the cardholder name field is empty. Otherwise, tokenize
       * // all the fields
       * if (state.fields.cardholderName.isEmpty) {
       *  fields = fields.filter(function (field) {
       *    return field !== 'cardholderName';
       *  });
       * }
       *
       * hostedFieldsInstance.tokenize({
       *  fieldsToTokenize: fields
       * }, function (tokenizeErr, payload) {
       *   if (tokenizeErr) {
       *     console.error(tokenizeErr);
       *   } else {
       *     console.log('Got nonce:', payload.nonce);
       *   }
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.tokenize = function (options) {
        var self = this;
        if (!options) {
          options = {};
        }
        return new Promise(function (resolve, reject) {
          self._bus.emit(events.TOKENIZATION_REQUEST, options, function (response) {
            var err = response[0];
            var payload = response[1];
            if (err) {
              self._attachInvalidFieldContainersToError(err);
              reject(new BraintreeError(err));
            } else {
              resolve(payload);
            }
          });
        });
      };

      /**
       * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
       * @public
       * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {string} classname The class to be added.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
       *
       * @example
       * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
       *   if (addClassErr) {
       *     console.error(addClassErr);
       *   }
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.addClass = function (field, classname) {
        var err;
        if (!allowedFields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
          });
        } else if (!this._fields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          this._bus.emit(events.ADD_CLASS, {
            field: field,
            classname: classname
          });
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
       * @public
       * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {string} classname The class to be removed.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
       *
       * @example
       * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
       *   if (addClassErr) {
       *     console.error(addClassErr);
       *     return;
       *   }
       *
       *   // some time later...
       *   hostedFieldsInstance.removeClass('number', 'custom-class');
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.removeClass = function (field, classname) {
        var err;
        if (!allowedFields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
          });
        } else if (!this._fields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          this._bus.emit(events.REMOVE_CLASS, {
            field: field,
            classname: classname
          });
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
       * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
       *
       * @public
       * @param {object} options The options for the attribute you wish to set.
       * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {string} options.attribute The name of the attribute you wish to add to the field.
       * @param {string} options.value The value for the attribute.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
       *
       * @example <caption>Set the placeholder attribute of a field</caption>
       * hostedFieldsInstance.setAttribute({
       *   field: 'number',
       *   attribute: 'placeholder',
       *   value: '1111 1111 1111 1111'
       * }, function (attributeErr) {
       *   if (attributeErr) {
       *     console.error(attributeErr);
       *   }
       * });
       *
       * @example <caption>Set the aria-required attribute of a field</caption>
       * hostedFieldsInstance.setAttribute({
       *   field: 'number',
       *   attribute: 'aria-required',
       *   value: true
       * }, function (attributeErr) {
       *   if (attributeErr) {
       *     console.error(attributeErr);
       *   }
       * });
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.setAttribute = function (options) {
        var attributeErr, err;
        if (!allowedFields.hasOwnProperty(options.field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
          });
        } else if (!this._fields.hasOwnProperty(options.field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          attributeErr = attributeValidationError(options.attribute, options.value);
          if (attributeErr) {
            err = attributeErr;
          } else {
            this._bus.emit(events.SET_ATTRIBUTE, {
              field: options.field,
              attribute: options.attribute,
              value: options.value
            });
          }
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * Sets the month options for the expiration month field when presented as a select element.
       *
       * @public
       * @param {array} options An array of 12 entries corresponding to the 12 months.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the options are updated successfully. Errors if expirationMonth is not configured on the Hosted Fields instance or if the expirationMonth field is not configured to be a select input.
       *
       * @example <caption>Update the month options to spanish</caption>
       * hostedFieldsInstance.setMonthOptions([
       *   '01 - enero',
       *   '02 - febrero',
       *   '03 - marzo',
       *   '04 - abril',
       *   '05 - mayo',
       *   '06 - junio',
       *   '07 - julio',
       *   '08 - agosto',
       *   '09 - septiembre',
       *   '10 - octubre',
       *   '11 - noviembre',
       *   '12 - diciembre'
       * ]);
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.setMonthOptions = function (options) {
        var self = this;
        var merchantOptions = this._merchantConfigurationOptions.fields;
        var errorMessage;
        if (!merchantOptions.expirationMonth) {
          errorMessage = "Expiration month field must exist to use setMonthOptions.";
        } else if (!merchantOptions.expirationMonth.select) {
          errorMessage = "Expiration month field must be a select element.";
        }
        if (errorMessage) {
          return Promise.reject(new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
            message: errorMessage
          }));
        }
        return new Promise(function (resolve) {
          self._bus.emit(events.SET_MONTH_OPTIONS, options, resolve);
        });
      };

      /**
       * Sets a visually hidden message (for screen readers) on a {@link module:braintree-web/hosted-fields~field field}.
       *
       * @public
       * @param {object} options The options for the attribute you wish to set.
       * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
       * @param {string} options.message The message to set.
       *
       * @example <caption>Set an error message on a field</caption>
       * hostedFieldsInstance.setMessage({
       *   field: 'number',
       *   message: 'Invalid card number'
       * });
       *
       * @example <caption>Remove the message on a field</caption>
       * hostedFieldsInstance.setMessage({
       *   field: 'number',
       *   message: ''
       * });
       *
       * @returns {void}
       */
      HostedFields.prototype.setMessage = function (options) {
        this._bus.emit(events.SET_MESSAGE, {
          field: options.field,
          message: options.message
        });
      };

      /**
       * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
       *
       * @public
       * @param {object} options The options for the attribute you wish to remove.
       * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {string} options.attribute The name of the attribute you wish to remove from the field.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
       *
       * @example <caption>Remove the placeholder attribute of a field</caption>
       * hostedFieldsInstance.removeAttribute({
       *   field: 'number',
       *   attribute: 'placeholder'
       * }, function (attributeErr) {
       *   if (attributeErr) {
       *     console.error(attributeErr);
       *   }
       * });
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.removeAttribute = function (options) {
        var attributeErr, err;
        if (!allowedFields.hasOwnProperty(options.field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
          });
        } else if (!this._fields.hasOwnProperty(options.field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          attributeErr = attributeValidationError(options.attribute);
          if (attributeErr) {
            err = attributeErr;
          } else {
            this._bus.emit(events.REMOVE_ATTRIBUTE, {
              field: options.field,
              attribute: options.attribute
            });
          }
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
       *
       * @public
       * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      HostedFields.prototype.setPlaceholder = function (field, placeholder) {
        return this.setAttribute({
          field: field,
          attribute: "placeholder",
          value: placeholder
        });
      };

      /**
       * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
       * @public
       * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * hostedFieldsInstance.clear('number', function (clearErr) {
       *   if (clearErr) {
       *     console.error(clearErr);
       *   }
       * });
       *
       * @example <caption>Clear several fields</caption>
       * hostedFieldsInstance.clear('number');
       * hostedFieldsInstance.clear('cvv');
       * hostedFieldsInstance.clear('expirationDate');
       */
      HostedFields.prototype.clear = function (field) {
        var err;
        if (!allowedFields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
          });
        } else if (!this._fields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          this._bus.emit(events.CLEAR_FIELD, {
            field: field
          });
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
       * @public
       * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
       * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
       * @returns {void}
       * @example
       * hostedFieldsInstance.focus('number', function (focusErr) {
       *   if (focusErr) {
       *     console.error(focusErr);
       *   }
       * });
       * @example <caption>Using an event listener</caption>
       * myElement.addEventListener('click', function (e) {
       *   // In Firefox, the focus method can be suppressed
       *   //   if the element has a tabindex property or the element
       *   //   is an anchor link with an href property.
       *   e.preventDefault();
       *   hostedFieldsInstance.focus('number');
       * });
       */
      HostedFields.prototype.focus = function (field) {
        var err;
        var fieldConfig = this._fields[field];
        if (!allowedFields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
            code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
            message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
          });
        } else if (!this._fields.hasOwnProperty(field)) {
          err = new BraintreeError({
            type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
            code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
            message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
          });
        } else {
          fieldConfig.frameElement.focus();
          this._bus.emit(events.TRIGGER_INPUT_FOCUS, {
            field: field
          });
          if (browserDetection.isIos()) {
            // Inputs outside of the viewport don't always scroll into view on
            // focus in iOS Safari. 5ms timeout gives the browser a chance to
            // do the right thing and prevents stuttering.
            setTimeout(function () {
              if (!isVisibleEnough(fieldConfig.containerElement)) {
                fieldConfig.containerElement.scrollIntoView();
              }
            }, SAFARI_FOCUS_TIMEOUT);
          }
        }
        if (err) {
          return Promise.reject(err);
        }
        return Promise.resolve();
      };

      /**
       * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
       * @public
       * @returns {object} {@link HostedFields~stateObject|stateObject}
       * @example <caption>Check if all fields are valid</caption>
       * var state = hostedFieldsInstance.getState();
       *
       * var formValid = Object.keys(state.fields).every(function (key) {
       *   return state.fields[key].isValid;
       * });
       */
      HostedFields.prototype.getState = function () {
        return this._state;
      };

      // React adds decorations to DOM nodes that cause
      // circular dependencies, so we remove them from the
      // config before sending it to the iframes. However,
      // we don't want to mutate the original object that
      // was passed in, so we create fresh objects via assign
      function formatMerchantConfigurationForIframes(config) {
        var formattedConfig = assign({}, config);
        formattedConfig.fields = assign({}, formattedConfig.fields);
        Object.keys(formattedConfig.fields).forEach(function (field) {
          formattedConfig.fields[field] = assign({}, formattedConfig.fields[field]);
          delete formattedConfig.fields[field].container;
        });
        return formattedConfig;
      }
      module.exports = wrapPromise.wrapPrototype(HostedFields);
    }, {
      "../../lib/analytics": 135,
      "../../lib/assign": 137,
      "../../lib/braintree-error": 140,
      "../../lib/constants": 142,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/create-assets-url": 145,
      "../../lib/create-deferred-client": 147,
      "../../lib/destructor": 149,
      "../../lib/errors": 151,
      "../../lib/find-root-node": 152,
      "../../lib/is-verified-domain": 170,
      "../../lib/methods": 172,
      "../../lib/shadow": 175,
      "../shared/browser-detection": 127,
      "../shared/constants": 128,
      "../shared/errors": 129,
      "../shared/find-parent-tags": 130,
      "../shared/focus-intercept": 131,
      "../shared/get-card-types": 132,
      "./attribute-validation-error": 120,
      "./compose-url": 121,
      "./focus-change": 122,
      "./get-styles-from-class": 123,
      "./inject-frame": 125,
      "@braintree/event-emitter": 30,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "@braintree/wrap-promise": 40,
      "framebus": 50
    }],
    125: [function (_dereq_, module, exports) {
      "use strict";

      var focusIntercept = _dereq_("../shared/focus-intercept");
      var directions = _dereq_("../shared/constants").navigationDirections;
      module.exports = function injectFrame(id, frame, container, focusHandler) {
        var frameType = frame.getAttribute("type");
        var clearboth = document.createElement("div");
        var fragment = document.createDocumentFragment();
        var focusInterceptBefore = focusIntercept.generate(id, frameType, directions.BACK, focusHandler);
        var focusInterceptAfter = focusIntercept.generate(id, frameType, directions.FORWARD, focusHandler);
        clearboth.style.clear = "both";
        fragment.appendChild(focusInterceptBefore);
        fragment.appendChild(frame);
        fragment.appendChild(focusInterceptAfter);
        fragment.appendChild(clearboth);
        container.appendChild(fragment);
        return [frame, clearboth];
      };
    }, {
      "../shared/constants": 128,
      "../shared/focus-intercept": 131
    }],
    126: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/hosted-fields */
      var HostedFields = _dereq_("./external/hosted-fields");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var errors = _dereq_("./shared/errors");
      var supportsInputFormatting = _dereq_("restricted-input/supports-input-formatting");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var VERSION = "3.115.2";

      /**
       * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
       * @typedef {object} field
       * @property {string} selector Deprecated: Now an alias for `options.container`.
       * @property {(string|HTMLElement)} container A DOM node or CSS selector to find the container where the hosted field will be inserted.
       * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
       * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
       * @property {string} [iframeTitle] The title used for the iframe containing the credit card input. By default, this will be `Secure Credit Card Frame - <the name of the specific field>`.
       * @property {string} [internalLabel] Each Hosted Field iframe has a hidden label that is used by screen readers to identify the input. The `internalLabel` property can be used to customize the field for localization purposes. The default values are:
       * * number: Credit Card Number
       * * cvv: CVV
       * * expirationDate: Expiration Date
       * * expirationMonth: Expiration Month
       * * expirationYear: Expiration Year
       * * postalCode: Postal Code
       * * cardholderName: Cardholder Name
       * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
       * @property {(object|boolean)} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
       * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
       * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
       * @property {(object|boolean)} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
       * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
       * @property {number} [maxCardLength] This option applies only to the number field. Allows a limit to the length of the card number, even if the card brand may support numbers of a greater length. If the value passed is greater than the max length for a card brand, the smaller number of the 2 values will be used. For example, is `maxCardLength` is set to 16, but an American Express card is entered (which has a max card length of 15), a max card length of 15 will be used.
       * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and setting the length of the postal code input when cards are coming from a known region. The default `maxlength` for the postal code input is `10`.
       * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
       * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
       * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
       * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
       * @property {boolean} [rejectUnsupportedCards=false] Deprecated since version 3.46.0, use `supportedCardBrands` instead. Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
       * @property {object} [supportedCardBrands] Override card brands that are supported by the card form. Pass `'card-brand-id': true` to override the default in the merchant configuration and enable a card brand. Pass `'card-brand-id': false` to disable a card brand. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering an American Express card would get an invalid card field. This can only be used for the  `number` field. (Note: only allow card types that your merchant account is actually able to process.)
       *
       * Valid card brand ids are:
       * * visa
       * * mastercard
       * * american-express
       * * diners-club
       * * discover
       * * jcb
       * * union-pay
       * * maestro
       * * elo
       * * mir
       * * hiper
       * * hipercard
       */

      /**
       * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
       * @typedef {object} fieldOptions
       * @property {field} [number] A field for card number.
       * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` or `MM/YY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
       * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
       * @property {field} [expirationYear] A field for expiration year in `YYYY` or `YY` format. This should be used with the `expirationMonth` property.
       * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
       * @property {field} [postalCode] A field for postal or region code.
       * @property {field} [cardholderName] A field for the cardholder name on the customer's credit card.
       */

      /**
       * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
       *
       * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recommended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
       *
       * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
       *
       * Supported CSS properties are:
       * `appearance`
       * `box-shadow`
       * `color`
       * `direction`
       * `font-family`
       * `font-size-adjust`
       * `font-size`
       * `font-stretch`
       * `font-style`
       * `font-variant-alternates`
       * `font-variant-caps`
       * `font-variant-east-asian`
       * `font-variant-ligatures`
       * `font-variant-numeric`
       * `font-variant`
       * `font-weight`
       * `font`
       * `letter-spacing`
       * `line-height`
       * `opacity`
       * `outline`
       * `margin`
       * `margin-top`
       * `margin-right`
       * `margin-bottom`
       * `margin-left`
       * `padding`
       * `padding-top`
       * `padding-right`
       * `padding-bottom`
       * `padding-left`
       * `text-align`
       * `text-shadow`
       * `transition`
       * `-moz-appearance`
       * `-moz-box-shadow`
       * `-moz-osx-font-smoothing`
       * `-moz-tap-highlight-color`
       * `-moz-transition`
       * `-webkit-appearance`
       * `-webkit-box-shadow`
       * `-webkit-font-smoothing`
       * `-webkit-tap-highlight-color`
       * `-webkit-transition`
       * @typedef {object} styleOptions
       */

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
       * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
       * @param {boolean} [options.preventAutofill=false] When true, browsers will not try to prompt the customer to autofill their credit card information.
       * @param {string} [options.sessionId] Used in specific cases where associating SDK events with a specific external id is required.
       * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
       * @returns {void}
       * @example
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   styles: {
       *     'input': {
       *       'font-size': '16pt',
       *       'color': '#3A3A3A'
       *     },
       *     '.number': {
       *       'font-family': 'monospace'
       *     },
       *     '.valid': {
       *       'color': 'green'
       *     }
       *   },
       *   fields: {
       *     number: {
       *       container: '#card-number'
       *     },
       *     cvv: {
       *       container: '#cvv',
       *       placeholder: '•••'
       *     },
       *     expirationDate: {
       *       container: '#expiration-date'
       *     }
       *   }
       * }, callback);
       * @example <caption>With cardholder name</caption>
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   fields: {
       *     number: {
       *       container: '#card-number'
       *     },
       *     cardholderName: {
       *       container: '#cardholder-name'
       *     },
       *     cvv: {
       *       container: '#cvv',
       *     },
       *     expirationDate: {
       *       container: '#expiration-date'
       *     }
       *   }
       * }, callback);
       * @example <caption>Applying styles with a class name</caption>
       * // in document head
       * <style>
       *   .braintree-input-class {
       *     color: black;
       *   }
       *   .braintree-valid-class {
       *     color: green;
       *   }
       *   .braintree-invalid-class {
       *     color: red;
       *   }
       * </style>
       * // in a script tag
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   styles: {
       *     'input': 'braintree-input-class',
       *     '.invalid': 'braintree-invalid-class',
       *     '.valid': {
       *       // you can also use the object syntax alongside
       *       // the class name syntax
       *       color: green;
       *     }
       *   },
       *   fields: {
       *     number: {
       *       container: '#card-number'
       *     },
       *     // etc...
       *   }
       * }, callback);
       * @example <caption>Right to Left Language Support</caption>
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   styles: {
       *     'input': {
       *       // other styles
       *       direction: 'rtl'
       *     },
       *   },
       *   fields: {
       *     number: {
       *       container: '#card-number',
       *       // Credit card formatting is not currently supported
       *       // with RTL languages, so we need to turn it off for the number input
       *       formatInput: false
       *     },
       *     cvv: {
       *       container: '#cvv',
       *       placeholder: '•••'
       *     },
       *     expirationDate: {
       *       container: '#expiration-date',
       *       type: 'month'
       *     }
       *   }
       * }, callback);
       * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   fields: {
       *     // Only add the `cvv` option.
       *     cvv: {
       *       container: '#cvv',
       *       placeholder: '•••'
       *     }
       *   }
       * }, callback);
       * @example <caption>Creating an expiration date update form with prefilled data</caption>
       * var storedCreditCardInformation = {
       *   // get this info from your server
       *   // with a payment method lookup
       *   month: '09',
       *   year: '2017'
       * };
       *
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   fields: {
       *     expirationMonth: {
       *       container: '#expiration-month',
       *       prefill: storedCreditCardInformation.month
       *     },
       *     expirationYear: {
       *       container: '#expiration-year',
       *       prefill: storedCreditCardInformation.year
       *     }
       *   }
       * }, callback);
       * @example <caption>Validate the card form for supported card types</caption>
       * braintree.hostedFields.create({
       *   client: clientInstance,
       *   fields: {
       *     number: {
       *       container: '#card-number',
       *       supportedCardBrands: {
       *         visa: false, // prevents Visas from showing up as valid even when the Braintree control panel is configured to allow them
       *         'diners-club': true // allow Diners Club cards to be valid (processed as Discover cards on the Braintree backend)
       *       }
       *     },
       *     cvv: {
       *       container: '#cvv',
       *       placeholder: '•••'
       *     },
       *     expirationDate: {
       *       container: '#expiration-date',
       *       type: 'month'
       *     }
       *   },
       * }, callback);
       */
      function create(options) {
        return basicComponentVerification.verify({
          name: "Hosted Fields",
          authorization: options.authorization,
          client: options.client
        }).then(function () {
          var integration = new HostedFields(options);
          return new Promise(function (resolve, reject) {
            integration.on("ready", function () {
              resolve(integration);
            });
            integration.on("timeout", function () {
              reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
            });
          });
        });
      }
      module.exports = {
        /**
         * @static
         * @function supportsInputFormatting
         * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/main/README.md#browsers-where-formatting-is-turned-off-automatically).
         * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
         * @example
         * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
         * var canFormat = braintree.hostedFields.supportsInputFormatting();
         * var fields = {
         *   number: {
         *     container: '#card-number'
         *   },
         *   cvv: {
         *     container: '#cvv'
         *   }
         * };
         *
         * if (canFormat) {
         *   fields.expirationDate = {
         *     selection: '#expiration-date'
         *   };
         *   functionToCreateAndInsertExpirationDateDivToForm();
         * } else {
         *   fields.expirationMonth = {
         *     selection: '#expiration-month'
         *   };
         *   fields.expirationYear = {
         *     selection: '#expiration-year'
         *   };
         *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
         * }
         *
         * braintree.hostedFields.create({
         *   client: clientInstance,
         *   styles: {
         *     // Styles
         *   },
         *   fields: fields
         * }, callback);
         */
        supportsInputFormatting: supportsInputFormatting,
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "./external/hosted-fields": 124,
      "./shared/errors": 129,
      "@braintree/wrap-promise": 40,
      "restricted-input/supports-input-formatting": 84
    }],
    127: [function (_dereq_, module, exports) {
      "use strict";

      var isAndroid = _dereq_("@braintree/browser-detection/is-android");
      var isChromeOS = _dereq_("@braintree/browser-detection/is-chrome-os");
      var isIos = _dereq_("@braintree/browser-detection/is-ios");
      var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
      function hasSoftwareKeyboard() {
        return isAndroid() || isChromeOS() || isIos();
      }
      function isChromeIos() {
        return isChrome() && isIos();
      }
      module.exports = {
        isAndroid: isAndroid,
        isChromeOS: isChromeOS,
        isChromeIos: isChromeIos,
        isFirefox: _dereq_("@braintree/browser-detection/is-firefox"),
        isIos: isIos,
        isIosWebview: _dereq_("@braintree/browser-detection/is-ios-webview"),
        hasSoftwareKeyboard: hasSoftwareKeyboard
      };
    }, {
      "@braintree/browser-detection/is-android": 20,
      "@braintree/browser-detection/is-chrome": 22,
      "@braintree/browser-detection/is-chrome-os": 21,
      "@braintree/browser-detection/is-firefox": 23,
      "@braintree/browser-detection/is-ios": 27,
      "@braintree/browser-detection/is-ios-webview": 25
    }],
    128: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("../../lib/enumerate");
      var errors = _dereq_("./errors");
      var VERSION = "3.115.2";
      var constants = {
        VERSION: VERSION,
        maxExpirationYearAge: 19,
        externalEvents: {
          FOCUS: "focus",
          BLUR: "blur",
          EMPTY: "empty",
          NOT_EMPTY: "notEmpty",
          VALIDITY_CHANGE: "validityChange",
          CARD_TYPE_CHANGE: "cardTypeChange"
        },
        defaultMaxLengths: {
          number: 19,
          postalCode: 8,
          expirationDate: 7,
          expirationMonth: 2,
          expirationYear: 4,
          cvv: 3
        },
        externalClasses: {
          FOCUSED: "braintree-hosted-fields-focused",
          INVALID: "braintree-hosted-fields-invalid",
          VALID: "braintree-hosted-fields-valid"
        },
        navigationDirections: {
          BACK: "before",
          FORWARD: "after"
        },
        defaultIFrameStyle: {
          border: "none",
          width: "100%",
          height: "100%",
          float: "left"
        },
        tokenizationErrorCodes: {
          81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
          // NEXT_MAJOR_VERSION this error triggers for both AVS and CVV errors
          // but the code name implies that it would only trigger for CVV verification
          // failures
          81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
        },
        allowedStyles: ["-moz-appearance", "-moz-box-shadow", "-moz-osx-font-smoothing", "-moz-tap-highlight-color", "-moz-transition", "-webkit-appearance", "-webkit-box-shadow", "-webkit-font-smoothing", "-webkit-tap-highlight-color", "-webkit-text-fill-color", "-webkit-transition", "appearance", "box-shadow", "color", "direction", "font", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-weight", "letter-spacing", "line-height", "margin", "margin-top", "margin-right", "margin-bottom", "margin-left", "opacity", "outline", "padding", "padding-top", "padding-right", "padding-bottom", "padding-left", "text-align", "text-shadow", "transition"],
        allowedFields: {
          cardholderName: {
            name: "cardholder-name",
            label: "Cardholder Name"
          },
          number: {
            name: "credit-card-number",
            label: "Credit Card Number"
          },
          cvv: {
            name: "cvv",
            label: "CVV"
          },
          expirationDate: {
            name: "expiration",
            label: "Expiration Date"
          },
          expirationMonth: {
            name: "expiration-month",
            label: "Expiration Month"
          },
          expirationYear: {
            name: "expiration-year",
            label: "Expiration Year"
          },
          postalCode: {
            name: "postal-code",
            label: "Postal Code"
          }
        },
        allowedAttributes: {
          "aria-invalid": "boolean",
          "aria-required": "boolean",
          disabled: "boolean",
          placeholder: "string"
        },
        allowedBillingAddressFields: ["company", "countryCodeNumeric", "countryCodeAlpha2", "countryCodeAlpha3", "countryName", "extendedAddress", "locality", "region", "firstName", "lastName", "postalCode", "streetAddress"],
        allowedShippingAddressFields: ["company", "countryCodeNumeric", "countryCodeAlpha2", "countryCodeAlpha3", "countryName", "extendedAddress", "locality", "region", "firstName", "lastName", "postalCode", "streetAddress"],
        autocompleteMappings: {
          "cardholder-name": "cc-name",
          "credit-card-number": "cc-number",
          expiration: "cc-exp",
          "expiration-month": "cc-exp-month",
          "expiration-year": "cc-exp-year",
          cvv: "cc-csc",
          "postal-code": "billing postal-code"
        }
      };
      constants.events = enumerate(["ADD_CLASS", "AUTOFILL_DATA_AVAILABLE", "BIN_AVAILABLE", "CARD_FORM_ENTRY_HAS_BEGUN", "CLEAR_FIELD", "CONFIGURATION", "FRAME_READY", "INPUT_EVENT", "READY_FOR_CLIENT", "REMOVE_ATTRIBUTE", "REMOVE_CLASS", "REMOVE_FOCUS_INTERCEPTS", "SET_ATTRIBUTE", "SET_MESSAGE", "SET_MONTH_OPTIONS", "TOKENIZATION_REQUEST", "TRIGGER_FOCUS_CHANGE", "TRIGGER_INPUT_FOCUS", "VALIDATE_STRICT"], "hosted-fields:");
      module.exports = constants;
    }, {
      "../../lib/enumerate": 150,
      "./errors": 129
    }],
    129: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Hosted Fields - Creation Error Codes
       * @description Errors that occur when [creating the Hosted Fields component](./module-braintree-web_hosted-fields.html#.create).
       * @property {UNKNOWN} HOSTED_FIELDS_TIMEOUT Occurs when Hosted Fields does not finish setting up within 60 seconds.
       * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_KEY Occurs when Hosted Fields is instantiated with an invalid Field option.
       * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_SELECTOR Occurs when Hosted Fields given a field selector that is not valid.
       * @property {MERCHANT} HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME Occurs when Hosted Fields given a field selector that already contains an iframe.
       * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
       */

      /**
       * @name BraintreeError.Hosted Fields - Field Manipulation Error Codes
       * @description Errors that occur when modifying fields through [`addClass`](./HostedFields.html#addClass), [`removeClass`](./HostedFields.html#removeClass), [`setAttribute`](./HostedFields.html#setAttribute), [`removeAttribute`](./HostedFields.html#removeAttribute), [`clear`](./HostedFields.html#clear), [`focus`](./HostedFields.html#focus), and [`setMonthOptions`](./HostedFields.html#setMonthOptions).
       * @property {MERCHANT} HOSTED_FIELDS_FIELD_INVALID Occurs when attempting to modify a field that is not a valid Hosted Fields option.
       * @property {MERCHANT} HOSTED_FIELDS_FIELD_NOT_PRESENT Occurs when attempting to modify a field that is not configured with Hosted Fields.
       * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
       */

      /**
       * @name BraintreeError.Hosted Fields - Set Attribute Error Codes
       * @description Errors that occur when using the [`setAttribute` method](./HostedFields.html#setAttribute)
       * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED Occurs when trying to set an attribute that is not supported to be set.
       * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED Occurs when the type of value for an attribute is not allowed to be set.
       */

      /**
       * @name BraintreeError.Hosted Fields - Tokenize Error Codes
       * @description Errors that occur when [tokenizing the card details with Hosted Fields](./HostedFields.html#tokenize).
       * @property {NETWORK} HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be contacted.
       * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE Occurs when attempting to vault a card, but the client token being used is configured to fail if the card already exists in the vault.
       * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED Occurs when cvv verification is turned on in the Braintree control panel.
       * @property {CUSTOMER} HOSTED_FIELDS_FAILED_TOKENIZATION Occurs when the credit card details were sent to Braintree, but failed to tokenize.
       * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_EMPTY Occurs when all the Hosted Fields inputs are empty.
       * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_INVALID Occurs when one ore more fields are invalid.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        HOSTED_FIELDS_TIMEOUT: {
          type: BraintreeError.types.UNKNOWN,
          code: "HOSTED_FIELDS_TIMEOUT",
          message: "Hosted Fields timed out when attempting to set up."
        },
        HOSTED_FIELDS_INVALID_FIELD_KEY: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_INVALID_FIELD_KEY"
        },
        HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_INVALID_FIELD_SELECTOR",
          message: "Selector does not reference a valid DOM node."
        },
        HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME",
          message: "Element already contains a Braintree iframe."
        },
        HOSTED_FIELDS_FIELD_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_FIELD_INVALID"
        },
        HOSTED_FIELDS_FIELD_NOT_PRESENT: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_FIELD_NOT_PRESENT"
        },
        HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR",
          message: "A tokenization network error occurred."
        },
        HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
          type: BraintreeError.types.CUSTOMER,
          code: "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE",
          message: "This credit card already exists in the merchant's vault."
        },
        HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
          type: BraintreeError.types.CUSTOMER,
          code: "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED",
          message: "CVV verification failed during tokenization."
        },
        HOSTED_FIELDS_FAILED_TOKENIZATION: {
          type: BraintreeError.types.CUSTOMER,
          code: "HOSTED_FIELDS_FAILED_TOKENIZATION",
          message: "The supplied card data failed tokenization."
        },
        HOSTED_FIELDS_FIELDS_EMPTY: {
          type: BraintreeError.types.CUSTOMER,
          code: "HOSTED_FIELDS_FIELDS_EMPTY",
          message: "All fields are empty. Cannot tokenize empty card fields."
        },
        HOSTED_FIELDS_FIELDS_INVALID: {
          type: BraintreeError.types.CUSTOMER,
          code: "HOSTED_FIELDS_FIELDS_INVALID",
          message: "Some payment input fields are invalid. Cannot tokenize invalid card fields."
        },
        HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED"
        },
        HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED"
        },
        HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "HOSTED_FIELDS_FIELD_PROPERTY_INVALID"
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    130: [function (_dereq_, module, exports) {
      "use strict";

      function findParentTags(element, tag) {
        var parent = element.parentNode;
        var parents = [];
        while (parent != null) {
          if (parent.tagName != null && parent.tagName.toLowerCase() === tag) {
            parents.push(parent);
          }
          parent = parent.parentNode;
        }
        return parents;
      }
      module.exports = findParentTags;
    }, {}],
    131: [function (_dereq_, module, exports) {
      "use strict";

      var browserDetection = _dereq_("./browser-detection");
      var constants = _dereq_("./constants");
      var allowedFields = Object.keys(constants.allowedFields);
      var directions = constants.navigationDirections;
      var focusIntercept = {
        generate: function (hostedFieldsId, type, direction, handler) {
          var input = document.createElement("input");
          var focusInterceptStyles = {
            border: "none !important",
            display: "block !important",
            height: "1px !important",
            left: "-1px !important",
            opacity: "0 !important",
            position: "absolute !important",
            top: "-1px !important",
            width: "1px !important"
          };
          var shouldCreateFocusIntercept = browserDetection.hasSoftwareKeyboard() || browserDetection.isFirefox();
          if (!shouldCreateFocusIntercept) {
            return document.createDocumentFragment();
          }
          input.setAttribute("aria-hidden", "true");
          input.setAttribute("autocomplete", "off");
          input.setAttribute("data-braintree-direction", direction);
          input.setAttribute("data-braintree-type", type);
          input.setAttribute("id", "bt-" + type + "-" + direction + "-" + hostedFieldsId);
          input.setAttribute("style", JSON.stringify(focusInterceptStyles).replace(/[{}"]/g, "").replace(/,/g, ";"));
          input.classList.add("focus-intercept");
          input.addEventListener("focus", function (event) {
            handler(event);

            /*
              Certain browsers without software keyboards (Firefox, Internet
              Explorer) need the focus intercept inputs that get inserted
              around the actual input to blur themselves, otherwise the
              browser gets confused about what should have focus. Can't
              apply this to browsers with software keyboards however,
              because it blurs everything, and focus on the actual input is
              also lost.
            */
            if (!browserDetection.hasSoftwareKeyboard()) {
              input.blur();
            }
          });
          return input;
        },
        destroy: function (idString) {
          var focusInputs;
          if (!idString) {
            focusInputs = document.querySelectorAll("[data-braintree-direction]");
            focusInputs = [].slice.call(focusInputs);
          } else {
            focusInputs = [document.getElementById(idString)];
          }
          focusInputs.forEach(function (node) {
            if (node && node.nodeType === 1 && focusIntercept.matchFocusElement(node.getAttribute("id"))) {
              node.parentNode.removeChild(node);
            }
          });
        },
        matchFocusElement: function (idString) {
          var idComponents, hasBTPrefix, isAllowedType, isValidDirection;
          if (!idString) {
            return false;
          }
          idComponents = idString.split("-");
          if (idComponents.length < 4) {
            return false;
          }
          hasBTPrefix = idComponents[0] === "bt";
          isAllowedType = allowedFields.indexOf(idComponents[1]) > -1;
          isValidDirection = idComponents[2] === directions.BACK || idComponents[2] === directions.FORWARD;
          return Boolean(hasBTPrefix && isAllowedType && isValidDirection);
        }
      };
      module.exports = focusIntercept;
    }, {
      "./browser-detection": 127,
      "./constants": 128
    }],
    132: [function (_dereq_, module, exports) {
      "use strict";

      var creditCardType = _dereq_("credit-card-type");
      module.exports = function (number) {
        var results = creditCardType(number);
        results.forEach(function (card) {
          // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
          // but we still pass master-card in the braintree API
          // in a major version bump, we can remove this and
          // this will be mastercard instead of master-card
          if (card.type === "mastercard") {
            card.type = "master-card";
          }
        });
        return results;
      };
    }, {
      "credit-card-type": 42
    }],
    133: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web
       * @description This is the top-level module exported by the Braintree JavaScript SDK. In a browser environment, this will be the global <code>braintree</code> object. In a CommonJS environment (like Browserify or Webpack), it will be the default export of the <code>braintree-web</code> package. In AMD environments (like RequireJS), it can be `require`d like other modules.
       * @example
       * <caption>CommonJS</caption>
       * var braintree = require('braintree-web');
       *
       * braintree.client.create(...);
       * @example
       * <caption>In the browser</caption>
       * <script src="https://js.braintreegateway.com/web/{@pkg version}/js/client.min.js"></script>
       * <script>
       *   window.braintree.client.create(...);
       * </script>
       * @example
       * <caption>AMD</caption>
       * // main.js
       * require.config({
       *   paths: {
       *     braintreeClient: 'https://js.braintreegateway.com/web/{@pkg version}/js/client.min'
       *   }
       * });
       *
       * require(['braintreeClient'], function (braintreeClient) {
       *   braintreeClient.create(...);
       * });
       */

      /**
       * @global
       * @callback callback
       * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
       * @param {?any} [data] The successful result of the asynchronous function call (if data exists).
       * @description The Node.js-style callback pattern used throughout the SDK.
       * @returns {void}
       */
      var americanExpress = _dereq_("./american-express");
      var applePay = _dereq_("./apple-pay");
      var client = _dereq_("./client");
      var fastlane = _dereq_("./fastlane");
      var dataCollector = _dereq_("./data-collector");
      var hostedFields = _dereq_("./hosted-fields");
      var localPayment = _dereq_("./local-payment");
      var masterpass = _dereq_("./masterpass");
      var paymentRequest = _dereq_("./payment-request");
      var paypal = _dereq_("./paypal");
      var paypalCheckout = _dereq_("./paypal-checkout");
      var googlePayment = _dereq_("./google-payment");
      var sepa = _dereq_("./sepa");
      var threeDSecure = _dereq_("./three-d-secure");
      var unionpay = _dereq_("./unionpay");
      var usBankAccount = _dereq_("./us-bank-account");
      var vaultManager = _dereq_("./vault-manager");
      var venmo = _dereq_("./venmo");
      var visaCheckout = _dereq_("./visa-checkout");
      var preferredPaymentMethods = _dereq_("./preferred-payment-methods");
      var VERSION = "3.115.2";
      module.exports = {
        /** @type {module:braintree-web/fastlane} */
        fastlane: fastlane,
        /** @type {module:braintree-web/american-express} */
        americanExpress: americanExpress,
        /** @type {module:braintree-web/apple-pay} */
        applePay: applePay,
        /** @type {module:braintree-web/client} */
        client: client,
        /** @type {module:braintree-web/data-collector} */
        dataCollector: dataCollector,
        /** @type {module:braintree-web/hosted-fields} */
        hostedFields: hostedFields,
        /** @type {module:braintree-web/local-payment} */
        localPayment: localPayment,
        /** @type {module:braintree-web/masterpass} */
        masterpass: masterpass,
        /** @type {module:braintree-web/google-payment} */
        googlePayment: googlePayment,
        /** @type {module:braintree-web/payment-request} */
        paymentRequest: paymentRequest,
        /** @type {module:braintree-web/paypal} */
        paypal: paypal,
        /** @type {module:braintree-web/paypal-checkout} */
        paypalCheckout: paypalCheckout,
        /** @type {module:braintree-web/three-d-secure} */
        threeDSecure: threeDSecure,
        /** @type {module:braintree-web/unionpay} */
        unionpay: unionpay,
        /** @type {module:braintree-web/us-bank-account} */
        usBankAccount: usBankAccount,
        /** @type {module:braintree-web/vault-manager} */
        vaultManager: vaultManager,
        /** @type {module:braintree-web/venmo} */
        venmo: venmo,
        /** @type {module:braintree-web/visa-checkout} */
        visaCheckout: visaCheckout,
        /** @type {module:braintree-web/sepa} */
        sepa: sepa,
        /** @type {module:braintree-web/preferred-payment-methods} */
        preferredPaymentMethods: preferredPaymentMethods,
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "./american-express": 87,
      "./apple-pay": 90,
      "./client": 95,
      "./data-collector": 113,
      "./fastlane": 116,
      "./google-payment": 119,
      "./hosted-fields": 126,
      "./local-payment": 182,
      "./masterpass": 185,
      "./payment-request": 190,
      "./paypal": 197,
      "./paypal-checkout": 194,
      "./preferred-payment-methods": 200,
      "./sepa": 204,
      "./three-d-secure": 216,
      "./unionpay": 220,
      "./us-bank-account": 226,
      "./vault-manager": 229,
      "./venmo": 234,
      "./visa-checkout": 244
    }],
    134: [function (_dereq_, module, exports) {
      "use strict";

      var createAuthorizationData = _dereq_("./create-authorization-data");
      var jsonClone = _dereq_("./json-clone");
      var constants = _dereq_("./constants");
      function addMetadata(configuration, data) {
        var key;
        var attrs = data ? jsonClone(data) : {};
        var authAttrs = createAuthorizationData(configuration.authorization).attrs;
        var _meta = jsonClone(configuration.analyticsMetadata);
        attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
        for (key in attrs._meta) {
          if (attrs._meta.hasOwnProperty(key)) {
            _meta[key] = attrs._meta[key];
          }
        }
        attrs._meta = _meta;
        if (authAttrs.tokenizationKey) {
          attrs.tokenizationKey = authAttrs.tokenizationKey;
        } else {
          attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
        }
        return attrs;
      }
      function addEventMetadata(clientInstanceOrPromise) {
        var configuration = clientInstanceOrPromise.getConfiguration();
        var authAttrs = createAuthorizationData(configuration.authorization).attrs;
        var isProd = configuration.gatewayConfiguration.environment === "production";

        /* eslint-disable camelcase */
        var metadata = {
          api_integration_type: configuration.analyticsMetadata.integrationType,
          app_id: window.location.host,
          c_sdk_ver: constants.VERSION,
          component: "braintreeclientsdk",
          merchant_sdk_env: isProd ? "production" : "sandbox",
          merchant_id: configuration.gatewayConfiguration.merchantId,
          event_source: "web",
          platform: constants.PLATFORM,
          platform_version: window.navigator.userAgent,
          session_id: configuration.analyticsMetadata.sessionId,
          client_session_id: configuration.analyticsMetadata.sessionId,
          tenant_name: "braintree"
        };
        if (authAttrs.tokenizationKey) {
          metadata.tokenization_key = authAttrs.tokenizationKey;
        } else {
          metadata.auth_fingerprint = authAttrs.authorizationFingerprint;
        }
        /* eslint-enable camelcase */

        return metadata;
      }
      module.exports = {
        addMetadata: addMetadata,
        addEventMetadata: addEventMetadata
      };
    }, {
      "./constants": 142,
      "./create-authorization-data": 146,
      "./json-clone": 171
    }],
    135: [function (_dereq_, module, exports) {
      "use strict";

      var constants = _dereq_("./constants");
      var metadata = _dereq_("./add-metadata");
      var assign = _dereq_("./assign").assign;
      function sendPaypalEvent(clientInstanceOrPromise, eventName, callback) {
        return sendPaypalEventPlusFields(clientInstanceOrPromise, eventName, {}, callback);
      }
      function sendPaypalEventPlusFields(clientInstanceOrPromise, eventName, extraFields, callback) {
        var timestamp = Date.now();
        return Promise.resolve(clientInstanceOrPromise).then(function (client) {
          var request = client._request;
          var url = constants.ANALYTICS_URL;
          var qualifiedEvent = constants.ANALYTICS_PREFIX + eventName;
          var configuration = client.getConfiguration();
          var isProd = configuration.gatewayConfiguration.environment === "production";
          var data = {
            events: [],
            tracking: []
          };
          var trackingMeta = metadata.addEventMetadata(client, data);
          trackingMeta.event_name = qualifiedEvent; // eslint-disable-line camelcase
          trackingMeta.t = timestamp; // eslint-disable-line camelcase

          data.events = [{
            level: "info",
            event: qualifiedEvent,
            payload: {
              env: isProd ? "production" : "sandbox",
              timestamp: timestamp
            }
          }];
          data.tracking = [trackingMeta];
          if (extraFields && typeof extraFields === "object") {
            data.tracking = [appendExtraFieldsTo(trackingMeta, extraFields)];
          }
          return request({
            url: url,
            method: "post",
            data: data,
            timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
          }, callback);
        }).catch(function (err) {
          if (callback) {
            callback(err);
          }
        });
      }
      function appendExtraFieldsTo(trackingMeta, extraFields) {
        var result = {};
        var allowedExtraFields = assign({}, extraFields);
        Object.keys(allowedExtraFields).forEach(function (field) {
          if (constants.ALLOWED_EXTRA_EVENT_FIELDS.indexOf(field) === -1) {
            delete allowedExtraFields[field];
          }
        });
        result = assign(trackingMeta, allowedExtraFields);
        return result;
      }
      module.exports = {
        sendEvent: sendPaypalEvent,
        sendEventPlus: sendPaypalEventPlusFields
      };
    }, {
      "./add-metadata": 134,
      "./assign": 137,
      "./constants": 142
    }],
    136: [function (_dereq_, module, exports) {
      "use strict";

      var loadScript = _dereq_("@braintree/asset-loader/load-script");
      var loadConnectScript = _dereq_("@paypal/accelerated-checkout-loader");
      module.exports = {
        loadScript: loadScript,
        loadFastlane: loadConnectScript.loadAxo
      };
    }, {
      "@braintree/asset-loader/load-script": 2,
      "@paypal/accelerated-checkout-loader": 41
    }],
    137: [function (_dereq_, module, exports) {
      "use strict";

      var assignNormalized = typeof Object.assign === "function" ? Object.assign : assignPolyfill;
      function assignPolyfill(destination) {
        var i, source, key;
        for (i = 1; i < arguments.length; i++) {
          source = arguments[i];
          for (key in source) {
            if (source.hasOwnProperty(key)) {
              destination[key] = source[key];
            }
          }
        }
        return destination;
      }
      module.exports = {
        assign: assignNormalized,
        _assign: assignPolyfill
      };
    }, {}],
    138: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      var sharedErrors = _dereq_("./errors");
      var VERSION = "3.115.2";
      function basicComponentVerification(options) {
        var client, authorization, name;
        if (!options) {
          return Promise.reject(new BraintreeError({
            type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
            code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
            message: "Options must be passed to basicComponentVerification function."
          }));
        }
        name = options.name;
        client = options.client;
        authorization = options.authorization;
        if (!client && !authorization) {
          return Promise.reject(new BraintreeError({
            type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
            code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
            // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
            // instead of passing in a client instance. Leave this a silent feature for now.
            message: "options.client is required when instantiating " + name + "."
          }));
        }
        if (!authorization && client.getVersion() !== VERSION) {
          return Promise.reject(new BraintreeError({
            type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
            code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
            message: "Client (version " + client.getVersion() + ") and " + name + " (version " + VERSION + ") components must be from the same SDK version."
          }));
        }
        return Promise.resolve();
      }
      module.exports = {
        verify: basicComponentVerification
      };
    }, {
      "./braintree-error": 140,
      "./errors": 151
    }],
    139: [function (_dereq_, module, exports) {
      "use strict";

      var once = _dereq_("./once");
      function call(fn, callback) {
        var isSync = fn.length === 0;
        if (isSync) {
          fn();
          callback(null);
        } else {
          fn(callback);
        }
      }
      module.exports = function (functions, cb) {
        var i;
        var length = functions.length;
        var remaining = length;
        var callback = once(cb);
        if (length === 0) {
          callback(null);
          return;
        }
        function finish(err) {
          if (err) {
            callback(err);
            return;
          }
          remaining -= 1;
          if (remaining === 0) {
            callback(null);
          }
        }
        for (i = 0; i < length; i++) {
          call(functions[i], finish);
        }
      };
    }, {
      "./once": 173
    }],
    140: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("./enumerate");

      /**
       * @class
       * @global
       * @param {object} options Construction options
       * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
       * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
       */
      function BraintreeError(options) {
        if (!BraintreeError.types.hasOwnProperty(options.type)) {
          throw new Error(options.type + " is not a valid type.");
        }
        if (!options.code) {
          throw new Error("Error code required.");
        }
        if (!options.message) {
          throw new Error("Error message required.");
        }
        this.name = "BraintreeError";

        /**
         * @type {string}
         * @description A code that corresponds to specific errors.
         */
        this.code = options.code;

        /**
         * @type {string}
         * @description A short description of the error.
         */
        this.message = options.message;

        /**
         * @type {BraintreeError.types}
         * @description The type of error.
         */
        this.type = options.type;

        /**
         * @type {object=}
         * @description Additional information about the error, such as an underlying network error response.
         */
        this.details = options.details;
      }
      BraintreeError.prototype = Object.create(Error.prototype);
      BraintreeError.prototype.constructor = BraintreeError;

      /**
       * Enum for {@link BraintreeError} types.
       * @name BraintreeError.types
       * @enum
       * @readonly
       * @memberof BraintreeError
       * @property {string} CUSTOMER An error caused by the customer.
       * @property {string} MERCHANT An error that is actionable by the merchant.
       * @property {string} NETWORK An error due to a network problem.
       * @property {string} INTERNAL An error caused by Braintree code.
       * @property {string} UNKNOWN An error where the origin is unknown.
       */
      BraintreeError.types = enumerate(["CUSTOMER", "MERCHANT", "NETWORK", "INTERNAL", "UNKNOWN"]);
      BraintreeError.findRootError = function (err) {
        if (err instanceof BraintreeError && err.details && err.details.originalError) {
          return BraintreeError.findRootError(err.details.originalError);
        }
        return err;
      };
      module.exports = BraintreeError;
    }, {
      "./enumerate": 150
    }],
    141: [function (_dereq_, module, exports) {
      "use strict";

      // Taken from https://github.com/sindresorhus/decamelize/blob/95980ab6fb44c40eaca7792bdf93aff7c210c805/index.js
      function transformKey(key) {
        return key.replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1_$2").toLowerCase();
      }
      function camelCaseToSnakeCase(input) {
        var converted;
        if (input === null) {
          converted = null;
        } else if (Array.isArray(input)) {
          converted = [];
          input.forEach(function (x) {
            converted.push(camelCaseToSnakeCase(x));
          });
        } else if (typeof input === "object") {
          converted = Object.keys(input).reduce(function (newObj, key) {
            var transformedKey = transformKey(key);
            if (typeof input[key] === "object") {
              newObj[transformedKey] = camelCaseToSnakeCase(input[key]);
            } else {
              newObj[transformedKey] = input[key];
            }
            return newObj;
          }, {});
        } else {
          converted = input;
        }
        return converted;
      }
      module.exports = camelCaseToSnakeCase;
    }, {}],
    142: [function (_dereq_, module, exports) {
      "use strict";

      var VERSION = "3.115.2";
      var PLATFORM = "web";
      var CLIENT_API_URLS = {
        production: "https://api.braintreegateway.com:443",
        sandbox: "https://api.sandbox.braintreegateway.com:443"
      };
      var ASSETS_URLS = {
        production: "https://assets.braintreegateway.com",
        sandbox: "https://assets.braintreegateway.com"
      };
      var GRAPHQL_URLS = {
        production: "https://payments.braintree-api.com/graphql",
        sandbox: "https://payments.sandbox.braintree-api.com/graphql"
      };

      // endRemoveIf(production)

      module.exports = {
        ANALYTICS_PREFIX: PLATFORM + ".",
        ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
        ANALYTICS_URL: "https://www.paypal.com/xoplatform/logger/api/logger",
        ASSETS_URLS: ASSETS_URLS,
        CLIENT_API_URLS: CLIENT_API_URLS,
        FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
        FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
        FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
        BUS_CONFIGURATION_REQUEST_EVENT: "BUS_CONFIGURATION_REQUEST",
        GRAPHQL_URLS: GRAPHQL_URLS,
        INTEGRATION_TIMEOUT_MS: 60000,
        VERSION: VERSION,
        INTEGRATION: "custom",
        SOURCE: "client",
        PLATFORM: PLATFORM,
        BRAINTREE_LIBRARY_VERSION: "braintree/" + PLATFORM + "/" + VERSION,
        ALLOWED_EXTRA_EVENT_FIELDS: ["paypal_context_id"]
      };
    }, {}],
    143: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      var sharedErrors = _dereq_("./errors");
      module.exports = function (instance, methodNames) {
        methodNames.forEach(function (methodName) {
          instance[methodName] = function () {
            throw new BraintreeError({
              type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
              code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
              message: methodName + " cannot be called after teardown."
            });
          };
        });
      };
    }, {
      "./braintree-error": 140,
      "./errors": 151
    }],
    144: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      function convertToBraintreeError(originalErr, btErrorObject) {
        if (originalErr instanceof BraintreeError) {
          return originalErr;
        }
        return new BraintreeError({
          type: btErrorObject.type,
          code: btErrorObject.code,
          message: btErrorObject.message,
          details: {
            originalError: originalErr
          }
        });
      }
      module.exports = convertToBraintreeError;
    }, {
      "./braintree-error": 140
    }],
    145: [function (_dereq_, module, exports) {
      "use strict";

      // endRemoveIf(production)
      var ASSETS_URLS = _dereq_("./constants").ASSETS_URLS;
      function createAssetsUrl(authorization) {
        // endRemoveIf(production)

        return ASSETS_URLS.production;
      }
      /* eslint-enable */

      module.exports = {
        create: createAssetsUrl
      };
    }, {
      "./constants": 142
    }],
    146: [function (_dereq_, module, exports) {
      "use strict";

      var atob = _dereq_("../lib/vendor/polyfill").atob;
      var CLIENT_API_URLS = _dereq_("../lib/constants").CLIENT_API_URLS;
      function _isTokenizationKey(str) {
        return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
      }
      function _parseTokenizationKey(tokenizationKey) {
        var tokens = tokenizationKey.split("_");
        var environment = tokens[0];
        var merchantId = tokens.slice(2).join("_");
        return {
          merchantId: merchantId,
          environment: environment
        };
      }
      function createAuthorizationData(authorization) {
        var parsedClientToken, parsedTokenizationKey;
        var data = {
          attrs: {},
          configUrl: ""
        };
        if (_isTokenizationKey(authorization)) {
          parsedTokenizationKey = _parseTokenizationKey(authorization);
          data.environment = parsedTokenizationKey.environment;
          data.attrs.tokenizationKey = authorization;
          data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + "/merchants/" + parsedTokenizationKey.merchantId + "/client_api/v1/configuration";
        } else {
          parsedClientToken = JSON.parse(atob(authorization));
          data.environment = parsedClientToken.environment;
          data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
          data.configUrl = parsedClientToken.configUrl;
          data.graphQL = parsedClientToken.graphQL;
        }
        return data;
      }
      module.exports = createAuthorizationData;
    }, {
      "../lib/constants": 142,
      "../lib/vendor/polyfill": 179
    }],
    147: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      var assets = _dereq_("./assets");
      var sharedErrors = _dereq_("./errors");
      var VERSION = "3.115.2";
      function createDeferredClient(options) {
        var promise = Promise.resolve();
        if (options.client) {
          return Promise.resolve(options.client);
        }
        if (!(window.braintree && window.braintree.client)) {
          promise = assets.loadScript({
            src: options.assetsUrl + "/web/" + VERSION + "/js/client.min.js"
          }).catch(function (err) {
            return Promise.reject(new BraintreeError({
              type: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
              code: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
              message: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
              details: {
                originalError: err
              }
            }));
          });
        }
        return promise.then(function () {
          if (window.braintree.client.VERSION !== VERSION) {
            return Promise.reject(new BraintreeError({
              type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
              code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
              message: "Client (version " + window.braintree.client.VERSION + ") and " + options.name + " (version " + VERSION + ") components must be from the same SDK version."
            }));
          }
          return window.braintree.client.create({
            authorization: options.authorization,
            debug: options.debug
          });
        });
      }
      module.exports = {
        create: createDeferredClient
      };
    }, {
      "./assets": 136,
      "./braintree-error": 140,
      "./errors": 151
    }],
    148: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (fn) {
        return function () {
          // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
          var args = arguments;
          setTimeout(function () {
            fn.apply(null, args);
          }, 1);
        };
      };
    }, {}],
    149: [function (_dereq_, module, exports) {
      "use strict";

      var batchExecuteFunctions = _dereq_("./batch-execute-functions");
      function Destructor() {
        this._teardownRegistry = [];
        this._isTearingDown = false;
      }
      Destructor.prototype.registerFunctionForTeardown = function (fn) {
        if (typeof fn === "function") {
          this._teardownRegistry.push(fn);
        }
      };
      Destructor.prototype.teardown = function (callback) {
        if (this._isTearingDown) {
          callback(new Error("Destructor is already tearing down"));
          return;
        }
        this._isTearingDown = true;
        batchExecuteFunctions(this._teardownRegistry, function (err) {
          this._teardownRegistry = [];
          this._isTearingDown = false;
          if (typeof callback === "function") {
            callback(err);
          }
        }.bind(this));
      };
      module.exports = Destructor;
    }, {
      "./batch-execute-functions": 139
    }],
    150: [function (_dereq_, module, exports) {
      "use strict";

      function enumerate(values, prefix) {
        prefix = prefix == null ? "" : prefix;
        return values.reduce(function (enumeration, value) {
          enumeration[value] = prefix + value;
          return enumeration;
        }, {});
      }
      module.exports = enumerate;
    }, {}],
    151: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Shared Internal Error Codes
       * @ignore
       * @description These codes should never be experienced by the merchant directly.
       * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
       */

      /**
       * @name BraintreeError.Shared Errors - Component Creation Error Codes
       * @description Errors that occur when creating components.
       * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a component is created that is missing a required option.
       * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
       * @property {NETWORK} CLIENT_SCRIPT_FAILED_TO_LOAD Occurs when a component attempts to load the Braintree client script, but the request fails.
       */

      /**
       * @name BraintreeError.Shared Errors - Component Instance Error Codes
       * @description Errors that occur when using instances of components.
       * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
       */
      var BraintreeError = _dereq_("./braintree-error");
      module.exports = {
        INVALID_USE_OF_INTERNAL_FUNCTION: {
          type: BraintreeError.types.INTERNAL,
          code: "INVALID_USE_OF_INTERNAL_FUNCTION"
        },
        INSTANTIATION_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "INSTANTIATION_OPTION_REQUIRED"
        },
        INCOMPATIBLE_VERSIONS: {
          type: BraintreeError.types.MERCHANT,
          code: "INCOMPATIBLE_VERSIONS"
        },
        CLIENT_SCRIPT_FAILED_TO_LOAD: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
          message: "Braintree client script could not be loaded."
        },
        METHOD_CALLED_AFTER_TEARDOWN: {
          type: BraintreeError.types.MERCHANT,
          code: "METHOD_CALLED_AFTER_TEARDOWN"
        }
      };
    }, {
      "./braintree-error": 140
    }],
    152: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function findRootNode(element) {
        while (element.parentNode) {
          element = element.parentNode;
        }
        return element;
      };
    }, {}],
    153: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (array, key, value) {
        var i;
        for (i = 0; i < array.length; i++) {
          if (array[i].hasOwnProperty(key) && array[i][key] === value) {
            return array[i];
          }
        }
        return null;
      };
    }, {}],
    154: [function (_dereq_, module, exports) {
      "use strict";

      var Popup = _dereq_("./strategies/popup");
      var PopupBridge = _dereq_("./strategies/popup-bridge");
      var Modal = _dereq_("./strategies/modal");
      var Bus = _dereq_("framebus");
      var events = _dereq_("../shared/events");
      var errors = _dereq_("../shared/errors");
      var constants = _dereq_("../shared/constants");
      var uuid = _dereq_("@braintree/uuid");
      var iFramer = _dereq_("@braintree/iframer");
      var BraintreeError = _dereq_("../../braintree-error");
      var browserDetection = _dereq_("../shared/browser-detection");
      var assign = _dereq_("./../../assign").assign;
      var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../constants").BUS_CONFIGURATION_REQUEST_EVENT;
      var REQUIRED_CONFIG_KEYS = ["name", "dispatchFrameUrl", "openFrameUrl"];
      function noop() {}
      function _validateFrameConfiguration(options) {
        if (!options) {
          throw new Error("Valid configuration is required");
        }
        REQUIRED_CONFIG_KEYS.forEach(function (key) {
          if (!options.hasOwnProperty(key)) {
            throw new Error("A valid frame " + key + " must be provided");
          }
        });
        if (!/^[\w_]+$/.test(options.name)) {
          throw new Error("A valid frame name must be provided");
        }
      }
      function FrameService(options) {
        _validateFrameConfiguration(options);
        this._serviceId = uuid().replace(/-/g, "");
        this._options = {
          name: options.name + "_" + this._serviceId,
          dispatchFrameUrl: options.dispatchFrameUrl,
          openFrameUrl: options.openFrameUrl,
          height: options.height,
          width: options.width,
          top: options.top,
          left: options.left
        };
        this.state = options.state || {};
        this._bus = new Bus({
          channel: this._serviceId
        });
        this._setBusEvents();
      }
      FrameService.prototype.initialize = function (callback) {
        var dispatchFrameReadyHandler = function () {
          callback();
          this._bus.off(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
        }.bind(this);
        this._bus.on(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
        this._writeDispatchFrame();
      };
      FrameService.prototype._writeDispatchFrame = function () {
        var frameName = constants.DISPATCH_FRAME_NAME + "_" + this._serviceId;
        var frameSrc = this._options.dispatchFrameUrl;
        this._dispatchFrame = iFramer({
          "aria-hidden": true,
          name: frameName,
          title: frameName,
          src: frameSrc,
          class: constants.DISPATCH_FRAME_CLASS,
          height: 0,
          width: 0,
          style: {
            position: "absolute",
            left: "-9999px"
          }
        });
        document.body.appendChild(this._dispatchFrame);
      };
      FrameService.prototype._setBusEvents = function () {
        this._bus.on(events.DISPATCH_FRAME_REPORT, function (res, reply) {
          if (this._onCompleteCallback) {
            this._onCompleteCallback.call(null, res.err, res.payload);
          }
          this._frame.close();
          this._onCompleteCallback = null;
          if (reply) {
            reply();
          }
        }.bind(this));
        this._bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function (reply) {
          reply(this.state);
        }.bind(this));
      };
      FrameService.prototype.open = function (options, callback) {
        options = options || {};
        this._frame = this._getFrameForEnvironment(options);
        this._frame.initialize(callback);
        if (this._frame instanceof PopupBridge) {
          // Frameservice loads a spinner then redirects to the final destination url.
          // For Popupbridge it doesn't have the same rules around popups since it's deferred to the mobile side
          // therefore, skips the regular open path and instead uses `#redirect` to handle things
          return;
        }
        assign(this.state, options.state);
        this._onCompleteCallback = callback;
        this._frame.open();
        if (this.isFrameClosed()) {
          this._cleanupFrame();
          if (callback) {
            callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_OPEN_FAILED));
          }
          return;
        }
        this._pollForPopupClose();
      };
      FrameService.prototype.redirect = function (url) {
        if (this._frame && !this.isFrameClosed()) {
          this._frame.redirect(url);
        }
      };
      FrameService.prototype.close = function () {
        if (!this.isFrameClosed()) {
          this._frame.close();
        }
      };
      FrameService.prototype.focus = function () {
        if (!this.isFrameClosed()) {
          this._frame.focus();
        }
      };
      FrameService.prototype.createHandler = function (options) {
        options = options || {};
        return {
          close: function () {
            if (options.beforeClose) {
              options.beforeClose();
            }
            this.close();
          }.bind(this),
          focus: function () {
            if (options.beforeFocus) {
              options.beforeFocus();
            }
            this.focus();
          }.bind(this)
        };
      };
      FrameService.prototype.createNoopHandler = function () {
        return {
          close: noop,
          focus: noop
        };
      };
      FrameService.prototype.teardown = function () {
        this.close();
        this._dispatchFrame.parentNode.removeChild(this._dispatchFrame);
        this._dispatchFrame = null;
        this._cleanupFrame();
      };
      FrameService.prototype.isFrameClosed = function () {
        return this._frame == null || this._frame.isClosed();
      };
      FrameService.prototype._cleanupFrame = function () {
        this._frame = null;
        clearInterval(this._popupInterval);
        this._popupInterval = null;
      };
      FrameService.prototype._pollForPopupClose = function () {
        this._popupInterval = setInterval(function () {
          if (this.isFrameClosed()) {
            this._cleanupFrame();
            if (this._onCompleteCallback) {
              this._onCompleteCallback(new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED));
            }
          }
        }.bind(this), constants.POPUP_POLL_INTERVAL);
        return this._popupInterval;
      };
      FrameService.prototype._getFrameForEnvironment = function (options) {
        var usePopup = browserDetection.supportsPopups();
        var popupBridgeExists = Boolean(window.popupBridge);
        var initOptions = assign({}, this._options, options);
        if (popupBridgeExists) {
          return new PopupBridge(initOptions);
        } else if (usePopup) {
          return new Popup(initOptions);
        }
        return new Modal(initOptions);
      };
      module.exports = FrameService;
    }, {
      "../../braintree-error": 140,
      "../../constants": 142,
      "../shared/browser-detection": 161,
      "../shared/constants": 162,
      "../shared/errors": 163,
      "../shared/events": 164,
      "./../../assign": 137,
      "./strategies/modal": 156,
      "./strategies/popup": 159,
      "./strategies/popup-bridge": 157,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "framebus": 50
    }],
    155: [function (_dereq_, module, exports) {
      "use strict";

      var FrameService = _dereq_("./frame-service");

      /**
       * @ignore
       * @function create
       * Initializing FrameService should be done at the point when the component is created, so it is ready whenever a component needs to open a popup window.
       * Browsers have varying rules around what constitutes and async action worth blocking a popup for, but the likes of Safari
       * will block the popup if `frameService#create` is invoked during any asynchronous process (such as an API request to tokenize payment details).
       *
       * The process of setting up the dispatch frame and subsequent framebus communications via event listeners are considered async by Safari's standards.
       *
       * @param {object} options The options provided to frameservice
       * @param {string} options.name The name to use for identifying the various pieces associated with frameservice.
       * @param {string} options.dispatchFrameUrl The static asset to load for use as the dispatch frame. This allows for secure communication between the iframe and the popup, since they are on the same asset domain (usually checkout.paypal.com or assets.braintreegateway.com)
       * @param {string} options.openFrameUrl The url to load in the popup. Sometimes it is the case that you'll need info that comes _after_ the popup loads in which case we load the `landing-frame` that's a loading spinner then redirect to the proper/final destination. See the PayPal component for an example.
       * Otherwise if all the info needed is ready up-front, then you can forego a landing frame and go straight to the final destination.
       * @param {string} [options.height] The desired popup height.
       * @param {string} [options.width] The desired popup width.
       * @param {string} [options.top] The desired top value of the popup for positioning.
       * @param {string} [options.left] The desired left value of the popup for positioning.
       * @param {object} [options.state] Seems to be dead code, but allows for injecting data in to popup. NEXT_MAJOR_VERSION remove this param if no usage exists.
       * @param {function} callback The function to invoke once the frameservice is created and ready to use. FrameService instance is returned.
       */
      module.exports = {
        create: function createFrameService(options, callback) {
          var frameService = new FrameService(options);
          frameService.initialize(function () {
            callback(frameService);
          });
        }
      };
    }, {
      "./frame-service": 154
    }],
    156: [function (_dereq_, module, exports) {
      "use strict";

      var iFramer = _dereq_("@braintree/iframer");
      var assign = _dereq_("../../../assign").assign;
      var browserDetection = _dereq_("../../shared/browser-detection");
      var ELEMENT_STYLES = {
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        padding: 0,
        margin: 0,
        border: 0,
        outline: "none",
        zIndex: 20001,
        background: "#FFFFFF"
      };
      function noop() {}

      /**
       *
       * We should not ever really use the Modal. Modals are _like_  popups, but the key difference is that the customer can't actually verify it's app domain and thus secure/valid. Old PP sdk (./src/paypal) uses this
       * to get info from webviews (e.g. facebook).
       */

      function Modal(options) {
        this._closed = null;
        this._frame = null;
        this._options = options || {};
        this._container = this._options.container || document.body;
      }
      Modal.prototype.initialize = noop;
      Modal.prototype.open = function () {
        var iframerConfig = {
          src: this._options.openFrameUrl,
          name: this._options.name,
          scrolling: "yes",
          height: "100%",
          width: "100%",
          style: assign({}, ELEMENT_STYLES),
          title: "Lightbox Frame"
        };
        if (browserDetection.isIos()) {
          // WKWebView has buggy behavior when scrolling a fixed position modal. The workaround is to lock scrolling in
          // the background. When modal is closed, we restore scrolling and return to the previous scroll position.
          if (browserDetection.isIosWKWebview()) {
            this._lockScrolling();
            // Allows WKWebView to scroll all the way down to bottom
            iframerConfig.style = {};
          }
          this._el = document.createElement("div");
          assign(this._el.style, ELEMENT_STYLES, {
            height: "100%",
            width: "100%",
            overflow: "auto",
            "-webkit-overflow-scrolling": "touch"
          });
          this._frame = iFramer(iframerConfig);
          this._el.appendChild(this._frame);
        } else {
          this._el = this._frame = iFramer(iframerConfig);
        }
        this._closed = false;
        this._container.appendChild(this._el);
      };
      Modal.prototype.focus = noop;
      Modal.prototype.close = function () {
        this._container.removeChild(this._el);
        this._frame = null;
        this._closed = true;
        if (browserDetection.isIosWKWebview()) {
          this._unlockScrolling();
        }
      };
      Modal.prototype.isClosed = function () {
        return Boolean(this._closed);
      };
      Modal.prototype.redirect = function (redirectUrl) {
        this._frame.src = redirectUrl;
      };
      Modal.prototype._unlockScrolling = function () {
        document.body.style.overflow = this._savedBodyProperties.overflowStyle;
        document.body.style.position = this._savedBodyProperties.positionStyle;
        window.scrollTo(this._savedBodyProperties.left, this._savedBodyProperties.top);
        delete this._savedBodyProperties;
      };
      Modal.prototype._lockScrolling = function () {
        var doc = document.documentElement;

        // From https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened#comment65626743_24727206
        this._savedBodyProperties = {
          left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
          top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
          overflowStyle: document.body.style.overflow,
          positionStyle: document.body.style.position
        };
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        window.scrollTo(0, 0);
      };
      module.exports = Modal;
    }, {
      "../../../assign": 137,
      "../../shared/browser-detection": 161,
      "@braintree/iframer": 32
    }],
    157: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../../../braintree-error");
      var errors = _dereq_("../../shared/errors");
      function noop() {}
      function PopupBridge(options) {
        this._closed = null;
        this._options = options;
      }
      PopupBridge.prototype.initialize = function (callback) {
        var self = this;
        window.popupBridge.onComplete = function (err, payload) {
          var popupDismissed = !payload && !err;
          self._closed = true;
          if (err || popupDismissed) {
            // User clicked "Done" button of browser view
            callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED));
            return;
          }
          // User completed popup flow (includes success and cancel cases)
          callback(null, payload);
        };
      };
      PopupBridge.prototype.open = function (options) {
        var url;
        options = options || {};
        url = options.openFrameUrl || this._options.openFrameUrl;
        this._closed = false;
        window.popupBridge.open(url);
      };
      PopupBridge.prototype.focus = noop;
      PopupBridge.prototype.close = noop;
      PopupBridge.prototype.isClosed = function () {
        return Boolean(this._closed);
      };
      PopupBridge.prototype.redirect = function (redirectUrl) {
        this.open({
          openFrameUrl: redirectUrl
        });
      };
      module.exports = PopupBridge;
    }, {
      "../../../braintree-error": 140,
      "../../shared/errors": 163
    }],
    158: [function (_dereq_, module, exports) {
      "use strict";

      var constants = _dereq_("../../../shared/constants");
      var position = _dereq_("./position");
      function calculatePosition(type, userDefinedPosition, size) {
        if (typeof userDefinedPosition !== "undefined") {
          return userDefinedPosition;
        }
        return position[type](size);
      }
      module.exports = function composePopupOptions(options) {
        var height = options.height || constants.DEFAULT_POPUP_HEIGHT;
        var width = options.width || constants.DEFAULT_POPUP_WIDTH;
        var top = calculatePosition("top", options.top, height);
        var left = calculatePosition("left", options.left, width);
        return [constants.POPUP_BASE_OPTIONS, "height=" + height, "width=" + width, "top=" + top, "left=" + left].join(",");
      };
    }, {
      "../../../shared/constants": 162,
      "./position": 160
    }],
    159: [function (_dereq_, module, exports) {
      "use strict";

      var composeOptions = _dereq_("./compose-options");
      function noop() {}
      function Popup(options) {
        this._frame = null;
        this._options = options || {};
      }
      Popup.prototype.initialize = noop;
      Popup.prototype.open = function () {
        this._frame = window.open(this._options.openFrameUrl, this._options.name, composeOptions(this._options));
      };
      Popup.prototype.focus = function () {
        this._frame.focus();
      };
      Popup.prototype.close = function () {
        if (this._frame.closed) {
          return;
        }
        this._frame.close();
      };
      Popup.prototype.isClosed = function () {
        return !this._frame || Boolean(this._frame.closed);
      };
      Popup.prototype.redirect = function (redirectUrl) {
        this._frame.location.href = redirectUrl;
      };
      module.exports = Popup;
    }, {
      "./compose-options": 158
    }],
    160: [function (_dereq_, module, exports) {
      "use strict";

      function top(height) {
        var windowHeight = window.outerHeight || document.documentElement.clientHeight;
        var windowTop = window.screenY == null ? window.screenTop : window.screenY;
        return center(windowHeight, height, windowTop);
      }
      function left(width) {
        var windowWidth = window.outerWidth || document.documentElement.clientWidth;
        var windowLeft = window.screenX == null ? window.screenLeft : window.screenX;
        return center(windowWidth, width, windowLeft);
      }
      function center(windowMetric, popupMetric, offset) {
        return (windowMetric - popupMetric) / 2 + offset;
      }
      module.exports = {
        top: top,
        left: left,
        center: center
      };
    }, {}],
    161: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        isIos: _dereq_("@braintree/browser-detection/is-ios"),
        isIosWKWebview: _dereq_("@braintree/browser-detection/is-ios-wkwebview"),
        supportsPopups: _dereq_("@braintree/browser-detection/supports-popups")
      };
    }, {
      "@braintree/browser-detection/is-ios": 27,
      "@braintree/browser-detection/is-ios-wkwebview": 26,
      "@braintree/browser-detection/supports-popups": 29
    }],
    162: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        DISPATCH_FRAME_NAME: "dispatch",
        DISPATCH_FRAME_CLASS: "braintree-dispatch-frame",
        POPUP_BASE_OPTIONS: "resizable,scrollbars",
        DEFAULT_POPUP_WIDTH: 450,
        DEFAULT_POPUP_HEIGHT: 535,
        POPUP_POLL_INTERVAL: 100,
        POPUP_CLOSE_TIMEOUT: 100
      };
    }, {}],
    163: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Popup Related Error Codes
       * @ignore
       * @description Errors that occur when using a component that opens a popup window.
       * @property {INTERNAL} FRAME_SERVICE_FRAME_CLOSED - Occurs when the frame is closed before tokenization can occur.
       * @property {INTERNAL} FRAME_SERVICE_FRAME_OPEN_FAILED - Occurs when the popup could not be opened.
       */
      var BraintreeError = _dereq_("../../braintree-error");
      module.exports = {
        FRAME_SERVICE_FRAME_CLOSED: {
          type: BraintreeError.types.INTERNAL,
          code: "FRAME_SERVICE_FRAME_CLOSED",
          message: "Frame closed before tokenization could occur."
        },
        FRAME_SERVICE_FRAME_OPEN_FAILED: {
          type: BraintreeError.types.INTERNAL,
          code: "FRAME_SERVICE_FRAME_OPEN_FAILED",
          message: "Frame failed to open."
        }
      };
    }, {
      "../../braintree-error": 140
    }],
    164: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("../../enumerate");
      module.exports = enumerate(["DISPATCH_FRAME_READY", "DISPATCH_FRAME_REPORT"], "frameService:");
    }, {
      "../../enumerate": 150
    }],
    165: [function (_dereq_, module, exports) {
      "use strict";

      var VERSION = "3.115.2";
      var assign = _dereq_("./assign").assign;
      function generateTokenizationParameters(configuration, overrides) {
        var metadata = configuration.analyticsMetadata;
        var basicTokenizationParameters = {
          gateway: "braintree",
          "braintree:merchantId": configuration.gatewayConfiguration.merchantId,
          "braintree:apiVersion": "v1",
          "braintree:sdkVersion": VERSION,
          "braintree:metadata": JSON.stringify({
            source: metadata.source,
            integration: metadata.integration,
            sessionId: metadata.sessionId,
            version: VERSION,
            platform: metadata.platform
          })
        };
        return assign({}, basicTokenizationParameters, overrides);
      }
      module.exports = function (configuration, googlePayVersion, googleMerchantId) {
        var data, paypalPaymentMethod;
        var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
        var environment = configuration.gatewayConfiguration.environment === "production" ? "PRODUCTION" : "TEST";
        if (googlePayVersion === 2) {
          data = {
            apiVersion: 2,
            apiVersionMinor: 0,
            environment: environment,
            allowedPaymentMethods: [{
              type: "CARD",
              parameters: {
                allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(function (card) {
                  return card.toUpperCase();
                })
              },
              tokenizationSpecification: {
                type: "PAYMENT_GATEWAY",
                parameters: generateTokenizationParameters(configuration, {
                  "braintree:authorizationFingerprint": androidPayConfiguration.googleAuthorizationFingerprint
                })
              }
            }]
          };
          if (googleMerchantId) {
            data.merchantInfo = {
              merchantId: googleMerchantId
            };
          }
          if (androidPayConfiguration.paypalClientId) {
            paypalPaymentMethod = {
              type: "PAYPAL",
              parameters: {
                /* eslint-disable camelcase */
                purchase_context: {
                  purchase_units: [{
                    payee: {
                      client_id: androidPayConfiguration.paypalClientId
                    },
                    recurring_payment: true
                  }]
                }
                /* eslint-enable camelcase */
              },
              tokenizationSpecification: {
                type: "PAYMENT_GATEWAY",
                parameters: generateTokenizationParameters(configuration, {
                  "braintree:paypalClientId": androidPayConfiguration.paypalClientId
                })
              }
            };
            data.allowedPaymentMethods.push(paypalPaymentMethod);
          }
        } else {
          data = {
            environment: environment,
            allowedPaymentMethods: ["CARD", "TOKENIZED_CARD"],
            paymentMethodTokenizationParameters: {
              tokenizationType: "PAYMENT_GATEWAY",
              parameters: generateTokenizationParameters(configuration, {
                "braintree:authorizationFingerprint": androidPayConfiguration.googleAuthorizationFingerprint
              })
            },
            cardRequirements: {
              allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(function (card) {
                return card.toUpperCase();
              })
            }
          };
          if (configuration.authorizationType === "TOKENIZATION_KEY") {
            data.paymentMethodTokenizationParameters.parameters["braintree:clientKey"] = configuration.authorization;
          }
          if (googleMerchantId) {
            data.merchantId = googleMerchantId;
          }
          if (googlePayVersion) {
            data.apiVersion = googlePayVersion;
          }
        }
        return data;
      };
    }, {
      "./assign": 137
    }],
    166: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function inIframe(win) {
        win = win || window;
        try {
          return win.self !== win.top;
        } catch (e) {
          return true;
        }
      };
    }, {}],
    167: [function (_dereq_, module, exports) {
      "use strict";

      function convertDateStringToDate(dateString) {
        var splitDate = dateString.split("-");
        return new Date(splitDate[0], splitDate[1], splitDate[2]);
      }
      function isDateStringBeforeOrOn(firstDate, secondDate) {
        return convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate);
      }
      module.exports = isDateStringBeforeOrOn;
    }, {}],
    168: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (creditCardDetails) {
        return creditCardDetails && creditCardDetails.hasOwnProperty("fastlane") && creditCardDetails.fastlane;
      };
    }, {}],
    169: [function (_dereq_, module, exports) {
      "use strict";

      function isHTTPS(protocol) {
        protocol = protocol || window.location.protocol;
        return protocol === "https:";
      }
      module.exports = {
        isHTTPS: isHTTPS
      };
    }, {}],
    170: [function (_dereq_, module, exports) {
      "use strict";

      var parser;
      var legalHosts = {
        "paypal.com": 1,
        "braintreepayments.com": 1,
        "braintreegateway.com": 1,
        "braintree-api.com": 1
      };

      // endRemoveIf(production)

      function stripSubdomains(domain) {
        return domain.split(".").slice(-2).join(".");
      }
      function isVerifiedDomain(url) {
        var mainDomain;
        url = url.toLowerCase();
        if (!/^https:/.test(url)) {
          return false;
        }
        parser = parser || document.createElement("a");
        parser.href = url;
        mainDomain = stripSubdomains(parser.hostname);
        return legalHosts.hasOwnProperty(mainDomain);
      }
      module.exports = isVerifiedDomain;
    }, {}],
    171: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (value) {
        return JSON.parse(JSON.stringify(value));
      };
    }, {}],
    172: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (obj) {
        return Object.keys(obj).filter(function (key) {
          return typeof obj[key] === "function";
        });
      };
    }, {}],
    173: [function (_dereq_, module, exports) {
      "use strict";

      function once(fn) {
        var called = false;
        return function () {
          if (!called) {
            called = true;
            fn.apply(null, arguments);
          }
        };
      }
      module.exports = once;
    }, {}],
    174: [function (_dereq_, module, exports) {
      "use strict";

      function _notEmpty(obj) {
        var key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      }

      /* eslint-disable no-mixed-operators */
      function _isArray(value) {
        return value && typeof value === "object" && typeof value.length === "number" && Object.prototype.toString.call(value) === "[object Array]" || false;
      }
      /* eslint-enable no-mixed-operators */

      function hasQueryParams(url) {
        url = url || window.location.href;
        return /\?/.test(url);
      }
      function parse(url) {
        var query, params;
        url = url || window.location.href;
        if (!hasQueryParams(url)) {
          return {};
        }
        query = url.split("?")[1] || "";
        query = query.replace(/#.*$/, "").split("&");
        params = query.reduce(function (toReturn, keyValue) {
          var parts = keyValue.split("=");
          var key = decodeURIComponent(parts[0]);
          var value = decodeURIComponent(parts[1]);
          toReturn[key] = value;
          return toReturn;
        }, {});
        return params;
      }
      function stringify(params, namespace) {
        var k, v, p;
        var query = [];
        for (p in params) {
          if (!params.hasOwnProperty(p)) {
            continue;
          }
          v = params[p];
          if (namespace) {
            if (_isArray(params)) {
              k = namespace + "[]";
            } else {
              k = namespace + "[" + p + "]";
            }
          } else {
            k = p;
          }
          if (typeof v === "object") {
            query.push(stringify(v, k));
          } else {
            query.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return query.join("&");
      }
      function queryify(url, params) {
        url = url || "";
        if (params != null && typeof params === "object" && _notEmpty(params)) {
          url += url.indexOf("?") === -1 ? "?" : "";
          url += url.indexOf("=") !== -1 ? "&" : "";
          url += stringify(params);
        }
        return url;
      }
      module.exports = {
        parse: parse,
        stringify: stringify,
        queryify: queryify,
        hasQueryParams: hasQueryParams
      };
    }, {}],
    175: [function (_dereq_, module, exports) {
      "use strict";

      var uuid = _dereq_("@braintree/uuid");
      var findRootNode = _dereq_("./find-root-node");

      // based on https://github.com/krakenjs/belter/blob/cdddc4f8ddb172d29db9e7e1ad1eeeacfb93e215/src/dom.js#L981-L1031
      // thanks @bluepnume

      function isShadowElement(element) {
        element = findRootNode(element);
        return element.toString() === "[object ShadowRoot]";
      }
      function getShadowHost(element) {
        element = findRootNode(element);
        if (!isShadowElement(element)) {
          return null;
        }
        return element.host;
      }
      function transformToSlot(element, styles) {
        var styleNode = findRootNode(element).querySelector("style");
        var shadowHost = getShadowHost(element);
        var slotName = "shadow-slot-" + uuid();
        var slot = document.createElement("slot");
        var slotProvider = document.createElement("div");
        slot.setAttribute("name", slotName);
        element.appendChild(slot);
        slotProvider.setAttribute("slot", slotName);
        shadowHost.appendChild(slotProvider);
        if (styles) {
          if (!styleNode) {
            styleNode = document.createElement("style");
            element.appendChild(styleNode);
          }
          styleNode.sheet.insertRule('::slotted([slot="' + slotName + '"]) { ' + styles + " }");
        }
        if (isShadowElement(shadowHost)) {
          return transformToSlot(slotProvider, styles);
        }
        return slotProvider;
      }
      module.exports = {
        isShadowElement: isShadowElement,
        getShadowHost: getShadowHost,
        transformToSlot: transformToSlot
      };
    }, {
      "./find-root-node": 152,
      "@braintree/uuid": 36
    }],
    176: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (snakeString) {
        if (snakeString.indexOf("_") === -1) {
          return snakeString;
        }
        return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
          return match[1].toUpperCase();
        });
      };
    }, {}],
    177: [function (_dereq_, module, exports) {
      "use strict";

      var querystring = _dereq_("./querystring");
      function getUrlParams() {
        return querystring.parse(window.location.href);
      }
      module.exports = {
        getUrlParams: getUrlParams
      };
    }, {
      "./querystring": 174
    }],
    178: [function (_dereq_, module, exports) {
      "use strict";

      function useMin(isDebug) {
        return isDebug ? "" : ".min";
      }
      module.exports = useMin;
    }, {}],
    179: [function (_dereq_, module, exports) {
      "use strict";

      // NEXT_MAJOR_VERSION old versions of IE don't have atob, in the
      // next major version, we're dropping support for those versions
      // so we can eliminate the need to have this atob polyfill
      var atobNormalized = typeof atob === "function" ? atob : atobPolyfill;
      function atobPolyfill(base64String) {
        var a, b, c, b1, b2, b3, b4, i;
        var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$");
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var result = "";
        if (!base64Matcher.test(base64String)) {
          throw new Error("Non base64 encoded input passed to window.atob polyfill");
        }
        i = 0;
        do {
          b1 = characters.indexOf(base64String.charAt(i++));
          b2 = characters.indexOf(base64String.charAt(i++));
          b3 = characters.indexOf(base64String.charAt(i++));
          b4 = characters.indexOf(base64String.charAt(i++));
          a = (b1 & 0x3f) << 2 | b2 >> 4 & 0x3;
          b = (b2 & 0xf) << 4 | b3 >> 2 & 0xf;
          c = (b3 & 0x3) << 6 | b4 & 0x3f;
          result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : "") + (c ? String.fromCharCode(c) : "");
        } while (i < base64String.length);
        return result;
      }
      module.exports = {
        atob: function (base64String) {
          return atobNormalized.call(window, base64String);
        },
        _atob: atobPolyfill
      };
    }, {}],
    180: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        REQUIRED_OPTIONS_FOR_START_PAYMENT: ["givenName", "surname", "currencyCode", "paymentType", "amount", "fallback"],
        REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE: ["givenName", "surname", "currencyCode", "onPaymentStart", "paymentType", "amount", "address", "billingAddress", "birthDate", "email", "locale", "customerServiceInstructions", "correlationId", "phone", "phoneCountryCode", "lineItems"],
        REQUIRED_OPTIONS_FOR_ADDRESS: ["streetAddress", "locality", "postalCode", "countryCode"],
        REQUIRED_OPTIONS_FOR_LINE_ITEMS: ["category", "name", "quantity", "unitAmount", "unitTaxAmount"],
        REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE: ["givenName", "surname", "currencyCode", "paymentType", "amount"],
        REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0: ["authCode"],
        REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST: ["authCode", "consumerReference", "aliasLabel"],
        REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT: ["consumerReference", "aliasKey"]
      };
    }, {}],
    181: [function (_dereq_, module, exports) {
      "use strict";

      var frameService = _dereq_("../../lib/frame-service/external");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var useMin = _dereq_("../../lib/use-min");
      var VERSION = "3.115.2";
      var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
      var analytics = _dereq_("../../lib/analytics");
      var methods = _dereq_("../../lib/methods");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var querystring = _dereq_("../../lib/querystring");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var constants = _dereq_("./constants");
      var errors = _dereq_("../shared/errors");
      var assign = _dereq_("../../lib/assign").assign;
      var inIframe = _dereq_("../../lib/in-iframe");
      var DEFAULT_WINDOW_WIDTH = 1282;
      var DEFAULT_WINDOW_HEIGHT = 720;
      ExtendedPromise.suppressUnhandledPromiseMessage = true;

      /**
       * @class
       * @param {object} options see {@link module:braintree-web/local-payment.create|local-payment.create}
       * @classdesc This class represents a LocalPayment component. Instances of this class can open a LocalPayment window for paying with alternate payments local to a specific country. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
       *
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/local-payment.create|braintree-web.local-payment.create} instead.</strong>
       */
      function LocalPayment(options) {
        this._client = options.client;
        this._assetsUrl = options.client.getConfiguration().gatewayConfiguration.assetsUrl + "/web/" + VERSION;
        this._isDebug = options.client.getConfiguration().isDebug;
        this._loadingFrameUrl = this._assetsUrl + "/html/local-payment-landing-frame" + useMin(this._isDebug) + ".html";
        this._authorizationInProgress = false;
        this._paymentType = "unknown";
        this._merchantAccountId = options.merchantAccountId;
        if (options.redirectUrl) {
          this._redirectUrl = options.redirectUrl;
          this._isRedirectFlow = true;
        }
      }
      LocalPayment.prototype._initialize = function () {
        var self = this;
        var client = this._client;
        var failureTimeout = setTimeout(function () {
          analytics.sendEvent(client, "local-payment.load.timed-out");
        }, INTEGRATION_TIMEOUT_MS);
        return new Promise(function (resolve) {
          frameService.create({
            name: "localpaymentlandingpage",
            dispatchFrameUrl: self._assetsUrl + "/html/dispatch-frame" + useMin(self._isDebug) + ".html",
            openFrameUrl: self._loadingFrameUrl
          }, function (service) {
            self._frameService = service;
            clearTimeout(failureTimeout);
            analytics.sendEvent(client, "local-payment.load.succeeded");
            resolve(self);
          });
        });
      };

      /**
       * Options used for most local payment types.
       * @typedef {object} LocalPayment~StartPaymentOptions
       * @property {object} fallback Configuration for what to do when app switching back from a Bank app on a mobile device. Only applicable to the popup flow.
       * @property {string} fallback.buttonText The text to display in a button to redirect back to the merchant page.
       * @property {string} fallback.url The url to redirect to when the redirect button is pressed. Query params will be added to the url to process the data returned from the bank.
       * @property {string} fallback.cancelButtonText The text to display in a button to redirect back to the merchant page when the customer cancels. If no `cancelButtonText` is provided, `buttonText` will be used.
       * @property {string} fallback.cancelUrl The url to redirect to when the redirect button is pressed when the customer cancels. Query params will be added to the url to check the state of the payment. If no `cancelUrl` is provided, `url` will be used.
       * @property {object} [windowOptions] The options for configuring the window that is opened when starting the payment. Only applicable to the popup flow.
       * @property {number} [windowOptions.width=1282] The width in pixels of the window opened when starting the payment. The default width size is this large to allow various banking partner landing pages to display the QR Code to be scanned by the bank's mobile app. Many will not display the QR code when the window size is smaller than a standard desktop screen.
       * @property {number} [windowOptions.height=720] The height in pixels of the window opened when starting the payment.
       * @property {string} amount The amount to authorize for the transaction.
       * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
       * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
       * @property {string} paymentType The type of local payment. See https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom
       * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
       * @property {string} email Payer email of the customer.
       * @property {string} givenName First name of the customer.
       * @property {string} surname Last name of the customer.
       * @property {string} phone Phone number of the customer.
       * @property {boolean} recurrent Enable recurrent payment.
       * @property {string} customerId The customer's id in merchant's system (required for recurrent payments).
       * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
       * @property {object} address The shipping address.
       * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
       * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
       * @property {string} address.locality Customer's city.
       * @property {string} address.region Customer's region or state.
       * @property {string} address.postalCode Customer's postal code.
       * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
       * @property {function} onPaymentStart A function that will be called with two parameters: an object containing the  `paymentId` and a `continueCallback` that must be called to launch the flow. You can use method to do any preprocessing on your server before the flow begins..
       */

      /**
       * Options used for the Pay Upon Invoice local payment type.
       * @typedef {object} LocalPayment~StartPaymentPayUponInvoiceOptions
       * @property {string} amount The amount to authorize for the transaction.
       * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
       * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
       * @property {string} paymentType The type of local payment. Must be `pay_upon_invoice`.
       * @property {string} [paymentTypeCountryCode] The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
       * @property {string} email Payer email of the customer.
       * @property {string} givenName First name of the customer.
       * @property {string} surname Last name of the customer.
       * @property {string} phone Phone number of the customer.
       * @property {string} phoneCountryCode The country calling code.
       * @property {string} birthDate The birth date of the customer in `YYYY-MM-DD` format.
       * @property {object} address The shipping address.
       * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
       * @property {string} [address.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
       * @property {string} address.locality Customer's city.
       * @property {string} [address.region] Customer's region or state.
       * @property {string} address.postalCode Customer's postal code.
       * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
       * @property {string} [shippingAmount] The shipping fee for all items. This value can not be a negative number.
       * @property {string} [discountAmount] The discount for all items. This value can not be a negative number.
       * @property {object} billingAddress The billing address.
       * @property {string} billingAddress.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
       * @property {string} [billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
       * @property {string} billingAddress.locality Customer's city.
       * @property {string} [billingAddress.region] Customer's region or state.
       * @property {string} billingAddress.postalCode Customer's postal code.
       * @property {string} billingAddress.countryCode Customer's country code (two-character ISO 3166-1 code).
       * @property {object[]} lineItems List of line items.
       * @property {string} lineItems.category The item category type: `'DIGITAL_GOODS'`, `'PHYSICAL_GOODS'`, or `'DONATION'`.
       * @property {string} lineItems.name Item name. Maximum 127 characters.
       * @property {string} lineItems.quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
       * @property {string} lineItems.unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
       * @property {string} lineItems.unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative.
       * @property {string} locale The BCP 47-formatted locale. PayPal supports a five-character code. For example, `en-DE`, `da-DK`, `he-IL`, `id-ID`, `ja-JP`, `no-NO`, `pt-BR`, `ru-RU`, `sv-SE`, `th-TH`, `zh-CN`, `zh-HK`, or `zh-TW`.
       * @property {string} customerServiceInstructions Instructions for how to contact the merchant's customer service. Maximum 4,000 characters.
       * @property {string} correlationId Used to correlate user sessions with server transactions.
       * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
       */

      /**
       * Options used for the seamless/oneclick BLIK local payment type.
       * @typedef {object} LocalPayment~StartPaymentOptions
       * @property {string} amount The amount to authorize for the transaction.
       * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
       * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
       * @property {string} paymentType The type of local payment. Must be `blik`.
       * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
       * @property {string} email Payer email of the customer.
       * @property {string} givenName First name of the customer.
       * @property {string} surname Last name of the customer.
       * @property {string} phone Phone number of the customer.
       * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
       * @property {object} address The shipping address.
       * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
       * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
       * @property {string} address.locality Customer's city.
       * @property {string} address.region Customer's region or state.
       * @property {string} address.postalCode Customer's postal code.
       * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
       * @property {object} blikOptions Blik seamless/oneclick specific options. Should contain only one object: `level_0` or `oneClick`.
       * @property {object} blikOptions.level_0 Blik seamless specific options.
       * @property {string} blikOptions.level_0.authCode 6-digit code used to authenticate a consumer within BLIK.
       * @property {object} blikOptions.oneClick Blik oneclick specific options.
       * @property {string} blikOptions.oneClick.authCode 6-digit code used to authenticate a consumer within BLIK.
       * @property {string} blikOptions.oneClick.consumerReference The merchant generated, unique reference serving as a primary identifier for accounts connected between Blik and a merchant.
       * @property {string} blikOptions.oneClick.aliasLabel A bank defined identifier used as a display name to allow the payer to differentiate between multiple registered bank accounts.
       * @property {string} blikOptions.oneClick.aliasKey A Blik-defined identifier for a specific Blik-enabled bank account that is associated with a given merchant. Used only in conjunction with a Consumer Reference.
       * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
       */

      /**
       * Launches the local payment flow and returns a nonce payload. Only one local payment flow should be active at a time. One way to achieve this is to disable your local payment button while the flow is open.
       * @public
       * @function
       * @param {LocalPayment~StartPaymentOptions|LocalPayment~StartPaymentPayUponInvoiceOptions} options Options for initiating the local payment payment flow.
       * @param {callback} callback The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * localPaymentInstance.startPayment({
       *   paymentType: 'ideal',
       *   paymentTypeCountryCode: 'NL',
       *   fallback: {
       *     buttonText: 'Return to Merchant',
       *     url: 'https://example.com/my-checkout-page'
       *   },
       *   amount: '10.00',
       *   currencyCode: 'EUR',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   address: {
       *     countryCode: 'NL'
       *   },
       *   onPaymentStart: function (data, continueCallback) {
       *     // Do any preprocessing before starting the flow
       *     // data.paymentId is the ID of the localPayment
       *     continueCallback();
       *   }
       * }).then(function (payload) {
       *   // Submit payload.nonce to your server
       * }).catch(function (startPaymentError) {
       *   // Handle flow errors or premature flow closure
       *   console.error('Error!', startPaymentError);
       * });
       * @example <caption>Pay Upon Invoice</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'pay_upon_invoice',
       *   amount: '100.00',
       *   currencyCode: 'EUR',
       *   givenName: 'Max',
       *   surname: 'Mustermann',
       *   address: { // This is used as the shipping address.
       *     streetAddress: 'Taunusanlage 12',
       *     locality: 'Frankfurt',
       *     postalCode: '60325',
       *     countryCode: 'DE',
       *   },
       *   billingAddress: {
       *     streetAddress: 'Schönhauser Allee 84',
       *     locality: 'Berlin',
       *     postalCode: '10439',
       *     countryCode: 'DE'
       *   },
       *   birthDate: '1990-01-01',
       *   email: 'buyer@example.com',
       *   locale: 'en-DE',
       *   customerServiceInstructions: 'Customer service phone is +49 6912345678.',
       *   lineItems: [{
       *     category: 'PHYSICAL_GOODS',
       *     name: 'Basketball Shoes',
       *     quantity: '1',
       *     unitAmount: '81.00',
       *     unitTaxAmount: '19.00',
       *   }],
       *   phone: '6912345678',
       *   phoneCountryCode: '49',
       *   correlationId: correlationId,
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       * @example <caption>BLIK seamless</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'blik',
       *   paymentTypeCountryCode: 'PL',
       *   amount: '10.00',
       *   currencyCode: 'PLN',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   phone: '1234566789',
       *   address: {
       *     streetAddress: 'Mokotowska 1234',
       *     locality: 'Warsaw',
       *     postalCode: '02-697',
       *     countryCode: 'PL',
       *   },
       *   blikOptions: {
       *     level_0: {
       *       authCode: "123456",
       *     },
       *   },
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       * @example <caption>BLIK oneclick first payment</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'blik',
       *   paymentTypeCountryCode: 'PL',
       *   amount: '10.00',
       *   currencyCode: 'PLN',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   phone: '1234566789',
       *   address: {
       *     streetAddress: 'Mokotowska 1234',
       *     locality: 'Warsaw',
       *     postalCode: '02-697',
       *     countryCode: 'PL',
       *   },
       *   blikOptions: {
       *     oneClick: {
       *       authCode: "123456",
       *       consumerReference: "ABCde123",
       *       aliasLabel: "my uniq alias",
       *     },
       *   },
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       * @example <caption>BLIK oneclick subsequent payment</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'blik',
       *   paymentTypeCountryCode: 'PL',
       *   amount: '10.00',
       *   currencyCode: 'PLN',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   phone: '1234566789',
       *   address: {
       *     streetAddress: 'Mokotowska 1234',
       *     locality: 'Warsaw',
       *     postalCode: '02-697',
       *     countryCode: 'PL',
       *   },
       *   blikOptions: {
       *     oneClick: {
       *       consumerReference: "ABCde123",
       *       aliasKey: "123456789",
       *     },
       *   },
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       * @example <caption>MB WAY</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'mbway',
       *   amount: '10.00',
       *   currencyCode: 'EUR',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   phone: '1234566789',
       *   phoneCountryCode: '351'
       *   address: {
       *     streetAddress: 'Rua Escura 12',
       *     locality: 'Porto',
       *     postalCode: '4465-283',
       *     countryCode: 'PT',
       *   },
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       * @example <caption>BANCOMAT PAY</caption>
       * localPaymentInstance.startPayment({
       *   paymentType: 'bancomatpay',
       *   amount: '10.00',
       *   currencyCode: 'EUR',
       *   givenName: 'Joe',
       *   surname: 'Doe',
       *   phone: '1234566789',
       *   phoneCountryCode: '49'
       *   address: {
       *     streetAddress: 'Via del Corso 12',
       *     locality: 'Roma',
       *     postalCode: '00100',
       *     countryCode: 'IT',
       *   },
       *   onPaymentStart: function (data) {
       *     // NOTE: It is critical here to store data.paymentId on your server
       *     //       so it can be mapped to a webhook sent by Braintree once the
       *     //       buyer completes their payment.
       *     console.log('Payment ID:', data.paymentId);
       *   },
       * }).catch(function (err) {
       *   // Handle any error calling startPayment.
       *   console.error(err);
       * });
       */
      LocalPayment.prototype.startPayment = function (options) {
        var missingOption, missingError, address, fallback, params, promise, billingAddress, windowOptions, onPaymentStartPromise, serviceId, cancelUrl, returnUrl;
        var self = this; // eslint-disable-line no-invalid-this

        if (self._isRedirectFlow) {
          options.redirectUrl = self._redirectUrl;
        } else {
          serviceId = self._frameService._serviceId;
        }
        // In order to provide the merchant with appropriate error messaging,
        // more robust validation is being done on the client-side, since some
        // option names are mapped to legacy names for the sake of the API.
        // For example, if `billingAddress.streetAddress` was missing, then
        // the API error response would say that `billing_address.line1` was
        // missing. This client-side validation will correctly tell the
        // merchant that `billingAddress.streetAddress` was missing.
        missingOption = hasMissingOption(options);
        if (missingOption) {
          missingError = new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION);
          if (typeof missingOption === "string") {
            missingError.details = "Missing required '" + missingOption + "' option.";
          }
          return Promise.reject(missingError);
        }
        windowOptions = options.windowOptions || {};
        address = options.address || {};
        fallback = options.fallback || {};
        billingAddress = options.billingAddress || {};
        params = {
          amount: options.amount,
          billingAddress: {
            line1: billingAddress.streetAddress,
            line2: billingAddress.extendedAddress,
            city: billingAddress.locality,
            state: billingAddress.region,
            postalCode: billingAddress.postalCode,
            countryCode: billingAddress.countryCode
          },
          birthDate: options.birthDate,
          blikOptions: options.blikOptions,
          city: address.locality,
          correlationId: options.correlationId,
          countryCode: address.countryCode,
          currencyIsoCode: options.currencyCode,
          discountAmount: options.discountAmount,
          experienceProfile: {
            brandName: options.displayName,
            customerServiceInstructions: options.customerServiceInstructions,
            locale: options.locale,
            noShipping: !options.shippingAddressRequired
          },
          firstName: options.givenName,
          fundingSource: options.paymentType,
          intent: "sale",
          lastName: options.surname,
          line1: address.streetAddress,
          line2: address.extendedAddress,
          lineItems: options.lineItems,
          merchantAccountId: self._merchantAccountId,
          merchantOrPartnerCustomerId: options.customerId,
          payerEmail: options.email,
          paymentTypeCountryCode: options.paymentTypeCountryCode,
          phone: options.phone,
          phoneCountryCode: options.phoneCountryCode,
          postalCode: address.postalCode,
          recurrent: options.recurrent,
          shippingAmount: options.shippingAmount,
          state: address.region
        };
        if (self._isRedirectFlow) {
          cancelUrl = querystring.queryify(self._redirectUrl, {
            wasCanceled: true
          });
          returnUrl = self._redirectUrl;
        } else {
          cancelUrl = querystring.queryify(self._assetsUrl + "/html/local-payment-redirect-frame" + useMin(self._isDebug) + ".html", {
            channel: serviceId,
            r: fallback.cancelUrl || fallback.url,
            t: fallback.cancelButtonText || fallback.buttonText,
            c: 1 // indicating we went through the cancel flow
          });
          returnUrl = querystring.queryify(self._assetsUrl + "/html/local-payment-redirect-frame" + useMin(self._isDebug) + ".html", {
            channel: serviceId,
            r: fallback.url,
            t: fallback.buttonText
          });
        }
        assign(params, {
          cancelUrl: cancelUrl,
          returnUrl: returnUrl
        });
        self._paymentType = options.paymentType.toLowerCase();
        if (self._authorizationInProgress && !self._isRedirectFlow) {
          analytics.sendEvent(self._client, self._paymentType + ".local-payment.start-payment.error.already-opened");
          return Promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_ALREADY_IN_PROGRESS));
        }
        self._authorizationInProgress = true;
        promise = new ExtendedPromise();

        // For deferred payment types, the popup window should not be opened,
        // since the actual payment will be done outside of this session.
        if (!isDeferredPaymentTypeOptions(options) && !self._isRedirectFlow) {
          self._startPaymentCallback = self._createStartPaymentCallback(function (val) {
            promise.resolve(val);
          }, function (err) {
            promise.reject(err);
          });
          self._frameService.open({
            width: windowOptions.width || DEFAULT_WINDOW_WIDTH,
            height: windowOptions.height || DEFAULT_WINDOW_HEIGHT
          }, self._startPaymentCallback);
        }
        self._client.request({
          method: "post",
          endpoint: "local_payments/create",
          data: params
        }).then(function (response) {
          var redirectUrl = response.paymentResource.redirectUrl;
          if (self._isRedirectFlow) {
            analytics.sendEvent(self._client, self._paymentType + ".local-payment.start-payment.redirected");
          } else {
            analytics.sendEvent(self._client, self._paymentType + ".local-payment.start-payment.opened");
          }
          self._startPaymentOptions = options;
          if (isDeferredPaymentTypeOptions(options)) {
            self._authorizationInProgress = false;
            if (typeof redirectUrl === "string" && redirectUrl.length) {
              promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED));
            } else {
              onPaymentStartPromise = options.onPaymentStart({
                paymentId: response.paymentResource.paymentToken
              });
              if (onPaymentStartPromise instanceof Promise) {
                onPaymentStartPromise.then(function () {
                  promise.resolve();
                });
              } else {
                promise.resolve();
              }
            }
          } else if (self._isRedirectFlow) {
            if (inIframe()) {
              window.top.location.href = response.paymentResource.redirectUrl;
            } else {
              window.location.href = response.paymentResource.redirectUrl;
            }
          } else {
            options.onPaymentStart({
              paymentId: response.paymentResource.paymentToken
            }, function () {
              self._frameService.redirect(response.paymentResource.redirectUrl);
            });
          }
        }).catch(function (err) {
          var status = err.details && err.details.httpStatus;
          if (!self._isRedirectFlow) {
            self._frameService.close();
          }
          self._authorizationInProgress = false;
          if (status === 422) {
            promise.reject(new BraintreeError({
              type: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.type,
              code: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.code,
              message: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.message,
              details: {
                originalError: err
              }
            }));
            return;
          }
          promise.reject(convertToBraintreeError(err, {
            type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
            code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
            message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message
          }));
        });
        return promise;
      };

      /**
       * Manually tokenizes params for a local payment received from PayPal.When app switching back from a mobile application (such as a bank application for an iDEAL payment), the window may lose context with the parent page. In that case, a fallback url is used, and this method can be used to finish the flow.
       * @public
       * @function
       * @param {object} [params] All options for tokenizing local payment parameters. If no params are passed in, the params will be pulled off of the query string of the page.
       * @param {string} params.btLpToken The token representing the local payment. Aliased to `token` if `btLpToken` is not present.
       * @param {string} params.btLpPaymentId The payment id for the local payment. Aliased to `paymentId` if `btLpPaymentId` is not present.
       * @param {string} params.btLpPayerId The payer id for the local payment. Aliased to `PayerID` if `btLpPayerId` is not present.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
       * @example
       * localPaymentInstance.tokenize().then(function (payload) {
       *   // send payload.nonce to your server
       * }).catch(function (err) {
       *   // handle tokenization error
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      LocalPayment.prototype.tokenize = function (params) {
        var self = this;
        var client = this._client;
        params = params || querystring.parse();

        // iOS Safari parses query params by adding the params inside an object called: queryItems
        if (params.queryItems) {
          params = params.queryItems;
        }
        if (params.c || params.wasCanceled) {
          return Promise.reject(new BraintreeError({
            type: errors.LOCAL_PAYMENT_CANCELED.type,
            code: errors.LOCAL_PAYMENT_CANCELED.code,
            message: errors.LOCAL_PAYMENT_CANCELED.message,
            details: {
              originalError: {
                errorcode: params.errorcode,
                token: params.btLpToken
              }
            }
          }));
        } else if (params.errorcode) {
          return Promise.reject(new BraintreeError({
            type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
            code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
            message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message,
            details: {
              originalError: {
                errorcode: params.errorcode,
                token: params.btLpToken
              }
            }
          }));
        }
        return client.request({
          endpoint: "payment_methods/paypal_accounts",
          method: "post",
          data: this._formatTokenizeData(params)
        }).then(function (response) {
          var payload = self._formatTokenizePayload(response);
          if (window.popupBridge) {
            analytics.sendEvent(client, self._paymentType + ".local-payment.tokenization.success-popupbridge");
          } else {
            analytics.sendEvent(client, self._paymentType + ".local-payment.tokenization.success");
          }
          return payload;
        }).catch(function (err) {
          analytics.sendEvent(client, self._paymentType + ".local-payment.tokenization.failed");
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.type,
            code: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.code,
            message: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.message
          }));
        });
      };

      /**
       * Closes the LocalPayment window if it is open.
       * @public
       * @example
       * localPaymentInstance.closeWindow();
       * @returns {void}
       */
      LocalPayment.prototype.closeWindow = function () {
        if (this._authoriztionInProgress) {
          analytics.sendEvent(this._client, this._paymentType + ".local-payment.start-payment.closed.by-merchant");
        }
        this._frameService.close();
      };

      /**
       * Focuses the LocalPayment window if it is open.
       * @public
       * @example
       * localPaymentInstance.focusWindow();
       * @returns {void}
       */
      LocalPayment.prototype.focusWindow = function () {
        this._frameService.focus();
      };
      LocalPayment.prototype._createStartPaymentCallback = function (resolve, reject) {
        var self = this;
        var client = this._client;
        return function (err, params) {
          self._authorizationInProgress = false;
          if (err) {
            if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
              if (params && params.errorcode === "processing_error") {
                // something failed within the payment window (rather than when
                // tokenizing with Braintree)
                analytics.sendEvent(client, self._paymentType + ".local-payment.failed-in-window");
                reject(new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_FAILED));
                return;
              }

              // its possible to have a query param with errorcode=payment_error, which
              // indicates that the customer cancelled the flow from within the UI,
              // but as there's no meaningful difference to the merchant whether the
              // customer closes via the UI or by manually closing the window, we
              // don't differentiate these
              analytics.sendEvent(client, self._paymentType + ".local-payment.tokenization.closed.by-user");
              reject(new BraintreeError(errors.LOCAL_PAYMENT_WINDOW_CLOSED));
            } else if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
              reject(new BraintreeError({
                code: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.code,
                type: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.type,
                message: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.message,
                details: {
                  originalError: err
                }
              }));
            }
          } else if (params) {
            if (!window.popupBridge) {
              self._frameService.redirect(self._loadingFrameUrl);
            }
            self.tokenize(params).then(resolve).catch(reject).then(function () {
              self._frameService.close();
            });
          }
        };
      };
      LocalPayment.prototype._formatTokenizePayload = function (response) {
        var payload;
        var account = {};
        if (response.paypalAccounts) {
          account = response.paypalAccounts[0];
        }
        payload = {
          nonce: account.nonce,
          details: {},
          type: account.type
        };
        if (account.details) {
          if (account.details.payerInfo) {
            payload.details = account.details.payerInfo;
          }
          if (account.details.correlationId) {
            payload.correlationId = account.details.correlationId;
          }
        }
        return payload;
      };

      /**
       * Checks if required tokenization parameters are available in querystring for manual tokenization requests.
       * @public
       * @function
       * @example
       * // if query string contains
       * // ?btLpToken=token&btLpPaymentId=payment-id&btLpPayerId=payer-id
       * localPaymentInstance.hasTokenizationParams(); // true
       *
       * // if query string has token: (full page redirect flow)
       * // ?token=abcdefg123456789
       * localPaymentInstance.hasTokenizationParams(); // true
       *
       * // if query string is missing required params
       * localPaymentInstance.hasTokenizationParams(); // false
       *
       * if (localPaymentInstance.hasTokenizationParams()) {
       *   localPaymentInstance.tokenize();
       * }
       * @returns {Boolean} Returns a Boolean value for the state of the query string.
       */
      LocalPayment.prototype.hasTokenizationParams = function () {
        var params = querystring.parse();
        if (params.errorcode || params.token) {
          return true;
        }
        return Boolean(params.btLpToken && params.btLpPaymentId && params.btLpPayerId);
      };
      LocalPayment.prototype._formatTokenizeData = function (params) {
        var clientConfiguration = this._client.getConfiguration();
        var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
        var data = {
          merchantAccountId: this._merchantAccountId,
          paypalAccount: {
            correlationId: params.btLpToken || params.token,
            paymentToken: params.btLpPaymentId || params.paymentId,
            payerId: params.btLpPayerId || params.PayerID,
            unilateral: gatewayConfiguration.paypal.unvettedMerchant,
            intent: "sale"
          }
        };
        return data;
      };

      // Some payment types are deferred. Meaning, the actual payment will
      // occur at a later time outside of this session. For example, with
      // Pay Upon Invoice, the customer will later receive an email that will
      // be used to make the actual payment through RatePay. This function
      // will return `true` if the given options contain `paymentType` of
      // a deferred payment type; and/or some payments, like blik, may have
      // specific extra options to be treated as deferred. Otherwise, it
      // will return `false`.
      function isDeferredPaymentTypeOptions(options) {
        var blikOptions = options.blikOptions || {};
        var paymentType = typeof options.paymentType === "string" ? options.paymentType.toLowerCase() : options.paymentType;
        if (paymentType === "blik") {
          return blikOptions.hasOwnProperty("level_0") || blikOptions.hasOwnProperty("oneClick");
        }
        return ["pay_upon_invoice", "mbway", "bancomatpay"].includes(paymentType);
      }
      function hasMissingAddressOption(options) {
        var i, option;
        for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_ADDRESS.length; i++) {
          option = constants.REQUIRED_OPTIONS_FOR_ADDRESS[i];
          if (!options.hasOwnProperty(option)) {
            return option;
          }
        }
        return false;
      }
      function hasMissingLineItemsOption(items) {
        var i, j, item, option;
        for (j = 0; j < items.length; j++) {
          item = items[j];
          for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS.length; i++) {
            option = constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS[i];
            if (!item.hasOwnProperty(option)) {
              return option;
            }
          }
        }
        return false;
      }
      function hasMissingBlikOptions(options) {
        var i, option, oneClick;
        var blikOptions = options.blikOptions || {};
        if (!options.redirectUrl) {
          constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE.push("onPaymentStart");
        }
        for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE.length; i++) {
          option = constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE[i];
          if (!options.hasOwnProperty(option)) {
            return option;
          }
        }
        if (blikOptions.hasOwnProperty("level_0")) {
          for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0.length; i++) {
            option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0[i];

            // eslint-disable-next-line camelcase
            if (!blikOptions.level_0.hasOwnProperty(option)) {
              return "blikOptions.level_0." + option;
            }
          }
        } else if (blikOptions.hasOwnProperty("oneClick")) {
          oneClick = blikOptions.oneClick || {};
          if (oneClick.hasOwnProperty("aliasKey")) {
            for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT.length; i++) {
              option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT[i];
              if (!oneClick.hasOwnProperty(option)) {
                return "blikOptions.oneClick." + option;
              }
            }
          } else {
            for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST.length; i++) {
              option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST[i];
              if (!oneClick.hasOwnProperty(option)) {
                return "blikOptions.oneClick." + option;
              }
            }
          }
        }
        return false;
      }

      // This will return the name of the first missing required option that
      // is found or `true` if `options` itself is not defined. Otherwise, it
      // will return `false`.
      function hasMissingOption(options) {
        var i, option, missingAddressOption, missingLineItemOption, paymentType;
        if (!options) {
          return true;
        }
        if (isDeferredPaymentTypeOptions(options)) {
          paymentType = options.paymentType || "";
          if (paymentType.toLowerCase() === "pay_upon_invoice") {
            for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE.length; i++) {
              option = constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE[i];
              if (!options.hasOwnProperty(option)) {
                return option;
              }
              if (option === "address" || option === "billingAddress") {
                missingAddressOption = hasMissingAddressOption(options[option]);
                if (missingAddressOption) {
                  return option + "." + missingAddressOption;
                }
              } else if (option === "lineItems") {
                missingLineItemOption = hasMissingLineItemsOption(options[option]);
                if (missingLineItemOption) {
                  return option + "." + missingLineItemOption;
                }
              }
            }
          } else if (paymentType.toLowerCase() === "blik") {
            return hasMissingBlikOptions(options);
          }
        } else {
          if (!options.redirectUrl) {
            constants.REQUIRED_OPTIONS_FOR_START_PAYMENT.push("onPaymentStart");
          }
          for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_START_PAYMENT.length; i++) {
            option = constants.REQUIRED_OPTIONS_FOR_START_PAYMENT[i];
            if (!options.hasOwnProperty(option)) {
              return option;
            }
          }
          if (!options.fallback.url) {
            return "fallback.url";
          }
          if (!options.fallback.buttonText) {
            return "fallback.buttonText";
          }
          if (options.recurrent === true && !options.customerId) {
            return "customerId";
          }
        }
        return false;
      }

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/local-payment.create|create}.
       * @public
       * @param {callback} [callback] Called on completion.
       * @example
       * localPaymentInstance.teardown();
       * @example <caption>With callback</caption>
       * localPaymentInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      LocalPayment.prototype.teardown = function () {
        var self = this; // eslint-disable-line no-invalid-this

        if (!self._isRedirectFlow) {
          self._frameService.teardown();
        }
        convertMethodsToError(self, methods(LocalPayment.prototype));
        analytics.sendEvent(self._client, "local-payment.teardown-completed");
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(LocalPayment);
    }, {
      "../../lib/analytics": 135,
      "../../lib/assign": 137,
      "../../lib/braintree-error": 140,
      "../../lib/constants": 142,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/convert-to-braintree-error": 144,
      "../../lib/frame-service/external": 155,
      "../../lib/in-iframe": 166,
      "../../lib/methods": 172,
      "../../lib/querystring": 174,
      "../../lib/use-min": 178,
      "../shared/errors": 183,
      "./constants": 180,
      "@braintree/extended-promise": 31,
      "@braintree/wrap-promise": 40
    }],
    182: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/local-payment
       * @description A component to integrate with local payment methods. *This component is currently in beta and is subject to change.*
       */
      var analytics = _dereq_("../lib/analytics");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var LocalPayment = _dereq_("./external/local-payment");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./shared/errors");
      var parse = _dereq_("../lib/querystring").parse;

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization and creation of the authorizing transaction. Braintree strongly recommends specifying this parameter.
       * @param {string} [options.redirectUrl] When provided, triggers full page redirect flow instead of popup flow.
       * @param {callback} callback The second argument, `data`, is the {@link LocalPayment} instance.
       * @example <caption>Using the local payment component to set up an iDEAL button</caption>
       * var idealButton = document.querySelector('.ideal-button');
       *
       * braintree.client.create({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (clientErr, clientInstance) {
       *   if (clientErr) {
       *     console.error('Error creating client:', clientErr);
       *     return;
       *   }
       *
       *   braintree.localPayment.create({
       *     client: clientInstance,
       *     merchantAccountId: 'merchantAccountEUR',
       *   }, function (localPaymentErr, localPaymentInstance) {
       *     if (localPaymentErr) {
       *       console.error('Error creating local payment component:', localPaymentErr);
       *       return;
       *     }
       *
       *     idealButton.removeAttribute('disabled');
       *
       *     // When the button is clicked, attempt to start the payment flow.
       *     idealButton.addEventListener('click', function (event) {
       *       // Because this opens a popup, this has to be called as a result of
       *       // customer action, like clicking a button. You cannot call this at any time.
       *       localPaymentInstance.startPayment({
       *         paymentType: 'ideal',
       *         amount: '10.67',
       *         city: 'Den Haag',
       *         countryCode: 'NL',
       *         firstName: 'Test',
       *         lastName: 'McTester',
       *         line1: '123 of 456 Fake Lane',
       *         line2: 'Apartment 789',
       *         payerEmail: 'payer@example.com',
       *         phone: '123456789',
       *         postalCode: '1234 AA',
       *         currencyCode: 'EUR',
       *         onPaymentStart: function (data, continueCallback) {
       *           // Do any preprocessing to store the ID and setup webhook
       *           // Call start to initiate the popup
       *           continueCallback();
       *         }
       **       }, function (startPaymentErr, payload) {
       *         if (startPaymentErr) {
       *           if (startPaymentErr.type !== 'CUSTOMER') {
       *             console.error('Error starting payment:', startPaymentErr);
       *           }
       *           return;
       *         }
       *
       *         idealButton.setAttribute('disabled', true);
       *
       *         console.log(payload.paymentId);
       *       });
       *     }, false);
       *   });
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "Local Payment";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var localPaymentInstance, params;
          var config = client.getConfiguration();
          options.client = client;
          if (config.gatewayConfiguration.paypalEnabled !== true) {
            return Promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_NOT_ENABLED));
          }
          analytics.sendEvent(client, "local-payment.initialized");
          localPaymentInstance = new LocalPayment(options);
          if (options.redirectUrl) {
            params = parse(window.location.href);
            if (params.token || params.wasCanceled) {
              return localPaymentInstance.tokenize(params).then(function (payload) {
                localPaymentInstance.tokenizePayload = payload;
                return localPaymentInstance;
              }).catch(function (err) {
                console.log("Error while tokenizing: ", err);
                return localPaymentInstance;
              });
            }
            return localPaymentInstance;
          }
          return localPaymentInstance._initialize();
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "../lib/querystring": 174,
      "./external/local-payment": 181,
      "./shared/errors": 183,
      "@braintree/wrap-promise": 40
    }],
    183: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.LocalPayment - Creation Error Codes
       * @description Errors that occur when [creating the Local Payment component](./module-braintree-web_local-payment.html#.create).
       * @property {MERCHANT} LOCAL_PAYMENT_NOT_ENABLED Occurs when Local Payment is not enabled on the Braintree control panel.
       */

      /**
       * @name BraintreeError.LocalPayment - startPayment Error Codes
       * @description Errors that occur when using the [`startPayment` method](./LocalPayment.html#startPayment).
       * @property {MERCHANT} LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION Occurs when a startPayment is missing a required option.
       * @property {MERCHANT} LOCAL_PAYMENT_ALREADY_IN_PROGRESS Occurs when a startPayment call is already in progress.
       * @property {MERCHANT} LOCAL_PAYMENT_INVALID_PAYMENT_OPTION Occurs when a startPayment call has an invalid option.
       * @property {NETWORK} LOCAL_PAYMENT_START_PAYMENT_FAILED Occurs when a startPayment call fails.
       * @property {NETWORK} LOCAL_PAYMENT_TOKENIZATION_FAILED Occurs when a startPayment call fails to tokenize the result from authorization.
       * @property {CUSTOMER} LOCAL_PAYMENT_CANCELED Occurs when the customer cancels the Local Payment.
       * @property {CUSTOMER} LOCAL_PAYMENT_WINDOW_CLOSED Occurs when the customer closes the Local Payment window.
       * @property {MERCHANT} LOCAL_PAYMENT_WINDOW_OPEN_FAILED Occurs when the Local Payment window fails to open. Usually because `startPayment` was not called as a direct result of a user action.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        LOCAL_PAYMENT_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "LOCAL_PAYMENT_NOT_ENABLED",
          message: "LocalPayment is not enabled for this merchant."
        },
        LOCAL_PAYMENT_ALREADY_IN_PROGRESS: {
          type: BraintreeError.types.MERCHANT,
          code: "LOCAL_PAYMENT_ALREADY_IN_PROGRESS",
          message: "LocalPayment payment is already in progress."
        },
        LOCAL_PAYMENT_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "LOCAL_PAYMENT_CANCELED",
          message: "Customer canceled the LocalPayment before authorizing."
        },
        LOCAL_PAYMENT_WINDOW_CLOSED: {
          type: BraintreeError.types.CUSTOMER,
          code: "LOCAL_PAYMENT_WINDOW_CLOSED",
          message: "Customer closed LocalPayment window before authorizing."
        },
        LOCAL_PAYMENT_WINDOW_OPEN_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "LOCAL_PAYMENT_WINDOW_OPEN_FAILED",
          message: "LocalPayment window failed to open; make sure startPayment was called in response to a user action."
        },
        LOCAL_PAYMENT_START_PAYMENT_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "LOCAL_PAYMENT_START_PAYMENT_FAILED",
          message: "LocalPayment startPayment failed."
        },
        LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION",
          message: "Missing required option for startPayment."
        },
        LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED",
          message: "LocalPayment startPayment deferred payment failed."
        },
        LOCAL_PAYMENT_TOKENIZATION_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "LOCAL_PAYMENT_TOKENIZATION_FAILED",
          message: "Could not tokenize user's local payment method."
        },
        LOCAL_PAYMENT_INVALID_PAYMENT_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "LOCAL_PAYMENT_INVALID_PAYMENT_OPTION",
          message: "Local payment options are invalid."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    184: [function (_dereq_, module, exports) {
      "use strict";

      var frameService = _dereq_("../../lib/frame-service/external");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var errors = _dereq_("../shared/errors");
      var VERSION = "3.115.2";
      var methods = _dereq_("../../lib/methods");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var analytics = _dereq_("../../lib/analytics");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
      var constants = _dereq_("../shared/constants");
      var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;

      /**
       * Masterpass Address object.
       * @typedef {object} Masterpass~Address
       * @property {string} countryCodeAlpha2 The customer's country code.
       * @property {string} extendedAddress The customer's extended address.
       * @property {string} locality The customer's locality.
       * @property {string} postalCode The customer's postal code.
       * @property {string} region The customer's region.
       * @property {string} streetAddress The customer's street address.
       */

      /**
       * @typedef {object} Masterpass~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} description The human readable description.
       * @property {string} type The payment method type, always `MasterpassCard`.
       * @property {object} details Additional account details.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {object} contact The customer's contact information.
       * @property {string} contact.firstName The customer's first name.
       * @property {string} contact.lastName The customer's last name.
       * @property {string} contact.phoneNumber The customer's phone number.
       * @property {string} contact.emailAddress The customer's email address.
       * @property {Masterpass~Address} billingAddress The customer's billing address.
       * @property {Masterpass~Address} shippingAddress The customer's shipping address.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * @class
       * @param {object} options see {@link module:braintree-web/masterpass.create|masterpass.create}
       * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/masterpass.create|braintree.masterpass.create} instead.</strong>
       * @classdesc This class represents an Masterpass component. Instances of this class have methods for launching a new window to process a transaction with Masterpass.
       */
      function Masterpass(options) {
        var configuration = options.client.getConfiguration();
        this._client = options.client;
        this._assetsUrl = configuration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
        this._isDebug = configuration.isDebug;
        this._authInProgress = false;
        if (window.popupBridge && typeof window.popupBridge.getReturnUrlPrefix === "function") {
          this._callbackUrl = window.popupBridge.getReturnUrlPrefix() + "return";
        } else {
          this._callbackUrl = this._assetsUrl + "/html/redirect-frame" + (this._isDebug ? "" : ".min") + ".html";
        }
      }
      Masterpass.prototype._initialize = function () {
        var self = this;
        return new Promise(function (resolve) {
          var failureTimeout = setTimeout(function () {
            analytics.sendEvent(self._client, "masterpass.load.timed-out");
          }, INTEGRATION_TIMEOUT_MS);
          frameService.create({
            name: constants.LANDING_FRAME_NAME,
            height: constants.POPUP_HEIGHT,
            width: constants.POPUP_WIDTH,
            dispatchFrameUrl: self._assetsUrl + "/html/dispatch-frame" + (self._isDebug ? "" : ".min") + ".html",
            openFrameUrl: self._assetsUrl + "/html/masterpass-landing-frame" + (self._isDebug ? "" : ".min") + ".html"
          }, function (service) {
            self._frameService = service;
            clearTimeout(failureTimeout);
            analytics.sendEvent(self._client, "masterpass.load.succeeded");
            resolve(self);
          });
        });
      };

      /**
       * Launches the Masterpass flow and returns a nonce payload. Only one Masterpass flow should be active at a time. One way to achieve this is to disable your Masterpass button while the flow is open.
       *
       * Braintree will apply these properties in `options.config`. Merchants should not override these values, except for advanced usage.
       *  - `environment`
       *  - `requestToken`
       *  - `callbackUrl`
       *  - `merchantCheckoutId`
       *  - `allowedCardTypes`
       *  - `version`
       *
       * @public
       * @param {object} options All options for initiating the Masterpass payment flow.
       * @param {string} options.currencyCode The currency code to process the payment.
       * @param {string} options.subtotal The amount to authorize for the transaction.
       * @param {object} [options.config] All configuration parameters accepted by Masterpass lightbox, except `function` data type. These options will override the values set by Braintree server. Please see {@link Masterpass Lightbox Parameters|https://developer.mastercard.com/page/masterpass-lightbox-parameters} for more information.
       * @param {object} [options.frameOptions] Used to configure the window that contains the Masterpass login.
       * @param {number} [options.frameOptions.width] Popup width to be used instead of default value (450px).
       * @param {number} [options.frameOptions.height] Popup height to be used instead of default value (660px).
       * @param {number} [options.frameOptions.top] The top position of the popup window to be used instead of default value, that is calculated based on provided height, and parent window size.
       * @param {number} [options.frameOptions.left] The left position to the popup window to be used instead of default value, that is calculated based on provided width, and parent window size.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Masterpass~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Masterpass~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * button.addEventListener('click', function () {
       *   // Disable the button so that we don't attempt to open multiple popups.
       *   button.setAttribute('disabled', 'disabled');
       *
       *   // Because tokenize opens a new window, this must be called
       *   // as a result of a user action, such as a button click.
       *   masterpassInstance.tokenize({
       *     currencyCode: 'USD',
       *     subtotal: '10.00'
       *   }).then(function (payload) {
       *     button.removeAttribute('disabled');
       *     // Submit payload.nonce to your server
       *   }).catch(function (tokenizeError) {
       *     button.removeAttribute('disabled');
       *     // Handle flow errors or premature flow closure
       *
       *     switch (tokenizeErr.code) {
       *       case 'MASTERPASS_POPUP_CLOSED':
       *         console.error('Customer closed Masterpass popup.');
       *         break;
       *       case 'MASTERPASS_ACCOUNT_TOKENIZATION_FAILED':
       *         console.error('Masterpass tokenization failed. See details:', tokenizeErr.details);
       *         break;
       *       case 'MASTERPASS_FLOW_FAILED':
       *         console.error('Unable to initialize Masterpass flow. Are your options correct?', tokenizeErr.details);
       *         break;
       *       default:
       *         console.error('Error!', tokenizeErr);
       *     }
       *   });
       * });
       */
      Masterpass.prototype.tokenize = function (options) {
        var self = this;
        if (!options || hasMissingOption(options)) {
          return Promise.reject(new BraintreeError(errors.MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION));
        }
        if (self._authInProgress) {
          return Promise.reject(new BraintreeError(errors.MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS));
        }
        return new Promise(function (resolve, reject) {
          self._navigateFrameToLoadingPage(options).catch(reject);
          // This MUST happen after _navigateFrameToLoadingPage for Metro browsers to work.
          self._frameService.open(options.frameOptions, self._createFrameOpenHandler(resolve, reject));
        });
      };
      Masterpass.prototype._navigateFrameToLoadingPage = function (options) {
        var self = this;
        this._authInProgress = true;
        return this._client.request({
          method: "post",
          endpoint: "masterpass/request_token",
          data: {
            requestToken: {
              originUrl: window.location.protocol + "//" + window.location.hostname,
              subtotal: options.subtotal,
              currencyCode: options.currencyCode,
              callbackUrl: this._callbackUrl
            }
          }
        }).then(function (response) {
          var redirectUrl = self._assetsUrl + "/html/masterpass-loading-frame" + (self._isDebug ? "" : ".min") + ".html?";
          var gatewayConfiguration = self._client.getConfiguration().gatewayConfiguration;
          var config = options.config || {};
          var queryParams;
          queryParams = {
            environment: gatewayConfiguration.environment,
            requestToken: response.requestToken,
            callbackUrl: self._callbackUrl,
            merchantCheckoutId: gatewayConfiguration.masterpass.merchantCheckoutId,
            allowedCardTypes: gatewayConfiguration.masterpass.supportedNetworks,
            version: constants.MASTERPASS_VERSION
          };
          Object.keys(config).forEach(function (key) {
            if (typeof config[key] !== "function") {
              queryParams[key] = config[key];
            }
          });
          redirectUrl += Object.keys(queryParams).map(function (key) {
            return key + "=" + queryParams[key];
          }).join("&");
          self._frameService.redirect(redirectUrl);
        }).catch(function (err) {
          var status = err.details && err.details.httpStatus;
          self._closeWindow();
          if (status === 422) {
            return Promise.reject(convertToBraintreeError(err, errors.MASTERPASS_INVALID_PAYMENT_OPTION));
          }
          return Promise.reject(convertToBraintreeError(err, errors.MASTERPASS_FLOW_FAILED));
        });
      };
      Masterpass.prototype._createFrameOpenHandler = function (resolve, reject) {
        var self = this;
        if (window.popupBridge) {
          return function (popupBridgeErr, payload) {
            self._authInProgress = false;
            if (popupBridgeErr) {
              analytics.sendEvent(self._client, "masterpass.tokenization.closed-popupbridge.by-user");
              reject(convertToBraintreeError(popupBridgeErr, errors.MASTERPASS_POPUP_CLOSED));
              return;
            } else if (!payload.queryItems) {
              analytics.sendEvent(self._client, "masterpass.tokenization.failed-popupbridge");
              reject(new BraintreeError(errors.MASTERPASS_FLOW_FAILED));
              return;
            }
            self._tokenizeMasterpass(payload.queryItems).then(resolve).catch(reject);
          };
        }
        return function (frameServiceErr, payload) {
          if (frameServiceErr) {
            self._authInProgress = false;
            if (frameServiceErr.code === "FRAME_SERVICE_FRAME_CLOSED") {
              analytics.sendEvent(self._client, "masterpass.tokenization.closed.by-user");
              reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));
              return;
            }
            if (frameServiceErr.code && frameServiceErr.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
              analytics.sendEvent(self._client, "masterpass.tokenization.failed.to-open");
              reject(new BraintreeError({
                code: errors.MASTERPASS_POPUP_OPEN_FAILED.code,
                type: errors.MASTERPASS_POPUP_OPEN_FAILED.type,
                message: errors.MASTERPASS_POPUP_OPEN_FAILED.message,
                details: {
                  originalError: frameServiceErr
                }
              }));
              return;
            }
            analytics.sendEvent(self._client, "masterpass.tokenization.failed");
            self._closeWindow();
            reject(convertToBraintreeError(frameServiceErr, errors.MASTERPASS_FLOW_FAILED));
            return;
          }
          self._tokenizeMasterpass(payload).then(resolve).catch(reject);
        };
      };
      Masterpass.prototype._tokenizeMasterpass = function (payload) {
        var self = this;
        if (payload.mpstatus !== "success") {
          analytics.sendEvent(self._client, "masterpass.tokenization.closed.by-user");
          self._closeWindow();
          return Promise.reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));
        }
        if (isMissingRequiredPayload(payload)) {
          analytics.sendEvent(self._client, "masterpass.tokenization.closed.missing-payload");
          self._closeWindow();
          return Promise.reject(new BraintreeError(errors.MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS));
        }
        return self._client.request({
          endpoint: "payment_methods/masterpass_cards",
          method: "post",
          data: {
            masterpassCard: {
              checkoutResourceUrl: payload.checkout_resource_url,
              requestToken: payload.oauth_token,
              verifierToken: payload.oauth_verifier
            }
          }
        }).then(function (response) {
          self._closeWindow();
          if (window.popupBridge) {
            analytics.sendEvent(self._client, "masterpass.tokenization.success-popupbridge");
          } else {
            analytics.sendEvent(self._client, "masterpass.tokenization.success");
          }
          return response.masterpassCards[0];
        }).catch(function (tokenizeErr) {
          self._closeWindow();
          if (window.popupBridge) {
            analytics.sendEvent(self._client, "masterpass.tokenization.failed-popupbridge");
          } else {
            analytics.sendEvent(self._client, "masterpass.tokenization.failed");
          }
          return Promise.reject(convertToBraintreeError(tokenizeErr, errors.MASTERPASS_ACCOUNT_TOKENIZATION_FAILED));
        });
      };
      function isMissingRequiredPayload(payload) {
        return [payload.oauth_verifier, payload.oauth_token, payload.checkout_resource_url].some(function (element) {
          return element == null || element === "null";
        });
      }
      Masterpass.prototype._closeWindow = function () {
        this._authInProgress = false;
        this._frameService.close();
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/masterpass.create|create}.
       * @public
       * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
       * @example
       * masterpassInstance.teardown();
       * @example <caption>With callback</caption>
       * masterpassInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Masterpass.prototype.teardown = function () {
        var self = this;
        return new Promise(function (resolve) {
          self._frameService.teardown();
          convertMethodsToError(self, methods(Masterpass.prototype));
          analytics.sendEvent(self._client, "masterpass.teardown-completed");
          resolve();
        });
      };
      function hasMissingOption(options) {
        var i, option;
        for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_TOKENIZE.length; i++) {
          option = constants.REQUIRED_OPTIONS_FOR_TOKENIZE[i];
          if (!options.hasOwnProperty(option)) {
            return true;
          }
        }
        return false;
      }
      module.exports = wrapPromise.wrapPrototype(Masterpass);
    }, {
      "../../lib/analytics": 135,
      "../../lib/braintree-error": 140,
      "../../lib/constants": 142,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/convert-to-braintree-error": 144,
      "../../lib/frame-service/external": 155,
      "../../lib/methods": 172,
      "../shared/constants": 187,
      "../shared/errors": 188,
      "@braintree/wrap-promise": 40
    }],
    185: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/masterpass
       * @description Processes Masterpass. *This component is currently in beta and is subject to change.*
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var browserDetection = _dereq_("./shared/browser-detection");
      var Masterpass = _dereq_("./external/masterpass");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var VERSION = "3.115.2";
      var errors = _dereq_("./shared/errors");
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link Masterpass} instance. If no callback is passed in, the create function returns a promise that resolves the {@link Masterpass} instance.
       * @example
       * braintree.masterpass.create({
       *   client: clientInstance
       * }, function (createErr, masterpassInstance) {
       *   if (createErr) {
       *     if (createErr.code === 'MASTERPASS_BROWSER_NOT_SUPPORTED') {
       *       console.error('This browser is not supported.');
       *     } else {
       *       console.error('Error!', createErr);
       *     }
       *     return;
       *   }
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "Masterpass";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          if (!isSupported()) {
            return Promise.reject(new BraintreeError(errors.MASTERPASS_BROWSER_NOT_SUPPORTED));
          }
          return Promise.resolve();
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var masterpassInstance, configuration;
          options.client = client;
          configuration = options.client.getConfiguration().gatewayConfiguration;
          if (!configuration.masterpass) {
            return Promise.reject(new BraintreeError(errors.MASTERPASS_NOT_ENABLED));
          }
          masterpassInstance = new Masterpass(options);
          return masterpassInstance._initialize();
        });
      }

      /**
       * @static
       * @function isSupported
       * @description Returns true if Masterpass supports this browser.
       * @example
       * if (braintree.masterpass.isSupported()) {
       *   // Add Masterpass button to the page
       * } else {
       *   // Hide Masterpass payment option
       * }
       * @returns {Boolean} Returns true if Masterpass supports this browser.
       */
      function isSupported() {
        return Boolean(window.popupBridge || browserDetection.supportsPopups());
      }
      module.exports = {
        create: wrapPromise(create),
        isSupported: isSupported,
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./external/masterpass": 184,
      "./shared/browser-detection": 186,
      "./shared/errors": 188,
      "@braintree/wrap-promise": 40
    }],
    186: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        supportsPopups: _dereq_("@braintree/browser-detection/supports-popups")
      };
    }, {
      "@braintree/browser-detection/supports-popups": 29
    }],
    187: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        LANDING_FRAME_NAME: "braintreemasterpasslanding",
        POPUP_WIDTH: 450,
        POPUP_HEIGHT: 660,
        MASTERPASS_VERSION: "v6",
        REQUIRED_OPTIONS_FOR_TOKENIZE: ["subtotal", "currencyCode"]
      };
    }, {}],
    188: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Masterpass - Creation Error Codes
       * @description Errors that occur when [creating the Masterpass component](./module-braintree-web_masterpass#.create).
       * @property {CUSTOMER} MASTERPASS_BROWSER_NOT_SUPPORTED Occurs when browser is not a supported browser for Masterpass.
       * @property {MERCHANT} MASTERPASS_NOT_ENABLED Occurs when Masterpass is not enabled in the Braintree control panel.
       */

      /**
       * @name BraintreeError.Masterpass - Tokenize Error Codes
       * @description Errors that occur when [tokenizing](./Masterpass.html#tokenize).
       * @property {MERCHANT} MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when tokenize is called without a required option.
       * @property {MERCHANT} MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS Occurs if tokenization flow is initialized while another flow is already in progress.
       * @property {NETWORK} MASTERPASS_ACCOUNT_TOKENIZATION_FAILED Occurs when tokenization of Masterpass details fails.
       * @property {MERCHANT} MASTERPASS_POPUP_OPEN_FAILED Occurs when the popup fails to open.
       * @property {MERCHANT} MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS Occurs when Masterpass is missing required parameters for tokenization.
       * @property {CUSTOMER} MASTERPASS_POPUP_CLOSED Occurs when the popup is closed by the customer.
       * @property {MERCHANT} MASTERPASS_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is used to tokenize Masterpass.
       * @property {NETWORK} MASTERPASS_FLOW_FAILED Occurs when an error is returned from request to tokenize.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        MASTERPASS_BROWSER_NOT_SUPPORTED: {
          type: BraintreeError.types.CUSTOMER,
          code: "MASTERPASS_BROWSER_NOT_SUPPORTED",
          message: "Browser is not supported."
        },
        MASTERPASS_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_NOT_ENABLED",
          message: "Masterpass is not enabled for this merchant."
        },
        MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION",
          message: "Missing required option for tokenize."
        },
        MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS",
          message: "Masterpass tokenization is already in progress."
        },
        MASTERPASS_ACCOUNT_TOKENIZATION_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "MASTERPASS_ACCOUNT_TOKENIZATION_FAILED",
          message: "Could not tokenize user's Masterpass account."
        },
        MASTERPASS_POPUP_OPEN_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_POPUP_OPEN_FAILED",
          message: "Masterpass popup failed to open. Make sure to tokenize in response to a user action, such as a click."
        },
        MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS",
          message: "Masterpass popup failed to return all required parameters needed to continue tokenization."
        },
        MASTERPASS_POPUP_CLOSED: {
          type: BraintreeError.types.CUSTOMER,
          code: "MASTERPASS_POPUP_CLOSED",
          message: "Customer closed Masterpass popup before authorizing."
        },
        MASTERPASS_INVALID_PAYMENT_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "MASTERPASS_INVALID_PAYMENT_OPTION",
          message: "Masterpass payment options are invalid."
        },
        MASTERPASS_FLOW_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "MASTERPASS_FLOW_FAILED",
          message: "Could not initialize Masterpass flow."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    189: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../../lib/analytics");
      var assign = _dereq_("../../lib/assign").assign;
      var Bus = _dereq_("framebus");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var generateGooglePayConfiguration = _dereq_("../../lib/generate-google-pay-configuration");
      var iFramer = _dereq_("@braintree/iframer");
      var uuid = _dereq_("@braintree/uuid");
      var useMin = _dereq_("../../lib/use-min");
      var methods = _dereq_("../../lib/methods");
      var EventEmitter = _dereq_("@braintree/event-emitter");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var VERSION = "3.115.2";
      var constants = _dereq_("../shared/constants");
      var events = constants.events;
      var errors = constants.errors;
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @typedef {object} PaymentRequestComponent~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {object} details Additional account details.
       * @property {string} details.bin The BIN number of the card..
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {object} details.rawPaymentResponse The raw payment response from the payment request, with sensitive card details removed.
       * @property {string} description A human-readable description.
       * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * @typedef {object} PaymentRequestComponent~paymentRequestConfiguration
       * @property {object} configuration.details The payment details. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_payment_details).
       * @property {array} [configuration.supportedPaymentMethods] The supported payment methods. If not passed in, the supported payment methods from the merchant account that generated the authorization for the client will be used. For details on this array, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_supported_payment_methods).
       * @property {object} [configuration.options] Additional payment request options. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_options_optional).
       */

      /**
       * @typedef {object} PaymentRequestComponent~shippingEventObject
       * @description The event payload sent from {@link PaymentRequestComponent#on|on}.
       * @property {object} target An object which contains data about the event.
       * @property {function} updateWith A method to call with the updated Payment Request details.
       */

      /**
       * @name PaymentRequestComponent#on
       * @function
       * @param {string} event The name of the event to which you are subscribing.
       * @param {function} handler A callback to handle the event.
       * @description Subscribes a handler function to a named event. `event` should be {@link PaymentRequestComponent#event:shippingAddressChange|shippingAddressChange} or {@link PaymentRequestComponent#event:shippingOptionChange|shippingOptionChange}. For convenience, you can also listen on `shippingaddresschange` or `shippingoptionchange` to match the event listeners in the [Payment Request API documentation](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request#shipping_in_payment_request_api). Events will emit a {@link PaymentRequestComponent~shippingEventObject|shippingEventObject}.
       * @example
       * <caption>Listening to a Payment Request event, in this case 'shippingAddressChange'</caption>
       * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
       *   paymentRequestInstance.on('shippingAddressChange', function (event) {
       *     console.log(event.target.shippingAddress);
       *   });
       * });
       * @returns {void}
       */

      /**
       * @name PaymentRequestComponent#off
       * @function
       * @param {string} event The name of the event to which you are unsubscribing.
       * @param {function} handler The callback for the event you are unsubscribing from.
       * @description Unsubscribes the handler function to a named event.
       * @example
       * <caption>Subscribing and then unsubscribing from a Payment Request event, in this case 'shippingAddressChange'</caption>
       * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
       *   var callback = function (event) {
       *     console.log(event.target.shippingAddress);
       *   };
       *   paymentRequestInstance.on('shippingAddressChange', callback);
       *
       *   // later on
       *   paymentRequestInstance.off('shippingAddressChange', callback);
       * });
       * @returns {void}
       */

      /**
       * This event is emitted when the customer selects a shipping address.
       * @event PaymentRequestComponent#shippingAddressChange
       * @type {PaymentRequestComponent~shippingEventObject}
       * @example
       * <caption>Listening to a shipping address change event</caption>
       * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
       *   paymentRequestInstance.on('shippingAddressChange', function (event) {
       *     // validate event.target.shippingAddress if needed
       *
       *     event.updateWith(paymentRequestDetails);
       *   });
       * });
       */

      /**
       * This event is emitted when the customer selects a shipping option.
       * @event PaymentRequestComponent#shippingOptionChange
       * @type {PaymentRequestComponent~shippingEventObject}
       * @example
       * <caption>Listening to a shipping option change event</caption>
       * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
       *   paymentRequestInstance.on('shippingOptionChange', function (event) {
       *     // validate event.target.shippingOption if needed
       *
       *     paymentRequestDetails.shippingOptions.forEach(function (option) {
       *       option.selected = option.id === event.target.shippingOption;
       *     });
       *
       *     event.updateWith(paymentRequestDetails);
       *   });
       * });
       */

      var CARD_TYPE_MAPPINGS = {
        Visa: "visa",
        MasterCard: "mastercard",
        "American Express": "amex",
        "Diners Club": "diners",
        Discover: "discover",
        JCB: "jcb",
        UnionPay: "unionpay",
        Maestro: "maestro"
      };
      var BRAINTREE_GOOGLE_PAY_MERCHANT_ID = "18278000977346790994";
      function composeUrl(assetsUrl, componentId, isDebug) {
        var baseUrl = assetsUrl;

        // endRemoveIf(production)

        return baseUrl + "/web/" + VERSION + "/html/payment-request-frame" + useMin(isDebug) + ".html#" + componentId;
      }

      /**
       * @class PaymentRequestComponent
       * @param {object} options The Payment Request Component {@link module:braintree-web/payment-request.create create} options.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/payment-request.create|braintree-web.payment-request.create} instead.</strong>
       *
       * @classdesc This class represents a Payment Request component produced by {@link module:braintree-web/payment-request.create|braintree-web/payment-request.create}. Instances of this class have methods for initializing a Payment Request.
       *
       * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
       */
      function PaymentRequestComponent(options) {
        var enabledPaymentMethods = options.enabledPaymentMethods || {};
        EventEmitter.call(this);
        this._componentId = uuid();
        this._client = options.client;
        this._enabledPaymentMethods = {
          basicCard: enabledPaymentMethods.basicCard !== false,
          googlePay: enabledPaymentMethods.googlePay !== false
        };
        this._googlePayVersion = options.googlePayVersion === 2 ? 2 : 1;
        this._googleMerchantId = BRAINTREE_GOOGLE_PAY_MERCHANT_ID;
        this._supportedPaymentMethods = this._constructDefaultSupportedPaymentMethods();
        this._defaultSupportedPaymentMethods = Object.keys(this._supportedPaymentMethods).map(function (key) {
          return this._supportedPaymentMethods[key];
        }.bind(this));
        this._bus = new Bus({
          channel: this._componentId
        });
      }
      EventEmitter.createChild(PaymentRequestComponent);
      PaymentRequestComponent.prototype._constructDefaultSupportedPaymentMethods = function () {
        var configuration = this._client.getConfiguration();
        var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
        var cardConfiguration = configuration.gatewayConfiguration.creditCards;
        var supportedPaymentMethods = {};
        if (this._enabledPaymentMethods.basicCard && cardConfiguration && cardConfiguration.supportedCardTypes.length > 0) {
          supportedPaymentMethods.basicCard = {
            supportedMethods: "basic-card",
            data: {
              supportedNetworks: cardConfiguration.supportedCardTypes.reduce(function (types, cardType) {
                if (cardType in CARD_TYPE_MAPPINGS) {
                  types.push(CARD_TYPE_MAPPINGS[cardType]);
                }
                return types;
              }, [])
            }
          };
        }
        if (this._enabledPaymentMethods.googlePay && androidPayConfiguration && androidPayConfiguration.enabled) {
          supportedPaymentMethods.googlePay = {
            supportedMethods: "https://google.com/pay",
            data: generateGooglePayConfiguration(configuration, this._googlePayVersion, this._googleMerchantId)
          };
        }
        return supportedPaymentMethods;
      };
      PaymentRequestComponent.prototype.initialize = function () {
        var clientConfiguration = this._client.getConfiguration();
        var self = this;
        this._frame = iFramer({
          allowPaymentRequest: true,
          name: "braintree-payment-request-frame",
          class: "braintree-payment-request-frame",
          height: 0,
          width: 0,
          style: {
            position: "absolute",
            left: "-9999px"
          },
          title: "Secure Payment Frame"
        });
        if (this._defaultSupportedPaymentMethods.length === 0) {
          return Promise.reject(new BraintreeError(errors.PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS));
        }
        return new Promise(function (resolve) {
          self._bus.on(events.FRAME_READY, function (reply) {
            reply(self._client);
          });
          self._bus.on(events.FRAME_CAN_MAKE_REQUESTS, function () {
            analytics.sendEvent(self._client, "payment-request.initialized");
            self._bus.on(events.SHIPPING_ADDRESS_CHANGE, function (shippingAddress) {
              var shippingAddressChangeEvent = {
                target: {
                  shippingAddress: shippingAddress
                },
                updateWith: function (paymentDetails) {
                  self._bus.emit(events.UPDATE_SHIPPING_ADDRESS, paymentDetails);
                }
              };
              self._emit("shippingAddressChange", shippingAddressChangeEvent);
              self._emit("shippingaddresschange", shippingAddressChangeEvent);
            });
            self._bus.on(events.SHIPPING_OPTION_CHANGE, function (shippingOption) {
              var shippingOptionChangeEvent = {
                target: {
                  shippingOption: shippingOption
                },
                updateWith: function (paymentDetails) {
                  self._bus.emit(events.UPDATE_SHIPPING_OPTION, paymentDetails);
                }
              };
              self._emit("shippingOptionChange", shippingOptionChangeEvent);
              self._emit("shippingoptionchange", shippingOptionChangeEvent);
            });
            resolve(self);
          });

          // TODO - We may need to apply the same setTimeout hack that Hosted Fields
          // uses for iframes to load correctly in Edge. See:
          // https://github.com/braintree/braintree-web/blob/0c951e5f9859c606652485de14188b6bd6656677/src/hosted-fields/external/hosted-fields.js#L449-L469
          self._frame.src = composeUrl(clientConfiguration.gatewayConfiguration.assetsUrl, self._componentId, clientConfiguration.isDebug);
          document.body.appendChild(self._frame);
        });
      };

      /**
       * Create an object to pass into tokenize to specify a custom configuration. If no overrides are provided, the default configuration will be provided.
       * @public
       * @param {string} type The supported payment method type. Possible values are `basicCard` and `googlePay`.
       * If no type is provided, the function will throw an error. If the type provided is not an enabled payment method for the merchant account , the function will throw an error.
       * @param {object} [overrides] The configuration overrides for the [data property on the supported payment methods objects](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request). If not passed in, the default configuration for the specified type will be provided. If a property is not provided, the value from the default configuration will be used.
       * @example <caption>Getting the default configuration for a specified type</caption>
       * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard');
       *
       * configuration.supportedMethods; // 'basic-card'
       * configuration.data.supportedNetworks; // ['visa', 'mastercard', 'amex'] <- whatever the supported card networks for the merchant account are
       * @example <caption>Specifying overrides</caption>
       * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
       *   supportedNetworks: ['visa'],
       *   supportedTypes: ['credit', 'debit']
       * });
       *
       * configuration.supportedMethods; // 'basic-card'
       * configuration.data.supportedNetworks; // ['visa']
       * configuration.data.supportedTypes; // ['credit', 'debit']
       * @returns {object} Returns a configuration object for use in the tokenize function.
       */
      PaymentRequestComponent.prototype.createSupportedPaymentMethodsConfiguration = function (type, overrides) {
        var configuration;
        if (!type) {
          throw new BraintreeError(errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE);
        }
        if (!this._enabledPaymentMethods[type]) {
          throw new BraintreeError(errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED);
        }
        configuration = assign({}, this._supportedPaymentMethods[type]);
        configuration.data = assign({}, configuration.data, overrides);
        return configuration;
      };

      /**
       * Tokenizes a Payment Request
       * @public
       * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link PaymentRequest~paymentPayload|paymentPayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link PaymentRequestComponent~tokenizePayload|tokenizePayload}.
       * @example
       * paymentRequestInstance.tokenize({
       *   details: {
       *     total: {
       *       label: 'Price',
       *       amount: {
       *         currency: 'USD',
       *         value: '100.00'
       *       }
       *     }
       *   }
       * }).then(function (payload) {
       *   // send payload.nonce to server
       *
       *   // examine the raw response (with card details removed for security) from the payment request
       *   console.log(payload.details.rawPaymentResponse);
       * }).catch(function (err) {
       *   if (err.code === 'PAYMENT_REQUEST_CANCELED') {
       *     // payment request was canceled by user
       *   } else {
       *     // an error occurred while processing
       *   }
       * });
       * @example <caption>Tokenize only Visa cards</caption>
       * var basicCardConfiguration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
       *   supportedNetworks: ['visa']
       * };
       *
       * paymentRequestInstance.tokenize({
       *   supportedPaymentMethods: [basicCardConfiguration],
       *   details: {
       *     total: {
       *       label: 'Price',
       *       amount: {
       *         currency: 'USD',
       *         value: '100.00'
       *       }
       *     }
       *   }
       * }).then(function (payload) {
       *   // send payload.nonce to your server
       * });
       * @example <caption>Include payment request options</caption>
       * paymentRequestInstance.tokenize({
       *   details: {
       *     total: {
       *       label: 'Price',
       *       amount: {
       *         currency: 'USD',
       *         value: '100.00'
       *       }
       *     }
       *   },
       *   options: {
       *     requestPayerName: true,
       *     requestPayerPhone: true,
       *     requestPayerEmail: true
       *   }
       * }).then(function (payload) {
       *   // send payload.nonce to your server
       *   // collect additional info from the raw response
       *   console.log(payload.details.rawPaymentResponse);
       * });
       * @example <caption>Request Shipping Information</caption>
       * var shippingOptions = [
       *   {
       *     id: 'economy',
       *     label: 'Economy Shipping (5-7 Days)',
       *     amount: {
       *       currency: 'USD',
       *       value: '0',
       *     },
       *   }, {
       *     id: 'express',
       *     label: 'Express Shipping (2-3 Days)',
       *     amount: {
       *       currency: 'USD',
       *       value: '5',
       *     },
       *   }, {
       *     id: 'next-day',
       *     label: 'Next Day Delivery',
       *     amount: {
       *       currency: 'USD',
       *       value: '12',
       *     },
       *   },
       * ];
       * var paymentDetails = {
       * 	 total: {
       *     label: 'Total',
       *     amount: {
       *       currency: 'USD',
       *       value: '10.00',
       *     }
       *   },
       *   shippingOptions: shippingOptions
       * };
       *
       * paymentRequestInstance.on('shippingAddressChange', function (event) {
       *   // validate shipping address on event.target.shippingAddress
       *   // make changes to the paymentDetails or shippingOptions if necessary
       *
       *   event.updateWith(paymentDetails)
       * });
       *
       * paymentRequestInstance.on('shippingOptionChange', function (event) {
       *   shippingOptions.forEach(function (option) {
       *     option.selected = option.id === event.target.shippingOption;
       *   });
       *
       *   event.updateWith(paymentDetails)
       * });
       *
       * paymentRequestInstance.tokenize({
       *   details: paymentDetails,
       *   options: {
       *     requestShipping: true
       *   }
       * }).then(function (payload) {
       *   // send payload.nonce to your server
       *   // collect shipping information from payload
       *   console.log(payload.details.rawPaymentResponse.shippingAddress);
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PaymentRequestComponent.prototype.tokenize = function (configuration) {
        var self = this;

        // NEXT_MAJOR_VERSION fail early if a payment method is passed in
        // that the component does not support
        return new Promise(function (resolve, reject) {
          self._bus.emit(events.PAYMENT_REQUEST_INITIALIZED, {
            supportedPaymentMethods: configuration.supportedPaymentMethods || self._defaultSupportedPaymentMethods,
            details: configuration.details,
            options: configuration.options
          }, function (response) {
            var rawError = response[0];
            var payload = response[1];
            if (rawError) {
              reject(self._formatTokenizationError(rawError));
              return;
            }
            analytics.sendEvent(self._client, "payment-request.tokenize.succeeded");
            resolve({
              nonce: payload.nonce,
              type: payload.type,
              description: payload.description,
              details: {
                rawPaymentResponse: payload.details.rawPaymentResponse,
                cardType: payload.details.cardType,
                lastFour: payload.details.lastFour,
                lastTwo: payload.details.lastTwo
              },
              binData: payload.binData
            });
          });
        });
      };

      /**
       * Check if the customer can make payments.
       * @public
       * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
       * @param {callback} [callback] Called on completion.
       * @example
       * var paymentDetails = {
       * 	 total: {
       *     label: 'Total',
       *     amount: {
       *       currency: 'USD',
       *       value: '10.00',
       *     }
       *   }
       * };
       *
       * paymentRequestInstance.canMakePayment({
       *   details: paymentDetails
       * }).then(function (result) {
       *   if (result) {
       *     // set up payment request button
       *   }
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PaymentRequestComponent.prototype.canMakePayment = function (configuration) {
        var self = this;
        var unsupportedPaymentMethod;

        // NEXT_MAJOR_VERSION Move this check to component creation
        if (!window.PaymentRequest) {
          analytics.sendEvent(self._client, "payment-request.can-make-payment.not-available");
          return Promise.resolve(false);
        }
        if (configuration.supportedPaymentMethods) {
          configuration.supportedPaymentMethods.forEach(function (config) {
            var supportedMethods = config.supportedMethods;
            if (!(supportedMethods in constants.SUPPORTED_METHODS)) {
              unsupportedPaymentMethod = supportedMethods;
            }
          });
          if (unsupportedPaymentMethod) {
            return Promise.reject(new BraintreeError({
              type: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.type,
              code: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.code,
              message: unsupportedPaymentMethod + " is not a supported payment method."
            }));
          }
        }
        return new Promise(function (resolve, reject) {
          self._bus.emit(events.CAN_MAKE_PAYMENT, {
            supportedPaymentMethods: configuration.supportedPaymentMethods || self._defaultSupportedPaymentMethods,
            details: configuration.details,
            options: configuration.options
          }, function (response) {
            var error = response[0];
            var payload = response[1];
            if (error) {
              reject(self._formatCanMakePaymentError(error));
              return;
            }
            analytics.sendEvent(self._client, "payment-request.can-make-payment." + payload);
            resolve(payload);
          });
        });
      };

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/payment-request.create|create}.
       * @public
       * @param {callback} [callback] Called on completion.
       * @example
       * paymentRequestInstance.teardown();
       * @example <caption>With callback</caption>
       * paymentRequestInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PaymentRequestComponent.prototype.teardown = function () {
        this._bus.teardown();
        this._frame.parentNode.removeChild(this._frame);
        convertMethodsToError(this, methods(PaymentRequestComponent.prototype));
        analytics.sendEvent(this._client, "payment-request.teardown-completed");
        return Promise.resolve();
      };
      PaymentRequestComponent.prototype._formatTokenizationError = function (error) {
        var formattedError;
        switch (error.name) {
          case "AbortError":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_CANCELED.type,
              code: errors.PAYMENT_REQUEST_CANCELED.code,
              message: errors.PAYMENT_REQUEST_CANCELED.message,
              details: {
                originalError: error
              }
            });
            analytics.sendEvent(this._client, "payment-request.tokenize.canceled");
            return formattedError;
          case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
              code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
              message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
              details: {
                originalError: error
              }
            });
            break;
          case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_TOKENIZATION_ERROR":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.type,
              code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.code,
              message: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.message,
              details: {
                originalError: error
              }
            });
            break;
          case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_PARSING_ERROR":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.type,
              code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.code,
              message: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.message,
              details: {
                originalError: error
              }
            });
            break;
          default:
            formattedError = new BraintreeError({
              code: errors.PAYMENT_REQUEST_NOT_COMPLETED.code,
              type: error.type || BraintreeError.types.CUSTOMER,
              message: errors.PAYMENT_REQUEST_NOT_COMPLETED.message,
              details: {
                originalError: error
              }
            });
        }
        analytics.sendEvent(this._client, "payment-request.tokenize.failed");
        return formattedError;
      };
      PaymentRequestComponent.prototype._formatCanMakePaymentError = function (error) {
        var formattedError;
        switch (error.name) {
          case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
              code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
              message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
              details: {
                originalError: error
              }
            });
            break;
          case "NotAllowedError":
            formattedError = new BraintreeError({
              type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.type,
              code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.code,
              message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.message,
              details: {
                originalError: error
              }
            });
            break;
          default:
            formattedError = new BraintreeError({
              code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.code,
              type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.type,
              message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.message,
              details: {
                originalError: error
              }
            });
        }
        analytics.sendEvent(this._client, "payment-request.can-make-payment.failed");
        return formattedError;
      };
      module.exports = wrapPromise.wrapPrototype(PaymentRequestComponent);
    }, {
      "../../lib/analytics": 135,
      "../../lib/assign": 137,
      "../../lib/braintree-error": 140,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/generate-google-pay-configuration": 165,
      "../../lib/methods": 172,
      "../../lib/use-min": 178,
      "../shared/constants": 191,
      "@braintree/event-emitter": 30,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "@braintree/wrap-promise": 40,
      "framebus": 50
    }],
    190: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/payment-request
       * @description A component to integrate with the Payment Request API.
       *
       * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
       * */
      var PaymentRequestComponent = _dereq_("./external/payment-request");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var VERSION = "3.115.2";

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {object} [options.enabledPaymentMethods] An object representing which payment methods to display.
       * @param {boolean} [options.enabledPaymentMethods.basicCard=true] Whether or not to display credit card as an option in the Payment Request dialog. If left blank or set to true, credit cards will be displayed in the dialog if the merchant account is set up to process credit cards.
       * @param {boolean} [options.enabledPaymentMethods.googlePay=true] Whether or not to display Google Pay as an option in the Payment Request dialog. If left blank or set to true, Google Pay will be displayed in the dialog if the merchant account is set up to process Google Pay.
       * @param {Number} [options.googlePayVersion=1] Ignored if `options.enabledPaymentMethods.googlePay = false`. If `true`, this option specifies the version of Google Pay to use. Choose either 1 (default) or 2.
       * @param {callback} [callback] The second argument, `data`, is the {@link PaymentRequestComponent} instance. If no callback is provided, `create` returns a promise that resolves with the {@link PaymentRequestComponent} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * if (window.PaymentRequest) {
       *   braintree.paymentRequest.create({
       *     client: clientInstance
       *   }, cb);
       * } else {
       *   // fall back to Hosted Fields if browser does not support Payment Request API
       *   braintree.hostedFields.create(hostedFieldsOptions, cb);
       * }
       * @example <caption>Explicitly turning off credit cards from Payment Request API dialog</caption>
       * braintree.paymentRequest.create({
       *   client: clientInstance,
       *   enabledPaymentMethods: {
       *     googlePay: true,
       *     basicCard: false
       *   }
       * }, cb);
       * @example <caption>Using Google Pay v2 or basic card</caption>
       * braintree.paymentRequest.create({
       *   client: clientInstance,
       *   enabledPaymentMethods: {
       *     basicCard: true,
       *     googlePay: true
       *   },
       *   googlePayVersion: 2
       * }, cb);
       *
       */
      function create(options) {
        var name = "Payment Request";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var paymentRequestInstance;
          options.client = client;
          paymentRequestInstance = new PaymentRequestComponent(options);
          return paymentRequestInstance.initialize();
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./external/payment-request": 189,
      "@braintree/wrap-promise": 40
    }],
    191: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("../../lib/enumerate");
      var errors = _dereq_("./errors");
      var constants = {};
      constants.events = enumerate(["CAN_MAKE_PAYMENT", "FRAME_READY", "FRAME_CAN_MAKE_REQUESTS", "PAYMENT_REQUEST_INITIALIZED", "SHIPPING_ADDRESS_CHANGE", "UPDATE_SHIPPING_ADDRESS", "SHIPPING_OPTION_CHANGE", "UPDATE_SHIPPING_OPTION"], "payment-request:");
      constants.errors = errors;
      constants.SUPPORTED_METHODS = {
        "basic-card": true,
        "https://google.com/pay": true
      };
      module.exports = constants;
    }, {
      "../../lib/enumerate": 150,
      "./errors": 192
    }],
    192: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Payment Request - Creation Error Codes
       * @description Errors that occur when [creating the Payment Request component](./module-braintree-web_payment-request.html#.create).
       * @property {MERCHANT} PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS Occurs when there are no valid payment methods configured.
       */

      /**
       * @name BraintreeError.Payment Request - createSupportedPaymentMethodsConfiguration  Error Codes
       * @description Errors that occur when using the [`createSupportedPaymentMethodsConfiguration` method](./PaymentRequestComponent.html#createSupportedPaymentMethodsConfiguration)
       * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE Occurs when no type is supplied for method.
       * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED Occurs when configured type is not enabled.
       */

      /**
       * @name BraintreeError.Payment Request - tokenize  Error Codes
       * @description Errors that occur when using the [`tokenize` method](./PaymentRequestComponent.html#tokenize)
       * @property {CUSTOMER} PAYMENT_REQUEST_CANCELED Occurs when customer cancels the Payment Request.
       * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is closed do to the options being misconfigured.
       * @property {MERCHANT} PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE Occurs when a Google Payment payment method is unable to be tokenized.
       * @property {UNKNOWN} PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR Occurs when the result of tokenizing a Google Payment payment method could not be parsed.
       * @property {CUSTOMER} PAYMENT_REQUEST_NOT_COMPLETED Occurs when an error prevented the Payment Request from being completed.
       */

      /**
       * @name BraintreeError.Payment Request - canMakePayment  Error Codes
       * @description Errors that occur when using the [`canMakePayment` method](./PaymentRequestComponent.html#canMakePayment)
       * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is instantiated with misconfigured options.
       * @property {MERCHANT} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED Occurs when `canMakePayment` results in a `DomException` with a `NotAllowedError`. This usually occurs when `canMakePayment` is called multiple times with different supported payment options.
       * @property {MERCHANT} PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD Occurs when `canMakePayment` is called with a `supportedPaymentMethods` array that contains a payment method that is not supported by the Braintree SDK.
       * @property {UNKNOWN} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED Occurs when `canMakePayment` fails for any reason other than a misconfigured Payment Request object.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS",
          message: "There are no supported payment methods associated with this account."
        },
        PAYMENT_REQUEST_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "PAYMENT_REQUEST_CANCELED",
          message: "Payment request was canceled."
        },
        PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED",
          message: "Something went wrong when configuring the payment request."
        },
        PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED",
          message: "Something went wrong when calling `canMakePayment`"
        },
        PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED",
          message: "Something went wrong when calling `canMakePayment`. Most likely, `canMakePayment` was called multiple times with different supportedMethods configurations."
        },
        PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD"
        },
        PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE",
          message: "Something went wrong when tokenizing the Google Pay card."
        },
        PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR",
          message: "Something went wrong when tokenizing the Google Pay card."
        },
        PAYMENT_REQUEST_NOT_COMPLETED: {
          code: "PAYMENT_REQUEST_NOT_COMPLETED",
          message: "Payment request could not be completed."
        },
        PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE",
          message: "createSupportedPaymentMethodsConfiguration must include a type parameter."
        },
        PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED",
          message: "createSupportedPaymentMethodsConfiguration type parameter must be valid or enabled."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    193: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.PayPal Checkout - Creation Error Codes
       * @description Errors that occur when [creating the PayPal Checkout component](./module-braintree-web_paypal-checkout.html#.create).
       * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
       * @property {MERCHANT} PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED Occurs only when testing in Sandbox, when a PayPal sandbox account is not linked to the merchant account in the Braintree control panel.
       */

      /**
       * @name BraintreeError.PayPal Checkout - createPayment Error Codes
       * @description Errors that occur when using the [`createPayment` method](./PayPalCheckout.html#createPayment).
       * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when a required option is missing.
       * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
       * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow.
       */

      /**
       * @name BraintreeError.PayPal Checkout - startVaultInitiatedCheckout Error Codes
       * @description Errors that occur when using the [`startVaultInitiatedCheckout` method](./PayPalCheckout.html#startVaultInitiatedCheckout).
       * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED Occurs when a required param is missing when calling the method.
       * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened. This often occurs because the call to start the vault initiated flow was not triggered from a click event.
       * @property {CUSTOMER} PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED Occurs when a customer closes the PayPal flow before completion.
       * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS Occurs when the flow is initialized while an authorization is already in progress.
       * @property {NETWORK} PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED Occurs when something went wrong setting up the flow.
       */

      /**
       * @name BraintreeError.PayPal Checkout - tokenizePayment Error Codes
       * @description Errors that occur when using the [`tokenizePayment` method](./PayPalCheckout.html#tokenizePayment).
       * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
       */

      /**
       * @name BraintreeError.Paypal Checkout - updatePayment Error Codes
       * @description Errors that occur when using the [`updatePayment` method](./PayPalCheckout.html#updatePayment).
       * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
       * @property {MERCHANT} PAYPAL_MISSING_REQUIRED_OPTION Occurs when a required option is missing.
       * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow or communicating with the server.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        PAYPAL_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_NOT_ENABLED",
          message: "PayPal is not enabled for this merchant."
        },
        PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED",
          message: "A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developer.paypal.com/braintree/docs/guides/paypal/testing-go-live#linked-paypal-testing for details on linking your PayPal sandbox with Braintree."
        },
        PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
          message: "Could not tokenize user's PayPal account."
        },
        PAYPAL_FLOW_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "PAYPAL_FLOW_FAILED",
          message: "Could not initialize PayPal flow."
        },
        PAYPAL_FLOW_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_FLOW_OPTION_REQUIRED",
          message: "PayPal flow property is invalid or missing."
        },
        PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED"
        },
        PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED",
          message: "Something went wrong when setting up the checkout workflow."
        },
        PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED",
          message: "PayPal popup failed to open, make sure to initiate the vault checkout in response to a user action."
        },
        PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED",
          message: "Customer closed PayPal popup before authorizing."
        },
        PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS",
          message: "Vault initiated checkout already in progress."
        },
        PAYPAL_INVALID_PAYMENT_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_INVALID_PAYMENT_OPTION",
          message: "PayPal payment options are invalid."
        },
        PAYPAL_MISSING_REQUIRED_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_MISSING_REQUIRED_OPTION",
          message: "Missing required option."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    194: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/paypal-checkout
       * @description A component to integrate with the [PayPal JS SDK](https://github.com/paypal/paypal-checkout-components).
       */
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var PayPalCheckout = _dereq_("./paypal-checkout");
      var VERSION = "3.115.2";

      /**
       * @static
       * @function create
       * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
       *
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization.
       * @param {boolean} [options.autoSetDataUserIdToken=false] Whether or not to render the PayPal SDK button with a customer's vaulted PayPal account. Must be used in conjunction with a Client Token generated with a customer id.
       * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
       * @example
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   // set up the PayPal JS SDK
       * }).catch(function (err) {
       *   console.error('Error!', err);
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "PayPal Checkout";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var instance = new PayPalCheckout(options);
          return instance._initialize(options);
        });
      }

      /**
       * @static
       * @function isSupported
       * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
       * @deprecated Previously, this method checked for Popup support in the browser. The PayPal JS SDK now falls back to a modal if popups are not supported.
       * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
       */
      function isSupported() {
        return true;
      }
      module.exports = {
        create: wrapPromise(create),
        isSupported: isSupported,
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "./paypal-checkout": 195,
      "@braintree/wrap-promise": 40
    }],
    195: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../lib/analytics");
      var assign = _dereq_("../lib/assign").assign;
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
      var errors = _dereq_("./errors");
      var constants = _dereq_("../paypal/shared/constants");
      var frameService = _dereq_("../lib/frame-service/external");
      var createAuthorizationData = _dereq_("../lib/create-authorization-data");
      var methods = _dereq_("../lib/methods");
      var useMin = _dereq_("../lib/use-min");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var querystring = _dereq_("../lib/querystring");
      var camelCaseToSnakeCase = _dereq_("../lib/camel-case-to-snake-case");
      var VERSION = "3.115.2";
      var INTEGRATION_TIMEOUT_MS = _dereq_("../lib/constants").INTEGRATION_TIMEOUT_MS;
      var REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT = ["amount", "currency", "vaultInitiatedCheckoutPaymentMethodToken"];
      var PAYPAL_SDK_PRELOAD_URL = "https://www.{ENV}paypal.com/smart/buttons/preload";
      ExtendedPromise.suppressUnhandledPromiseMessage = true;

      /**
       * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
       * @typedef {object} PayPalCheckout~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} type The payment method type, always `PayPalAccount`.
       * @property {object} details Additional PayPal account details.
       * @property {string} details.email User's email address.
       * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
       * @property {string} details.firstName User's given name.
       * @property {string} details.lastName User's surname.
       * @property {?string} details.countryCode User's 2 character country code.
       * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
       * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
       * @property {string} details.shippingAddress.recipientName Recipient of postage.
       * @property {string} details.shippingAddress.line1 Street number and name.
       * @property {string} details.shippingAddress.line2 Extended address.
       * @property {string} details.shippingAddress.city City or locality.
       * @property {string} details.shippingAddress.state State or region.
       * @property {string} details.shippingAddress.postalCode Postal code.
       * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
       * @property {?object} details.billingAddress User's billing address details.
       * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
       * Alternatively, see `shippingAddress` above as an available client option.
       * @property {string} details.billingAddress.line1 Street number and name.
       * @property {string} details.billingAddress.line2 Extended address.
       * @property {string} details.billingAddress.city City or locality.
       * @property {string} details.billingAddress.state State or region.
       * @property {string} details.billingAddress.postalCode Postal code.
       * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
       * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
       * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
       * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {number} creditFinancingOffered.term Length of financing terms in months.
       * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
       * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
       * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
       * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
       */

      /**
       * @class
       * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
       * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. Instances of this class can generate payment data and tokenize authorized payments.
       *
       * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. You must provide your PayPal `client-id` as a query parameter. You can [retrieve this value from the PayPal Dashboard](https://developer.paypal.com/docs/checkout/integrate/#1-get-paypal-rest-api-credentials).
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
       *
       * #### Integrate Checkout Flow with PayPal SDK
       *
       * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
       *
       * ```html
       * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id"></script>
       * <div id="paypal-button"></div>
       * ```
       *
       * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
       *
       * ```javascript
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   return paypal.Buttons({
       *     createOrder: function () {
       *       return paypalCheckoutInstance.createPayment({
       *         flow: 'checkout',
       *         currency: 'USD',
       *         amount: '10.00',
       *         intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
       *         // your other createPayment options here
       *       });
       *     },
       *
       *     onApprove: function (data, actions) {
       *       // some logic here before tokenization happens below
       *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
       *         // Submit payload.nonce to your server
       *       });
       *     },
       *
       *     onCancel: function () {
       *       // handle case where user cancels
       *     },
       *
       *     onError: function (err) {
       *       // handle case where error occurs
       *     }
       *   }).render('#paypal-button');
       * }).catch(function (err) {
       *  console.error('Error!', err);
       * });
       * ```
       *
       * #### Integrate Vault Flow with PayPal SDK
       *
       * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
       *
       * ```html
       * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id&vault=true"></script>
       * <div id="paypal-button"></div>
       * ```
       *
       * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
       *
       * ```javascript
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   return paypal.Buttons({
       *     createBillingAgreement: function () {
       *       return paypalCheckoutInstance.createPayment({
       *         flow: 'vault'
       *         // your other createPayment options here
       *       });
       *     },
       *
       *     onApprove: function (data, actions) {
       *       // some logic here before tokenization happens below
       *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
       *         // Submit payload.nonce to your server
       *       });
       *     },
       *
       *     onCancel: function () {
       *       // handle case where user cancels
       *     },
       *
       *     onError: function (err) {
       *       // handle case where error occurs
       *     }
       *   }).render('#paypal-button');
       * }).catch(function (err) {
       *  console.error('Error!', err);
       * });
       * ```
       *
       * #### Integrate with Checkout.js (deprecated PayPal SDK)
       *
       * If you are creating a new PayPal integration, please follow the previous integration guide to use the current version of the PayPal SDK. Use this integration guide only as a reference if you are already integrated with Checkout.js.
       *
       * You must have PayPal's Checkout.js script loaded on your page.
       *
       * ```html
       * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
       * ```
       *
       * ```javascript
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   return paypal.Button.render({
       *     env: 'production', // or 'sandbox'
       *
       *     payment: function () {
       *       return paypalCheckoutInstance.createPayment({
       *         // your createPayment options here
       *       });
       *     },
       *
       *     onAuthorize: function (data, actions) {
       *       // some logic here before tokenization happens below
       *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
       *         // Submit payload.nonce to your server
       *       });
       *     }
       *   }, '#paypal-button');
       * }).catch(function (err) {
       *  console.error('Error!', err);
       * });
       * ```
       */
      function PayPalCheckout(options) {
        this._merchantAccountId = options.merchantAccountId;
        // TODO remove this requirement for it to be opt in.
        // This feature is not yet GA, so we're intentionally making
        // it opt in and not publicly documenting it yet. Once it's
        // GA, we can remove the requirement to opt in to it
        this._autoSetDataUserIdToken = Boolean(options.autoSetDataUserIdToken);
      }
      PayPalCheckout.prototype._initialize = function (options) {
        var config;
        if (options.client) {
          config = options.client.getConfiguration();
          this._authorizationInformation = {
            fingerprint: config.authorizationFingerprint,
            environment: config.gatewayConfiguration.environment
          };
        } else {
          config = createAuthorizationData(options.authorization);
          this._authorizationInformation = {
            fingerprint: config.attrs.authorizationFingerprint,
            environment: config.environment
          };
        }
        this._clientPromise = createDeferredClient.create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: "PayPal Checkout"
        }).then(function (client) {
          this._configuration = client.getConfiguration();

          // we skip these checks if a merchant account id is
          // passed in, because the default merchant account
          // may not have paypal enabled
          if (!this._merchantAccountId) {
            if (!this._configuration.gatewayConfiguration.paypalEnabled) {
              this._setupError = new BraintreeError(errors.PAYPAL_NOT_ENABLED);
            } else if (this._configuration.gatewayConfiguration.paypal.environmentNoNetwork === true) {
              this._setupError = new BraintreeError(errors.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED);
            }
          }
          if (this._setupError) {
            return Promise.reject(this._setupError);
          }
          analytics.sendEvent(client, "paypal-checkout.initialized");
          this._frameServicePromise = this._setupFrameService(client);
          return client;
        }.bind(this));

        // if client was passed in, let config checks happen before
        // resolving the instance. Otherwise, just resolve the instance
        if (options.client) {
          return this._clientPromise.then(function () {
            return this;
          }.bind(this));
        }
        return Promise.resolve(this);
      };
      PayPalCheckout.prototype._setupFrameService = function (client) {
        var frameServicePromise = new ExtendedPromise();
        var config = client.getConfiguration();
        var timeoutRef = setTimeout(function () {
          analytics.sendEvent(client, "paypal-checkout.frame-service.timed-out");
          frameServicePromise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED));
        }, INTEGRATION_TIMEOUT_MS);
        this._assetsUrl = config.gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION;
        this._isDebug = config.isDebug;
        // Note: this is using the static landing frame that the deprecated PayPal component builds and uses
        this._loadingFrameUrl = this._assetsUrl + "/html/paypal-landing-frame" + useMin(this._isDebug) + ".html";
        frameService.create({
          name: "braintreepaypallanding",
          dispatchFrameUrl: this._assetsUrl + "/html/dispatch-frame" + useMin(this._isDebug) + ".html",
          openFrameUrl: this._loadingFrameUrl
        }, function (service) {
          this._frameService = service;
          clearTimeout(timeoutRef);
          frameServicePromise.resolve();
        }.bind(this));
        return frameServicePromise;
      };

      /**
       * @typedef {object} PayPalCheckout~lineItem
       * @property {string} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
       * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
       * @property {string} name Item name. Maximum 127 characters.
       * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
       * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
       * @property {?string} description Item description. Maximum 127 characters.
       * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
       * @property {?string} url The URL to product information.
       */

      /**
       * @typedef {object} PayPalCheckout~shippingOption
       * @property {string} id A unique ID that identifies a payer-selected shipping option.
       * @property {string} label A description that the payer sees, which helps them choose an appropriate shipping option. For example, `Free Shipping`, `USPS Priority Shipping`, `Expédition prioritaire USPS`, or `USPS yōuxiān fā huò`. Localize this description to the payer's locale.
       * @property {boolean} selected If `selected = true` is specified as part of the API request it represents the shipping option that the payee/merchant expects to be pre-selected for the payer when they first view the shipping options within the PayPal checkout experience. As part of the response if a shipping option has `selected = true` it represents the shipping option that the payer selected during the course of checkout with PayPal. Only 1 `shippingOption` can be set to `selected = true`.
       * @property {string} type The method by which the payer wants to get their items. The possible values are:
       * * `SHIPPING` - The payer intends to receive the items at a specified address.
       * * `PICKUP` - The payer intends to pick up the items at a specified address. For example, a store address.
       * @property {object} amount The shipping cost for the selected option.
       * @property {string} amount.currency The three-character ISO-4217 currency code. PayPal does not support all currencies.
       * @property {string} amount.value The amount the shipping option will cost. Includes the specified number of digits after decimal separator for the ISO-4217 currency code.
       */

      /** @typedef {object} PayPalCheckout~pricingScheme
       * @property {string} pricingModel The pricing model. Options are `FIXED`, `VARIABLE`, or `AUTO_RELOAD`.
       * @property {string} price The price for the billing cycle.
       * @property {string} reloadThresholdAmount The amount at which to reload on auto_reload plans.
       */

      /**
       * @typedef {Object} PayPalCheckout~billingCycles
       * @property {(string|number)} billingFrequency The frequency of billing.
       * @property {string} billingFrequencyUnit The unit of billing frequency. Options are `DAY`, `WEEK`, `MONTH`, or `YEAR`.
       * @property {(string|number)} numberOfExecutions The number of executions for the billing cycle.
       * @property {(string|number)} sequence The order in the upcoming billing cycles.
       * @property {string} startDate The start date in ISO 8601 format (`2024-04-06T00:00:00Z`). If populated and the intent is to charge the buyer for the billing cycle at the checkout, it should be populated as current time in ISO 8601 format.
       * @property {boolean} trial Indicates if the billing cycle is a trial.
       * @property {pricingScheme} pricingScheme The {@link PayPalCheckout~pricingScheme|pricing scheme object} for this billing cycle.
       */

      /**
       * @typedef {Object} PayPalCheckout~planMetadata
       * @property {billingCycles[]} [billingCycles] An array of {@link PayPalCheckout~billingCycles|billing cyles} for this plan.
       * @property {string} currencyIsoCode The ISO code for the currency, for example `USD`.
       * @property {string} name The name of the plan.
       * @property {string} productDescription A description of the product. (Accepts only one element)
       * @property {(string|number)} productQuantity The quantity of the product. (Accepts only one element)
       * @property {(string|number)} oneTimeFeeAmount The one-time fee amount.
       * @property {(string|number)} shippingAmount The amount for shipping.
       * @property {(string|number)} productPrice The price of the product.
       * @property {(string|number)} taxAmount The amount of tax.
       */

      /**
       * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to the PayPal JS SDK.
       * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
       * @public
       * @param {object} options All options for the PayPalCheckout component.
       * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
       * @param {string} [options.intent=authorize]
       * * `authorize` - Submits the transaction for authorization but not settlement.
       * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
       * * `capture` - Payment will be immediately submitted for settlement upon creating a transaction. `sale` can be used as an alias for this value.
       * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
       * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow. Should not include shipping cost.
       * * Supports up to 2 digits after the decimal point
       * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
       * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
       * @param {boolean} [options.requestBillingAgreement] If `true` and `flow = checkout`, the customer will be prompted to consent to a billing agreement during the checkout flow. This value is ignored when `flow = vault`.
       * @param {object} [options.billingAgreementDetails] When `requestBillingAgreement = true`, allows for details to be set for the billing agreement portion of the flow.
       * @param {string} [options.billingAgreementDetails.description] Description of the billing agreement to display to the customer.
       * @param {string} [options.vaultInitiatedCheckoutPaymentMethodToken] Use the payment method nonce representing a PayPal account with a Billing Agreement ID to create the payment and redirect the customer to select a new financial instrument. This option is only applicable to the `checkout` flow.
       * @param {shippingOption[]} [options.shippingOptions] List of shipping options offered by the payee or merchant to the payer to ship or pick up their items.
       * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
       * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
       * @param {string} options.shippingAddressOverride.line1 Street address.
       * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
       * @param {string} options.shippingAddressOverride.city City.
       * @param {string} options.shippingAddressOverride.state State.
       * @param {string} options.shippingAddressOverride.postalCode Postal code.
       * @param {string} options.shippingAddressOverride.countryCode Country.
       * @param {string} [options.shippingAddressOverride.phone] Phone number.
       * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
       * @param {string} [options.shippingAddressOverride.recipientEmail] Email address of the recipient.
       * @param {string} [options.shippingAddressOverride.internationalPhone.countryCode] Phone country code of the recipient.
       * @param {string} [options.shippingAddressOverride.internationalPhone.nationalNumber] Phone national number of the recipient.
       * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
       * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
       * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
       * * `login` - A PayPal account login page is used.
       * * `billing` - A non-PayPal account landing page is used.
       * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
       *
       * @param {string} [options.planType] Determines the charge pattern for the Recurring Billing Agreement. Can be 'RECURRING', 'SUBSCRIPTION', 'UNSCHEDULED', or 'INSTALLMENTS'.
       * @param {planMetadata} [options.planMetadata] When plan type is defined, allows for {@link PayPalCheckout~planMetadata|plan metadata} to be set for the Billing Agreement.
       * @param {string} [options.userAuthenticationEmail] Optional merchant-provided buyer email, used to streamline the sign-in process for both one-time checkout and vault flows.
       * @param {string} [options.shippingCallbackUrl] Optional server side shipping callback URL to be notified when a customer updates their shipping address or options. A callback request will be sent to the merchant server at this URL.
       * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
       * @example
       * // this paypal object is created by the PayPal JS SDK
       * // see https://github.com/paypal/paypal-checkout-components
       * paypal.Buttons({
       *   createOrder: function () {
       *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
       *     return paypalCheckoutInstance.createPayment({
       *       flow: 'checkout',
       *       amount: '10.00',
       *       currency: 'USD',
       *       intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
       *     });
       *   },
       *   // Add other options, e.g. onApproved, onCancel, onError
       * }).render('#paypal-button');
       *
       * @example
       * // shippingOptions are passed to createPayment. You can review the result from onAuthorize to determine which shipping option id was selected.
       * ```javascript
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   return paypal.Button.render({
       *     env: 'production'
       *
       *     payment: function () {
       *       return paypalCheckoutInstance.createPayment({
       *         flow: 'checkout',
       *         amount: '10.00',
       *         currency: 'USD',
       *         shippingOptions: [
       *           {
       *             id: 'UUID-9',
       *             type: 'PICKUP',
       *             label: 'Store Location Five',
       *             selected: true,
       *             amount: {
       *               value: '1.00',
       *               currency: 'USD'
       *             }
       *           },
       *           {
       *             id: 'shipping-speed-fast',
       *             type: 'SHIPPING',
       *             label: 'Fast Shipping',
       *             selected: false,
       *             amount: {
       *               value: '1.00',
       *               currency: 'USD'
       *             }
       *           },
       *           {
       *             id: 'shipping-speed-slow',
       *             type: 'SHIPPING',
       *             label: 'Slow Shipping',
       *             selected: false,
       *             amount: {
       *               value: '1.00',
       *               currency: 'USD'
       *             }
       *           }
       *         ]
       *       });
       *     },
       *
       *     onAuthorize: function (data, actions) {
       *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
       *         // Submit payload.nonce to your server
       *       });
       *     }
       *   }, '#paypal-button');
       * }).catch(function (err) {
       *  console.error('Error!', err);
       * });
       *
       * ```
       *
       * @example <caption>use the new plan features</caption>
       * // Plan and plan metadata are passed to createPayment
       * ```javascript
       * braintree.client.create({
       *   authorization: 'authorization'
       * }).then(function (clientInstance) {
       *   return braintree.paypalCheckout.create({
       *     client: clientInstance
       *   });
       * }).then(function (paypalCheckoutInstance) {
       *   return paypal.Button.render({
       *     env: 'production'
       *
       *     payment: function () {
       *       return paypalCheckoutInstance.createPayment({
       *         flow: 'vault',
       *         planType: 'RECURRING',
       *         planMetadata: {
       *           billingCycles: [
       *             {
       *                billingFrequency: "1",
       *                billingFrequencyUnit: "MONTH",
       *                numberOfExecutions: "1",
       *                sequence: "1",
       *                startDate: "2024-04-06T00:00:00Z",
       *                trial: true,
       *                pricingScheme: {
       *                  pricingModel: "FIXED",
       *              },
       *            },
       *            ],
       *           currencyIsoCode: "USD",
       *           name: "Netflix with Ads",
       *           productDescription: "iPhone 13",
       *           productQuantity: "1.0",
       *           oneTimeFeeAmount: "10",
       *           shippingAmount: "3.0",
       *           productPrice: "200",
       *           taxAmount: "20",
       *        };
       *       });
       *     },
       *
       *     onAuthorize: function (data, actions) {
       *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
       *         // Submit payload.nonce to your server
       *       });
       *     }
       *   }, '#paypal-button');
       * }).catch(function (err) {
       *  console.error('Error!', err);
       * });
       *
       * ```
       *
       * @returns {(promise|void)} returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.createPayment = function (options) {
        var self = this;
        if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
          return Promise.reject(new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED));
        }
        analytics.sendEvent(this._clientPromise, "paypal-checkout.createPayment");
        return this._createPaymentResource(options).then(function (response) {
          var flowToken, urlParams;
          if (options.flow === "checkout") {
            urlParams = querystring.parse(response.paymentResource.redirectUrl);
            flowToken = urlParams.token;
          } else {
            flowToken = response.agreementSetup.tokenId;
          }
          self._contextId = flowToken;
          return flowToken;
        });
      };
      PayPalCheckout.prototype._createPaymentResource = function (options, config) {
        var self = this;
        var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];
        this._flow = options.flow;
        delete this.intentFromCreatePayment;
        config = config || {};
        if (options.offerCredit === true) {
          analytics.sendEvent(this._clientPromise, "paypal-checkout.credit.offered");
        }
        return this._clientPromise.then(function (client) {
          return client.request({
            endpoint: endpoint,
            method: "post",
            data: self._formatPaymentResourceData(options, config)
          }).then(function (data) {
            self.intentFromCreatePayment = options.intent;
            return data;
          });
        }).catch(function (err) {
          var status;
          if (self._setupError) {
            return Promise.reject(self._setupError);
          }
          status = err.details && err.details.httpStatus;
          if (status === 422) {
            return Promise.reject(new BraintreeError({
              type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
              code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
              message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
              details: {
                originalError: err
              }
            }));
          }
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.PAYPAL_FLOW_FAILED.type,
            code: errors.PAYPAL_FLOW_FAILED.code,
            message: errors.PAYPAL_FLOW_FAILED.message
          }));
        });
      };

      /**
       * Use this function to update {@link PayPalCheckout~lineItem|line items} and/or {@link PayPalCheckout~shippingOption|shipping options} associated with a PayPalCheckout flow (`paymentId`).
       * When a {@link callback} is defined, this function returns undefined and invokes the callback. The second callback argument, <code>data</code>, is the returned server data. If no callback is provided, `updatePayment` returns a promise that resolves with the server data.
       * @public
       * @param {object} options All options for the PayPalCheckout component.
       * @param {string} options.paymentId This should be PayPal `paymentId`.
       * @param {(string|number)} options.amount The amount of the transaction, including the amount of the selected shipping option, and all `line_items`.
       * * Supports up to 2 decimal digits.
       * @param {string} options.currency The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
       * @param {string} [options.recipientEmail] Email address of the contact and shipping recipient of the order.
       * @param {shippingOption[]} [options.shippingOptions] List of {@link PayPalCheckout~shippingOption|shipping options} offered by the payee or merchant to the payer to ship or pick up their items.
       * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
       * @param {object} [options.amountBreakdown] Optional collection of amounts that break down the total into individual pieces.
       * @param {string} [options.amountBreakdown.itemTotal] Optional, item amount
       * @param {string} [options.amountBreakdown.shipping] Optional, shipping amount
       * @param {string} [options.amountBreakdown.handling] Optional, handling amount
       * @param {string} [options.amountBreakdown.taxTotal] Optional, tax amount
       * @param {string} [options.amountBreakdown.insurance] Optional, insurance amount
       * @param {string} [options.amountBreakdown.shippingDiscount] Optional, shipping discount amount
       * @param {string} [options.amountBreakdown.discount] Optional, discount amount
       * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
       * @example
       * // this paypal object is created by the PayPal JS SDK
       * // see https://github.com/paypal/paypal-checkout-components
       * paypal.Buttons({
       *   createOrder: function () {
       *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
       *     return paypalCheckoutInstance.createPayment({
       *       //
       *     });
       *   },
       *   onShippingChange: function (data) {
       *     // Examine data and determine if the payment needs to be updated.
       *     // when updatePayment resolves, it is automatically passed to the PayPal JS SDK
       *     return paypalCheckoutInstance.updatePayment({
       *         paymentId: data.paymentId,
       *         amount: '15.00',
       *         currency: 'USD',
       *         shippingOptions: [
       *           {
       *             id: 'shipping-speed-fast',
       *             type: 'SHIPPING',
       *             label: 'Fast Shipping',
       *             selected: true,
       *             amount: {
       *               value: '5.00',
       *               currency: 'USD'
       *             }
       *           },
       *           {
       *             id: 'shipping-speed-slow',
       *             type: 'SHIPPING',
       *             label: 'Slow Shipping',
       *             selected: false,
       *             amount: {
       *               value: '1.00',
       *               currency: 'USD'
       *             }
       *           }
       *         ]
       *     });
       *   }
       *   // Add other options, e.g. onApproved, onCancel, onError
       * }).render('#paypal-button');
       *
       * ```
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.updatePayment = function (options) {
        var self = this;
        var endpoint = "paypal_hermes/patch_payment_resource";
        if (!options || this._hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.updatePayment.missing-options", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.reject(new BraintreeError(errors.PAYPAL_MISSING_REQUIRED_OPTION));
        }
        if (!this._verifyConsistentCurrency(options)) {
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.updatePayment.inconsistent-currencies", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.reject(new BraintreeError({
            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
              originalError: new Error("One or more shipping option currencies differ from checkout currency.")
            }
          }));
        }
        analytics.sendEventPlus(this._clientPromise, "paypal-checkout.updatePayment", {
          paypal_context_id: self._contextId // eslint-disable-line camelcase
        });
        return this._clientPromise.then(function (client) {
          return client.request({
            endpoint: endpoint,
            method: "post",
            data: self._formatUpdatePaymentData(options)
          });
        }).catch(function (err) {
          var status = err.details && err.details.httpStatus;
          if (status === 422) {
            analytics.sendEventPlus(self._clientPromise, "paypal-checkout.updatePayment.invalid", {
              paypal_context_id: self._contextId // eslint-disable-line camelcase
            });
            return Promise.reject(new BraintreeError({
              type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
              code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
              message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
              details: {
                originalError: err
              }
            }));
          }
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.updatePayment." + errors.PAYPAL_FLOW_FAILED.code, {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.PAYPAL_FLOW_FAILED.type,
            code: errors.PAYPAL_FLOW_FAILED.code,
            message: errors.PAYPAL_FLOW_FAILED.message
          }));
        });
      };

      /**
       * Initializes the PayPal checkout flow with a payment method nonce that represents a vaulted PayPal account.
       * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
       * @public
       * @ignore
       * @param {object} options These options are identical to the {@link PayPalCheckout#createPayment|options for creating a payment resource}, except for the following:
       * * `flow` cannot be set (will always be `'checkout'`)
       * * `amount`, `currency`, and `vaultInitiatedCheckoutPaymentMethodToken` are required instead of optional
       * * Additional configuration is available (listed below)
       * @param {boolean} [options.optOutOfModalBackdrop=false] By default, the webpage will darken and become unusable while the PayPal window is open. For full control of the UI, pass `true` for this option.
       * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
       * @example
       * paypalCheckoutInstance.startVaultInitiatedCheckout({
       *   vaultInitiatedCheckoutPaymentMethodToken: 'nonce-that-represents-a-vaulted-paypal-account',
       *   amount: '10.00',
       *   currency: 'USD'
       * }).then(function (payload) {
       *   // send payload.nonce to your server
       * }).catch(function (err) {
       *   if (err.code === 'PAYPAL_POPUP_CLOSED') {
       *     // indicates that customer canceled by
       *     // manually closing the PayPal popup
       *   }
       *
       *   // handle other errors
       * });
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.startVaultInitiatedCheckout = function (options) {
        var missingRequiredParam;
        var self = this;
        if (this._vaultInitiatedCheckoutInProgress) {
          analytics.sendEventPlus(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.error.already-in-progress", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS));
        }
        REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT.forEach(function (param) {
          if (!options.hasOwnProperty(param)) {
            missingRequiredParam = param;
          }
        });
        if (missingRequiredParam) {
          return Promise.reject(new BraintreeError({
            type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.type,
            code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.code,
            message: "Required param " + missingRequiredParam + " is missing."
          }));
        }
        this._vaultInitiatedCheckoutInProgress = true;
        this._addModalBackdrop(options);
        options = assign({}, options, {
          flow: "checkout"
        });
        analytics.sendEventPlus(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.started", {
          paypal_context_id: self._contextId // eslint-disable-line camelcase
        });
        return this._waitForVaultInitiatedCheckoutDependencies().then(function () {
          var frameCommunicationPromise = new ExtendedPromise();
          var startVaultInitiatedCheckoutPromise = self._createPaymentResource(options, {
            returnUrl: self._constructVaultCheckutUrl("redirect-frame"),
            cancelUrl: self._constructVaultCheckutUrl("cancel-frame")
          }).then(function (response) {
            var redirectUrl = response.paymentResource.redirectUrl;
            self._frameService.redirect(redirectUrl);
            return frameCommunicationPromise;
          });
          self._frameService.open({}, self._createFrameServiceCallback(frameCommunicationPromise));
          return startVaultInitiatedCheckoutPromise;
        }).catch(function (err) {
          self._vaultInitiatedCheckoutInProgress = false;
          self._removeModalBackdrop();
          if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
            analytics.sendEventPlus(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-customer", {
              paypal_context_id: self._contextId // eslint-disable-line camelcase
            });
            return Promise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED));
          }
          if (self._frameService) {
            self._frameService.close();
          }
          if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
            analytics.sendEventPlus(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.failed.popup-not-opened", {
              paypal_context_id: self._contextId // eslint-disable-line camelcase
            });
            return Promise.reject(new BraintreeError({
              code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.code,
              type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.type,
              message: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.message,
              details: {
                originalError: err
              }
            }));
          }
          return Promise.reject(err);
        }).then(function (response) {
          self._frameService.close();
          self._vaultInitiatedCheckoutInProgress = false;
          self._removeModalBackdrop();
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.succeeded", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.resolve(response);
        });
      };
      PayPalCheckout.prototype._addModalBackdrop = function (options) {
        if (options.optOutOfModalBackdrop) {
          return;
        }
        if (!this._modalBackdrop) {
          this._modalBackdrop = document.createElement("div");
          this._modalBackdrop.setAttribute("data-braintree-paypal-vault-initiated-checkout-modal", true);
          this._modalBackdrop.style.position = "fixed";
          this._modalBackdrop.style.top = 0;
          this._modalBackdrop.style.bottom = 0;
          this._modalBackdrop.style.left = 0;
          this._modalBackdrop.style.right = 0;
          this._modalBackdrop.style.zIndex = 9999;
          this._modalBackdrop.style.background = "black";
          this._modalBackdrop.style.opacity = "0.7";
          this._modalBackdrop.addEventListener("click", function () {
            this.focusVaultInitiatedCheckoutWindow();
          }.bind(this));
        }
        document.body.appendChild(this._modalBackdrop);
      };
      PayPalCheckout.prototype._removeModalBackdrop = function () {
        if (!(this._modalBackdrop && this._modalBackdrop.parentNode)) {
          return;
        }
        this._modalBackdrop.parentNode.removeChild(this._modalBackdrop);
      };

      /**
       * Closes the PayPal window if it is opened via `startVaultInitiatedCheckout`.
       * @public
       * @ignore
       * @param {callback} [callback] Gets called when window is closed.
       * @example
       * paypalCheckoutInstance.closeVaultInitiatedCheckoutWindow();
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.closeVaultInitiatedCheckoutWindow = function () {
        if (this._vaultInitiatedCheckoutInProgress) {
          analytics.sendEventPlus(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-merchant", {
            paypal_context_id: this._contextId // eslint-disable-line camelcase
          });
        }
        return this._waitForVaultInitiatedCheckoutDependencies().then(function () {
          this._frameService.close();
        }.bind(this));
      };

      /**
       * Focuses the PayPal window if it is opened via `startVaultInitiatedCheckout`.
       * @public
       * @ignore
       * @param {callback} [callback] Gets called when window is focused.
       * @example
       * paypalCheckoutInstance.focusVaultInitiatedCheckoutWindow();
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.focusVaultInitiatedCheckoutWindow = function () {
        return this._waitForVaultInitiatedCheckoutDependencies().then(function () {
          this._frameService.focus();
        }.bind(this));
      };
      PayPalCheckout.prototype._createFrameServiceCallback = function (frameCommunicationPromise) {
        var self = this;

        // TODO when a merchant integrates an iOS or Android integration
        // with a webview using the web SDK, we will have to add popupbridge
        // support
        return function (err, payload) {
          if (err) {
            frameCommunicationPromise.reject(err);
          } else if (payload) {
            self._frameService.redirect(self._loadingFrameUrl);
            self.tokenizePayment({
              paymentToken: payload.token,
              payerID: payload.PayerID,
              paymentID: payload.paymentId,
              orderID: payload.orderId
            }).then(function (res) {
              frameCommunicationPromise.resolve(res);
            }).catch(function (tokenizationError) {
              frameCommunicationPromise.reject(tokenizationError);
            });
          }
        };
      };
      PayPalCheckout.prototype._waitForVaultInitiatedCheckoutDependencies = function () {
        var self = this;
        return this._clientPromise.then(function () {
          return self._frameServicePromise;
        });
      };
      PayPalCheckout.prototype._constructVaultCheckutUrl = function (frameName) {
        var serviceId = this._frameService._serviceId;
        return this._assetsUrl + "/html/" + frameName + useMin(this._isDebug) + ".html?channel=" + serviceId;
      };

      /**
       * Tokenizes the authorize data from the PayPal JS SDK when completing a buyer approval flow.
       * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
       * @public
       * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
       * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onApproved` callback.
       * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onApproved` callback.
       * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onApproved` callback.
       * @param {boolean} [tokenizeOptions.vault=true] Whether or not to vault the resulting PayPal account (if using a client token generated with a customer id and the vault flow).
       * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
       * @example <caption>Opt out of auto-vaulting behavior</caption>
       * // create the paypalCheckoutInstance with a client token generated with a customer id
       * paypal.Buttons({
       *   createBillingAgreement: function () {
       *     return paypalCheckoutInstance.createPayment({
       *       flow: 'vault'
       *       // your other createPayment options here
       *     });
       *   },
       *   onApproved: function (data) {
       *     data.vault = false;
       *
       *     return paypalCheckoutInstance.tokenizePayment(data);
       *   },
       *   // Add other options, e.g. onCancel, onError
       * }).render('#paypal-button');
       *
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.tokenizePayment = function (tokenizeOptions) {
        var self = this;
        var shouldVault = true;
        var payload;
        var options = {
          flow: this._flow,
          intent: tokenizeOptions.intent || this.intentFromCreatePayment
        };
        var params = {
          // The paymentToken provided by the PayPal JS SDK is the EC Token
          ecToken: tokenizeOptions.paymentToken,
          billingToken: tokenizeOptions.billingToken,
          payerId: tokenizeOptions.payerID,
          paymentId: tokenizeOptions.paymentID,
          orderId: tokenizeOptions.orderID,
          shippingOptionsId: tokenizeOptions.shippingOptionsId
        };
        if (tokenizeOptions.hasOwnProperty("vault")) {
          shouldVault = tokenizeOptions.vault;
        }
        options.vault = shouldVault;
        analytics.sendEventPlus(this._clientPromise, "paypal-checkout.tokenization.started", {
          paypal_context_id: self._contextId // eslint-disable-line camelcase
        });
        return this._clientPromise.then(function (client) {
          return client.request({
            endpoint: "payment_methods/paypal_accounts",
            method: "post",
            data: self._formatTokenizeData(options, params)
          });
        }).then(function (response) {
          payload = self._formatTokenizePayload(response);
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.tokenization.success", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          if (payload.creditFinancingOffered) {
            analytics.sendEventPlus(self._clientPromise, "paypal-checkout.credit.accepted", {
              paypal_context_id: self._contextId // eslint-disable-line camelcase
            });
          }
          return payload;
        }).catch(function (err) {
          if (self._setupError) {
            return Promise.reject(self._setupError);
          }
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.tokenization.failed", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
            code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
            message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
          }));
        });
      };

      /**
       * Resolves with the PayPal client id to be used when loading the PayPal SDK.
       * @public
       * @param {callback} [callback] The second argument, <code>id</code>, is a the PayPal client id. If no callback is provided, the promise resolves with the PayPal client id.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * paypalCheckoutInstance.getClientId().then(function (id) {
       *  var script = document.createElement('script');
       *
       *  script.src = 'https://www.paypal.com/sdk/js?client-id=' + id;
       *  script.onload = function () {
       *    // setup the PayPal SDK
       *  };
       *
       *  document.body.appendChild(script);
       * });
       */
      PayPalCheckout.prototype.getClientId = function () {
        return this._clientPromise.then(function (client) {
          return client.getConfiguration().gatewayConfiguration.paypal.clientId;
        });
      };

      /**
       * Resolves when the PayPal SDK has been successfully loaded onto the page.
       * @public
       * @param {object} [options] A configuration object to modify the query params and data-attributes on the PayPal SDK. A subset of the parameters are listed below. For a full list of query params, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/?mark=query#query-parameters).
       * @param {string} [options.client-id] By default, this will be the client id associated with the authorization used to create the Braintree component. When used in conjunction with passing `authorization` when creating the PayPal Checkout component, you can speed up the loading of the PayPal SDK.
       * @param {string} [options.intent="authorize"] By default, the PayPal SDK defaults to an intent of `capture`. Since the default intent when calling {@link PayPalCheckout#createPayment|`createPayment`} is `authorize`, the PayPal SDK will be loaded with `intent=authorize`. If you wish to use a different intent when calling {@link PayPalCheckout#createPayment|`createPayment`}, make sure it matches here. If `sale` is used, it will be converted to `capture` for the PayPal SDK. If the `vault: true` param is used, `tokenize` will be passed as the default intent.
       * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
       *
       * Supported locales are:
       * `da_DK`,
       * `de_DE`,
       * `en_AU`,
       * `en_GB`,
       * `en_US`,
       * `es_ES`,
       * `fr_CA`,
       * `fr_FR`,
       * `id_ID`,
       * `it_IT`,
       * `ja_JP`,
       * `ko_KR`,
       * `nl_NL`,
       * `no_NO`,
       * `pl_PL`,
       * `pt_BR`,
       * `pt_PT`,
       * `ru_RU`,
       * `sv_SE`,
       * `th_TH`,
       * `zh_CN`,
       * `zh_HK`,
       * and `zh_TW`.
       *
       * @param {string} [options.currency="USD"] If a currency is passed in {@link PayPalCheckout#createPayment|`createPayment`}, it must match the currency passed here.
       * @param {boolean} [options.vault] Must be `true` when using `flow: vault` in {@link PayPalCheckout#createPayment|`createPayment`}.
       * @param {string} [options.components=buttons] By default, the Braintree SDK will only load the PayPal smart buttons component. If you would like to load just the [messages component](https://developer.paypal.com/docs/business/checkout/add-capabilities/credit-messaging/), pass `messages`. If you would like to load both, pass `buttons,messages`
       * @param {object} [options.dataAttributes] The data attributes to apply to the script. Any data attribute can be passed. A subset of the parameters are listed below. For a full list of data attributes, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#script-parameters).
       * @param {string} [options.dataAttributes.client-token] The client token to use in the script. (usually not needed)
       * @param {string} [options.dataAttributes.csp-nonce] See the [PayPal docs about content security nonces](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#csp-nonce).
       * @param {callback} [callback] Called when the PayPal SDK has been loaded onto the page. The second argument is the PayPal Checkout instance. If no callback is provided, the promise resolves with the PayPal Checkout instance when the PayPal SDK has been loaded onto the page.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example <caption>Without options</caption>
       * paypalCheckoutInstance.loadPayPalSDK().then(function () {
       *   // window.paypal.Buttons is now available to use
       * });
       * @example <caption>With options</caption>
       * paypalCheckoutInstance.loadPayPalSDK({
       *   'client-id': 'PayPal Client Id', // Can speed up rendering time to hardcode this value
       *
       *   intent: 'capture', // Make sure this value matches the value in createPayment
       *   currency: 'USD', // Make sure this value matches the value in createPayment
       * }).then(function () {
       *   // window.paypal.Buttons is now available to use
       * });
       * @example <caption>With Vaulting</caption>
       * paypalCheckoutInstance.loadPayPalSDK({
       *   vault: true
       * }).then(function () {
       *   // window.paypal.Buttons is now available to use
       * });
       */
      PayPalCheckout.prototype.loadPayPalSDK = function (options) {
        var idPromise, src;
        var loadPromise = new ExtendedPromise();
        var dataAttributes = options && options.dataAttributes || {};
        var userIdToken = dataAttributes["user-id-token"] || dataAttributes["data-user-id-token"];
        if (this._configuration) {
          dataAttributes["client-metadata-id"] = dataAttributes["client-metadata-id"] ? dataAttributes["client-metadata-id"] : this._configuration.analyticsMetadata.sessionId;
        }
        if (!userIdToken) {
          userIdToken = this._authorizationInformation.fingerprint && this._authorizationInformation.fingerprint.split("?")[0];
        }
        this._paypalScript = document.createElement("script");

        // NEXT_MAJOR_VERSION
        // this options object should have 2 properties:
        // * queryParams
        // * dataAttributes
        // should make organizing this better than squashing
        // all the query params at the top level and extracting
        // the data attributes
        options = assign({}, {
          components: "buttons"
        }, options);
        delete options.dataAttributes;

        // NEXT_MAJOR_VERSION if merchant passes an explicit intent,
        // currency, amount, etc, save those for use in createPayment
        // if no explicit param of that type is passed in when calling
        // createPayment to reduce the number of items that need to be
        // duplicated here and in createPayment
        if (options.vault) {
          options.intent = options.intent || "tokenize";
        } else {
          options.intent = options.intent || "authorize";
          options.currency = options.currency || "USD";
        }
        src = "https://www.paypal.com/sdk/js?";
        this._paypalScript.onload = function () {
          loadPromise.resolve();
        };
        Object.keys(dataAttributes).forEach(function (attribute) {
          this._paypalScript.setAttribute("data-" + attribute.replace(/^data\-/, ""), dataAttributes[attribute]);
        }.bind(this));
        if (options["client-id"]) {
          idPromise = Promise.resolve(options["client-id"]);
        } else {
          idPromise = this.getClientId();
        }
        idPromise.then(function (id) {
          options["client-id"] = id;
          if (this._autoSetDataUserIdToken && userIdToken) {
            this._paypalScript.setAttribute("data-user-id-token", userIdToken);

            // preloading improves the rendering time of the PayPal button
            this._attachPreloadPixel({
              id: id,
              userIdToken: userIdToken,
              amount: dataAttributes.amount,
              currency: options.currency,
              merchantId: options["merchant-id"]
            });
          }
          this._paypalScript.src = querystring.queryify(src, options);
          document.head.insertBefore(this._paypalScript, document.head.firstElementChild);
        }.bind(this));
        return loadPromise.then(function () {
          return this;
        }.bind(this));
      };
      PayPalCheckout.prototype._attachPreloadPixel = function (options) {
        var request;
        var id = options.id;
        var userIdToken = options.userIdToken;
        var env = this._authorizationInformation.environment;
        var subdomain = env === "production" ? "" : "sandbox.";
        var url = PAYPAL_SDK_PRELOAD_URL.replace("{ENV}", subdomain);
        var preloadOptions = {
          "client-id": id,
          "user-id-token": userIdToken
        };
        if (options.amount) {
          preloadOptions.amount = options.amount;
        }
        if (options.currency) {
          preloadOptions.currency = options.currency;
        }
        if (options.merchantId) {
          preloadOptions["merchant-id"] = options.merchantId;
        }
        request = new XMLHttpRequest();
        request.open("GET", querystring.queryify(url, preloadOptions));
        request.send();
      };
      PayPalCheckout.prototype._formatPaymentResourceData = function (options, config) {
        var key;
        var gatewayConfiguration = this._configuration.gatewayConfiguration;
        // NEXT_MAJOR_VERSION default value for intent in PayPal SDK is capture
        // but our integrations default value is authorize. Default this to capture
        // in the next major version.
        var intent = options.intent;
        var paymentResource = {
          // returnUrl and cancelUrl are required in hermes create_payment_resource route
          // but are not used by the PayPal sdk, except to redirect to an error page
          returnUrl: config.returnUrl || "https://www.paypal.com/checkoutnow/error",
          cancelUrl: config.cancelUrl || "https://www.paypal.com/checkoutnow/error",
          offerPaypalCredit: options.offerCredit === true,
          merchantAccountId: this._merchantAccountId,
          experienceProfile: {
            brandName: options.displayName || gatewayConfiguration.paypal.displayName,
            localeCode: options.locale,
            noShipping: (!options.enableShippingAddress).toString(),
            addressOverride: options.shippingAddressEditable === false,
            landingPageType: options.landingPageType
          },
          shippingOptions: options.shippingOptions,
          payer_email: options.userAuthenticationEmail // eslint-disable-line camelcase
        };
        if (options.hasOwnProperty("shippingCallbackUrl")) {
          paymentResource.shippingCallbackUrl = options.shippingCallbackUrl;
        }
        if (options.flow === "checkout") {
          paymentResource.amount = options.amount;
          paymentResource.currencyIsoCode = options.currency;
          paymentResource.requestBillingAgreement = options.requestBillingAgreement;
          if (intent) {
            // 'sale' has been changed to 'capture' in PayPal's backend, but
            // we use an old version with 'sale'. We provide capture as an alias
            // to match the PayPal SDK
            if (intent === "capture") {
              intent = "sale";
            }
            paymentResource.intent = intent;
          }
          if (options.hasOwnProperty("lineItems")) {
            paymentResource.lineItems = options.lineItems;
          }
          if (options.hasOwnProperty("vaultInitiatedCheckoutPaymentMethodToken")) {
            paymentResource.vaultInitiatedCheckoutPaymentMethodToken = options.vaultInitiatedCheckoutPaymentMethodToken;
          }
          if (options.hasOwnProperty("shippingOptions")) {
            paymentResource.shippingOptions = options.shippingOptions;
          }
          for (key in options.shippingAddressOverride) {
            if (options.shippingAddressOverride.hasOwnProperty(key)) {
              paymentResource[key] = options.shippingAddressOverride[key];
            }
          }
          if (options.hasOwnProperty("billingAgreementDetails")) {
            paymentResource.billingAgreementDetails = options.billingAgreementDetails;
          }
        } else {
          // NOTE: This flow is "vault"
          paymentResource.shippingAddress = options.shippingAddressOverride;
          if (options.billingAgreementDescription) {
            paymentResource.description = options.billingAgreementDescription;
          }
          if (options.planType) {
            /* eslint-disable camelcase */
            paymentResource.plan_type = options.planType;
            if (options.planMetadata) {
              paymentResource.plan_metadata = camelCaseToSnakeCase(options.planMetadata);
            }
            /* eslint-enable camelcase */
          }
        }

        // this needs to be set outside of the block where add it to the
        // payment request so that a follow up tokenization call can use it,
        // but if a second create payment resource call is made without
        // the correlation id, we want to reset it to undefined so that the
        // tokenization call does not use a stale correlation id
        this._riskCorrelationId = options.riskCorrelationId;
        if (options.riskCorrelationId) {
          paymentResource.correlationId = this._riskCorrelationId;
        }
        return paymentResource;
      };

      /**
       * @ignore
       * @static
       * @function _verifyConsistentCurrency
       * Verifies that `options.currency` and the currencies for each `shippingOption` the same.
       * @param {object} options `options` provided for `updatePayment`.
       * @returns {boolean} true is currencies match (or no shipping options); false if currencies do not match.
       */

      PayPalCheckout.prototype._verifyConsistentCurrency = function (options) {
        if (options.currency && options.hasOwnProperty("shippingOptions") && Array.isArray(options.shippingOptions)) {
          return options.shippingOptions.every(function (item) {
            return item.amount && item.amount.currency && options.currency.toLowerCase() === item.amount.currency.toLowerCase();
          });
        }
        return true;
      };

      /**
       * @ignore
       * @static
       * @function _hasMissingOption
       * @param {object} options All options provided for intiating the PayPal flow.
       * @param {array} required A list of required inputs that must be include as part of the options.
       * @returns {boolean} Returns a boolean.
       */

      PayPalCheckout.prototype._hasMissingOption = function (options, required) {
        var i, option;
        required = required || [];
        if (!options.hasOwnProperty("amount") && !options.hasOwnProperty("lineItems")) {
          return true;
        }
        for (i = 0; i < required.length; i++) {
          option = required[i];
          if (!options.hasOwnProperty(option)) {
            return true;
          }
        }
        return false;
      };
      PayPalCheckout.prototype._formatUpdatePaymentData = function (options) {
        var self = this;
        var paymentResource = {
          merchantAccountId: this._merchantAccountId,
          paymentId: options.paymentId || options.orderId,
          currencyIsoCode: options.currency
        };
        if (options.hasOwnProperty("amount")) {
          paymentResource.amount = options.amount;
        }
        if (options.hasOwnProperty("lineItems")) {
          paymentResource.lineItems = options.lineItems;
        }
        if (options.hasOwnProperty("shippingOptions")) {
          paymentResource.shippingOptions = options.shippingOptions;
        }
        if (options.hasOwnProperty("amountBreakdown")) {
          paymentResource.amountBreakdown = options.amountBreakdown;
        }

        /* shippingAddress not supported yet */
        if (options.hasOwnProperty("shippingAddress")) {
          analytics.sendEventPlus(self._clientPromise, "paypal-checkout.updatePayment.shippingAddress.provided.by-the-merchant", {
            paypal_context_id: self._contextId // eslint-disable-line camelcase
          });
          paymentResource.line1 = options.shippingAddress.line1;
          if (options.shippingAddress.hasOwnProperty("line2")) {
            paymentResource.line2 = options.shippingAddress.line2;
          }
          paymentResource.city = options.shippingAddress.city;
          paymentResource.state = options.shippingAddress.state;
          paymentResource.postalCode = options.shippingAddress.postalCode;
          paymentResource.countryCode = options.shippingAddress.countryCode;
          if (options.shippingAddress.hasOwnProperty("phone")) {
            paymentResource.phone = options.shippingAddress.phone;
          }
          if (options.shippingAddress.hasOwnProperty("recipientName")) {
            paymentResource.recipientName = options.shippingAddress.recipientName;
          }
        }
        return paymentResource;
      };
      PayPalCheckout.prototype._formatTokenizeData = function (options, params) {
        var clientConfiguration = this._configuration;
        var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
        var isTokenizationKey = clientConfiguration.authorizationType === "TOKENIZATION_KEY";
        var isVaultFlow = options.flow === "vault";
        var correlationId = this._riskCorrelationId || params.billingToken || params.ecToken;
        var data = {
          paypalAccount: {
            correlationId: correlationId,
            options: {
              validate: isVaultFlow && !isTokenizationKey && options.vault
            }
          }
        };
        if (isVaultFlow) {
          data.paypalAccount.billingAgreementToken = params.billingToken;
        } else {
          data.paypalAccount.paymentToken = params.paymentId || params.orderId;
          data.paypalAccount.payerId = params.payerId;
          data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
          if (options.intent) {
            data.paypalAccount.intent = options.intent;
          }
        }
        if (this._merchantAccountId) {
          data.merchantAccountId = this._merchantAccountId;
        }
        return data;
      };
      PayPalCheckout.prototype._formatTokenizePayload = function (response) {
        var payload;
        var account = {};
        if (response.paypalAccounts) {
          account = response.paypalAccounts[0];
        }
        payload = {
          nonce: account.nonce,
          details: {},
          type: account.type
        };
        if (account.details && account.details.payerInfo) {
          payload.details = account.details.payerInfo;
        }
        if (account.details && account.details.creditFinancingOffered) {
          payload.creditFinancingOffered = account.details.creditFinancingOffered;
        }
        if (account.details && account.details.shippingOptionId) {
          payload.shippingOptionId = account.details.shippingOptionId;
        }
        if (account.details && account.details.cobrandedCardLabel) {
          payload.cobrandedCardLabel = account.details.cobrandedCardLabel;
        }
        return payload;
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * paypalCheckoutInstance.teardown();
       * @example <caption>With callback</caption>
       * paypalCheckoutInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPalCheckout.prototype.teardown = function () {
        var self = this;
        convertMethodsToError(this, methods(PayPalCheckout.prototype));
        if (this._paypalScript && this._paypalScript.parentNode) {
          this._paypalScript.parentNode.removeChild(this._paypalScript);
        }
        return this._frameServicePromise.catch(function () {
          // no need to error in teardown for an error setting up the frame service
        }).then(function () {
          if (!self._frameService) {
            return Promise.resolve();
          }
          return self._frameService.teardown();
        });
      };
      module.exports = wrapPromise.wrapPrototype(PayPalCheckout);
    }, {
      "../lib/analytics": 135,
      "../lib/assign": 137,
      "../lib/braintree-error": 140,
      "../lib/camel-case-to-snake-case": 141,
      "../lib/constants": 142,
      "../lib/convert-methods-to-error": 143,
      "../lib/convert-to-braintree-error": 144,
      "../lib/create-assets-url": 145,
      "../lib/create-authorization-data": 146,
      "../lib/create-deferred-client": 147,
      "../lib/frame-service/external": 155,
      "../lib/methods": 172,
      "../lib/querystring": 174,
      "../lib/use-min": 178,
      "../paypal/shared/constants": 198,
      "./errors": 193,
      "@braintree/extended-promise": 31,
      "@braintree/wrap-promise": 40
    }],
    196: [function (_dereq_, module, exports) {
      "use strict";

      var frameService = _dereq_("../../lib/frame-service/external");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
      var useMin = _dereq_("../../lib/use-min");
      var once = _dereq_("../../lib/once");
      var VERSION = "3.115.2";
      var constants = _dereq_("../shared/constants");
      var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
      var analytics = _dereq_("../../lib/analytics");
      var methods = _dereq_("../../lib/methods");
      var deferred = _dereq_("../../lib/deferred");
      var errors = _dereq_("../shared/errors");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var querystring = _dereq_("../../lib/querystring");
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @typedef {object} PayPal~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} type The payment method type, always `PayPalAccount`.
       * @property {object} details Additional PayPal account details.
       * @property {string} details.email User's email address.
       * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
       * @property {string} details.firstName User's given name.
       * @property {string} details.lastName User's surname.
       * @property {?string} details.countryCode User's 2 character country code.
       * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
       * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
       * @property {string} details.shippingAddress.recipientName Recipient of postage.
       * @property {string} details.shippingAddress.line1 Street number and name.
       * @property {string} details.shippingAddress.line2 Extended address.
       * @property {string} details.shippingAddress.city City or locality.
       * @property {string} details.shippingAddress.state State or region.
       * @property {string} details.shippingAddress.postalCode Postal code.
       * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
       * @property {?object} details.billingAddress User's billing address details.
       * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
       * Alternatively, see `shippingAddress` above as an available client option.
       * @property {string} details.billingAddress.line1 Street number and name.
       * @property {string} details.billingAddress.line2 Extended address.
       * @property {string} details.billingAddress.city City or locality.
       * @property {string} details.billingAddress.state State or region.
       * @property {string} details.billingAddress.postalCode Postal code.
       * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
       * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
       * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
       * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {number} creditFinancingOffered.term Length of financing terms in months.
       * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
       * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
       * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
       * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
       * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
       * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
       *
       */

      /**
       * @typedef {object} PayPal~tokenizeReturn
       * @property {Function} close A handle to close the PayPal checkout flow.
       * @property {Function} focus A handle to focus the PayPal checkout flow. Note that some browsers (notably iOS Safari) do not support focusing popups. Firefox requires the focus call to occur as the result of a user interaction, such as a button click.
       */

      /**
       * @class
       * @param {object} options see {@link module:braintree-web/paypal.create|paypal.create}
       * @classdesc This class represents a PayPal component. Instances of this class can open a PayPal window for authenticating a PayPal account. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
       *
       * This component has been deprecated in favor of the {@link PayPalCheckout|PayPal Checkout component}, which provides a fully managed UI. New features will not be added to this component.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal.create|braintree-web.paypal.create} instead.</strong>
       */
      function PayPal(options) {
        this._client = options.client;
        this._assetsUrl = options.client.getConfiguration().gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION;
        this._isDebug = options.client.getConfiguration().isDebug;
        this._loadingFrameUrl = this._assetsUrl + "/html/paypal-landing-frame" + useMin(this._isDebug) + ".html";
        this._authorizationInProgress = false;
      }
      PayPal.prototype._initialize = function () {
        var self = this;
        var client = this._client;
        var failureTimeout = setTimeout(function () {
          analytics.sendEvent(client, "paypal.load.timed-out");
        }, INTEGRATION_TIMEOUT_MS);
        return new Promise(function (resolve) {
          frameService.create({
            name: constants.LANDING_FRAME_NAME,
            dispatchFrameUrl: self._assetsUrl + "/html/dispatch-frame" + useMin(self._isDebug) + ".html",
            openFrameUrl: self._loadingFrameUrl
          }, function (service) {
            self._frameService = service;
            clearTimeout(failureTimeout);
            analytics.sendEvent(client, "paypal.load.succeeded");
            resolve(self);
          });
        });
      };

      /**
       * Launches the PayPal login flow and returns a nonce payload. Only one PayPal login flow should be active at a time. One way to achieve this is to disable your PayPal button while the flow is open.
       * @public
       * @param {object} options All tokenization options for the PayPal component.
       * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer id, the PayPal account will be added to that customer as a saved payment method.
       * @param {string} [options.intent=authorize]
       * * `authorize` - Submits the transaction for authorization but not settlement.
       * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
       * * `sale` - Payment will be immediately submitted for settlement upon creating a transaction.
       * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
       * @param {boolean} [options.offerPayLater=false] Offers PayPal Pay Later if the customer qualifies. Defaults to false. Only available with `flow: 'checkout'`.
       * @param {string} [options.useraction]
       * Changes the call-to-action in the PayPal flow. By default the final button will show the localized
       * word for "Continue" and implies that the final amount billed is not yet known.
       *
       * Setting this option to `commit` changes the button text to "Pay Now" and page text will convey to
       * the user that billing will take place immediately.
       * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow.
       * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
       * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
       * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
       *
       * Supported locales are:
       * `da_DK`,
       * `de_DE`,
       * `en_AU`,
       * `en_GB`,
       * `en_US`,
       * `es_ES`,
       * `fr_CA`,
       * `fr_FR`,
       * `id_ID`,
       * `it_IT`,
       * `ja_JP`,
       * `ko_KR`,
       * `nl_NL`,
       * `no_NO`,
       * `pl_PL`,
       * `pt_BR`,
       * `pt_PT`,
       * `ru_RU`,
       * `sv_SE`,
       * `th_TH`,
       * `zh_CN`,
       * `zh_HK`,
       * and `zh_TW`.
       *
       * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
       * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
       * @param {string} options.shippingAddressOverride.line1 Street address.
       * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
       * @param {string} options.shippingAddressOverride.city City.
       * @param {string} options.shippingAddressOverride.state State.
       * @param {string} options.shippingAddressOverride.postalCode Postal code.
       * @param {string} options.shippingAddressOverride.countryCode Country.
       * @param {string} [options.shippingAddressOverride.phone] Phone number.
       * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
       * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
       * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
       * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
       * * `login` - A PayPal account login page is used.
       * * `billing` - A non-PayPal account landing page is used.
       * @param {callback} callback The second argument, <code>data</code>, is a {@link PayPal~tokenizePayload|tokenizePayload}.
       * @example
       * <caption>Tokenizing with the vault flow</caption>
       * button.addEventListener('click', function () {
       *   // Disable the button so that we don't attempt to open multiple popups.
       *   button.setAttribute('disabled', 'disabled');
       *
       *   // if there is any other part of the page that must be disabled
       *   // while authentication is in progress, do so now
       *
       *   // Because PayPal tokenization opens a popup, this must be called
       *   // as a result of a user action, such as a button click.
       *   paypalInstance.tokenize({
       *     flow: 'vault' // Required
       *     // Any other tokenization options
       *   }, function (tokenizeErr, payload) {
       *     button.removeAttribute('disabled');
       *
       *     // if any other part of the page was disabled, re-enable now
       *
       *     if (tokenizeErr) {
       *       // Handle tokenization errors or premature flow closure
       *
       *       switch (tokenizeErr.code) {
       *         case 'PAYPAL_POPUP_CLOSED':
       *           console.error('Customer closed PayPal popup.');
       *           break;
       *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
       *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
       *           break;
       *         case 'PAYPAL_FLOW_FAILED':
       *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
       *           break;
       *         default:
       *           console.error('Error!', tokenizeErr);
       *       }
       *     } else {
       *       // Submit payload.nonce to your server
       *     }
       *   });
       * });
      
       * @example
       * <caption>Tokenizing with the checkout flow</caption>
       * button.addEventListener('click', function () {
       *   // Disable the button so that we don't attempt to open multiple popups.
       *   button.setAttribute('disabled', 'disabled');
       *
       *   // Because PayPal tokenization opens a popup, this must be called
       *   // as a result of a user action, such as a button click.
       *   paypalInstance.tokenize({
       *     flow: 'checkout', // Required
       *     amount: '10.00', // Required
       *     currency: 'USD' // Required
       *     // Any other tokenization options
       *   }, function (tokenizeErr, payload) {
       *     button.removeAttribute('disabled');
       *
       *     if (tokenizeErr) {
       *       // Handle tokenization errors or premature flow closure
       *
       *       switch (tokenizeErr.code) {
       *         case 'PAYPAL_POPUP_CLOSED':
       *           console.error('Customer closed PayPal popup.');
       *           break;
       *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
       *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
       *           break;
       *         case 'PAYPAL_FLOW_FAILED':
       *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
       *           break;
       *         default:
       *           console.error('Error!', tokenizeErr);
       *       }
       *     } else {
       *       // Submit payload.nonce to your server
       *     }
       *   });
       * });
       * @returns {Promise|PayPal~tokenizeReturn} A handle to manage the PayPal checkout frame. If no callback is provided, returns a promise.
       */
      PayPal.prototype.tokenize = function (options, callback) {
        var self = this;
        var client = this._client;
        var tokenizePromise, optionError;
        if (callback) {
          callback = once(deferred(callback));
        }
        if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
          optionError = new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED);
          if (callback) {
            callback(optionError);
            return this._frameService.createNoopHandler();
          }
          return Promise.reject(optionError);
        }
        tokenizePromise = new Promise(function (resolve, reject) {
          if (self._authorizationInProgress) {
            analytics.sendEvent(client, "paypal.tokenization.error.already-opened");
            reject(new BraintreeError(errors.PAYPAL_TOKENIZATION_REQUEST_ACTIVE));
          } else {
            self._authorizationInProgress = true;
            if (!window.popupBridge) {
              analytics.sendEvent(client, "paypal.tokenization.opened");
            }
            if (options.offerCredit === true) {
              analytics.sendEvent(client, "paypal.credit.offered");
            }
            if (options.offerPayLater === true) {
              analytics.sendEvent(client, "paypal.paylater.offered");
            }
            self._navigateFrameToAuth(options).catch(reject);
            // self MUST happen after _navigateFrameToAuth for Metro browsers to work.
            self._frameService.open({}, self._createFrameServiceCallback(options, resolve, reject));
          }
        });
        if (callback) {
          tokenizePromise.then(function (res) {
            callback(null, res);
          }).catch(callback);
          return this._frameService.createHandler({
            beforeClose: function () {
              analytics.sendEvent(client, "paypal.tokenization.closed.by-merchant");
            }
          });
        }
        return tokenizePromise;
      };
      PayPal.prototype._createFrameServiceCallback = function (options, resolve, reject) {
        var self = this;
        var client = this._client;
        if (window.popupBridge) {
          return function (err, payload) {
            var canceled = payload && payload.path && payload.path.substring(0, 7) === "/cancel";
            self._authorizationInProgress = false;

            // `err` exists when the user clicks "Done" button of browser view
            if (err || canceled) {
              analytics.sendEvent(client, "paypal.tokenization.closed-popupbridge.by-user");
              // Call merchant's tokenize callback with an error
              reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
            } else if (payload) {
              self._tokenizePayPal(options, payload.queryItems).then(resolve).catch(reject);
            }
          };
        }
        return function (err, params) {
          self._authorizationInProgress = false;
          if (err) {
            if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
              analytics.sendEvent(client, "paypal.tokenization.closed.by-user");
              reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
            } else if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
              reject(new BraintreeError({
                code: errors.PAYPAL_POPUP_OPEN_FAILED.code,
                type: errors.PAYPAL_POPUP_OPEN_FAILED.type,
                message: errors.PAYPAL_POPUP_OPEN_FAILED.message,
                details: {
                  originalError: err
                }
              }));
            }
          } else if (params) {
            self._tokenizePayPal(options, params).then(resolve).catch(reject);
          }
        };
      };
      PayPal.prototype._tokenizePayPal = function (options, params) {
        var self = this;
        var client = this._client;
        if (!window.popupBridge) {
          this._frameService.redirect(this._loadingFrameUrl);
        }
        return client.request({
          endpoint: "payment_methods/paypal_accounts",
          method: "post",
          data: this._formatTokenizeData(options, params)
        }).then(function (response) {
          var payload = self._formatTokenizePayload(response);
          if (window.popupBridge) {
            analytics.sendEvent(client, "paypal.tokenization.success-popupbridge");
          } else {
            analytics.sendEvent(client, "paypal.tokenization.success");
          }
          if (payload.creditFinancingOffered) {
            analytics.sendEvent(client, "paypal.credit.accepted");
          }
          self._frameService.close();
          return payload;
        }).catch(function (err) {
          if (window.popupBridge) {
            analytics.sendEvent(client, "paypal.tokenization.failed-popupbridge");
          } else {
            analytics.sendEvent(client, "paypal.tokenization.failed");
          }
          self._frameService.close();
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
            code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
            message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
          }));
        });
      };
      PayPal.prototype._formatTokenizePayload = function (response) {
        var payload;
        var account = {};
        if (response.paypalAccounts) {
          account = response.paypalAccounts[0];
        }
        payload = {
          nonce: account.nonce,
          details: {},
          type: account.type
        };
        if (account.details && account.details.payerInfo) {
          payload.details = account.details.payerInfo;
        }
        if (account.details && account.details.creditFinancingOffered) {
          payload.creditFinancingOffered = account.details.creditFinancingOffered;
        }
        return payload;
      };
      PayPal.prototype._formatTokenizeData = function (options, params) {
        var clientConfiguration = this._client.getConfiguration();
        var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
        var isTokenizationKey = clientConfiguration.authorizationType === "TOKENIZATION_KEY";
        var data = {
          paypalAccount: {
            correlationId: params.ba_token || params.token,
            options: {
              validate: options.flow === "vault" && !isTokenizationKey
            }
          }
        };
        if (params.ba_token) {
          data.paypalAccount.billingAgreementToken = params.ba_token;
        } else {
          data.paypalAccount.paymentToken = params.paymentId;
          data.paypalAccount.payerId = params.PayerID;
          data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
          if (options.hasOwnProperty("intent")) {
            data.paypalAccount.intent = options.intent;
          }
        }
        return data;
      };
      PayPal.prototype._navigateFrameToAuth = function (options) {
        var self = this;
        var client = this._client;
        var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];
        return client.request({
          endpoint: endpoint,
          method: "post",
          data: this._formatPaymentResourceData(options)
        }).then(function (response) {
          var redirectUrl;
          if (options.flow === "checkout") {
            redirectUrl = response.paymentResource.redirectUrl;
          } else {
            redirectUrl = response.agreementSetup.approvalUrl;
          }
          if (options.useraction === "commit") {
            redirectUrl = querystring.queryify(redirectUrl, {
              useraction: "commit"
            });
          }
          if (window.popupBridge) {
            analytics.sendEvent(client, "paypal.tokenization.opened-popupbridge");
          }
          self._frameService.redirect(redirectUrl);
        }).catch(function (err) {
          var status = err.details && err.details.httpStatus;
          self._frameService.close();
          self._authorizationInProgress = false;
          if (status === 422) {
            return Promise.reject(new BraintreeError({
              type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
              code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
              message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
              details: {
                originalError: err
              }
            }));
          }
          return Promise.reject(convertToBraintreeError(err, {
            type: errors.PAYPAL_FLOW_FAILED.type,
            code: errors.PAYPAL_FLOW_FAILED.code,
            message: errors.PAYPAL_FLOW_FAILED.message
          }));
        });
      };
      PayPal.prototype._formatPaymentResourceData = function (options) {
        var key;
        var gatewayConfiguration = this._client.getConfiguration().gatewayConfiguration;
        var serviceId = this._frameService._serviceId;
        var paymentResource = {
          returnUrl: gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION + "/html/redirect-frame" + useMin(this._isDebug) + ".html?channel=" + serviceId,
          cancelUrl: gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION + "/html/cancel-frame" + useMin(this._isDebug) + ".html?channel=" + serviceId,
          offerPaypalCredit: options.offerCredit === true,
          offerPayLater: options.offerPayLater === true,
          experienceProfile: {
            brandName: options.displayName || gatewayConfiguration.paypal.displayName,
            localeCode: options.locale,
            noShipping: (!options.enableShippingAddress).toString(),
            addressOverride: options.shippingAddressEditable === false,
            landingPageType: options.landingPageType
          }
        };
        if (window.popupBridge && typeof window.popupBridge.getReturnUrlPrefix === "function") {
          paymentResource.returnUrl = window.popupBridge.getReturnUrlPrefix() + "return";
          paymentResource.cancelUrl = window.popupBridge.getReturnUrlPrefix() + "cancel";
        }
        if (options.flow === "checkout") {
          paymentResource.amount = options.amount;
          paymentResource.currencyIsoCode = options.currency;
          if (options.hasOwnProperty("intent")) {
            paymentResource.intent = options.intent;
          }
          for (key in options.shippingAddressOverride) {
            if (options.shippingAddressOverride.hasOwnProperty(key)) {
              paymentResource[key] = options.shippingAddressOverride[key];
            }
          }
        } else {
          paymentResource.shippingAddress = options.shippingAddressOverride;
          if (options.billingAgreementDescription) {
            paymentResource.description = options.billingAgreementDescription;
          }
        }
        return paymentResource;
      };

      /**
       * Closes the PayPal window if it is open.
       * @public
       * @example
       * paypalInstance.closeWindow();
       * @returns {void}
       */
      PayPal.prototype.closeWindow = function () {
        if (this._authorizationInProgress) {
          analytics.sendEvent(this._client, "paypal.tokenize.closed.by-merchant");
        }
        this._frameService.close();
      };

      /**
       * Focuses the PayPal window if it is open.
       * @public
       * @example
       * paypalInstance.focusWindow();
       * @returns {void}
       */
      PayPal.prototype.focusWindow = function () {
        this._frameService.focus();
      };

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/paypal.create|create}.
       * @public
       * @param {callback} [callback] Called on completion.
       * @example
       * paypalInstance.teardown();
       * @example <caption>With callback</caption>
       * paypalInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      PayPal.prototype.teardown = wrapPromise(function () {
        var self = this; // eslint-disable-line no-invalid-this

        self._frameService.teardown();
        convertMethodsToError(self, methods(PayPal.prototype));
        analytics.sendEvent(self._client, "paypal.teardown-completed");
        return Promise.resolve();
      });
      module.exports = PayPal;
    }, {
      "../../lib/analytics": 135,
      "../../lib/braintree-error": 140,
      "../../lib/constants": 142,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/convert-to-braintree-error": 144,
      "../../lib/deferred": 148,
      "../../lib/frame-service/external": 155,
      "../../lib/methods": 172,
      "../../lib/once": 173,
      "../../lib/querystring": 174,
      "../../lib/use-min": 178,
      "../shared/constants": 198,
      "../shared/errors": 199,
      "@braintree/wrap-promise": 40
    }],
    197: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/paypal
       * @description A component to integrate with PayPal.
       * @deprecated Use the {@link PayPalCheckout|PayPal Checkout component} instead.
       */
      var analytics = _dereq_("../lib/analytics");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./shared/errors");
      var PayPal = _dereq_("./external/paypal");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} callback The second argument, `data`, is the {@link PayPal} instance.
       * @example
       * // We recommend creating your PayPal button with button.js
       * // For an example, see https://codepen.io/braintree/pen/LNKJWa
       * var paypalButton = document.querySelector('.paypal-button');
       *
       * braintree.client.create({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (clientErr, clientInstance) {
       *   if (clientErr) {
       *     console.error('Error creating client:', clientErr);
       *     return;
       *   }
       *
       *   braintree.paypal.create({
       *     client: clientInstance
       *   }, function (paypalErr, paypalInstance) {
       *     if (paypalErr) {
       *       console.error('Error creating PayPal:', paypalErr);
       *       return;
       *     }
       *
       *     paypalButton.removeAttribute('disabled');
       *
       *     // When the button is clicked, attempt to tokenize.
       *     paypalButton.addEventListener('click', function (event) {
       *       // Because tokenization opens a popup, this has to be called as a result of
       *       // customer action, like clicking a button. You cannot call this at any time.
       *       paypalInstance.tokenize({
       *         flow: 'vault'
       *         // For more tokenization options, see the full PayPal tokenization documentation
       *         // https://braintree.github.io/braintree-web/current/PayPal.html#tokenize
       *       }, function (tokenizeErr, payload) {
       *         if (tokenizeErr) {
       *           if (tokenizeErr.type !== 'CUSTOMER') {
       *             console.error('Error tokenizing:', tokenizeErr);
       *           }
       *           return;
       *         }
       *
       *         // Tokenization succeeded
       *         paypalButton.setAttribute('disabled', true);
       *         console.log('Got a nonce! You should submit this to your server.');
       *         console.log(payload.nonce);
       *       });
       *     }, false);
       *   });
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "PayPal";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var pp;
          var config = client.getConfiguration();
          options.client = client;
          if (config.gatewayConfiguration.paypalEnabled !== true) {
            return Promise.reject(new BraintreeError(errors.PAYPAL_NOT_ENABLED));
          }
          analytics.sendEvent(options.client, "paypal.initialized");
          pp = new PayPal(options);
          return pp._initialize();
        });
      }

      /**
       * @static
       * @function isSupported
       * @description Returns true if PayPal [supports this browser](index.html#browser-support-webviews).
       * @example
       * if (braintree.paypal.isSupported()) {
       *   // Add PayPal button to the page
       * } else {
       *   // Hide PayPal payment option
       * }
       * @returns {Boolean} Returns true if PayPal supports this browser.
       */
      function isSupported() {
        return true;
      }
      module.exports = {
        create: wrapPromise(create),
        isSupported: isSupported,
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./external/paypal": 196,
      "./shared/errors": 199,
      "@braintree/wrap-promise": 40
    }],
    198: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        LANDING_FRAME_NAME: "braintreepaypallanding",
        FLOW_ENDPOINTS: {
          checkout: "create_payment_resource",
          vault: "setup_billing_agreement"
        },
        REQUIRED_OPTIONS: ["paymentId", "currency"]
      };
    }, {}],
    199: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.PayPal - Creation Error Codes
       * @description Errors that occur when [creating the PayPal component](./module-braintree-web_paypal.html#.create).
       * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
       */

      /**
       * @name BraintreeError.PayPal - tokenize Error Codes
       * @description Errors that occur when using the [`tokenize` method](./PayPal.html#tokenize).
       * @property {MERCHANT} PAYPAL_TOKENIZATION_REQUEST_ACTIVE Occurs when a tokenization request is already in progress.
       * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when flow option is not provided.
       * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
       * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when PayPal flow could not be initiated.
       * @property {MERCHANT} PAYPAL_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened.
       * @property {CUSTOMER} PAYPAL_POPUP_CLOSED Occurs when customer closes the PayPal window before completing the flow.
       * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is passed.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        PAYPAL_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_NOT_ENABLED",
          message: "PayPal is not enabled for this merchant."
        },
        PAYPAL_TOKENIZATION_REQUEST_ACTIVE: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_TOKENIZATION_REQUEST_ACTIVE",
          message: "Another tokenization request is active."
        },
        PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
          message: "Could not tokenize user's PayPal account."
        },
        PAYPAL_FLOW_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "PAYPAL_FLOW_FAILED",
          message: "Could not initialize PayPal flow."
        },
        PAYPAL_FLOW_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_FLOW_OPTION_REQUIRED",
          message: "PayPal flow property is invalid or missing."
        },
        PAYPAL_POPUP_OPEN_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_POPUP_OPEN_FAILED",
          message: "PayPal popup failed to open, make sure to tokenize in response to a user action."
        },
        PAYPAL_POPUP_CLOSED: {
          type: BraintreeError.types.CUSTOMER,
          code: "PAYPAL_POPUP_CLOSED",
          message: "Customer closed PayPal popup before authorizing."
        },
        PAYPAL_INVALID_PAYMENT_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "PAYPAL_INVALID_PAYMENT_OPTION",
          message: "PayPal payment options are invalid."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    200: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/preferred-payment-methods */
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var PreferredPaymentMethods = _dereq_("./preferred-payment-methods");
      var VERSION = "3.115.2";

      // NEXT_MAJOR_VERSION
      // Remove this integration entirely. It doesn't work, isn't documented, and otherwise isn't going to be pursued further beyond the non-operational beta it is in.
      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link PreferredPaymentMethods} instance.
       * @example
       * braintree.preferredPaymentMethods.create({
       *   client: clientInstance
       * }).then(function (preferredPaymentMethodsInstance) {
       *   // preferredPaymentMethodsInstance is ready to be used.
       * }).catch(function (error) {
       *   // handle creation error
       * });
       * @returns {Promise|void} Returns a Promise with resolves with the PreferredPaymentMethods instance.
       */
      function create(options) {
        var name = "PreferredPaymentMethods";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var instance = new PreferredPaymentMethods();
          return instance.initialize(options);
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "./preferred-payment-methods": 201,
      "@braintree/wrap-promise": 40
    }],
    201: [function (_dereq_, module, exports) {
      "use strict";

      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var analytics = _dereq_("../lib/analytics");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");

      /**
       * @class
       * @param {object} options See {@link module:braintree-web/preferred-payment-methods.create|preferred-payment-methods.create}
       */
      function PreferredPaymentMethods() {}
      PreferredPaymentMethods.prototype.initialize = function (options) {
        var self = this;
        this._clientPromise = createDeferredClient.create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: "PreferredPaymentMethods"
        }).catch(function (err) {
          self._setupError = err;
          return Promise.reject(err);
        });
        analytics.sendEvent(this._clientPromise, "preferred-payment-methods.initialized");
        return Promise.resolve(this);
      };

      /**
       * Fetches information about which payment methods are preferred on the device.
       * Used to determine which payment methods are given preference in your UI,
       * not whether they are presented entirely.
       *
       * This class is currently in beta and may change in future releases.
       * @public
       * @returns {Promise|void} Returns a promise if no callback is provided.
       * @example
       * <caption>Preferred Payment Methods</caption>
       * preferredPaymentMethodsInstance.fetchPreferredPaymentMethods().then(function (result) {
       *   if (result.paypalPreferred) {
       *     // PayPal preferred
       *   } else {
       *     // PayPal not preferred
       *   }
       *
       *   if (result.venmoPreferred) {
       *     // Venmo preferred
       *   } else {
       *     // Venmo not preferred
       *   }
       * });
       */
      PreferredPaymentMethods.prototype.fetchPreferredPaymentMethods = function () {
        var client;
        var self = this;
        return this._clientPromise.then(function (clientInstance) {
          client = clientInstance;
          return client.request({
            api: "graphQLApi",
            data: {
              query: "query PreferredPaymentMethods { " + "preferredPaymentMethods { " + "paypalPreferred " + "venmoPreferred " + "} " + "}"
            }
          });
        }).then(function (result) {
          var paypalPreferred = result.data.preferredPaymentMethods.paypalPreferred;
          var venmoPreferred = result.data.preferredPaymentMethods.venmoPreferred;
          analytics.sendEvent(client, "preferred-payment-methods.paypal.api-detected." + paypalPreferred);
          analytics.sendEvent(client, "preferred-payment-methods.venmo.api-detected." + venmoPreferred);
          return {
            paypalPreferred: paypalPreferred,
            venmoPreferred: venmoPreferred
          };
        }).catch(function () {
          if (self._setupError) {
            return Promise.reject(self._setupError);
          }
          analytics.sendEvent(client, "preferred-payment-methods.api-error");
          return {
            paypalPreferred: false,
            venmoPreferred: false
          };
        });
      };
      module.exports = wrapPromise.wrapPrototype(PreferredPaymentMethods);
    }, {
      "../lib/analytics": 135,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "@braintree/wrap-promise": 40
    }],
    202: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../../lib/braintree-error");
      var sepaErrors = _dereq_("../shared/errors");
      var frameService = _dereq_("../../lib/frame-service/external");
      var analytics = _dereq_("../../lib/analytics");
      var useMin = _dereq_("../../lib/use-min");
      var billingAddressOptions = _dereq_("../shared/constants").BILLING_ADDRESS_OPTIONS;
      var snakeCaseToCamelCase = _dereq_("../../lib/snake-case-to-camel-case");
      var assign = _dereq_("../../lib/assign").assign;
      var POPUP_WIDTH = 400;
      var POPUP_HEIGHT = 570;

      /**
       * @ignore
       * @typedef CreateMandateResponse
       * @property {string} approvalUrl The URL to present to the customer for payment approval.
       * @property {string} last4 The last four digits of the iban.
       * @property {string} bankReferenceToken The tokenized payment source to fun the payment.
       */

      /**
       *
       * A function that creates a mandate so that we can present the mandate to the customer via a popup.
       *
       * @ignore
       * @static
       * @function createMandate
       * @param {object} client The Braintree client.
       * @param {object} options All options for intiating the SEPA payment flow.
       * @param {string} [options.accountHolderName] The account holder name.
       * @param {object} [options.billingAddress] The customer's billing address
       * @param {string} [options.billingAddress.addressLine1] Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
       * @param {string} [options.billingAddress.addressLine2] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
       * @param {string} [options.billingAddress.adminArea1] Customer's city.
       * @param {string} [options.billingAddress.adminArea2] Customer's region or state.
       * @param {string} [options.billingAddress.postalCode] Customer's postal code.
       * @param {string} [options.cancelUrl] The URL to redirect to if authorization is cancelled.
       * @param {string} [options.countryCode] The customer's country code. Also used as billing address country code.
       * @param {string} [options.customerId] The customer's id.
       * @param {string} [options.iban] The customer's International Bank Account Number.
       * @param {string} [options.locale] The BCP 47-formatted locale. See https://developer.paypal.com/reference/locale-codes/ for a list of possible values.
       * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
       * @param {string} [options.merchantAccountId] The merchant's account id.
       * @param {string} [options.merchantId] The merchant id.
       * @param {string} [options.returnUrl] The URL to redirect to if authorization is successful.
       * @returns {Promise<CreateMandateResponse|Error>} Returns a promise with the mandate response or an error.
       */

      function createMandate(client, options) {
        // Disabling eslint because api is expecting snake_case format for the keys
        /* eslint-disable */
        var data = {
          sepa_debit: {
            account_holder_name: options.accountHolderName,
            billing_address: {
              country_code: options.countryCode
            },
            iban: options.iban,
            merchant_or_partner_customer_id: options.customerId,
            mandate_type: options.mandateType
          },
          locale: options.locale,
          cancel_url: options.cancelUrl,
          return_url: options.returnUrl,
          merchant_account_id: options.merchantAccountId
        };
        if (options.billingAddress) {
          billingAddressOptions.forEach(function (option) {
            var ccOption = snakeCaseToCamelCase(option);
            if (ccOption in options.billingAddress) {
              data.sepa_debit.billing_address[option] = options.billingAddress[ccOption]; // camelCase equivilent of option (eg. postal_code = postalCode) ]
            }
          });
        }
        /* eslint-enable */

        return client.request({
          api: "clientApi",
          method: "post",
          endpoint: "sepa_debit",
          data: data
        }).then(function (response) {
          var sepaDebitAccount = response.message.body.sepaDebitAccount;
          if (!sepaDebitAccount) {
            throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
          }
          return {
            approvalUrl: sepaDebitAccount.approvalUrl,
            last4: sepaDebitAccount.last4,
            bankReferenceToken: sepaDebitAccount.bankReferenceToken
          };
        }).catch(function () {
          throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
        });
      }

      /**
       *
       * A function for opening and managing the popup used for authorization.
       *
       * @ignore
       * @param {string} client The Braintree client.
       * @param {string} options The input options needed to manage the popup portion of the flow.
       * @param {string} [options.assetsUrl] The url to the Braintree asset to be used in frameservice.
       * @param {string} [options.approvalUrl] The url to open for SEPA authorization. It is `approvalUrl` coming back from the mandate creation, but commonly refered to as the mandate link.
       * @param {string} [options.debug] Whether to use debugging modes or not.
       * @returns {Promise<void|Error>} Returns a promise.
       */
      function openPopup(client, options) {
        var popupName = "sepadirectdebit";
        var assetsBaseUrl = options.assetsUrl + "/html";
        var debug = options.debug || false;
        return new Promise(function (resolve, reject) {
          var popupLocation = centeredPopupDimensions();
          frameService.create({
            name: popupName,
            dispatchFrameUrl: assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
            openFrameUrl: assetsBaseUrl + "/sepa-landing-frame" + useMin(debug) + ".html",
            top: popupLocation.top,
            left: popupLocation.left,
            height: POPUP_HEIGHT,
            width: POPUP_WIDTH
          }, function (frameServiceInstance) {
            analytics.sendEvent(client, "sepa.popup.initialized");
            frameServiceInstance.open({}, function (err, params) {
              if (mandateApproved(params)) {
                frameServiceInstance.close();
                return resolve();
              }
              if (customerCanceled(params, err)) {
                frameServiceInstance.close();
                return reject(new BraintreeError(sepaErrors.SEPA_CUSTOMER_CANCELED));
              }
              frameServiceInstance.close();
              return reject(new BraintreeError(sepaErrors.SEPA_TOKENIZATION_FAILED));
            });
            frameServiceInstance.redirect(options.approvalUrl);
          });
        });
      }
      function redirectPage(approvalUrl) {
        window.location.href = approvalUrl;
      }
      function mandateApproved(params) {
        return params && params.success;
      }
      function customerCanceled(params, error) {
        return params && params.cancel || error && error.code === "FRAME_SERVICE_FRAME_CLOSED";
      }
      function centeredPopupDimensions() {
        var popupTop = Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
        var popupLeft = Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;
        return {
          top: popupTop,
          left: popupLeft
        };
      }

      /**
       *
       * A function that creates a mandate so that we can present the mandate to the customer via a popup.
       *
       * @ignore
       * @static
       * @function handleApproval
       * @param {object} client The Braintree client.
       * @param {object} options All options for intiating the SEPA payment flow.
       * @param {string} [options.bankReferenceToken] The tokenized payment source to fun the payment.
       * @param {string} [options.customerId] The customer's id.
       * @param {string} [options.last4] The last four digits of iban.
       * @param {string} [options.mandateType] The mandate type being used. Specify ONE_OFF or RECURRENT payment.
       * @param {string} [options.merchantAccountId] The merchant's account id.
       * @param {string} [options.merchantId] The merchant id.
       * @returns {Promise<tokenizePayload|Error>} Returns a promise with the approval response or an error.
       */

      function handleApproval(client, options) {
        // Disabling eslint because api is expecting snake_case format for the keys
        /* eslint-disable */
        var data = {
          sepa_debit_account: {
            last_4: options.last4,
            merchant_or_partner_customer_id: options.customerId,
            bank_reference_token: options.bankReferenceToken,
            mandate_type: options.mandateType
          },
          merchant_account_id: options.merchantAccountId
        };

        /* eslint-enable */
        return client.request({
          api: "clientApi",
          method: "post",
          endpoint: "payment_methods/sepa_debit_accounts",
          data: data
        }).then(function (response) {
          if (!response.nonce) {
            throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
          }
          return {
            nonce: response.nonce,
            ibanLastFour: options.last4,
            customerId: options.customerId,
            mandateType: options.mandateType
          };
        }).catch(function () {
          throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
        });
      }
      function handleApprovalForFullPageRedirect(client, options) {
        return client.request({
          api: "clientApi",
          method: "get",
          endpoint: "sepa_debit/" + options.cart_id
        }).then(function (response) {
          var payload = response.sepaDebitMandateDetail;
          analytics.sendEvent(client, "sepa.redirect.mandate.approved");
          assign(options, {
            last4: payload.last4,
            customerId: payload.merchantOrPartnerCustomerId,
            mandateType: payload.mandateType,
            bankReferenceToken: payload.bankReferenceToken
          });
          return handleApproval(client, options);
        }).then(function (response) {
          analytics.sendEvent(client, "sepa.redirect.tokenization.success");
          return response;
        }).catch(function () {
          analytics.sendEvent(client, "sepa.redirect.handle-approval.failed");
          throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
        });
      }
      module.exports = {
        createMandate: createMandate,
        openPopup: openPopup,
        handleApproval: handleApproval,
        POPUP_WIDTH: POPUP_WIDTH,
        POPUP_HEIGHT: POPUP_HEIGHT,
        redirectPage: redirectPage,
        handleApprovalForFullPageRedirect: handleApprovalForFullPageRedirect
      };
    }, {
      "../../lib/analytics": 135,
      "../../lib/assign": 137,
      "../../lib/braintree-error": 140,
      "../../lib/frame-service/external": 155,
      "../../lib/snake-case-to-camel-case": 176,
      "../../lib/use-min": 178,
      "../shared/constants": 205,
      "../shared/errors": 206
    }],
    203: [function (_dereq_, module, exports) {
      "use strict";

      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var sepaErrors = _dereq_("../shared/errors");
      var constants = _dereq_("../shared/constants");
      var mandates = _dereq_("./mandate");
      var hasMissingOption = _dereq_("../shared/has-missing-option");
      var analytics = _dereq_("../../lib/analytics");
      var VERSION = "3.115.2";
      var assign = _dereq_("../../lib/assign").assign;

      /**
       * @class
       * @param {object} options see {@link module:braintree-web/sepa.create|sepa.create}
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/sepa.create|braintree-web.sepa.create} instead.</strong>
       * @classdesc This class represents a SEPA component produced by {@link module:braintree-web/sepa.create|braintree-web.sepa.create}. Instances provide methods for tokenizing SEPA payments.
       */
      function SEPA(options) {
        var getConfiguration = options.client.getConfiguration();
        this._client = options.client;
        this._assetsUrl = getConfiguration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
        this._isDebug = getConfiguration.isDebug;
        if (options.redirectUrl) {
          this._returnUrl = options.redirectUrl;
          this._cancelUrl = options.redirectUrl + "?cancel=1";
          this._isRedirectFlow = true;
        } else {
          this._returnUrl = this._assetsUrl + "/html/redirect-frame.html?success=1";
          this._cancelUrl = this._assetsUrl + "/html/redirect-frame.html?cancel=1";
        }
        if (options.tokenizePayload) {
          this.tokenizePayload = options.tokenizePayload;
        }
        analytics.sendEvent(this._client, "sepa.component.initialized");
      }

      /**
       * SEPA tokenize payload.
       * @typedef SEPA~tokenizePayload
       * @property {string} nonce The payment nonce.
       * @property {string} ibanLastFour The last four digits of the customer's IBAN.
       * @property {string} mandateType The specified mandateType used.
       * @property {string} customerId The provided customer id.
       */

      /**
       * @public
       * @param {object} options All options for intiating the SEPA payment flow.
       * @param {string} [options.accountHolderName] The account holder name.
       * @param {string} [options.customerId] The customer's id.
       * @param {string} [options.iban] The customer's International Bank Account Number.
       * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
       * @param {string} [options.countryCode] The customer's country code.
       * @param {string} [options.merchantAccountId] The merchant's account id.
       * @param {callback} [callback] The first argument is an error object, where the second is a {@link SEPA~tokenizePayload|tokenizePayload}
       * @returns {(Promise<tokenizePayload|error>)} Returns a promise if no callback is provided.
       *
       * @example
       * button.addEventListener('click', function () {
       *   var tokenizeInputs = {
       *     accountHolderName: "some-accnt-holder-name",
       *     customerId: "a-customer-id",
       *     iban: "a-full-iban",
       *     mandateType: "ONE_OFF",
       *     countryCode: "LI",
       *     merchantAccountId: "a-merchant-account-id"
       *   }
       *   sepaInstance.tokenize(tokenizeInputs).then(function (payload) {
       *      // Submit payload.nonce to your server
       *   }).catch(function(tokenizationErr) {
       *     // Handle errors in the flow
       *   })
       * })
       */
      SEPA.prototype.tokenize = function (options) {
        var self = this;
        var popupPromise;
        var createMandateOptions = assign({
          cancelUrl: self._cancelUrl,
          returnUrl: self._returnUrl
        }, options);
        if (!options || hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
          analytics.sendEvent(self._client, "sepa.input-validation.missing-options");
          return Promise.reject(new BraintreeError(sepaErrors.SEPA_TOKENIZE_MISSING_REQUIRED_OPTION));
        }
        if (!constants.MANDATE_TYPE_ENUM.includes(options.mandateType)) {
          analytics.sendEvent(self._client, "sepa.input-validation.invalid-mandate");
          return Promise.reject(new BraintreeError(sepaErrors.SEPA_INVALID_MANDATE_TYPE));
        }
        popupPromise = mandates.createMandate(self._client, createMandateOptions).then(function (mandateResponse) {
          analytics.sendEvent(self._client, "sepa.create-mandate.success");
          if (self._isRedirectFlow) {
            return mandates.redirectPage(mandateResponse.approvalUrl);
          }
          options.last4 = mandateResponse.last4;
          options.bankReferenceToken = mandateResponse.bankReferenceToken;
          return mandates.openPopup(self._client, {
            approvalUrl: mandateResponse.approvalUrl,
            assetsUrl: self._assetsUrl
          });
        });

        // Must be outside of .then() to return from top-level function
        if (self._isRedirectFlow) {
          return Promise.resolve();
        }

        // At this point, we know the promise came from the popup flow
        return popupPromise.then(function () {
          analytics.sendEvent(self._client, "sepa.mandate.approved");
          return mandates.handleApproval(self._client, {
            bankReferenceToken: options.bankReferenceToken,
            last4: options.last4,
            customerId: options.customerId,
            mandateType: options.mandateType,
            merchantAccountId: options.merchantAccountId
          });
        }).then(function (approval) {
          analytics.sendEvent(self._client, "sepa.tokenization.success");
          return Promise.resolve(approval);
        }).catch(function (err) {
          analytics.sendEvent(self._client, "sepa." + err.details + ".failed");
          return Promise.reject(err);
        });
      };
      module.exports = wrapPromise.wrapPrototype(SEPA);
    }, {
      "../../lib/analytics": 135,
      "../../lib/assign": 137,
      "../../lib/braintree-error": 140,
      "../shared/constants": 205,
      "../shared/errors": 206,
      "../shared/has-missing-option": 207,
      "./mandate": 202,
      "@braintree/wrap-promise": 40
    }],
    204: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/sepa */
      var analytics = _dereq_("../lib/analytics");
      var SEPA = _dereq_("./external/sepa");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var VERSION = "3.115.2";
      var parse = _dereq_("../lib/querystring").parse;
      var assign = _dereq_("../lib/assign").assign;
      var mandate = _dereq_("./external/mandate");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {boolean} [options.debug] A debug flag.
       * @param {string} [options.redirectUrl] When provided, triggers full page redirect flow instead of popup flow.
       * @param {callback} [callback] When provided, will be used instead of a promise. First argument is an error object, where the second is an instance of {@link SEPA|SEPA}.
       * @returns {Promise<void|error>} Returns the SEPA instance.
       * @example
       * braintree.sepa.create({
       *   client: clientInstance
       * }).then(function (sepaInstance) {
       *   // sepaInstance is ready to be used.
       * }).catch(function (createErr) {
       *   console.error('Error creating SEPA instance', createErr);
       * });
       * @example <caption>Creating a SEPA component</caption>
       * braintree.sepa.create({
       *   client: clientInstance,
       * }).then(function (sepaInstance) {
       *   // sepaInstance is ready to be used.
       * }).catch(function (createErr) {
       *   console.error('Error creating SEPA instance', createErr);
       * });
       */

      function create(options) {
        var name = "SEPA";
        var params = parse(window.location.href);
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          options.client = client;
          analytics.sendEvent(client, "sepa.client.initialized");
          return new SEPA(options);
        }).then(function (sepaInstance) {
          // This cart_id is actually a V2 orderId
          var redirectComplete = params.success && params.success === "true" && params.cart_id;
          if (redirectComplete) {
            options = assign(options, params);

            // Pick up redirect flow where it left off
            return mandate.handleApprovalForFullPageRedirect(options.client, options).then(function (payload) {
              sepaInstance.tokenizePayload = payload;
              return sepaInstance;
            }).catch(function (err) {
              console.error("Problem while finishing tokenizing: ", err);
            });
          } else if (params.cancel) {
            analytics.sendEvent(options.client, "sepa.redirect.customer-canceled.failed");
          }
          return sepaInstance;
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/assign": 137,
      "../lib/basic-component-verification": 138,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "../lib/querystring": 174,
      "./external/mandate": 202,
      "./external/sepa": 203,
      "@braintree/wrap-promise": 40
    }],
    205: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        REQUIRED_OPTIONS: ["iban", "merchantAccountId", "mandateType", "customerId", "accountHolderName", "countryCode"],
        BILLING_ADDRESS_OPTIONS: ["address_line_1", "address_line_2", "admin_area_1", "admin_area_2", "postal_code"],
        MANDATE_TYPE_ENUM: ["ONE_OFF", "RECURRENT"]
      };
    }, {}],
    206: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../../lib/braintree-error");

      /**
       * @name BraintreeError.SEPA - tokenize Error Codes
       * @description Errors that occur when using the {@link module:braintree-web/sepa.tokenize|sepa.tokenize} method.
       * @property {MERCHANT} SEPA_CREATE_MANDATE_FAILED Occurs when there was an issue creating a mandate. This can occur if the request fails, or if the merchant does not have SEPA enabled.
       * @property {CUSTOMER} SEPA_CUSTOMER_CANCELED Occurs when the customer has canceled the SEPA authorization process. This can be within the mandate approval popup, or by canceling the popup itself.
       * @property {MERCHANT} SEPA_INVALID_MANDATE_TYPE Occurs when an invalid mandate type is provided.
       * @property {UNKNOWN} SEPA_TOKENIZATION_FAILED Occurs when tokenization fails during the mandate approval process for unknown reasons.
       * @property {MERCHANT} SEPA_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when there are required input options not provided.
       * @property {UNKNOWN} SEPA_TRANSACTION_FAILED Occurs when final tokenization fails.
       */

      // Those with a "details" property are used in specific locations and this prop serves to identify where in the imlpementation the error originates.
      module.exports = {
        SEPA_CREATE_MANDATE_FAILED: {
          type: BraintreeError.types.MERCHANT,
          code: "SEPA_CREATE_MANDATE_FAILED",
          message: "SEPA create mandate failed.",
          details: "create-mandate"
        },
        SEPA_CUSTOMER_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "SEPA_CUSTOMER_CANCELED",
          message: "User canceled SEPA authorization",
          details: "customer-canceled"
        },
        SEPA_INVALID_MANDATE_TYPE: {
          type: BraintreeError.types.MERCHANT,
          code: "SEPA_INVALID_MANDATE_TYPE",
          message: "SEPA mandate type is invalid"
        },
        SEPA_TOKENIZATION_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "SEPA_TOKENIZATION_FAILED",
          message: "SEPA encountered a problem",
          details: "open-popup"
        },
        SEPA_TOKENIZE_MISSING_REQUIRED_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "SEPA_TOKENIZE_MISSING_REQUIRED_OPTION",
          message: "Missing required option for tokenize."
        },
        SEPA_TRANSACTION_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "SEPA_TRANSACTION_FAILED",
          message: "SEPA transaction failed",
          details: "handle-approval"
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    207: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @ignore
       * @static
       * @function hasMissingOption
       * @param {object} options All options provided for intiating the SEPA payment flow.
       * @param {array} required A list of required inputs that must be include as part of the options.
       * @returns {boolean} Returns a boolean.
       */
      function hasMissingOption(options, required) {
        var i, option;
        required = required || [];
        for (i = 0; i < required.length; i++) {
          option = required[i];
          if (!options.hasOwnProperty(option)) {
            return true;
          }
        }
        return false;
      }
      module.exports = hasMissingOption;
    }, {}],
    208: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../../lib/assign").assign;
      var analytics = _dereq_("../../../lib/analytics");
      var BraintreeError = _dereq_("../../../lib/braintree-error");
      var isVerifiedDomain = _dereq_("../../../lib/is-verified-domain");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var EventEmitter = _dereq_("@braintree/event-emitter");
      var errors = _dereq_("../../shared/errors");
      var iFramer = _dereq_("@braintree/iframer");
      var Bus = _dereq_("framebus");
      var constants = _dereq_("../../shared/constants");
      var uuid = _dereq_("@braintree/uuid");
      var events = _dereq_("../../shared/events");
      var useMin = _dereq_("../../../lib/use-min");
      var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;
      var VERSION = "3.115.2";
      var IFRAME_HEIGHT = 400;
      var IFRAME_WIDTH = 400;
      ExtendedPromise.suppressUnhandledPromiseMessage = true;
      function BaseFramework(options) {
        EventEmitter.call(this);
        this._client = options.client;
        this._createPromise = options.createPromise;
        this._createOptions = options;
        if (this._client) {
          this._isDebug = this._client.getConfiguration().isDebug;
          this._assetsUrl = this._client.getConfiguration().gatewayConfiguration.assetsUrl;
        } else {
          this._isDebug = Boolean(options.isDebug);
          this._assetsUrl = options.assetsUrl;
        }
        this._assetsUrl = this._assetsUrl + "/web/" + VERSION;
      }
      EventEmitter.createChild(BaseFramework);
      BaseFramework.prototype._waitForClient = function () {
        if (this._client) {
          return Promise.resolve();
        }
        return this._createPromise.then(function (client) {
          this._client = client;
        }.bind(this));
      };
      BaseFramework.prototype.setUpEventListeners = function () {
        throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
      };
      BaseFramework.prototype.verifyCard = function (options, privateOptions) {
        var formattedOptions, error;
        var self = this;
        privateOptions = privateOptions || {};
        error = this._checkForVerifyCardError(options, privateOptions);
        if (error) {
          return Promise.reject(error);
        }
        this._verifyCardInProgress = true;
        formattedOptions = this._formatVerifyCardOptions(options);
        return this._formatLookupData(formattedOptions).then(function (data) {
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.started");
          return self._performLookup(formattedOptions.nonce, data);
        }).then(function (response) {
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.3ds-version." + response.lookup.threeDSecureVersion);
          return self._onLookupComplete(response, formattedOptions);
        }).then(function (response) {
          return self.initializeChallengeWithLookupResponse(response, formattedOptions);
        }).then(function (payload) {
          self._resetVerificationState();
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.completed");
          return payload;
        }).catch(function (err) {
          self._resetVerificationState();
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.failed");
          return Promise.reject(err);
        });
      };
      BaseFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function () {
        throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
      };
      BaseFramework.prototype._presentChallenge = function () {
        throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
      };
      BaseFramework.prototype.prepareLookup = function () {
        throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
      };
      BaseFramework.prototype._resetVerificationState = function () {
        this._verifyCardInProgress = false;
        this._verifyCardPromisePlus = null;
        if (typeof this._reloadThreeDSecure === "function") {
          this._reloadThreeDSecure();
        }
      };
      BaseFramework.prototype._performLookup = function (nonce, data) {
        var self = this;
        var url = "payment_methods/" + nonce + "/three_d_secure/lookup";
        return this._waitForClient().then(function () {
          return self._client.request({
            endpoint: url,
            method: "post",
            data: data
          }).catch(function (err) {
            var status = err && err.details && err.details.httpStatus;
            var analyticsMessage = "three-d-secure.verification-flow.lookup-failed";
            var lookupError;
            if (status === 404) {
              lookupError = errors.THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR;
              analyticsMessage += ".404";
            } else if (status === 422) {
              lookupError = errors.THREEDS_LOOKUP_VALIDATION_ERROR;
              analyticsMessage += ".422";
            } else {
              lookupError = errors.THREEDS_LOOKUP_ERROR;
            }
            analytics.sendEvent(self._createPromise, analyticsMessage);
            return Promise.reject(new BraintreeError({
              type: lookupError.type,
              code: lookupError.code,
              message: lookupError.message,
              details: {
                originalError: err
              }
            }));
          });
        });
      };
      BaseFramework.prototype._existsAndIsNumeric = function (value) {
        /**
         * Returns true if value is numeric and false if value is:
         *  - undefined
         *  - null
         *  - an array
         *  - an empty string
         *  - boolean
         *  - otherwise non-numeric value (e.g. {}, "cows")
         */
        return !(value === undefined ||
        // eslint-disable-line no-undefined
        value === null || Array.isArray(value) || typeof value === "boolean" || typeof value === "string" && value.trim() === "" || isNaN(Number(value)));
      };
      BaseFramework.prototype._checkForVerifyCardError = function (options, privateOptions) {
        var errorOption;
        if (this._verifyCardInProgress === true) {
          return new BraintreeError(errors.THREEDS_AUTHENTICATION_IN_PROGRESS);
        } else if (!options.nonce) {
          errorOption = "a nonce";
        } else if (
        // eslint-disable-next-line no-undefined
        !this._existsAndIsNumeric(options.amount)) {
          errorOption = "an amount";
        }
        if (!errorOption) {
          errorOption = this._checkForFrameworkSpecificVerifyCardErrors(options, privateOptions);
        }
        if (errorOption) {
          return new BraintreeError({
            type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
            code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
            message: "verifyCard options must include " + errorOption + "."
          });
        }
        return null;
      };
      BaseFramework.prototype.initializeChallengeWithLookupResponse = function (lookupResponse, options) {
        var self = this;
        options = options || {};
        this._lookupPaymentMethod = lookupResponse.paymentMethod;

        // sets this in the case that initializeChallengeWithLookupResponse is
        // called as a standalone method from a server side lookup. In a normal
        // verifyCard flow, this promise will already exist
        self._verifyCardPromisePlus = self._verifyCardPromisePlus || new ExtendedPromise();
        self._handleLookupResponse(lookupResponse, options);
        return self._verifyCardPromisePlus.then(function (payload) {
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.liability-shifted." + String(payload.liabilityShifted));
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.liability-shift-possible." + String(payload.liabilityShiftPossible));
          return payload;
        });
      };
      BaseFramework.prototype._handleLookupResponse = function (lookupResponse, options) {
        var challengeShouldBePresented = Boolean(lookupResponse.lookup && lookupResponse.lookup.acsUrl);
        var details;
        analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.challenge-presented." + String(challengeShouldBePresented));
        if (challengeShouldBePresented) {
          this._presentChallenge(lookupResponse, options);
        } else {
          details = this._formatAuthResponse(lookupResponse.paymentMethod, lookupResponse.threeDSecureInfo);
          details.verificationDetails = lookupResponse.threeDSecureInfo;
          this._verifyCardPromisePlus.resolve(details);
        }
      };
      BaseFramework.prototype._onLookupComplete = function (response) {
        this._lookupPaymentMethod = response.paymentMethod;
        this._verifyCardPromisePlus = new ExtendedPromise();
        return Promise.resolve(response);
      };
      BaseFramework.prototype._formatAuthResponse = function (paymentMethod, threeDSecureInfo) {
        return {
          nonce: paymentMethod.nonce,
          type: paymentMethod.type,
          binData: paymentMethod.binData,
          details: paymentMethod.details,
          description: paymentMethod.description && paymentMethod.description.replace(/\+/g, " "),
          liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
          liabilityShiftPossible: threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
          threeDSecureInfo: paymentMethod.threeDSecureInfo
        };
      };
      BaseFramework.prototype._formatVerifyCardOptions = function (options) {
        return assign({}, options);
      };
      BaseFramework.prototype._formatLookupData = function (options) {
        var data = {
          amount: options.amount
        };
        if (options.collectDeviceData === true) {
          data.browserColorDepth = window.screen.colorDepth;
          data.browserJavaEnabled = window.navigator.javaEnabled();
          data.browserJavascriptEnabled = true;
          data.browserLanguage = window.navigator.language;
          data.browserScreenHeight = window.screen.height;
          data.browserScreenWidth = window.screen.width;
          data.browserTimeZone = new Date().getTimezoneOffset();
          data.deviceChannel = "Browser";
        }
        return Promise.resolve(data);
      };
      BaseFramework.prototype._handleV1AuthResponse = function (data) {
        var authResponse = JSON.parse(data.auth_response);
        if (authResponse.success) {
          this._verifyCardPromisePlus.resolve(this._formatAuthResponse(authResponse.paymentMethod, authResponse.threeDSecureInfo));
        } else if (authResponse.threeDSecureInfo && authResponse.threeDSecureInfo.liabilityShiftPossible) {
          this._verifyCardPromisePlus.resolve(this._formatAuthResponse(this._lookupPaymentMethod, authResponse.threeDSecureInfo));
        } else {
          this._verifyCardPromisePlus.reject(new BraintreeError({
            type: BraintreeError.types.UNKNOWN,
            code: "UNKNOWN_AUTH_RESPONSE",
            message: authResponse.error.message
          }));
        }
      };
      BaseFramework.prototype.cancelVerifyCard = function () {
        var response, threeDSecureInfo;
        this._verifyCardInProgress = false;
        if (!this._lookupPaymentMethod) {
          return Promise.reject(new BraintreeError(errors.THREEDS_NO_VERIFICATION_PAYLOAD));
        }
        threeDSecureInfo = this._lookupPaymentMethod.threeDSecureInfo;
        response = assign({}, this._lookupPaymentMethod, {
          liabilityShiftPossible: threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
          liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
          verificationDetails: threeDSecureInfo && threeDSecureInfo.verificationDetails
        });
        return Promise.resolve(response);
      };
      BaseFramework.prototype._setupV1Bus = function (options) {
        var clientConfiguration = this._client.getConfiguration();
        var parentURL = window.location.href.split("#")[0];
        var lookupResponse = options.lookupResponse;
        var channel = uuid();
        var bus = new Bus({
          channel: channel,
          verifyDomain: isVerifiedDomain
        });
        var authenticationCompleteBaseUrl = this._assetsUrl + "/html/three-d-secure-authentication-complete-frame.html?channel=" + encodeURIComponent(channel) + "&";
        bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function (reply) {
          reply({
            clientConfiguration: clientConfiguration,
            nonce: options.nonce,
            acsUrl: lookupResponse.acsUrl,
            pareq: lookupResponse.pareq,
            termUrl: lookupResponse.termUrl + "&three_d_secure_version=" + VERSION + "&authentication_complete_base_url=" + encodeURIComponent(authenticationCompleteBaseUrl),
            md: lookupResponse.md,
            parentUrl: parentURL
          });
        });
        bus.on(events.AUTHENTICATION_COMPLETE, options.handleAuthResponse);
        return bus;
      };
      BaseFramework.prototype._setupV1Iframe = function (options) {
        var url = this._assetsUrl + "/html/three-d-secure-bank-frame" + useMin(this._isDebug) + ".html?showLoader=" + options.showLoader;
        var bankIframe = iFramer({
          src: url,
          height: IFRAME_HEIGHT,
          width: IFRAME_WIDTH,
          name: constants.LANDING_FRAME_NAME + "_" + this._v1Bus.channel,
          title: "3D Secure Authorization Frame"
        });
        return bankIframe;
      };
      BaseFramework.prototype._setupV1Elements = function (options) {
        this._v1Bus = this._setupV1Bus(options);
        this._v1Iframe = this._setupV1Iframe(options);
      };
      BaseFramework.prototype._teardownV1Elements = function () {
        if (this._v1Bus) {
          this._v1Bus.teardown();
          this._v1Bus = null;
        }
        if (this._v1Iframe && this._v1Iframe.parentNode) {
          this._v1Iframe.parentNode.removeChild(this._v1Iframe);
          this._v1Iframe = null;
        }
        if (this._onV1Keyup) {
          document.removeEventListener("keyup", this._onV1Keyup);
          this._onV1Keyup = null;
        }
      };
      BaseFramework.prototype.teardown = function () {
        analytics.sendEvent(this._createPromise, "three-d-secure.teardown-completed");
        this._teardownV1Elements();
        return Promise.resolve();
      };
      module.exports = BaseFramework;
    }, {
      "../../../lib/analytics": 135,
      "../../../lib/assign": 137,
      "../../../lib/braintree-error": 140,
      "../../../lib/constants": 142,
      "../../../lib/is-verified-domain": 170,
      "../../../lib/use-min": 178,
      "../../shared/constants": 217,
      "../../shared/errors": 218,
      "../../shared/events": 219,
      "@braintree/event-emitter": 30,
      "@braintree/extended-promise": 31,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "framebus": 50
    }],
    209: [function (_dereq_, module, exports) {
      "use strict";

      // NEXT_MAJOR_VERSION drop support for Bootstrap framework,
      // recomend using inline frame version and putting it in
      // the merchant's own bootstrap modal
      var SongbirdFramework = _dereq_("./songbird");
      function Bootstrap3ModalFramework(options) {
        SongbirdFramework.call(this, options);
      }
      Bootstrap3ModalFramework.prototype = Object.create(SongbirdFramework.prototype, {
        constructor: SongbirdFramework
      });
      Bootstrap3ModalFramework.prototype._createV1IframeModalElement = function (iframe) {
        var modal = document.createElement("div");
        modal.innerHTML = '<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="CCAFrameModal-label" aria-hidden="true" style="display: block;">' + '<div class="modal-dialog" style="width:440px;z-index:999999;">' + '<div class="modal-content">' + '<div class="modal-body" data-braintree-v1-fallback-iframe-container>' + '<button type="button" data-braintree-v1-fallback-close-button class="close" data-dismiss="modal" aria-hidden="true">×</button>' + "</div>" + "</div>" + "</div>" + '<div data-braintree-v1-fallback-backdrop style="' + "position: fixed;" + "cursor: pointer;" + "z-index: 999998;" + "top: 0;" + "left: 0;" + "width: 100%;" + "height: 100%;" + '"></div>' + "</div>";
        modal.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(iframe);
        return modal;
      };
      Bootstrap3ModalFramework.prototype._createCardinalConfigurationOptions = function (setupOptions) {
        var options = SongbirdFramework.prototype._createCardinalConfigurationOptions.call(this, setupOptions);
        options.payment.framework = "bootstrap3";
        return options;
      };
      module.exports = Bootstrap3ModalFramework;
    }, {
      "./songbird": 214
    }],
    210: [function (_dereq_, module, exports) {
      "use strict";

      var SongbirdFramework = _dereq_("./songbird");
      function CardinalModalFramework(options) {
        SongbirdFramework.call(this, options);
      }
      CardinalModalFramework.prototype = Object.create(SongbirdFramework.prototype, {
        constructor: SongbirdFramework
      });
      CardinalModalFramework.prototype._createV1IframeModalElement = function (iframe) {
        var modal = document.createElement("div");
        var addCloseButton = Boolean(this._createOptions && this._createOptions.cardinalSDKConfig && this._createOptions.cardinalSDKConfig.payment && this._createOptions.cardinalSDKConfig.payment.displayExitButton);
        modal.innerHTML = '<div style="' + "position: fixed;" + "z-index: 999999;" + "top: 50%;" + "left: 50%;" + "padding: 24px 20px;" + "transform: translate(-50%,-50%);" + "border-radius: 2px;" + "background: #fff;" + "max-width: 100%;" + "overflow: auto;" + '">' + "<div>" + "<button data-braintree-v1-fallback-close-button " + 'style="' + "font-family: Helvetica,Arial,sans-serif;" + "font-size: 25px;" + "line-height: 12px;" + "position: absolute;" + "top: 2px;" + "right: 0px;" + "cursor: pointer;" + "color: #999;" + "border: 0;" + "outline: none;" + "background: none;" + '" ' + "onMouseOver=\"this.style.color='#000'\" " + "onMouseOut=\"this.style.color='#999'\"" + ">×</button>" + "</div>" +
        // iframe container
        '<div data-braintree-v1-fallback-iframe-container style="' + "height: 400px;" + '"></div>' + "</div>" +
        // modal backdrop
        '<div data-braintree-v1-fallback-backdrop style="' + "position: fixed;" + "z-index: 999998;" + "cursor: pointer;" + "top: 0;" + "left: 0;" + "width: 100%;" + "height: 100%;" + "transition: opacity 1ms ease;" + "background: rgba(0,0,0,.6);" + '"></div>';
        if (!addCloseButton) {
          modal.querySelector("[data-braintree-v1-fallback-close-button]").style.display = "none";
        }
        modal.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(iframe);
        return modal;
      };
      module.exports = CardinalModalFramework;
    }, {
      "./songbird": 214
    }],
    211: [function (_dereq_, module, exports) {
      "use strict";

      var LegacyFramework = _dereq_("./legacy");
      var CardinalModalFramework = _dereq_("./cardinal-modal");
      var Bootstrap3ModalFramework = _dereq_("./bootstrap3-modal");
      var InlineIframeFramework = _dereq_("./inline-iframe");
      module.exports = {
        legacy: LegacyFramework,
        "cardinal-modal": CardinalModalFramework,
        "bootstrap3-modal": Bootstrap3ModalFramework,
        "inline-iframe": InlineIframeFramework
      };
    }, {
      "./bootstrap3-modal": 209,
      "./cardinal-modal": 210,
      "./inline-iframe": 212,
      "./legacy": 213
    }],
    212: [function (_dereq_, module, exports) {
      "use strict";

      var SongbirdFramework = _dereq_("./songbird");
      var BraintreeError = _dereq_("../../../lib/braintree-error");
      var errors = _dereq_("../../shared/errors");
      var enumerate = _dereq_("../../../lib/enumerate");
      function InlineIframeFramework(options) {
        SongbirdFramework.call(this, options);
      }
      InlineIframeFramework.prototype = Object.create(SongbirdFramework.prototype, {
        constructor: SongbirdFramework
      });
      InlineIframeFramework.events = enumerate(["AUTHENTICATION_IFRAME_AVAILABLE"], "inline-iframe-framework:");
      InlineIframeFramework.prototype.setUpEventListeners = function (reply) {
        SongbirdFramework.prototype.setUpEventListeners.call(this, reply);
        this.on(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, function (payload, next) {
          reply("authentication-iframe-available", payload, next);
        });
      };
      InlineIframeFramework.prototype._createCardinalConfigurationOptions = function (setupOptions) {
        var options = SongbirdFramework.prototype._createCardinalConfigurationOptions.call(this, setupOptions);
        options.payment.framework = "inline";
        return options;
      };
      InlineIframeFramework.prototype._addV1IframeToPage = function () {
        this._emit(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, {
          element: this._v1Modal
        }, function () {
          // NOOP
        });
      };
      InlineIframeFramework.prototype._setupFrameworkSpecificListeners = function () {
        this.setCardinalListener("ui.inline.setup", this._onInlineSetup.bind(this));
      };
      InlineIframeFramework.prototype._onInlineSetup = function (htmlTemplate, details, resolve, reject) {
        var container, hasError;
        if (!htmlTemplate || !details) {
          hasError = true;
        } else if (details.paymentType !== "CCA") {
          hasError = true;
        } else if (!(details.data.mode === "suppress" || details.data.mode === "static")) {
          hasError = true;
        }
        if (hasError) {
          reject(new BraintreeError(errors.THREEDS_INLINE_IFRAME_DETAILS_INCORRECT));
          return;
        }
        container = document.createElement("div");
        container.innerHTML = htmlTemplate;
        if (details.data.mode === "suppress") {
          container.style.display = "none";
          document.body.appendChild(container);
          resolve();
        } else if (details.data.mode === "static") {
          this._emit(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, {
            element: container
          }, function () {
            resolve();
          });
        }
      };
      module.exports = InlineIframeFramework;
    }, {
      "../../../lib/braintree-error": 140,
      "../../../lib/enumerate": 150,
      "../../shared/errors": 218,
      "./songbird": 214
    }],
    213: [function (_dereq_, module, exports) {
      "use strict";

      var BaseFramework = _dereq_("./base");
      var deferred = _dereq_("../../../lib/deferred");
      function LegacyFramework(options) {
        BaseFramework.call(this, options);
      }
      LegacyFramework.prototype = Object.create(BaseFramework.prototype, {
        constructor: LegacyFramework
      });
      LegacyFramework.prototype.setUpEventListeners = function () {
        // noop
      };
      LegacyFramework.prototype.transformV1CustomerBillingAddress = function (customer) {
        customer.billingAddress.line1 = customer.billingAddress.streetAddress;
        customer.billingAddress.line2 = customer.billingAddress.extendedAddress;
        customer.billingAddress.city = customer.billingAddress.locality;
        customer.billingAddress.state = customer.billingAddress.region;
        customer.billingAddress.countryCode = customer.billingAddress.countryCodeAlpha2;
        delete customer.billingAddress.streetAddress;
        delete customer.billingAddress.extendedAddress;
        delete customer.billingAddress.locality;
        delete customer.billingAddress.region;
        delete customer.billingAddress.countryCodeAlpha2;
        return customer;
      };
      LegacyFramework.prototype._createIframe = function (options) {
        var self = this;
        this._setupV1Elements({
          nonce: options.nonce,
          lookupResponse: options.lookupResponse,
          showLoader: options.showLoader,
          handleAuthResponse: function (data) {
            self._handleAuthResponse(data, options);
          }
        });
        return this._v1Iframe;
      };
      LegacyFramework.prototype._handleAuthResponse = function (data, options) {
        this._v1Bus.teardown();
        options.removeFrame();

        // This also has to be in a setTimeout so it executes after the `removeFrame`.
        deferred(function () {
          this._handleV1AuthResponse(data);
        }.bind(this))();
      };
      LegacyFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function (options) {
        var errorOption;
        if (typeof options.addFrame !== "function") {
          errorOption = "an addFrame function";
        } else if (typeof options.removeFrame !== "function") {
          errorOption = "a removeFrame function";
        }
        return errorOption;
      };
      LegacyFramework.prototype._formatVerifyCardOptions = function (options) {
        var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(this, options);
        modifiedOptions.addFrame = deferred(options.addFrame);
        modifiedOptions.removeFrame = deferred(options.removeFrame);
        modifiedOptions.showLoader = options.showLoader !== false;
        return modifiedOptions;
      };
      LegacyFramework.prototype._formatLookupData = function (options) {
        var self = this;
        return BaseFramework.prototype._formatLookupData.call(this, options).then(function (data) {
          if (options.customer && options.customer.billingAddress) {
            data.customer = self.transformV1CustomerBillingAddress(options.customer);
          }
          return data;
        });
      };
      LegacyFramework.prototype._presentChallenge = function (lookupResponse, options) {
        options.addFrame(null, this._createIframe({
          showLoader: options.showLoader,
          lookupResponse: lookupResponse.lookup,
          nonce: lookupResponse.paymentMethod.nonce,
          removeFrame: options.removeFrame
        }));
      };
      module.exports = LegacyFramework;
    }, {
      "../../../lib/deferred": 148,
      "./base": 208
    }],
    214: [function (_dereq_, module, exports) {
      "use strict";

      var BaseFramework = _dereq_("./base");
      var assign = _dereq_("../../../lib/assign").assign;
      var deferred = _dereq_("../../../lib/deferred");
      var BraintreeError = _dereq_("../../../lib/braintree-error");
      var convertToBraintreeError = _dereq_("../../../lib/convert-to-braintree-error");
      var analytics = _dereq_("../../../lib/analytics");
      var assets = _dereq_("../../../lib/assets");
      var errors = _dereq_("../../shared/errors");
      var enumerate = _dereq_("../../../lib/enumerate");
      var constants = _dereq_("../../shared/constants");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var INTEGRATION_TIMEOUT_MS = _dereq_("../../../lib/constants").INTEGRATION_TIMEOUT_MS;
      var PLATFORM = _dereq_("../../../lib/constants").PLATFORM;
      var VERSION = "3.115.2";
      var CUSTOMER_CANCELED_SONGBIRD_MODAL = "01";
      var SONGBIRD_UI_EVENTS = ["ui.close", "ui.render",
      // TODO these events are not documented in the
      // client reference because so far we have
      // not been able to trigger them in our testing
      "ui.renderHidden", "ui.loading.close", "ui.loading.render"];
      var SCA_EXEMPTION_TYPES = ["low_value", "transaction_risk_analysis"];
      ExtendedPromise.suppressUnhandledPromiseMessage = true;
      function SongbirdFramework(options) {
        BaseFramework.call(this, options);
        this._songbirdInitFailed = false;
        this._clientMetadata = {
          requestedThreeDSecureVersion: "2",
          sdkVersion: PLATFORM + "/" + VERSION
        };
        this.originalSetupOptions = options;
        this._getDfReferenceIdPromisePlus = new ExtendedPromise();
        this.setupSongbird(options);
        this._cardinalEvents = [];
      }
      SongbirdFramework.prototype = Object.create(BaseFramework.prototype, {
        constructor: SongbirdFramework
      });
      SongbirdFramework.events = enumerate(["LOOKUP_COMPLETE", "CUSTOMER_CANCELED", "UI.CLOSE", "UI.RENDER", "UI.RENDERHIDDEN", "UI.LOADING.CLOSE", "UI.LOADING.RENDER"], "songbird-framework:");
      SongbirdFramework.prototype.setUpEventListeners = function (reply) {
        this.on(SongbirdFramework.events.LOOKUP_COMPLETE, function (data, next) {
          reply("lookup-complete", data, next);
        });
        this.on(SongbirdFramework.events.CUSTOMER_CANCELED, function () {
          reply("customer-canceled");
        });
        this.on(SongbirdFramework.events["UI.CLOSE"], function () {
          reply("authentication-modal-close");
        });
        this.on(SongbirdFramework.events["UI.RENDER"], function () {
          reply("authentication-modal-render");
        });
        this.on(SongbirdFramework.events["UI.RENDERHIDDEN"], function () {
          reply("authentication-modal-render-hidden");
        });
        this.on(SongbirdFramework.events["UI.LOADING.CLOSE"], function () {
          reply("authentication-modal-loader-close");
        });
        this.on(SongbirdFramework.events["UI.LOADING.RENDER"], function () {
          reply("authentication-modal-loader-render");
        });
      };
      SongbirdFramework.prototype.prepareLookup = function (options) {
        var data = assign({}, options);
        var self = this;
        return this.getDfReferenceId().then(function (id) {
          data.dfReferenceId = id;
        }).then(function () {
          return self._triggerCardinalBinProcess(options.bin);
        }).catch(function () {
          // catch and ignore errors from looking up
          // df reference and Cardinal bin process
        }).then(function () {
          return self._waitForClient();
        }).then(function () {
          data.clientMetadata = self._clientMetadata;
          data.authorizationFingerprint = self._client.getConfiguration().authorizationFingerprint;
          data.braintreeLibraryVersion = "braintree/web/" + VERSION;
          return data;
        });
      };
      SongbirdFramework.prototype.initializeChallengeWithLookupResponse = function (lookupResponse, options) {
        return this.setupSongbird().then(function () {
          return BaseFramework.prototype.initializeChallengeWithLookupResponse.call(this, lookupResponse, options);
        }.bind(this));
      };
      SongbirdFramework.prototype.handleSongbirdError = function (errorType) {
        this._songbirdInitFailed = true;
        this._removeSongbirdListeners();
        analytics.sendEvent(this._createPromise, "three-d-secure.cardinal-sdk.songbird-error." + errorType);
        if (this._songbirdPromise) {
          this._songbirdPromise.resolve();
        }
      };
      SongbirdFramework.prototype._triggerCardinalBinProcess = function (bin) {
        var self = this;
        var issuerStartTime = Date.now();
        return window.Cardinal.trigger("bin.process", bin).then(function (binResults) {
          self._clientMetadata.issuerDeviceDataCollectionTimeElapsed = Date.now() - issuerStartTime;
          self._clientMetadata.issuerDeviceDataCollectionResult = binResults && binResults.Status;
        });
      };
      SongbirdFramework.prototype.transformBillingAddress = function (additionalInformation, billingAddress) {
        if (billingAddress) {
          // map from public API to the API that the Gateway expects
          extractAddressData(billingAddress, additionalInformation, "billing");
          additionalInformation.billingPhoneNumber = billingAddress.phoneNumber;
          additionalInformation.billingGivenName = billingAddress.givenName;
          additionalInformation.billingSurname = billingAddress.surname;
        }
        return additionalInformation;
      };
      SongbirdFramework.prototype.transformShippingAddress = function (additionalInformation) {
        var shippingAddress = additionalInformation.shippingAddress;
        if (shippingAddress) {
          // map from public API to the API that the Gateway expects
          extractAddressData(shippingAddress, additionalInformation, "shipping");
          delete additionalInformation.shippingAddress;
        }
        return additionalInformation;
      };
      SongbirdFramework.prototype._createV1IframeModalElement = function (iframe) {
        var modal = document.createElement("div");
        modal.innerHTML = '<div data-braintree-v1-fallback-iframe-container="true" style="' + "height: 400px;" + '"></div>';
        modal.querySelector('[data-braintree-v1-fallback-iframe-container="true"]').appendChild(iframe);
        return modal;
      };
      SongbirdFramework.prototype._createV1IframeModal = function (iframe) {
        var modal = this._createV1IframeModalElement(iframe);
        var btn = modal.querySelector("[data-braintree-v1-fallback-close-button]");
        var backdrop = modal.querySelector("[data-braintree-v1-fallback-backdrop]");
        var self = this;
        function closeHandler() {
          modal.parentNode.removeChild(modal);
          self.cancelVerifyCard(errors.THREEDS_CARDINAL_SDK_CANCELED);
          document.removeEventListener("keyup", self._onV1Keyup);
          self._onV1Keyup = null;
        }
        this._onV1Keyup = function (e) {
          if (e.key !== "Escape") {
            return;
          }
          if (!modal.parentNode) {
            // modal not on page
            return;
          }
          closeHandler();
        };
        if (btn) {
          btn.addEventListener("click", closeHandler);
        }
        if (backdrop) {
          backdrop.addEventListener("click", closeHandler);
        }
        document.addEventListener("keyup", this._onV1Keyup);
        return modal;
      };
      SongbirdFramework.prototype._addV1IframeToPage = function () {
        document.body.appendChild(this._v1Modal);
      };
      SongbirdFramework.prototype.setupSongbird = function (setupOptions) {
        var self = this;
        var startTime = Date.now();
        if (this._songbirdPromise) {
          return this._songbirdPromise;
        }
        setupOptions = setupOptions || {};
        this._songbirdPromise = new ExtendedPromise();
        this._v2SetupFailureReason = "reason-unknown";
        self._loadCardinalScript(setupOptions).then(function () {
          if (!window.Cardinal) {
            self._v2SetupFailureReason = "cardinal-global-unavailable";
            return Promise.reject(new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_FAILED));
          }
          return self._configureCardinalSdk({
            setupOptions: setupOptions,
            setupStartTime: startTime
          });
        }).catch(function (err) {
          var error = convertToBraintreeError(err, {
            type: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,
            code: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,
            message: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.message
          });
          self._getDfReferenceIdPromisePlus.reject(error);
          window.clearTimeout(self._songbirdSetupTimeoutReference);
          analytics.sendEvent(self._client, "three-d-secure.cardinal-sdk.init.setup-failed");
          self.handleSongbirdError("cardinal-sdk-setup-failed." + self._v2SetupFailureReason);
        });
        return this._songbirdPromise;
      };
      SongbirdFramework.prototype._configureCardinalSdk = function (config) {
        var self = this;
        return this._waitForClient().then(function () {
          var threeDSConfig = self._client.getConfiguration().gatewayConfiguration.threeDSecure;
          return threeDSConfig;
        }).then(function (threeDSConfig) {
          var jwt = threeDSConfig.cardinalAuthenticationJWT;
          var setupOptions = config.setupOptions;
          var setupStartTime = config.setupStartTime;
          var cardinalConfiguration = self._createCardinalConfigurationOptions(setupOptions);
          SONGBIRD_UI_EVENTS.forEach(function (eventName) {
            self.setCardinalListener(eventName, function () {
              self._emit(SongbirdFramework.events[eventName.toUpperCase()]);
            });
          });
          self.setCardinalListener("payments.setupComplete", self._createPaymentsSetupCompleteCallback());
          self._setupFrameworkSpecificListeners();
          window.Cardinal.configure(cardinalConfiguration);
          window.Cardinal.setup("init", {
            jwt: jwt
          });
          self._clientMetadata.cardinalDeviceDataCollectionTimeElapsed = Date.now() - setupStartTime;
          self.setCardinalListener("payments.validated", self._createPaymentsValidatedCallback());
        }).catch(function (err) {
          self._v2SetupFailureReason = "cardinal-configuration-threw-error";
          return Promise.reject(err);
        });
      };
      SongbirdFramework.prototype.setCardinalListener = function (eventName, cb) {
        this._cardinalEvents.push(eventName);
        window.Cardinal.on(eventName, cb);
      };
      SongbirdFramework.prototype._setupFrameworkSpecificListeners = function () {
        // noop
      };
      SongbirdFramework.prototype._createCardinalConfigurationOptions = function (setupOptions) {
        var cardinalConfiguration = setupOptions.cardinalSDKConfig || {};
        var paymentSettings = cardinalConfiguration.payment || {};
        if (!cardinalConfiguration.logging && setupOptions.loggingEnabled) {
          cardinalConfiguration.logging = {
            level: "verbose"
          };
        }
        cardinalConfiguration.payment = {};
        if (paymentSettings.hasOwnProperty("displayLoading")) {
          cardinalConfiguration.payment.displayLoading = paymentSettings.displayLoading;
        }
        if (paymentSettings.hasOwnProperty("displayExitButton")) {
          cardinalConfiguration.payment.displayExitButton = paymentSettings.displayExitButton;
        }
        return cardinalConfiguration;
      };
      SongbirdFramework.prototype._loadCardinalScript = function (setupOptions) {
        var self = this;
        return this._waitForClient().then(function () {
          var scriptSource = self._getCardinalScriptSource();
          self._songbirdSetupTimeoutReference = window.setTimeout(function () {
            analytics.sendEvent(self._client, "three-d-secure.cardinal-sdk.init.setup-timeout");
            self.handleSongbirdError("cardinal-sdk-setup-timeout");
          }, setupOptions.timeout || INTEGRATION_TIMEOUT_MS);
          return assets.loadScript({
            src: scriptSource
          });
        }).catch(function (err) {
          self._v2SetupFailureReason = "songbird-js-failed-to-load";
          return Promise.reject(convertToBraintreeError(err, errors.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED));
        });
      };
      SongbirdFramework.prototype._getCardinalScriptSource = function () {
        var gatewayConfig = this._client.getConfiguration().gatewayConfiguration;
        if (gatewayConfig && gatewayConfig.environment === "production") {
          return constants.CARDINAL_SCRIPT_SOURCE.production;
        }
        return constants.CARDINAL_SCRIPT_SOURCE.sandbox;
      };
      SongbirdFramework.prototype._createPaymentsSetupCompleteCallback = function () {
        var self = this;
        return function (data) {
          self._getDfReferenceIdPromisePlus.resolve(data.sessionId);
          window.clearTimeout(self._songbirdSetupTimeoutReference);
          analytics.sendEvent(self._createPromise, "three-d-secure.cardinal-sdk.init.setup-completed");
          self._songbirdPromise.resolve();
        };
      };
      SongbirdFramework.prototype.getDfReferenceId = function () {
        return this._getDfReferenceIdPromisePlus;
      };
      SongbirdFramework.prototype._performJWTValidation = function (rawCardinalSDKVerificationData, jwt) {
        var self = this;
        var nonce = this._lookupPaymentMethod.nonce;
        var url = "payment_methods/" + nonce + "/three_d_secure/authenticate_from_jwt";
        var cancelCode = rawCardinalSDKVerificationData && rawCardinalSDKVerificationData.Payment && rawCardinalSDKVerificationData.Payment.ExtendedData && rawCardinalSDKVerificationData.Payment.ExtendedData.ChallengeCancel;
        if (cancelCode) {
          // see ChallengeCancel docs here for different values:
          // https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects
          analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.cardinal-sdk.cancel-code." + cancelCode);
          if (cancelCode === CUSTOMER_CANCELED_SONGBIRD_MODAL) {
            this._emit(SongbirdFramework.events.CUSTOMER_CANCELED);
          }
        }
        analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.upgrade-payment-method.started");
        return this._waitForClient().then(function () {
          return self._client.request({
            method: "post",
            endpoint: url,
            data: {
              jwt: jwt,
              paymentMethodNonce: nonce
            }
          });
        }).then(function (response) {
          var paymentMethod = response.paymentMethod || self._lookupPaymentMethod;
          var formattedResponse = self._formatAuthResponse(paymentMethod, response.threeDSecureInfo);
          formattedResponse.rawCardinalSDKVerificationData = rawCardinalSDKVerificationData;
          analytics.sendEvent(self._client, "three-d-secure.verification-flow.upgrade-payment-method.succeeded");
          return Promise.resolve(formattedResponse);
        }).catch(function (err) {
          var error = new BraintreeError({
            type: errors.THREEDS_JWT_AUTHENTICATION_FAILED.type,
            code: errors.THREEDS_JWT_AUTHENTICATION_FAILED.code,
            message: errors.THREEDS_JWT_AUTHENTICATION_FAILED.message,
            details: {
              originalError: err
            }
          });
          analytics.sendEvent(self._client, "three-d-secure.verification-flow.upgrade-payment-method.errored");
          return Promise.reject(error);
        });
      };
      SongbirdFramework.prototype._createPaymentsValidatedCallback = function () {
        var self = this;

        /**
         * @param {object} data Response Data
         * @see {@link https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects#ResponseObjects-ObjectDefinition}
         * @param {string} data.ActionCode The resulting state of the transaction.
         * @param {boolean} data.Validated Represents whether transaction was successfully or not.
         * @param {object} data.Payment Represents additional information about the verification.
         * @param {number} data.ErrorNumber A non-zero value represents the error encountered while attempting the process the message request.
         * @param {string} data.ErrorDescription Application error description for the associated error number.
         * @param {string} validatedJwt Response JWT
         * @returns {void}
         * */
        return function (data, validatedJwt) {
          var formattedError;
          analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.cardinal-sdk.action-code." + data.ActionCode.toLowerCase());
          if (!self._verifyCardPromisePlus) {
            self.handleSongbirdError("cardinal-sdk-setup-error.number-" + data.ErrorNumber);
            return;
          }
          switch (data.ActionCode) {
            // Handle these scenarios based on liability shift information in the response.
            case "SUCCESS":
            case "NOACTION":
            case "FAILURE":
              self._performJWTValidation(data, validatedJwt).then(function (result) {
                self._verifyCardPromisePlus.resolve(result);
              }).catch(function (err) {
                self._verifyCardPromisePlus.reject(err);
              });
              break;
            case "ERROR":
              analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.cardinal-sdk-error." + data.ErrorNumber);
              switch (data.ErrorNumber) {
                case 10001: // Cardinal Docs: Timeout when sending an /Init message
                case 10002:
                  // Cardinal Docs: Timeout when sending an /Start message
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT);
                  break;
                case 10003: // Cardinal Docs: Timeout when sending an /Validate message. Although this code exists we do not yet have a flow where a validate message is sent to Midas. This error should not yet be triggered
                case 10007: // Cardinal Docs: Timeout when sending an /Confirm message
                case 10009:
                  // Cardinal Docs: Timeout when sending an /Continue message
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT);
                  break;
                case 10005: // Cardinal Docs: Songbird was started without a request jwt.
                case 10006:
                  // Cardinal Docs: This is a general configuration error. The description is populated by the specific configuration error that caused the error.
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_CONFIG);
                  break;
                case 10008: // Cardinal Docs: Songbird was initialized without a merchant JWT.
                case 10010:
                  // Cardinal Docs: The response JWT was
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_JWT);
                  break;
                case 10011:
                  // This may never get called, according to the Cardinal docs:
                  // The user has canceled the transaction. This is generally found in alternative
                  // payments that supply a cancel button on the payment brand side.
                  analytics.sendEvent(self._createPromise, "three-d-secure.verification-flow.canceled");
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_CANCELED);
                  break;
                default:
                  formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_ERROR);
              }
              formattedError.details = {
                originalError: {
                  code: data.ErrorNumber,
                  description: data.ErrorDescription
                }
              };
              self._verifyCardPromisePlus.reject(formattedError);
              break;
            default:
          }
        };
      };
      SongbirdFramework.prototype._checkForVerifyCardError = function (options, privateOptions) {
        if (!options.bin) {
          return new BraintreeError({
            type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
            code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
            message: "verifyCard options must include a BIN."
          });
        }
        return BaseFramework.prototype._checkForVerifyCardError.call(this, options, privateOptions);
      };
      SongbirdFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function (options, privateOptions) {
        var errorOption;
        if (typeof options.onLookupComplete !== "function" && !privateOptions.ignoreOnLookupCompleteRequirement) {
          errorOption = "an onLookupComplete function";
        }
        return errorOption;
      };
      SongbirdFramework.prototype._formatVerifyCardOptions = function (options) {
        var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(this, options);
        var additionalInformation = modifiedOptions.additionalInformation || {};
        additionalInformation = this.transformBillingAddress(additionalInformation, options.billingAddress);
        additionalInformation = this.transformShippingAddress(additionalInformation);
        if (options.onLookupComplete) {
          modifiedOptions.onLookupComplete = deferred(options.onLookupComplete);
        }
        if (options.email) {
          additionalInformation.email = options.email;
        }
        if (options.mobilePhoneNumber) {
          additionalInformation.mobilePhoneNumber = options.mobilePhoneNumber;
        }
        modifiedOptions.additionalInformation = additionalInformation;
        return modifiedOptions;
      };
      SongbirdFramework.prototype._onLookupComplete = function (lookupResponse, options) {
        var self = this;
        return BaseFramework.prototype._onLookupComplete.call(this, lookupResponse).then(function (response) {
          return new Promise(function (resolve, reject) {
            response.requiresUserAuthentication = Boolean(response.lookup && response.lookup.acsUrl);
            function next() {
              resolve(response);
            }
            self._verifyCardPromisePlus.catch(reject);

            // If both event and callback are mistakenly used together,
            // prefer the callback when it is passed into the verifyCard options
            if (options.onLookupComplete) {
              options.onLookupComplete(response, next);
            } else {
              self._emit(SongbirdFramework.events.LOOKUP_COMPLETE, response, next);
            }
          });
        });
      };
      SongbirdFramework.prototype._presentChallenge = function (lookupResponse) {
        // transactionId is required for the Songbird flow, so if it
        // does not exist, we just return
        if (this._songbirdInitFailed || !lookupResponse.lookup.transactionId) {
          return;
        }

        // set up listener for ref id to call out to bt before calling verify callback
        window.Cardinal.continue("cca", {
          AcsUrl: lookupResponse.lookup.acsUrl,
          Payload: lookupResponse.lookup.pareq
        }, {
          OrderDetails: {
            TransactionId: lookupResponse.lookup.transactionId
          }
        });
      };
      SongbirdFramework.prototype._formatLookupData = function (options) {
        var self = this;
        return BaseFramework.prototype._formatLookupData.call(this, options).then(function (data) {
          data.additionalInfo = options.additionalInformation;
          if (options.accountType) {
            data.accountType = options.accountType;
          }
          if (options.challengeRequested) {
            data.challengeRequested = options.challengeRequested;
          }
          if (options.requestedExemptionType) {
            if (!SCA_EXEMPTION_TYPES.includes(options.requestedExemptionType)) {
              throw new BraintreeError({
                code: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.code,
                type: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.type,
                message: "requestedExemptionType `" + options.requestedExemptionType + "` is not a valid exemption. The accepted values are: `" + SCA_EXEMPTION_TYPES.join("`, `") + "`"
              });
            }
            data.requestedExemptionType = options.requestedExemptionType;
          }
          if (options.customFields) {
            data.customFields = options.customFields;
          }
          if (options.dataOnlyRequested) {
            data.dataOnlyRequested = options.dataOnlyRequested;
          }
          if (options.exemptionRequested) {
            data.exemptionRequested = options.exemptionRequested;
          }
          if (options.requestVisaDAF) {
            data.requestVisaDAF = options.requestVisaDAF;
          }
          if (options.bin) {
            data.bin = options.bin;
          }
          // NEXT_MAJOR_VERSION remove cardAdd in favor of cardAddChallengeRequested
          if (options.cardAdd != null) {
            data.cardAdd = options.cardAdd;
          }
          if (options.cardAddChallengeRequested != null) {
            data.cardAdd = options.cardAddChallengeRequested;
          }
          if (options.merchantName) {
            data.merchantName = options.merchantName;
          }
          return self.prepareLookup(data);
        });
      };
      SongbirdFramework.prototype.cancelVerifyCard = function (verifyCardError) {
        var self = this;
        return BaseFramework.prototype.cancelVerifyCard.call(this).then(function (response) {
          if (self._verifyCardPromisePlus) {
            verifyCardError = verifyCardError || new BraintreeError(errors.THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT);
            self._verifyCardPromisePlus.reject(verifyCardError);
          }
          return response;
        });
      };
      SongbirdFramework.prototype._removeSongbirdListeners = function () {
        this._cardinalEvents.forEach(function (eventName) {
          window.Cardinal.off(eventName);
        });
        this._cardinalEvents = [];
      };
      SongbirdFramework.prototype.teardown = function () {
        if (window.Cardinal) {
          this._removeSongbirdListeners();
        }

        // we intentionally do not remove the Cardinal SDK
        // from the page when tearing down. Subsequent
        // component creations will be faster because
        // the asset is already on the page

        return BaseFramework.prototype.teardown.call(this);
      };
      SongbirdFramework.prototype._reloadThreeDSecure = function () {
        var self = this;
        var startTime = Date.now();
        return self.teardown().then(function () {
          self._configureCardinalSdk({
            setupOptions: self.originalSetupOptions,
            setupStartTime: startTime
          });
        });
      };
      function extractAddressData(source, target, prefix) {
        target[prefix + "Line1"] = source.streetAddress;
        target[prefix + "Line2"] = source.extendedAddress;
        target[prefix + "Line3"] = source.line3;
        target[prefix + "City"] = source.locality;
        target[prefix + "State"] = source.region;
        target[prefix + "PostalCode"] = source.postalCode;
        target[prefix + "CountryCode"] = source.countryCodeAlpha2;
      }
      module.exports = SongbirdFramework;
    }, {
      "../../../lib/analytics": 135,
      "../../../lib/assets": 136,
      "../../../lib/assign": 137,
      "../../../lib/braintree-error": 140,
      "../../../lib/constants": 142,
      "../../../lib/convert-to-braintree-error": 144,
      "../../../lib/deferred": 148,
      "../../../lib/enumerate": 150,
      "../../shared/constants": 217,
      "../../shared/errors": 218,
      "./base": 208,
      "@braintree/extended-promise": 31
    }],
    215: [function (_dereq_, module, exports) {
      "use strict";

      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var methods = _dereq_("../../lib/methods");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var EventEmitter = _dereq_("@braintree/event-emitter");
      var FRAMEWORKS = _dereq_("./frameworks");

      /**
       * @deprecated
       * @callback ThreeDSecure~addFrameCallback
       * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
       * @param {HTMLIFrameElement} iframe An iframe element containing the bank's authentication page that you must put on your page.
       * @description **Deprecated** The callback used for options.addFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
       * @returns {void}
       */

      /**
       * @deprecated
       * @callback ThreeDSecure~removeFrameCallback
       * @description **Deprecated** The callback used for options.removeFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
       * @returns {void}
       */

      /**
       * @deprecated
       * @typedef {object} ThreeDSecure~verifyCardCustomerObject
       * @property {string} [customer.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters.
       * @property {string} [customer.email] The email used for verification.
       * @property {string} [customer.shippingMethod] The 2-digit string indicating the shipping method chosen for the transaction.
       * @property {string} [customer.billingAddress.firstName] The first name associated with the address.
       * @property {string} [customer.billingAddress.lastName] The last name associated with the address.
       * @property {string} [customer.billingAddress.streetAddress] Line 1 of the Address (eg. number, street, etc).
       * @property {string} [customer.billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.).
       * @property {string} [customer.billingAddress.locality] The locality (city) name associated with the address.
       * @property {string} [customer.billingAddress.region] The 2 letter code for US states or an ISO-3166-2 country subdivision code of up to three letters.
       * @property {string} [customer.billingAddress.postalCode] The zip code or equivalent for countries that have them.
       * @property {string} [customer.billingAddress.countryCodeAlpha2] The 2 character country code.
       * @property {string} [customer.billingAddress.phoneNumber] The phone number associated with the address. Only numbers; remove dashes, parenthesis and other characters.
       * @description **Deprecated** Optional customer information to be passed to 3DS 1.0 for verification.
       */

      /**
       * @typedef {object} ThreeDSecure~verifyPayload
       * @property {string} nonce The new payment method nonce produced by the 3D Secure lookup. The original nonce passed into {@link ThreeDSecure#verifyCard|verifyCard} was consumed. This new nonce should be used to transact on your server.
       * @property {string} type The payment method type.
       * @property {object} details Additional account details.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {string} description A human-readable description.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       * @property {boolean} liabilityShiftPossible *Deprecated:* Use `threeDSecureInfo.liabilityShiftPossible` instead.
       * @property {boolean} liabilityShifted *Deprecated:* Use `threeDSecureInfo.liabilityShifted` instead.
       * @property {object} threeDSecureInfo 3DS information about the card. Note: This information should be verified on the server by using the [payment method nonce find method](https://developer.paypal.com/braintree/docs/reference/request/payment-method-nonce/find). The values provided here are merely for convenience. Only values looked up on the server should determine the logic about how to process a transaction.
       * @property {string} threeDSecureInfo.acsTransactionId The transaction identifier from the issuing bank.
       * @property {string} threeDSecureInfo.cavv Cardholder authentication verification value or CAVV. The main encrypted message issuers and card networks use to verify authentication has occurred. Mastercard uses an AVV message and American Express uses an AEVV message, each of which should also be passed in the cavv parameter.
       * @property {string} threeDSecureInfo.dsTransactionId Transaction identifier resulting from 3D Secure 2 authentication.
       * @property {string} threeDSecureInfo.eciFlag The value of the electronic commerce indicator (ECI) flag, which indicates the outcome of the 3DS authentication. This will be a two-digit value.
       * @property {string} threeDSecureInfo.enrolled Indicates the status of 3D Secure authentication eligibility with the card issuer.
       * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
       * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether liability shift is still possible on a retry.
       * @property {string} threeDSecureInfo.paresStatus Transaction status result identifier.
       * @property {string} threeDSecureInfo.status Indicates the outcome of the 3D Secure event.
       * @property {string} threeDSecureInfo.threeDSecureAuthenticationId ID of the 3D Secure authentication performed for this transaction. Do not provide this field as a transaction sale parameter if you are using the returned payment method nonce from the payload.
       * @property {string} threeDSecureInfo.threeDSecureServerTransactionId Transaction identifier provided by the issuing bank who recieved the 3D Secure event.
       * @property {string} threeDSecureInfo.threeDSecureVersion The version of 3D Secure authentication used for the transaction.
       * @property {string} threeDSecureInfo.xid Transaction identifier resulting from 3D Secure authentication. Uniquely identifies the transaction and sometimes required in the authorization message. This is a base64-encoded value. This field will no longer be used in 3D Secure 2 authentications for Visa and Mastercard, however it will be supported by American Express.
       * @property {string} threeDSecureInfo.lookup.transStatus Error code returned from the 3D Secure MPI provider.
       * @property {string} threeDSecureInfo.lookup.transStatusReason Description correlating to the transStatus error code.
       * @property {string} threeDSecureInfo.authentication.transStatus Error code returned from the 3D Secure MPI provider.
       * @property {string} threeDSecureInfo.authentication.transStatusReason Description correlating to the transStatus error code.
       * @property {object} rawCardinalSDKVerificationData The response back from the Cardinal SDK after verification has completed. See [Cardinal's Documentation](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects) for more information. If the customer was not required to do a 3D Secure challenge, this object will not be available.
       */

      /**
       * @typedef {string} ThreeDSecure~prepareLookupPayload The client data to pass on when doing a server side lookup call.
       */

      /**
       * @typedef {object} ThreeDSecure~verificationData
       * @property {boolean} requiresUserAuthentication When `true`, the user will be presented with a 3D Secure challenge when calling `next` in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete` event}.
       * @property {object} threeDSecureInfo Contains liability shift details.
       * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether the card was eligible for 3D Secure.
       * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
       * @property {object} paymentMethod A {@link ThreeDSecure~verifyPayload|verifyPayload} object.
       * @property {object} lookup Details about the 3D Secure lookup.
       * @property {string} lookup.threeDSecureVersion The version of 3D Secure that will be used for the 3D Secure challenge.
       */

      /**
       * @typedef {object} ThreeDSecure~billingAddress
       * @property {string} [givenName] The first name associated with the billing address. (maximum length 50, ASCII characters)
       * @property {string} [surname] The last name associated with the billing address. (maximum length 50, ASCII characters)
       * @property {string} [phoneNumber] The phone number associated with the billing address. Only numbers; remove dashes, parenthesis and other characters.
       * @property {string} [streetAddress] Line 1 of the billing address (eg. number, street, etc). (maximum length 50)
       * @property {string} [extendedAddress] Line 2 of the billing address (eg. suite, apt #, etc.). (maximum length 50)
       * @property {string} [line3] Line 3 of the billing address if needed (eg. suite, apt #, etc). (maximum length 50)
       * @property {string} [locality] The locality (city) name associated with the billing address.
       * @property {string} [region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
       * @property {string} [postalCode] The zip code or equivalent for countries that have them.
       * @property {string} [countryCodeAlpha2] The 2 character country code.
       */

      /**
       * @typedef {object} ThreeDSecure~additionalInformation
       * @property {string} [workPhoneNumber] The work phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
       * @property {string} [shippingGivenName] The first name associated with the shipping address. (maximum length 50, ASCII characters)
       * @property {string} [shippingSurname] The last name associated with the shipping address. (maximum length 50, ASCII characters)
       * @property {object} [shippingAddress]
       * @property {string} [shippingAddress.streetAddress] Line 1 of the shipping address (eg. number, street, etc). (maximum length 50)
       * @property {string} [shippingAddress.extendedAddress] Line 2 of the shipping address (eg. suite, apt #, etc.). (maximum length 50)
       * @property {string} [shippingAddress.line3] Line 3 of the shipping address if needed (eg. suite, apt #, etc). (maximum length 50)
       * @property {string} [shippingAddress.locality] The locality (city) name associated with the shipping address. (maximum length 50)
       * @property {string} [shippingAddress.region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
       * @property {string} [shippingAddress.postalCode] The zip code or equivalent for countries that have them. (maximum length 10)
       * @property {string} [shippingAddress.countryCodeAlpha2] The 2 character country code. (maximum length 2)
       * @property {string} [shippingPhone] The phone number associated with the shipping address. Only numbers; remove dashes, parenthesis and other characters. (maximum length 20)
       * @property {string} [shippingMethod] The 2-digit string indicating the name of the shipping method chosen for the transaction. (maximum length 50) Possible values:
       * - `01` Same Day
       * - `02` Overnight / Expedited
       * - `03` Priority (2-3 Days)
       * - `04` Ground
       * - `05` Electronic Delivery
       * - `06` Ship to Store
       * @property {string} [shippingMethodIndicator] The 2-digit string indicating the shipping method chosen for the transaction Possible values.
       * - `01` Ship to cardholder billing address
       * - `02` Ship to another verified address on file with merchant
       * - `03` Ship to address that is different from billing address
       * - `04` Ship to store (store address should be populated on request)
       * - `05` Digital goods
       * - `06` Travel and event tickets, not shipped
       * - `07` Other
       * @property {string} [productCode] The 3-letter string representing the merchant product code. Possible values:
       * - `AIR` Airline
       * - `GEN` General Retail
       * - `DIG` Digital Goods
       * - `SVC` Services
       * - `RES` Restaurant
       * - `TRA` Travel
       * - `DSP` Cash Dispensing
       * - `REN` Car Rental
       * - `GAS` Fuel
       * - `LUX` Luxury Retail
       * - `ACC` Accommodation Retail
       * - `TBD` Other
       * @property {string} [deliveryTimeframe] The 2-digit number indicating the delivery time frame. Possible values:
       * - `01` Electronic delivery
       * - `02` Same day shipping
       * - `03` Overnight shipping
       * - `04` Two or more day shipping
       * @property {string} [deliveryEmail] For electronic delivery, email address to which the merchandise was delivered. (maximum length 254)
       * @property {string} [reorderindicator] The 2-digit number indicating whether the cardholder is reordering previously purchased merchandise. possible values:
       * - `01` First time ordered
       * - `02` Reordered
       * @property {string} [preorderIndicator] The 2-digit number indicating whether cardholder is placing an order with a future availability or release date. possible values:
       * - `01` Merchandise available
       * - `02` Future availability
       * @property {string} [preorderDate] The 8-digit number (format: YYYYMMDD) indicating expected date that a pre-ordered purchase will be available.
       * @property {string} [giftCardAmount] The purchase amount total for prepaid gift cards in major units. (maximum length 15)
       * @property {string} [giftCardCurrencyCode] ISO 4217 currency code for the gift card purchased. (maximum length 3)
       * @property {string} [giftCardCount] Total count of individual prepaid gift cards purchased. (maximum length 2)
       * @property {string} [accountAgeIndicator] The 2-digit value representing the length of time cardholder has had account. Possible values:
       * - `01` No Account
       * - `02` Created during transaction
       * - `03` Less than 30 days
       * - `04` 30-60 days
       * - `05` More than 60 days
       * @property {string} [accountCreateDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder opened the account.
       * @property {string} [accountChangeIndicator] The 2-digit value representing the length of time since the last change to the cardholder account. This includes shipping address, new payment account or new user added. Possible values:
       * - `01` Changed during transaction
       * - `02` Less than 30 days
       * - `03` 30-60 days
       * - `04` More than 60 days
       * @property {string} [accountChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder's account was last changed. This includes changes to the billing or shipping address, new payment accounts or new users added.
       * @property {string} [accountPwdChangeIndicator] The 2-digit value representing the length of time since the cardholder changed or reset the password on the account. Possible values:
       * - `01` No change
       * - `02` Changed during transaction
       * - `03` Less than 30 days
       * - `04` 30-60 days
       * - `05` More than 60 days
       * @property {string} [accountPwdChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder last changed or reset password on account.
       * @property {string} [shippingAddressUsageIndicator] The 2-digit value indicating when the shipping address used for transaction was first used. Possible values:
       * - `01` This transaction
       * - `02` Less than 30 days
       * - `03` 30-60 days
       * - `04` More than 60 days
       * @property {string} [shippingAddressUsageDate] The 8-digit number (format: YYYYMMDD) indicating the date when the shipping address used for this transaction was first used.
       * @property {string} [transactionCountDay] Number of transactions (successful or abandoned) for this cardholder account within the last 24 hours. (maximum length 3)
       * @property {string} [transactionCountYear] Number of transactions (successful or abandoned) for this cardholder account within the last year. (maximum length 3)
       * @property {string} [addCardAttempts] Number of add card attempts in the last 24 hours. (maximum length 3)
       * @property {string} [accountPurchases] Number of purchases with this cardholder account during the previous six months.
       * @property {string} [fraudActivity] The 2-digit value indicating whether the merchant experienced suspicious activity (including previous fraud) on the account. Possible values:
       * - `01` No suspicious activity
       * - `02` Suspicious activity observed
       * @property {string} [shippingNameIndicator] The 2-digit value indicating if the cardholder name on the account is identical to the shipping name used for the transaction. Possible values:
       * - `01` Account and shipping name identical
       * - `02` Account and shipping name differ
       * @property {string} [paymentAccountIndicator] The 2-digit value indicating the length of time that the payment account was enrolled in the merchant account. Possible values:
       * - `01` No account (guest checkout)
       * - `02` During the transaction
       * - `03` Less than 30 days
       * - `04` 30-60 days
       * - `05` More than 60 days
       * @property {string} [paymentAccountAge] The 8-digit number (format: YYYYMMDD) indicating the date the payment account was added to the cardholder account.
       * @property {string} [acsWindowSize] The 2-digit number to set the challenge window size to display to the end cardholder.  The ACS will reply with content that is formatted appropriately to this window size to allow for the best user experience.  The sizes are width x height in pixels of the window displayed in the cardholder browser window. Possible values:
       * - `01` 250x400
       * - `02` 390x400
       * - `03` 500x600
       * - `04` 600x400
       * - `05` Full page
       * @property {string} [sdkMaxTimeout] The 2-digit number of minutes (minimum 05) to set the maximum amount of time for all 3DS 2.0 messages to be communicated between all components.
       * @property {string} [addressMatch] The 1-character value (Y/N) indicating whether cardholder billing and shipping addresses match.
       * @property {string} [accountId] Additional cardholder account information. (maximum length 64)
       * @property {string} [ipAddress] The IP address of the consumer. IPv4 and IPv6 are supported.
       * - only one IP address supported
       * - only numbers, letters, period '.' chars, or colons ':' are acceptable
       * @property {string} [orderDescription] Brief description of items purchased. (maximum length 256)
       * @property {string} [taxAmount] Unformatted tax amount without any decimalization (ie. $123.67 = 12367). (maximum length 20)
       * @property {string} [userAgent] The exact content of the HTTP user agent header. (maximum length 500)
       * @property {string} [authenticationIndicator] The 2-digit number indicating the type of authentication request. Possible values:
       *  - `01` Payment
       *  - `02` Recurring transaction
       *  - `03` Installment
       *  - `04` Add card
       *  - `05` Maintain card
       *  - `06` Cardholder verification as part of EMV token ID&V
       *  - `08` Split Shipment
       *  - `09` Delayed Shipment
       *  - `85` Payment with multiple merchants
       * @property {string} [installment] An integer value greater than 1 indicating the maximum number of permitted authorizations for installment payments. (maximum length 3)
       * @property {string} [purchaseDate] The 14-digit number (format: YYYYMMDDHHMMSS) indicating the date in UTC of original purchase.
       * @property {string} [recurringEnd] The 8-digit number (format: YYYYMMDD) indicating the date after which no further recurring authorizations should be performed.
       * @property {string} [recurringFrequency] Integer value indicating the minimum number of days between recurring authorizations. A frequency of monthly is indicated by the value 28. Multiple of 28 days will be used to indicate months (ex. 6 months = 168). (maximum length 3)
       */

      /**
       * @name ThreeDSecure#on
       * @function
       * @param {string} event The name of the event to which you are subscribing.
       * @param {function} handler A callback to handle the event.
       * @description Subscribes a handler function to a named event. The following events are available:
       *   * {@link ThreeDSecure#event:lookup-complete|lookup-complete}
       *   * {@link ThreeDSecure#event:customer-canceled|customer-canceled}
       *   * {@link ThreeDSecure#event:authentication-iframe-available|authentication-iframe-available}
       *   * {@link ThreeDSecure#event:authentication-modal-render|authentication-modal-render}
       *   * {@link ThreeDSecure#event:authentication-modal-close|authentication-modal-close}
       * @example
       * <caption>Listening to a 3D Secure event</caption>
       * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
       *   threeDSecureInstance.on('lookup-complete', function (data, next) {
       *     console.log('data from the lookup', data);
       *     next();
       *   });
       *   threeDSecureInstance.on('customer-canceled', function () {
       *     console.log('log that the customer canceled');
       *   });
       * });
       * @returns {void}
       */

      /**
       * @name ThreeDSecure#off
       * @function
       * @param {string} event The name of the event to which you are unsubscribing.
       * @param {function} handler The callback for the event you are unsubscribing from.
       * @description Unsubscribes the handler function to a named event.
       * @example
       * <caption>Subscribing and then unsubscribing from a 3D Secure eld event</caption>
       * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
       *   var lookupCallback = function (data, next) {
       *     console.log(data);
       *     next();
       *   };
       *   var cancelCallback = function () {
       *     // log the cancelation
       *     // or update UI
       *   };
       *
       *   threeDSecureInstance.on('lookup-complete', lookupCallback);
       *   threeDSecureInstance.on('customer-canceled', cancelCallback);
       *
       *   // later on
       *   threeDSecureInstance.off('lookup-complete', lookupCallback);
       *   threeDSecureInstance.off('customer-canceled', cancelCallback);
       * });
       * @returns {void}
       */

      /**
       * This event is emitted when the `2-inline-iframe` version is specified when creating the 3D Secure instance and the authentication iframe becomes available.
       * @event ThreeDSecure#authentication-iframe-available
       * @example
       * <caption>Listening for the authentication iframe to be available</caption>
       *   threeDSecureInstance.on('authentication-iframe-available', function (event, next) {
       *     document.body.appendChild(event.element); // add iframe element to page
       *
       *     next(); // let the SDK know the iframe is ready
       *   });
       * });
       */

      /**
       * This event is emitted when using the 3D Secure 2.0 flow and the initial lookup request completes. If this is not used, a `onLookupComplete` callback must be passed into the `verifyCard` method.
       * @event ThreeDSecure#lookup-complete
       * @example
       * <caption>Listening for when the lookup request is complete</caption>
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2'
       * }, function (createErr, threeDSecureInstance) {
       *   threeDSecureInstance.on('lookup-complete', function (data, next) {
       *     // inspect the data
       *
       *     // call next when ready to proceed with the challenge
       *     next();
       *   });
       * });
       */

      /**
       * This event is emitted when using the 3D Secure 2.0 flow and the customer cancels the 3D Secure challenge.
       * @event ThreeDSecure#customer-canceled
       * @example
       * <caption>Listening for when the customer cancels the 3D Secure challenge</caption>
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2'
       * }, function (createErr, threeDSecureInstance) {
       *   threeDSecureInstance.on('customer-canceled', function () {
       *     // the customer canceled the 3D Secure challenge
       *   });
       * });
       */

      /**
       * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal closes, either because the authentication was completed or because the customer canceled the process.
       * @event ThreeDSecure#authentication-modal-close
       * @example
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2'
       * }, function (createErr, threeDSecureInstance) {
       *   threeDSecureInstance.on('authentication-modal-close', function () {
       *     // the modal was closed
       *   });
       * });
       */

      /**
       * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal is rendered.
       * @event ThreeDSecure#authentication-modal-render
       * @example
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2'
       * }, function (createErr, threeDSecureInstance) {
       *   threeDSecureInstance.on('authentication-modal-render', function () {
       *     // the modal was rendered, presenting the authentication form to the customer
       *   });
       * });
       */

      /**
       * @class
       * @param {object} options 3D Secure {@link module:braintree-web/three-d-secure.create create} options
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create} instead.</strong>
       * @classdesc This class represents a ThreeDSecure component produced by {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create}. Instances of this class have a method for launching a 3D Secure authentication flow.
       *
       * If you use the Braintree SDK from within an iframe, you must not use the `sandbox` attribute on your iframe or the 3D Secure modal will not function correctly.
       *
       * **Note**: 3D Secure 2.0 is documented below and will become the default integration method in a future version of Braintree-web. Until then, version 1.0 will continue to be supported. To view 3D Secure 1.0 documentation, look at Braintree-web documentation from version [3.40.0](https://braintree.github.io/braintree-web/3.40.0/ThreeDSecure.html) and earlier, or upgrade your integration by referring to the [3D Secure 2.0 adoption guide](https://developer.paypal.com/braintree/docs/guides/3d-secure/migration/javascript/v3).
       */
      function ThreeDSecure(options) {
        var self = this;
        var Framework = FRAMEWORKS[options.framework];
        EventEmitter.call(this);
        this._framework = new Framework(options);
        this._framework.setUpEventListeners(function () {
          self._emit.apply(self, arguments);
        });
      }
      EventEmitter.createChild(ThreeDSecure);
      // NEXT_MAJOR_VERSION remove exemptionRequested entirely in favor of `requestedExemptionType`
      /**
       * Launch the 3D Secure login flow, returning a nonce payload.
       *
       * @public
       * @param {object} options Options for card verification.
       * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
       * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
       * @param {string} options.amount The amount of the transaction in the current merchant account's currency. This must be expressed in numbers with an optional decimal (using `.`) and precision up to the hundredths place. For example, if you're processing a transaction for 1.234,56 € then `amount` should be `1234.56`.
       * @param {string} [options.accountType] The account type for the card (if known). Accepted values: `credit` or `debit`.
       * @param {boolean} [options.cardAddChallengeRequested] If set to `true`, a card-add challenge will be requested from the issuer. If set to `false`, a card-add challenge will not be requested. If the param is missing, a card-add challenge will only be requested for $0 amount. An authentication created using this flag should only be used for vaulting operations (creation of customers' credit cards or payment methods) and not for creating transactions.
       * @param {boolean} [options.cardAdd] *Deprecated:* Use `cardAddChallengeRequested` instead.
       * @param {boolean} [options.challengeRequested] If set to true, an authentication challenge will be forced if possible.
       * @param {boolean} [options.dataOnlyRequested] Indicates whether to use the data-only 3DS flow. If data-only is not supported by the processor, card brand or the transaction is in a PSD2 regulated region, it will fallback to a normal 3DS flow.
       * @param {boolean} [options.exemptionRequested] *Deprecated:* Use `requestedExemptionType` instead.
       * @param {boolean} [options.requestVisaDAF] Request to use VISA Digital Authentication Framework. If set to true, a Visa DAF authenticated payment credential will be created and/or used for authentication if the merchant is eligible.
       * @param {string} [options.merchantName] Allows to override the merchant name that is shown in the challenge.
       * @param {string} [options.requestedExemptionType] If an exemption is requested and the exemption's conditions are satisfied, then it will be applied. The following supported exemptions are defined as per PSD2 regulation: `low_value`, `transaction_risk_analysis`
       * @param {object} [options.customFields] Object where each key is the name of a custom field which has been configured in the Control Panel. In the Control Panel you can configure 3D Secure Rules which trigger on certain values.
       * @param {function} [options.onLookupComplete] *Deprecated:* Use {@link ThreeDSecure#event:lookup-complete|`threeDSecureInstance.on('lookup-complete')`} instead. Function to execute when lookup completes. The first argument, `data`, is a {@link ThreeDSecure~verificationData|verificationData} object, and the second argument, `next`, is a callback. `next` must be called to continue.
       * @param {string} [options.email] The email used for verification. (maximum length 255)
       * @param {string} [options.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
       * @param {object} [options.billingAddress] An {@link ThreeDSecure~billingAddress|billingAddress} object for verification.
       * @param {object} [options.additionalInformation] An {@link ThreeDSecure~additionalInformation|additionalInformation} object for verification.
       * @param {object} [options.collectDeviceData] If set to `true`, device data such as browser screen dimensions, language and time zone is submitted with lookup data.
       * @param {object} [options.customer] **Deprecated** Customer information for use in 3DS 1.0 verifications. Can contain any subset of a {@link ThreeDSecure~verifyCardCustomerObject|verifyCardCustomerObject}. Only to be used for 3DS 1.0 integrations.
       * @param {callback} options.addFrame **Deprecated** This {@link ThreeDSecure~addFrameCallback|addFrameCallback} will be called when the bank frame needs to be added to your page. Only to be used for 3DS 1.0 integrations.
       * @param {callback} options.removeFrame **Deprecated** For use in 3DS 1.0 Flows. This {@link ThreeDSecure~removeFrameCallback|removeFrameCallback} will be called when the bank frame needs to be removed from your page. Only to be used in 3DS 1.0 integrations.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~verifyPayload|verifyPayload}.
      
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * <caption>Verifying a payment method nonce with 3DS 2.0</caption>
       * var my3DSContainer;
       *
       * // set up listener after initialization
       * threeDSecure.on(('lookup-complete', function (data, next) {
       *   // use `data` here, then call `next()`
       *   next();
       * });
       *
       * // call verifyCard after tokenizing a card
       * threeDSecure.verifyCard({
       *   amount: '123.45',
       *   nonce: hostedFieldsTokenizationPayload.nonce,
       *   bin: hostedFieldsTokenizationPayload.details.bin,
       *   email: 'test@example.com'
       *   billingAddress: {
       *     givenName: 'Jill',
       *     surname: 'Doe',
       *     phoneNumber: '8101234567',
       *     streetAddress: '555 Smith St.',
       *     extendedAddress: '#5',
       *     locality: 'Oakland',
       *     region: 'CA',
       *     postalCode: '12345',
       *     countryCodeAlpha2: 'US'
       *   },
       *   additionalInformation: {
       *     workPhoneNumber: '5555555555',
       *     shippingGivenName: 'Jill',
       *     shippingSurname: 'Doe',
       *     shippingAddress: {
       *       streetAddress: '555 Smith st',
       *       extendedAddress: '#5',
       *       locality: 'Oakland',
       *       region: 'CA',
       *       postalCode: '12345',
       *       countryCodeAlpha2: 'US'
       *     }
       *     shippingPhone: '8101234567'
       *   }
       * }, function (err, payload) {
       *   if (err) {
       *     console.error(err);
       *     return;
       *   }
       *
       *   if (payload.liabilityShifted) {
       *     // Liability has shifted
       *     submitNonceToServer(payload.nonce);
       *   } else if (payload.liabilityShiftPossible) {
       *     // Liability may still be shifted
       *     // Decide if you want to submit the nonce
       *   } else {
       *     // Liability has not shifted and will not shift
       *     // Decide if you want to submit the nonce
       *   }
       * });
       * @example
       * <caption>Verifying a payment method nonce with 3DS 2.0 with onLookupComplete callback</caption>
       * var my3DSContainer;
       *
       * threeDSecure.verifyCard({
       *   amount: '123.45',
       *   nonce: hostedFieldsTokenizationPayload.nonce,
       *   bin: hostedFieldsTokenizationPayload.details.bin,
       *   email: 'test@example.com'
       *   billingAddress: {
       *     givenName: 'Jill',
       *     surname: 'Doe',
       *     phoneNumber: '8101234567',
       *     streetAddress: '555 Smith St.',
       *     extendedAddress: '#5',
       *     locality: 'Oakland',
       *     region: 'CA',
       *     postalCode: '12345',
       *     countryCodeAlpha2: 'US'
       *   },
       *   additionalInformation: {
       *     workPhoneNumber: '5555555555',
       *     shippingGivenName: 'Jill',
       *     shippingSurname: 'Doe',
       *     shippingAddress: {
       *       streetAddress: '555 Smith st',
       *       extendedAddress: '#5',
       *       locality: 'Oakland',
       *       region: 'CA',
       *       postalCode: '12345',
       *       countryCodeAlpha2: 'US'
       *     }
       *     shippingPhone: '8101234567'
       *   },
       *   onLookupComplete: function (data, next) {
       *     // use `data` here, then call `next()`
       *     next();
       *   }
       * }, function (err, payload) {
       *   if (err) {
       *     console.error(err);
       *     return;
       *   }
       *
       *   if (payload.liabilityShifted) {
       *     // Liability has shifted
       *     submitNonceToServer(payload.nonce);
       *   } else if (payload.liabilityShiftPossible) {
       *     // Liability may still be shifted
       *     // Decide if you want to submit the nonce
       *   } else {
       *     // Liability has not shifted and will not shift
       *     // Decide if you want to submit the nonce
       *   }
       * });
       * @example
       * <caption>Handling 3DS lookup errors</caption>
       * var my3DSContainer;
       *
       * // set up listener after initialization
       * threeDSecure.on(('lookup-complete', function (data, next) {
       *   // use `data` here, then call `next()`
       *   next();
       * });
       *
       * // call verifyCard after tokenizing a card
       * threeDSecure.verifyCard({
       *   amount: '123.45',
       *   nonce: hostedFieldsTokenizationPayload.nonce,
       *   bin: hostedFieldsTokenizationPayload.details.bin,
       *   email: 'test@example.com',
       *   billingAddress: billingAddressFromCustomer,
       *   additionalInformation: additionalInfoFromCustomer
       * }, function (err, payload) {
       *   if (err) {
       *     if (err.code.indexOf('THREEDS_LOOKUP') === 0) {
       *       // an error occurred during the initial lookup request
       *
       *       if (err.code === 'THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR') {
       *         // either the passed payment method nonce does not exist
       *         // or it was already consumed before the lookup call was made
       *       } else if (err.code.indexOf('THREEDS_LOOKUP_VALIDATION') === 0) {
       *         // a validation error occurred
       *         // likely some non-ascii characters were included in the billing
       *         // address given name or surname fields, or the cardholdername field
       *
       *         // Instruct your user to check their data and try again
       *       } else {
       *         // an unknown lookup error occurred
       *       }
       *     } else {
       *       // some other kind of error
       *     }
       *     return;
       *   }
       *
       *   // handle success
       * });
       */
      ThreeDSecure.prototype.verifyCard = function (options) {
        var privateOptions;
        if (this.hasListener("lookup-complete")) {
          privateOptions = {
            ignoreOnLookupCompleteRequirement: true
          };
        }
        return this._framework.verifyCard(options, privateOptions);
      };

      /* eslint-disable-next-line valid-jsdoc */
      /**
       * Launch the iframe challenge using a 3D Secure lookup response from a server side lookup.
       *
       * @public
       * @param {(object|string)} lookupResponse The lookup response from the server side call to lookup the 3D Secure information. The raw string or a parsed object can be passed.
       * @returns {Promise} Returns a promise.
       * @example
       * var my3DSContainer;
       *
       * threeDSecure.initializeChallengeWithLookupResponse(lookupResponseFromServer).then(function (payload) {
       *   if (payload.liabilityShifted) {
       *     // Liability has shifted
       *     submitNonceToServer(payload.nonce);
       *   } else if (payload.liabilityShiftPossible) {
       *     // Liability may still be shifted
       *     // Decide if you want to submit the nonce
       *   } else {
       *     // Liability has not shifted and will not shift
       *     // Decide if you want to submit the nonce
       *   }
       * });
       */
      ThreeDSecure.prototype.initializeChallengeWithLookupResponse = function (lookupResponse) {
        if (typeof lookupResponse === "string") {
          lookupResponse = JSON.parse(lookupResponse);
        }
        return this._framework.initializeChallengeWithLookupResponse(lookupResponse);
      };

      /**
       * Gather the data needed for a 3D Secure lookup call.
       *
       * @public
       * @param {object} options Options for 3D Secure lookup.
       * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
       * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}.
      
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * <caption>Preparing data for a 3D Secure lookup</caption>
       * threeDSecure.prepareLookup({
       *   nonce: hostedFieldsTokenizationPayload.nonce,
       *   bin: hostedFieldsTokenizationPayload.details.bin
       * }, function (err, payload) {
       *   if (err) {
       *     console.error(err);
       *     return;
       *   }
       *
       *   // send payload to server to do server side lookup
       * });
       */
      ThreeDSecure.prototype.prepareLookup = function (options) {
        return this._framework.prepareLookup(options).then(function (data) {
          return JSON.stringify(data);
        });
      };

      /**
       * Cancel the 3DS flow and return the verification payload if available. If using 3D Secure version 2, this will not close the UI of the authentication modal. It is recommended that this method only be used in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete`} event or the `onLookupComplete` callback.
       * @public
       * @param {callback} [callback] The second argument is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If there is no verifyPayload (the initial lookup did not complete), an error will be returned. If no callback is passed, `cancelVerifyCard` will return a promise.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example <caption>Cancel the verification in `lookup-complete` event</caption>
       * // set up listener after instantiation
       * threeDSecure.on('lookup-complete', function (data, next) {
       *   // determine if you want to call next to start the challenge,
       *   // if not, call cancelVerifyCard
       *   threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
       *     if (err) {
       *       // Handle error
       *       console.log(err.message); // No verification payload available
       *       return;
       *     }
       *
       *     verifyPayload.nonce; // The nonce returned from the 3ds lookup call
       *     verifyPayload.liabilityShifted; // boolean
       *     verifyPayload.liabilityShiftPossible; // boolean
       *   });
       * });
       *
       * // after tokenizing a credit card
       * threeDSecure.verifyCard({
       *   amount: '100.00',
       *   nonce: nonceFromTokenizationPayload,
       *   bin: binFromTokenizationPayload
       *   // other fields such as billing address
       * }, function (verifyError, payload) {
       *   if (verifyError) {
       *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
       *       // flow was canceled by merchant, 3ds info can be found in the payload
       *       // for cancelVerifyCard
       *     }
       *   }
       * });
       * @example <caption>Cancel the verification in onLookupComplete callback</caption>
       * threeDSecure.verifyCard({
       *   amount: '100.00',
       *   nonce: nonceFromTokenizationPayload,
       *   bin: binFromTokenizationPayload,
       *   // other fields such as billing address
       *   onLookupComplete: function (data, next) {
       *     // determine if you want to call next to start the challenge,
       *     // if not, call cancelVerifyCard
       *     threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
       *       if (err) {
       *         // Handle error
       *         console.log(err.message); // No verification payload available
       *         return;
       *       }
       *
       *       verifyPayload.nonce; // The nonce returned from the 3ds lookup call
       *       verifyPayload.liabilityShifted; // boolean
       *       verifyPayload.liabilityShiftPossible; // boolean
       *     });
       *   }
       * }, function (verifyError, payload) {
       *   if (verifyError) {
       *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
       *       // flow was canceled by merchant, 3ds info can be found in the payload
       *       // for cancelVerifyCard
       *     }
       *   }
       * });
       * @example <caption>Cancel the verification in 3D Secure version 1</caption>
       * // unlike with v2, this will not cause `verifyCard` to error, it will simply
       * // never call the callback
       * threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
       *   if (err) {
       *     // Handle error
       *     console.log(err.message); // No verification payload available
       *     return;
       *   }
       *
       *   verifyPayload.nonce; // The nonce returned from the 3ds lookup call
       *   verifyPayload.liabilityShifted; // boolean
       *   verifyPayload.liabilityShiftPossible; // boolean
       * });
       */
      ThreeDSecure.prototype.cancelVerifyCard = function () {
        return this._framework.cancelVerifyCard();
      };

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/three-d-secure.create|create}, with the exception that the Cardinal SDK, on window.Cardinal, will remain.
       * @public
       * @param {callback} [callback] Called on completion. If no callback is passed, `teardown` will return a promise.
       * @example
       * threeDSecure.teardown();
       * @example <caption>With callback</caption>
       * threeDSecure.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      ThreeDSecure.prototype.teardown = function () {
        var methodNames = methods(ThreeDSecure.prototype).concat(methods(EventEmitter.prototype));
        convertMethodsToError(this, methodNames);
        return this._framework.teardown();
      };
      module.exports = wrapPromise.wrapPrototype(ThreeDSecure);
    }, {
      "../../lib/convert-methods-to-error": 143,
      "../../lib/methods": 172,
      "./frameworks": 211,
      "@braintree/event-emitter": 30,
      "@braintree/wrap-promise": 40
    }],
    216: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/three-d-secure */
      var ThreeDSecure = _dereq_("./external/three-d-secure");
      var isHTTPS = _dereq_("../lib/is-https").isHTTPS;
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./shared/errors");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {object} [options.cardinalSDKConfig] A config for the underlying Cardinal SDK.
       * @param {object} [options.cardinalSDKConfig.logging] The logging configuration for the Cardinal SDK. See [Cardinal's documentation for the logging object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Logging) for more information.
       * @param {number} [options.cardinalSDKConfig.timeout] The time in milliseconds to wait before a request to Cardinal's API times out. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
       * @param {number} [options.cardinalSDKConfig.maxRequestRetries] How many times a request should be re-attempted to Cardinal's API before giving up as a failure. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
       * @param {object} [options.cardinalSDKConfig.payment] An object to describe how you want the user interactions to behave. Only a subset of the [Cardinal SDK payment configuration object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Payment) are supported: `displayLoading` and `displayExitButton`.
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {(number|string)} [options.version=1] The version of 3D Secure to use. Possible options:
       * * 1 - The legacy 3D Secure v1.0 integration.
       * * 2 - A 3D Secure v2.0 integration that uses a modal to host the 3D Secure iframe.
       * * 2-bootstrap3-modal - A 3D Secure v2.0 integration that uses a modal styled with Bootstrap 3 styles to host the 3D Secure iframe. Requires having the Bootstrap 3 script files and stylesheets on your page.
       * * 2-inline-iframe - A 3D Secure v2.0 integration that provides the authentication iframe directly to the merchant.
       * @param {callback} [callback] The second argument, `data`, is the {@link ThreeDSecure} instance. If no callback is provided, it returns a promise that resolves the {@link ThreeDSecure} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
      @example
       * <caption>Creating a v2 3D Secure component using 2 version (Cardinal modal)</caption>
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2'
       * }, function (createError, threeDSecure) {
       *   // set up lookup-complete listener
       *   threeDSecure.on('lookup-complete', function (data, next) {
       *     // check lookup data
       *
       *     next();
       *   });
       *
       *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
       *
       *   threeDSecure.verifyCard({
       *     nonce: nonceFromTokenizationPayload,,
       *     bin: binFromTokenizationPayload,
       *     amount: '100.00'
       *   }, function (verifyError, payload) {
       *     // inspect payload
       *     // send payload.nonce to your server
       *   });
       * });
       * @example
       * <caption>Creating a v2 3D Secure component using 2-bootstrap3-modal version</caption>
       * // must have the boostrap js, css and jquery files on your page
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2-bootstrap3-modal'
       * }, function (createError, threeDSecure) {
       *   // set up lookup-complete listener
       *   threeDSecure.on('lookup-complete', function (data, next) {
       *     // check lookup data
       *
       *     next();
       *   });
       *
       *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
       *
       *   // challenge will be presented in a bootstrap 3 modal
       *   threeDSecure.verifyCard({
       *     nonce: nonceFromTokenizationPayload,
       *     bin: binFromTokenizationPayload,
       *     amount: '100.00'
       *   }, function (verifyError, payload) {
       *     // inspect payload
       *     // send payload.nonce to your server
       *   });
       * });
       * @example
       * <caption>Creating a v2 3D Secure component using 2-inline-iframe version</caption>
       * braintree.threeDSecure.create({
       *   client: clientInstance,
       *   version: '2-inline-iframe'
       * }, function (createError, threeDSecure) {
       *   // set up lookup-complete listener
       *   threeDSecure.on('lookup-complete', function (data, next) {
       *     // check lookup data
       *
       *     next();
       *   });
       *   // set up iframe listener
       *   threeDSecure.on('authentication-iframe-available', function (event, next) {
       *     var element = event.element; // an html element that contains the iframe
       *
       *     document.body.appendChild(element); // put it on your page
       *
       *     next(); // let the sdk know the element has been added to the page
       *   });
       *
       *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
       *
       *   threeDSecure.verifyCard({
       *     nonce: nonceFromTokenizationPayload,,
       *     bin: binFromTokenizationPayload,
       *     amount: '100.00'
       *   }, function (verifyError, payload) {
       *     // inspect payload
       *     // send payload.nonce to your server
       *   });
       * });
       */
      function create(options) {
        var name = "3D Secure";
        var framework = getFramework(options);
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var assetsUrl = createAssetsUrl.create(options.authorization);
          var createPromise = createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: assetsUrl,
            name: name
          }).then(function (client) {
            var error, isProduction;
            var config = client.getConfiguration();
            var gwConfig = config.gatewayConfiguration;
            options.client = client;
            if (!gwConfig.threeDSecureEnabled) {
              error = errors.THREEDS_NOT_ENABLED;
            }
            if (config.authorizationType === "TOKENIZATION_KEY") {
              error = errors.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY;
            }
            isProduction = gwConfig.environment === "production";
            if (isProduction && !isHTTPS()) {
              error = errors.THREEDS_HTTPS_REQUIRED;
            }
            if (framework !== "legacy" && !(gwConfig.threeDSecure && gwConfig.threeDSecure.cardinalAuthenticationJWT)) {
              analytics.sendEvent(options.client, "three-d-secure.initialization.failed.missing-cardinalAuthenticationJWT");
              error = errors.THREEDS_NOT_ENABLED_FOR_V2;
            }
            if (error) {
              return Promise.reject(new BraintreeError(error));
            }
            analytics.sendEvent(options.client, "three-d-secure.initialized");
            return client;
          });
          var instance = new ThreeDSecure({
            client: options.client,
            assetsUrl: assetsUrl,
            createPromise: createPromise,
            loggingEnabled: options.loggingEnabled,
            cardinalSDKConfig: options.cardinalSDKConfig,
            framework: framework
          });
          if (options.client) {
            return createPromise.then(function () {
              return instance;
            });
          }
          return instance;
        });
      }
      function getFramework(options) {
        var version = String(options.version || "");
        if (!version || version === "1") {
          throw new BraintreeError({
            code: errors.THREEDS_UNSUPPORTED_VERSION.code,
            type: errors.THREEDS_UNSUPPORTED_VERSION.type,
            message: errors.THREEDS_UNSUPPORTED_VERSION.message
          });
        }
        switch (version) {
          case "2":
          case "2-cardinal-modal":
            return "cardinal-modal";
          case "2-bootstrap3-modal":
            return "bootstrap3-modal";
          case "2-inline-iframe":
            return "inline-iframe";
          default:
            throw new BraintreeError({
              code: errors.THREEDS_UNRECOGNIZED_VERSION.code,
              type: errors.THREEDS_UNRECOGNIZED_VERSION.type,
              message: "Version `" + options.version + "` is not a recognized version. You may need to update the version of your Braintree SDK to support this version."
            });
        }
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "../lib/is-https": 169,
      "./external/three-d-secure": 215,
      "./shared/errors": 218,
      "@braintree/wrap-promise": 40
    }],
    217: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        LANDING_FRAME_NAME: "braintreethreedsecurelanding",
        CARDINAL_SCRIPT_SOURCE: {
          production: "https://songbird.cardinalcommerce.com/edge/v1/songbird.js",
          sandbox: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js"
        }
      };
    }, {}],
    218: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.3D Secure - Creation Error Codes
       * @description Errors that occur when [creating the 3D Secure component](./module-braintree-web_three-d-secure.html#.create).
       * @property {MERCHANT} THREEDS_NOT_ENABLED Occurs when 3D Secure is not enabled in the Braintree control panel.
       * @property {MERCHANT} THREEDS_CAN_NOT_USE_TOKENIZATION_KEY Occurs when 3D Secure component is created without a Client Token.
       * @property {MERCHANT} THREEDS_HTTPS_REQUIRED Occurs when 3D Secure component is created in production over HTTPS.
       * @property {MERCHANT} THREEDS_NOT_ENABLED_FOR_V2 Occurs when 3D Secure component is created with version 2 parameter, but merchant is not enabled to use version 2.
       * @property {MERCHANT} THREEDS_UNRECOGNIZED_VERSION Occurs when unrecognized version enum is passed into the create call.
       * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_FAILED Occurs when Cardinal's Songbird.js library fails to setup for an unknown reason.
       * @property {NETWORK} THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED Occurs when using version 2 and Cardinal's Songbird.js script could not be loaded.
       * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT Occurs when Cardinal's Songbird.js library takes longer than 60 seconds to set up.
       * @property {UNKNOWN} THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT Occurs when Cardinal sends a response indicating a timeout on /Validate, /Confirm, or /Continue.
       * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_CONFIG Occurs when there is no JWT in the request. Also when there's some other malformed aspect of config.
       * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_JWT Occurs when a malformed config causes a either a missing response JWT or a malformed Cardinal response.
       * @property {UNKNOWN} THREEDS_CARDINAL_SDK_ERROR Occurs when a "general error" or a Cardinal hosted fields error happens. Description contains more details.
       * @property {CUSTOMER} THREEDS_CARDINAL_SDK_CANCELED Occurs when customer cancels the transaction mid-flow, usually with alt-pays that have their own cancel buttons.
       * @property {MERCHANT} THREEDS_UNSUPPORTED_VERSION Occurs when 3D Secure component is created with version 1 (or default version) parameter.
       */

      /**
       * @name BraintreeError.3D Secure - verifyCard Error Codes
       * @description Errors that occur when using the [`verifyCard` method](./ThreeDSecure.html#verifyCard).
       * @property {MERCHANT} THREEDS_AUTHENTICATION_IN_PROGRESS Occurs when another verification is already in progress.
       * @property {MERCHANT} THREEDS_MISSING_VERIFY_CARD_OPTION Occurs when a required option is missing.
       * @property {UNKNOWN} THREEDS_JWT_AUTHENTICATION_FAILED Occurs when something went wrong authenticating the JWT from the Cardinal SDK.
       * @property {MERCHANT} THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR Occurs when the supplied payment method nonce does not exist or the payment method nonce has already been consumed.
       * @property {CUSTOMER} THREEDS_LOOKUP_VALIDATION_ERROR Occurs when a validation error occurs during the 3D Secure lookup.
       * @property {UNKNOWN} THREEDS_LOOKUP_ERROR An unknown error occurred while attempting the 3D Secure lookup.
       * @property {MERCHANT} THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT Occurs when the 3D Secure flow is canceled by the merchant using `cancelVerifyCard` (3D Secure v2 flows only).
       * @property {UNKNOWN} THREEDS_INLINE_IFRAME_DETAILS_INCORRECT An unknown error occurred while attempting to use the inline iframe framework.
       * @property {MERCHANT} THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID Occurs when unrecognized exemption enum value is passed into verifyCard.
       */

      /**
       * @name BraintreeError.3D Secure - cancelVerifyCard Error Codes
       * @description Errors that occur when using the [`cancelVerifyCard` method](./ThreeDSecure.html#cancelVerifyCard).
       * @property {MERCHANT} THREEDS_NO_VERIFICATION_PAYLOAD Occurs when the 3D Secure flow is canceled, but there is no 3D Secure information available.
       */

      /**
       * @name BraintreeError.3D Secure - Internal Error Codes
       * @ignore
       * @description Errors that occur internally
       * @property {INTERNAL} THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN Occurs when iframe is initialized on a non-verified domain.
       * @property {INTERNAL} THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED Occurs when a 3D Secure framework method is not implemented.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        THREEDS_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_NOT_ENABLED",
          message: "3D Secure is not enabled for this merchant."
        },
        THREEDS_CAN_NOT_USE_TOKENIZATION_KEY: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_CAN_NOT_USE_TOKENIZATION_KEY",
          message: "3D Secure can not use a tokenization key for authorization."
        },
        THREEDS_HTTPS_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_HTTPS_REQUIRED",
          message: "3D Secure requires HTTPS."
        },
        THREEDS_NOT_ENABLED_FOR_V2: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_NOT_ENABLED_FOR_V2",
          message: "3D Secure version 2 is not enabled for this merchant. Contact Braintree Support for assistance at https://help.braintreepayments.com/"
        },
        THREEDS_UNRECOGNIZED_VERSION: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_UNRECOGNIZED_VERSION"
        },
        THREEDS_CARDINAL_SDK_SETUP_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_CARDINAL_SDK_SETUP_FAILED",
          message: "Something went wrong setting up Cardinal's Songbird.js library."
        },
        THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED",
          message: "Cardinal's Songbird.js library could not be loaded."
        },
        THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT",
          message: "Cardinal's Songbird.js took too long to setup."
        },
        THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT",
          message: "Cardinal's API took too long to respond."
        },
        THREEDS_CARDINAL_SDK_BAD_CONFIG: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_CARDINAL_SDK_BAD_CONFIG",
          message: "JWT or other required field missing. Please check your setup configuration."
        },
        THREEDS_CARDINAL_SDK_BAD_JWT: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_CARDINAL_SDK_BAD_JWT",
          message: "Cardinal JWT missing or malformed. Please check your setup configuration."
        },
        THREEDS_CARDINAL_SDK_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_CARDINAL_SDK_ERROR",
          message: "A general error has occurred with Cardinal. See description for more information."
        },
        THREEDS_CARDINAL_SDK_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "THREEDS_CARDINAL_SDK_CANCELED",
          message: "Canceled by user."
        },
        THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT",
          message: "3D Secure verfication canceled by merchant."
        },
        THREEDS_AUTHENTICATION_IN_PROGRESS: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_AUTHENTICATION_IN_PROGRESS",
          message: "Cannot call verifyCard while existing authentication is in progress."
        },
        THREEDS_MISSING_VERIFY_CARD_OPTION: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_MISSING_VERIFY_CARD_OPTION"
        },
        THREEDS_JWT_AUTHENTICATION_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_JWT_AUTHENTICATION_FAILED",
          message: "Something went wrong authenticating the JWT from Cardinal"
        },
        THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR",
          message: "Either the payment method nonce passed to `verifyCard` does not exist, or it was already consumed"
        },
        THREEDS_LOOKUP_VALIDATION_ERROR: {
          type: BraintreeError.types.CUSTOMER,
          code: "THREEDS_LOOKUP_VALIDATION_ERROR",
          message: "The data passed in `verifyCard` did not pass validation checks. See details for more info"
        },
        THREEDS_LOOKUP_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_LOOKUP_ERROR",
          message: "Something went wrong during the 3D Secure lookup"
        },
        THREEDS_INLINE_IFRAME_DETAILS_INCORRECT: {
          type: BraintreeError.types.UNKNOWN,
          code: "THREEDS_INLINE_IFRAME_DETAILS_INCORRECT",
          message: "Something went wrong when attempting to add the authentication iframe to the page."
        },
        THREEDS_NO_VERIFICATION_PAYLOAD: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_NO_VERIFICATION_PAYLOAD",
          message: "No verification payload available."
        },
        THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN: {
          type: BraintreeError.types.INTERNAL,
          code: "THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN",
          message: "Term Url must be on a Braintree domain."
        },
        THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED: {
          type: BraintreeError.types.INTERNAL,
          code: "THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED",
          message: "Method not implemented for this framework."
        },
        THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID",
          message: "Requested Exemption Type is invalid."
        },
        THREEDS_UNSUPPORTED_VERSION: {
          type: BraintreeError.types.MERCHANT,
          code: "THREEDS_UNSUPPORTED_VERSION",
          message: "3D Secure `1` is deprecated and no longer supported. See available versions at https://braintree.github.io/braintree-web/current/module-braintree-web_three-d-secure.html#.create"
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    219: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("../../lib/enumerate");
      module.exports = enumerate(["AUTHENTICATION_COMPLETE"], "threedsecure:");
    }, {
      "../../lib/enumerate": 150
    }],
    220: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/unionpay
       * @description This module allows you to accept UnionPay payments. *It is currently in beta and is subject to change.*
       */
      var UnionPay = _dereq_("./shared/unionpay");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./shared/errors");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link UnionPay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link UnionPay} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * braintree.unionpay.create({ client: clientInstance }, function (createErr, unionpayInstance) {
       *   if (createErr) {
       *     console.error(createErr);
       *     return;
       *   }
       *   // ...
       * });
       */
      function create(options) {
        var name = "UnionPay";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var config = client.getConfiguration();
          options.client = client;
          if (!config.gatewayConfiguration.unionPay || config.gatewayConfiguration.unionPay.enabled !== true) {
            return Promise.reject(new BraintreeError(errors.UNIONPAY_NOT_ENABLED));
          }
          analytics.sendEvent(options.client, "unionpay.initialized");
          return new UnionPay(options);
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./shared/errors": 222,
      "./shared/unionpay": 223,
      "@braintree/wrap-promise": 40
    }],
    221: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("../../lib/enumerate");
      module.exports = {
        events: enumerate(["HOSTED_FIELDS_FETCH_CAPABILITIES", "HOSTED_FIELDS_ENROLL", "HOSTED_FIELDS_TOKENIZE"], "union-pay:"),
        HOSTED_FIELDS_FRAME_NAME: "braintreeunionpayhostedfields"
      };
    }, {
      "../../lib/enumerate": 150
    }],
    222: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Union Pay - Creation Error Codes
       * @description Errors that occur when [creating the Union Pay component](./module-braintree-web_union-pay.html#.create).
       * @property {MERCHANT} UNIONPAY_NOT_ENABLED Occurs when Union Pay is not enabled on the Braintree control panel.
       */

      /**
       * @name BraintreeError.Union Pay - Shared Error Codes
       * @description Errors that occur when starting the Union Pay Flow
       * @property {MERCHANT} UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES Occurs when a method is used with both card details and a Hosted Fields instance.
       * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID Occurs when Hosted Fields instance used is not a valid Hosted Fields instance.
       * @property {MERCHANT} UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when neither card details or Hosted Fields are used.
       * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when Hosted Fields cannot be found on the page.
       */

      /**
       * @name BraintreeError.Union Pay - fetchCapabilities Error Codes
       * @description Errors that occur when using the [`fetchCapabilities` method](./UnionPay.html#fetchCapabilities).
       * @property {NETWORK} UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR Occurs when there is an error looking up the Union Pay capabilities.
       */

      /**
       * @name BraintreeError.Union Pay - enroll Error Codes
       * @description Errors that occur when using the [`enroll` method](./UnionPay.html#enroll).
       * @property {MERCHANT} UNIONPAY_MISSING_MOBILE_PHONE_DATA Occurs when no mobile phone data is provided.
       * @property {MERCHANT} UNIONPAY_EXPIRATION_DATE_INCOMPLETE Occurs when expiration date is incomplete.
       * @property {CUSTOMER} UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID Occurs when customer enrollment input is invalid.
       * @property {NETWORK} UNIONPAY_ENROLLMENT_NETWORK_ERROR Occurs when there is an error during enrollment.
       */

      /**
       * @name BraintreeError.Union Pay - tokenize Error Codes
       * @description Errors that occur when using the [`tokenize` method](./UnionPay.html#tokenize).
       * @property {CUSTOMER} UNIONPAY_FAILED_TOKENIZATION Occurs when data cannot be tokenized.
       * @property {NETWORK} UNIONPAY_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be reached.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        UNIONPAY_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_NOT_ENABLED",
          message: "UnionPay is not enabled for this merchant."
        },
        UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID",
          message: "Found an invalid Hosted Fields instance. Please use a valid Hosted Fields instance."
        },
        UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED",
          message: "Could not find the Hosted Fields instance."
        },
        UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED",
          message: "A card or a Hosted Fields instance is required. Please supply a card or a Hosted Fields instance."
        },
        UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES",
          message: "Please supply either a card or a Hosted Fields instance, not both."
        },
        UNIONPAY_EXPIRATION_DATE_INCOMPLETE: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_EXPIRATION_DATE_INCOMPLETE",
          message: "You must supply expiration month and year or neither."
        },
        UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID: {
          type: BraintreeError.types.CUSTOMER,
          code: "UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID",
          message: "Enrollment failed due to user input error."
        },
        UNIONPAY_ENROLLMENT_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "UNIONPAY_ENROLLMENT_NETWORK_ERROR",
          message: "Could not enroll UnionPay card."
        },
        UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR",
          message: "Could not fetch card capabilities."
        },
        UNIONPAY_TOKENIZATION_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "UNIONPAY_TOKENIZATION_NETWORK_ERROR",
          message: "A tokenization network error occurred."
        },
        UNIONPAY_MISSING_MOBILE_PHONE_DATA: {
          type: BraintreeError.types.MERCHANT,
          code: "UNIONPAY_MISSING_MOBILE_PHONE_DATA",
          message: "A `mobile` with `countryCode` and `number` is required."
        },
        UNIONPAY_FAILED_TOKENIZATION: {
          type: BraintreeError.types.CUSTOMER,
          code: "UNIONPAY_FAILED_TOKENIZATION",
          message: "The supplied card data failed tokenization."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    223: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../../lib/analytics");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var Bus = _dereq_("framebus");
      var constants = _dereq_("./constants");
      var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
      var useMin = _dereq_("../../lib/use-min");
      var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
      var errors = _dereq_("./errors");
      var events = constants.events;
      var iFramer = _dereq_("@braintree/iframer");
      var methods = _dereq_("../../lib/methods");
      var VERSION = "3.115.2";
      var uuid = _dereq_("@braintree/uuid");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;

      /**
       * @class
       * @param {object} options See {@link module:braintree-web/unionpay.create|unionpay.create}.
       * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/unionpay.create|braintree-web.unionpay.create} instead.</strong>
       * @classdesc This class represents a UnionPay component. Instances of this class have methods for {@link UnionPay#fetchCapabilities fetching capabilities} of UnionPay cards, {@link UnionPay#enroll enrolling} a UnionPay card, and {@link UnionPay#tokenize tokenizing} a UnionPay card.
       */
      function UnionPay(options) {
        this._options = options;
      }

      /**
       * @typedef {object} UnionPay~fetchCapabilitiesPayload
       * @property {boolean} isUnionPay Determines if this card is a UnionPay card.
       * @property {boolean} isDebit Determines if this card is a debit card. This property is only present if `isUnionPay` is `true`.
       * @property {object} unionPay UnionPay specific properties. This property is only present if `isUnionPay` is `true`.
       * @property {boolean} unionPay.supportsTwoStepAuthAndCapture Determines if the card allows for an authorization, but settling the transaction later.
       * @property {boolean} unionPay.isSupported Determines if Braintree can process this UnionPay card. When false, Braintree cannot process this card and the user should use a different card.
       */

      /**
       * Fetches the capabilities of a card, including whether or not the SMS enrollment process is required.
       * @public
       * @param {object} options UnionPay {@link UnionPay#fetchCapabilities fetchCapabilities} options
       * @param {object} [options.card] The card from which to fetch capabilities. Note that this will only have one property, `number`. Required if you are not using the `hostedFields` option.
       * @param {string} options.card.number Card number.
       * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}. If no callback is provided, `fetchCapabilities` returns a promise that resolves with a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      UnionPay.prototype.fetchCapabilities = function (options) {
        var self = this;
        var client = this._options.client;
        var cardNumber = options.card ? options.card.number : null;
        var hostedFields = options.hostedFields;
        if (cardNumber && hostedFields) {
          return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
        } else if (cardNumber) {
          return client.request({
            method: "get",
            endpoint: "payment_methods/credit_cards/capabilities",
            data: {
              _meta: {
                source: "unionpay"
              },
              creditCard: {
                number: cardNumber
              }
            }
          }).then(function (response) {
            analytics.sendEvent(client, "unionpay.capabilities-received");
            return response;
          }).catch(function (err) {
            var status = err.details && err.details.httpStatus;
            analytics.sendEvent(client, "unionpay.capabilities-failed");
            if (status === 403) {
              return Promise.reject(err);
            }
            return Promise.reject(new BraintreeError({
              type: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.type,
              code: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.code,
              message: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.message,
              details: {
                originalError: err
              }
            }));
          });
        } else if (hostedFields) {
          if (!hostedFields._bus) {
            return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
          }
          return self._initializeHostedFields().then(function () {
            return new Promise(function (resolve, reject) {
              self._bus.emit(events.HOSTED_FIELDS_FETCH_CAPABILITIES, {
                hostedFields: hostedFields
              }, function (response) {
                if (response.err) {
                  reject(new BraintreeError(response.err));
                  return;
                }
                resolve(response.payload);
              });
            });
          });
        }
        return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
      };

      /**
       * @typedef {object} UnionPay~enrollPayload
       * @property {string} enrollmentId UnionPay enrollment ID. This value should be passed to `tokenize`.
       * @property {boolean} smsCodeRequired UnionPay `smsCodeRequired` flag.
       * </p><b>true</b> - the user will receive an SMS code that needs to be supplied for tokenization.
       * </p><b>false</b> - the card can be immediately tokenized.
       */

      /**
       * Enrolls a UnionPay card. Use {@link UnionPay#fetchCapabilities|fetchCapabilities} to determine if the SMS enrollment process is required.
       * @public
       * @param {object} options UnionPay enrollment options:
       * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
       * @param {string} options.card.number The card number.
       * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
       * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
       * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
       * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
       * @param {object} options.mobile The mobile information collected from the customer.
       * @param {string} options.mobile.countryCode The country code of the customer's mobile phone number.
       * @param {string} options.mobile.number The customer's mobile phone number.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~enrollPayload|enrollPayload}. If no callback is provided, `enroll` returns a promise that resolves with {@link UnionPay~enrollPayload|enrollPayload}.
       * @returns {void}
       */
      UnionPay.prototype.enroll = function (options) {
        var self = this;
        var client = this._options.client;
        var card = options.card;
        var mobile = options.mobile;
        var hostedFields = options.hostedFields;
        var data;
        if (!mobile) {
          return Promise.reject(new BraintreeError(errors.UNIONPAY_MISSING_MOBILE_PHONE_DATA));
        }
        if (hostedFields) {
          if (!hostedFields._bus) {
            return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
          } else if (card) {
            return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
          }
          return new Promise(function (resolve, reject) {
            self._initializeHostedFields().then(function () {
              self._bus.emit(events.HOSTED_FIELDS_ENROLL, {
                hostedFields: hostedFields,
                mobile: mobile
              }, function (response) {
                if (response.err) {
                  reject(new BraintreeError(response.err));
                  return;
                }
                resolve(response.payload);
              });
            });
          });
        } else if (card && card.number) {
          data = {
            _meta: {
              source: "unionpay"
            },
            unionPayEnrollment: {
              number: card.number,
              mobileCountryCode: mobile.countryCode,
              mobileNumber: mobile.number
            }
          };
          if (card.expirationDate) {
            data.unionPayEnrollment.expirationDate = card.expirationDate;
          } else if (card.expirationMonth || card.expirationYear) {
            if (card.expirationMonth && card.expirationYear) {
              data.unionPayEnrollment.expirationYear = card.expirationYear;
              data.unionPayEnrollment.expirationMonth = card.expirationMonth;
            } else {
              return Promise.reject(new BraintreeError(errors.UNIONPAY_EXPIRATION_DATE_INCOMPLETE));
            }
          }
          return client.request({
            method: "post",
            endpoint: "union_pay_enrollments",
            data: data
          }).then(function (response) {
            analytics.sendEvent(client, "unionpay.enrollment-succeeded");
            return {
              enrollmentId: response.unionPayEnrollmentId,
              smsCodeRequired: response.smsCodeRequired
            };
          }).catch(function (err) {
            var error;
            var status = err.details && err.details.httpStatus;
            if (status === 403) {
              error = err;
            } else if (status < 500) {
              error = new BraintreeError(errors.UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID);
              error.details = {
                originalError: err
              };
            } else {
              error = new BraintreeError(errors.UNIONPAY_ENROLLMENT_NETWORK_ERROR);
              error.details = {
                originalError: err
              };
            }
            analytics.sendEvent(client, "unionpay.enrollment-failed");
            return Promise.reject(error);
          });
        }
        return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
      };

      /**
       * @typedef {object} UnionPay~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} type Always <code>CreditCard</code>.
       * @property {object} details Additional account details:
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {string} description A human-readable description.
       */

      /**
       * Tokenizes a UnionPay card and returns a nonce payload.
       * @public
       * @param {object} options UnionPay tokenization options:
       * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
       * @param {string} options.card.number The card number.
       * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
       * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
       * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
       * @param {string} [options.card.cvv] The card's security number.
       * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
       * @param {string} options.enrollmentId The enrollment ID from {@link UnionPay#enroll}.
       * @param {string} [options.smsCode] The SMS code received from the user if {@link UnionPay#enroll} payload have `smsCodeRequired`. if `smsCodeRequired` is false, smsCode should not be passed.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link UnionPay~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      UnionPay.prototype.tokenize = function (options) {
        var data;
        var self = this;
        var client = this._options.client;
        var card = options.card;
        var hostedFields = options.hostedFields;
        if (card && hostedFields) {
          return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
        } else if (card) {
          data = {
            _meta: {
              source: "unionpay"
            },
            creditCard: {
              number: options.card.number,
              options: {
                unionPayEnrollment: {
                  id: options.enrollmentId
                }
              }
            }
          };
          if (options.smsCode) {
            data.creditCard.options.unionPayEnrollment.smsCode = options.smsCode;
          }
          if (card.expirationDate) {
            data.creditCard.expirationDate = card.expirationDate;
          } else if (card.expirationMonth && card.expirationYear) {
            data.creditCard.expirationYear = card.expirationYear;
            data.creditCard.expirationMonth = card.expirationMonth;
          }
          if (options.card.cvv) {
            data.creditCard.cvv = options.card.cvv;
          }
          return client.request({
            method: "post",
            endpoint: "payment_methods/credit_cards",
            data: data
          }).then(function (response) {
            var tokenizedCard = response.creditCards[0];
            delete tokenizedCard.consumed;
            delete tokenizedCard.threeDSecureInfo;
            analytics.sendEvent(client, "unionpay.nonce-received");
            return tokenizedCard;
          }).catch(function (err) {
            var error;
            var status = err.details && err.details.httpStatus;
            analytics.sendEvent(client, "unionpay.nonce-failed");
            if (status === 403) {
              error = err;
            } else if (status < 500) {
              error = new BraintreeError(errors.UNIONPAY_FAILED_TOKENIZATION);
              error.details = {
                originalError: err
              };
            } else {
              error = new BraintreeError(errors.UNIONPAY_TOKENIZATION_NETWORK_ERROR);
              error.details = {
                originalError: err
              };
            }
            return Promise.reject(error);
          });
        } else if (hostedFields) {
          if (!hostedFields._bus) {
            return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
          }
          return new Promise(function (resolve, reject) {
            self._initializeHostedFields().then(function () {
              self._bus.emit(events.HOSTED_FIELDS_TOKENIZE, options, function (response) {
                if (response.err) {
                  reject(new BraintreeError(response.err));
                  return;
                }
                resolve(response.payload);
              });
            });
          });
        }
        return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
      };

      /**
       * Cleanly remove anything set up by {@link module:braintree-web/unionpay.create|create}. This only needs to be called when using UnionPay with Hosted Fields.
       * @public
       * @param {callback} [callback] Called on completion. If no callback is provided, returns a promise.
       * @example
       * unionpayInstance.teardown();
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      UnionPay.prototype.teardown = function () {
        if (this._bus) {
          this._hostedFieldsFrame.parentNode.removeChild(this._hostedFieldsFrame);
          this._bus.teardown();
        }
        convertMethodsToError(this, methods(UnionPay.prototype));
        return Promise.resolve();
      };
      UnionPay.prototype._initializeHostedFields = function () {
        var assetsUrl, isDebug;
        var componentId = uuid();
        var self = this;
        if (this._hostedFieldsInitializePromise) {
          return this._hostedFieldsInitializePromise;
        }
        this._hostedFieldsInitializePromise = new Promise(function (resolve) {
          assetsUrl = self._options.client.getConfiguration().gatewayConfiguration.assetsUrl;
          isDebug = self._options.client.getConfiguration().isDebug;
          self._bus = new Bus({
            channel: componentId,
            verifyDomain: isVerifiedDomain
          });
          self._hostedFieldsFrame = iFramer({
            name: constants.HOSTED_FIELDS_FRAME_NAME + "_" + componentId,
            src: assetsUrl + "/web/" + VERSION + "/html/unionpay-hosted-fields-frame" + useMin(isDebug) + ".html",
            height: 0,
            width: 0
          });
          self._bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function (reply) {
            reply(self._options.client);
            resolve();
          });
          document.body.appendChild(self._hostedFieldsFrame);
        });
        return this._hostedFieldsInitializePromise;
      };
      module.exports = wrapPromise.wrapPrototype(UnionPay);
    }, {
      "../../lib/analytics": 135,
      "../../lib/braintree-error": 140,
      "../../lib/constants": 142,
      "../../lib/convert-methods-to-error": 143,
      "../../lib/is-verified-domain": 170,
      "../../lib/methods": 172,
      "../../lib/use-min": 178,
      "./constants": 221,
      "./errors": 222,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "@braintree/wrap-promise": 40,
      "framebus": 50
    }],
    224: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        PLAID_LINK_JS: "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
      };
    }, {}],
    225: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Us Bank Account - Creation Error Codes
       * @description Errors that occur when [creating the Us Bank Account component](./module-braintree-web_us-bank-account.html#.create).
       * @property {MERCHANT} US_BANK_ACCOUNT_NOT_ENABLED Occurs when US Bank Account is not enabled in the Braintree control panel.
       */

      /**
       * @name BraintreeError.Us Bank Account - tokenize Error Codes
       * @description Errors that occur when using the [`tokenize` method](./UsBankAccount.html#tokenize).
       * @property {MERCHANT} US_BANK_ACCOUNT_OPTION_REQUIRED Occurs when a required option is not passed.
       * @property {MERCHANT} US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS Occurs when 1 or more incompatible options are passed.
       * @property {NETWORK} US_BANK_ACCOUNT_LOGIN_LOAD_FAILED Occurs when bank login flow fails.
       * @property {CUSTOMER} US_BANK_ACCOUNT_LOGIN_CLOSED Occurs when bank login window is closed.
       * @property {MERCHANT} US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE Occurs when a bank login flow is already active.
       * @property {NETWORK} US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR Occurs when payment details could not be tokenized.
       * @property {CUSTOMER} US_BANK_ACCOUNT_FAILED_TOKENIZATION Occurs when payment details failed to be tokenized.
       * @property {MERCHANT} US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED Occurs when bank login flow is not enabled in the Braintree control panel.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        US_BANK_ACCOUNT_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "US_BANK_ACCOUNT_OPTION_REQUIRED"
        },
        US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS: {
          type: BraintreeError.types.MERCHANT,
          code: "US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS"
        },
        US_BANK_ACCOUNT_LOGIN_LOAD_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "US_BANK_ACCOUNT_LOGIN_LOAD_FAILED",
          message: "Bank login flow failed to load."
        },
        US_BANK_ACCOUNT_LOGIN_CLOSED: {
          type: BraintreeError.types.CUSTOMER,
          code: "US_BANK_ACCOUNT_LOGIN_CLOSED",
          message: "Customer closed bank login flow before authorizing."
        },
        US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE: {
          type: BraintreeError.types.MERCHANT,
          code: "US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE",
          message: "Another bank login tokenization request is active."
        },
        US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR",
          message: "A tokenization network error occurred."
        },
        US_BANK_ACCOUNT_FAILED_TOKENIZATION: {
          type: BraintreeError.types.CUSTOMER,
          code: "US_BANK_ACCOUNT_FAILED_TOKENIZATION",
          message: "The supplied data failed tokenization."
        },
        US_BANK_ACCOUNT_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "US_BANK_ACCOUNT_NOT_ENABLED",
          message: "US bank account is not enabled."
        },
        US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED",
          message: "Bank login is not enabled."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    226: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/us-bank-account
       * @description This module is for accepting payments of US bank accounts.
       */
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var errors = _dereq_("./errors");
      var USBankAccount = _dereq_("./us-bank-account");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link USBankAccount} instance. If no callback is provided, `create` returns a promise that resolves with the {@link USBankAccount} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "US Bank Account";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          var usBankAccount;
          options.client = client;
          usBankAccount = options.client.getConfiguration().gatewayConfiguration.usBankAccount;
          if (!usBankAccount) {
            return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_NOT_ENABLED));
          }
          return new USBankAccount(options);
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./errors": 225,
      "./us-bank-account": 227,
      "@braintree/wrap-promise": 40
    }],
    227: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var constants = _dereq_("./constants");
      var errors = _dereq_("./errors");
      var sharedErrors = _dereq_("../lib/errors");
      var analytics = _dereq_("../lib/analytics");
      var once = _dereq_("../lib/once");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var methods = _dereq_("../lib/methods");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var TOKENIZE_BANK_DETAILS_MUTATION = createGraphQLMutation("UsBankAccount");
      var TOKENIZE_BANK_LOGIN_MUTATION = createGraphQLMutation("UsBankLogin");

      /**
       * @typedef {object} USBankAccount~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} type The payment method type, always `us_bank_account`.
       * @property {object} details Additional account details. Currently empty.
       */

      /**
       * @class
       * @param {object} options See {@link module:braintree-web/us-bank-account.create|us-bank-account.create}.
       * @classdesc This class represents a US Bank Account component. Instances of this class can tokenize raw bank details or present a bank login. <strong>You cannot use this constructor directly. Use {@link module:braintree-web/us-bank-account.create|braintree.us-bank-account.create} instead.</strong>
       */
      function USBankAccount(options) {
        this._client = options.client;
        this._isTokenizingBankLogin = false;
        analytics.sendEvent(this._client, "usbankaccount.initialized");
      }

      /**
       * Tokenizes bank information to return a payment method nonce. You can tokenize bank details by providing information like account and routing numbers. You can also tokenize with a bank login UI that prompts the customer to log into their bank account.
       * @public
       * @param {object} options All tokenization options for the US Bank Account component.
       * @param {string} options.mandateText A string for proof of customer authorization. For example, `'I authorize Braintree to debit my bank account on behalf of My Online Store.'`.
       * @param {object} [options.bankDetails] Bank detail information (such as account and routing numbers). `bankDetails` or `bankLogin` option must be provided.
       * @param {string} options.bankDetails.routingNumber The customer's bank routing number, such as `'307075259'`.
       * @param {string} options.bankDetails.accountNumber The customer's bank account number, such as `'999999999'`.
       * @param {string} options.bankDetails.accountType The customer's bank account type. Must be `'checking'` or `'savings'`.
       * @param {string} options.bankDetails.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
       * @param {string} [options.bankDetails.firstName] The customer's first name. Required when account ownership type is `personal`.
       * @param {string} [options.bankDetails.lastName] The customer's last name. Required when account ownership type is `personal`.
       * @param {string} [options.bankDetails.businessName] The customer's business name. Required when account ownership type is `business`.
       * @param {object} options.bankDetails.billingAddress The customer's billing address.
       * @param {string} options.bankDetails.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
       * @param {string} [options.bankDetails.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
       * @param {string} options.bankDetails.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
       * @param {string} options.bankDetails.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
       * @param {string} options.bankDetails.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
       * @param {object} [options.bankLogin] Bank login information. `bankLogin` or `bankDetails` option must be provided.
       * @param {string} options.bankLogin.displayName Display name for the bank login UI, such as `'My Store'`.
       * @param {string} options.bankLogin.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
       * @param {string} [options.bankLogin.firstName] The customer's first name. Required when account ownership type is `personal`.
       * @param {string} [options.bankLogin.lastName] The customer's last name. Required when account ownership type is `personal`.
       * @param {string} [options.bankLogin.businessName] The customer's business name. Required when account ownership type is `business`.
       * @param {object} options.bankLogin.billingAddress The customer's billing address.
       * @param {string} options.bankLogin.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
       * @param {string} [options.bankLogin.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
       * @param {string} options.bankLogin.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
       * @param {string} options.bankLogin.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
       * @param {string} options.bankLogin.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link USBankAccount~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with {@link USBankAccount~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * <caption>Tokenizing raw bank details</caption>
       * var routingNumberInput = document.querySelector('input[name="routing-number"]');
       * var accountNumberInput = document.querySelector('input[name="account-number"]');
       * var accountTypeInput = document.querySelector('input[name="account-type"]:checked');
       * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
       * var firstNameInput = document.querySelector('input[name="first-name"]');
       * var lastNameInput = document.querySelector('input[name="last-name"]');
       * var businessNameInput = document.querySelector('input[name="business-name"]');
       * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
       * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
       * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
       * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
       * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
       *
       * submitButton.addEventListener('click', function (event) {
       *   var bankDetails = {
       *     routingNumber: routingNumberInput.value,
       *     accountNumber: accountNumberInput.value,
       *     accountType: accountTypeInput.value,
       *     ownershipType: ownershipTypeInput.value,
       *     billingAddress: {
       *       streetAddress: billingAddressStreetInput.value,
       *       extendedAddress: billingAddressExtendedInput.value,
       *       locality: billingAddressLocalityInput.value,
       *       region: billingAddressRegionSelect.value,
       *       postalCode: billingAddressPostalInput.value
       *     }
       *   };
       *
       *   if (bankDetails.ownershipType === 'personal') {
       *     bankDetails.firstName = firstNameInput.value;
       *     bankDetails.lastName = lastNameInput.value;
       *   } else {
       *     bankDetails.businessName = businessNameInput.value;
       *   }
       *
       *   event.preventDefault();
       *
       *   usBankAccountInstance.tokenize({
       *     bankDetails: bankDetails,
       *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
       *   }, function (tokenizeErr, tokenizedPayload) {
       *     if (tokenizeErr) {
       *       console.error('There was an error tokenizing the bank details.');
       *       return;
       *     }
       *
       *     // Send tokenizePayload.nonce to your server here!
       *   });
       * });
       * @example
       * <caption>Tokenizing with bank login UI</caption>
       * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
       * var firstNameInput = document.querySelector('input[name="first-name"]');
       * var lastNameInput = document.querySelector('input[name="last-name"]');
       * var businessNameInput = document.querySelector('input[name="business-name"]');
       * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
       * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
       * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
       * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
       * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
       *
       * bankLoginButton.addEventListener('click', function (event) {
       *   var bankLogin = {
       *     displayName: 'My Online Store',
       *     ownershipType: ownershipTypeInput.value,
       *     billingAddress: {
       *       streetAddress: billingAddressStreetInput.value,
       *       extendedAddress: billingAddressExtendedInput.value,
       *       locality: billingAddressLocalityInput.value,
       *       region: billingAddressRegionSelect.value,
       *       postalCode: billingAddressPostalInput.value
       *     }
       *   }
       *   event.preventDefault();
       *
       *   if (bankLogin.ownershipType === 'personal') {
       *     bankLogin.firstName = firstNameInput.value;
       *     bankLogin.lastName = lastNameInput.value;
       *   } else {
       *     bankLogin.businessName = businessNameInput.value;
       *   }
       *
       *   usBankAccountInstance.tokenize({
       *     bankLogin: bankLogin,
       *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
       *   }, function (tokenizeErr, tokenizedPayload) {
       *     if (tokenizeErr) {
       *       console.error('There was an error tokenizing the bank details.');
       *       return;
       *     }
       *
       *     // Send tokenizePayload.nonce to your server here!
       *   });
       * });
       */
      USBankAccount.prototype.tokenize = function (options) {
        options = options || {};
        if (!options.mandateText) {
          return Promise.reject(new BraintreeError({
            type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
            code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
            message: "mandateText property is required."
          }));
        }
        if (options.bankDetails && options.bankLogin) {
          return Promise.reject(new BraintreeError({
            type: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.type,
            code: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.code,
            message: "tokenize must be called with bankDetails or bankLogin, not both."
          }));
        } else if (options.bankDetails) {
          return this._tokenizeBankDetails(options);
        } else if (options.bankLogin) {
          return this._tokenizeBankLogin(options);
        }
        return Promise.reject(new BraintreeError({
          type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
          code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
          message: "tokenize must be called with bankDetails or bankLogin."
        }));
      };
      USBankAccount.prototype._tokenizeBankDetails = function (options) {
        var client = this._client;
        var bankDetails = options.bankDetails;
        var data = {
          achMandate: options.mandateText,
          routingNumber: bankDetails.routingNumber,
          accountNumber: bankDetails.accountNumber,
          accountType: bankDetails.accountType.toUpperCase(),
          billingAddress: formatBillingAddressForGraphQL(bankDetails.billingAddress || {})
        };
        formatDataForOwnershipType(data, bankDetails);
        return client.request({
          api: "graphQLApi",
          data: {
            query: TOKENIZE_BANK_DETAILS_MUTATION,
            variables: {
              input: {
                usBankAccount: data
              }
            }
          }
        }).then(function (response) {
          analytics.sendEvent(client, "usbankaccount.bankdetails.tokenization.succeeded");
          return Promise.resolve(formatTokenizeResponseFromGraphQL(response, "tokenizeUsBankAccount"));
        }).catch(function (err) {
          var error = errorFrom(err);
          analytics.sendEvent(client, "usbankaccount.bankdetails.tokenization.failed");
          return Promise.reject(error);
        });
      };
      USBankAccount.prototype._tokenizeBankLogin = function (options) {
        var self = this;
        var client = this._client;
        var gatewayConfiguration = client.getConfiguration().gatewayConfiguration;
        var isProduction = gatewayConfiguration.environment === "production";
        var plaidConfig = gatewayConfiguration.usBankAccount.plaid;
        if (!options.bankLogin.displayName) {
          return Promise.reject(new BraintreeError({
            type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
            code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
            message: "displayName property is required when using bankLogin."
          }));
        }
        if (!plaidConfig) {
          return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED));
        }
        if (this._isTokenizingBankLogin) {
          return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE));
        }
        this._isTokenizingBankLogin = true;
        return new Promise(function (resolve, reject) {
          self._loadPlaid(function (plaidLoadErr, plaid) {
            if (plaidLoadErr) {
              reject(plaidLoadErr);
              return;
            }
            plaid.create({
              clientName: options.bankLogin.displayName,
              apiVersion: "v2",
              env: isProduction ? "production" : "sandbox",
              key: plaidConfig.publicKey,
              product: "auth",
              selectAccount: true,
              onExit: function () {
                self._isTokenizingBankLogin = false;
                analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.closed.by-user");
                reject(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_CLOSED));
              },
              onSuccess: function (publicToken, metadata) {
                var bankLogin = options.bankLogin;
                var data = {
                  publicToken: publicToken,
                  accountId: isProduction ? metadata.account_id : "plaid_account_id",
                  accountType: metadata.account.subtype.toUpperCase(),
                  achMandate: options.mandateText,
                  billingAddress: formatBillingAddressForGraphQL(bankLogin.billingAddress || {})
                };
                formatDataForOwnershipType(data, bankLogin);
                client.request({
                  api: "graphQLApi",
                  data: {
                    query: TOKENIZE_BANK_LOGIN_MUTATION,
                    variables: {
                      input: {
                        usBankLogin: data
                      }
                    }
                  }
                }).then(function (response) {
                  self._isTokenizingBankLogin = false;
                  analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.succeeded");
                  resolve(formatTokenizeResponseFromGraphQL(response, "tokenizeUsBankLogin"));
                }).catch(function (tokenizeErr) {
                  var error;
                  self._isTokenizingBankLogin = false;
                  error = errorFrom(tokenizeErr);
                  analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.failed");
                  reject(error);
                });
              }
            }).open();
            analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.started");
          });
        });
      };
      function errorFrom(err) {
        var error;
        var status = err.details && err.details.httpStatus;
        if (status === 401) {
          error = new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
        } else if (status < 500) {
          error = new BraintreeError(errors.US_BANK_ACCOUNT_FAILED_TOKENIZATION);
        } else {
          error = new BraintreeError(errors.US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR);
        }
        error.details = {
          originalError: err
        };
        return error;
      }
      function formatTokenizeResponseFromGraphQL(response, type) {
        var data = response.data[type].paymentMethod;
        var last4 = data.details.last4;
        var description = "US bank account ending in - " + last4;
        return {
          nonce: data.id,
          details: {},
          description: description,
          type: "us_bank_account"
        };
      }
      USBankAccount.prototype._loadPlaid = function (callback) {
        var existingScript, script;
        callback = once(callback);
        if (window.Plaid) {
          callback(null, window.Plaid);
          return;
        }
        existingScript = document.querySelector('script[src="' + constants.PLAID_LINK_JS + '"]');
        if (existingScript) {
          addLoadListeners(existingScript, callback);
        } else {
          script = document.createElement("script");
          script.src = constants.PLAID_LINK_JS;
          script.async = true;
          addLoadListeners(script, callback);
          document.body.appendChild(script);
          this._plaidScript = script;
        }
      };
      function addLoadListeners(script, callback) {
        function loadHandler() {
          var readyState = this.readyState; // eslint-disable-line no-invalid-this

          if (!readyState || readyState === "loaded" || readyState === "complete") {
            removeLoadListeners();
            callback(null, window.Plaid);
          }
        }
        function errorHandler() {
          script.parentNode.removeChild(script);
          callback(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_LOAD_FAILED));
        }
        function removeLoadListeners() {
          script.removeEventListener("error", errorHandler);
          script.removeEventListener("load", loadHandler);
          script.removeEventListener("readystatechange", loadHandler);
        }
        script.addEventListener("error", errorHandler);
        script.addEventListener("load", loadHandler);
        script.addEventListener("readystatechange", loadHandler);
      }
      function formatBillingAddressForGraphQL(address) {
        return {
          streetAddress: address.streetAddress,
          extendedAddress: address.extendedAddress,
          city: address.locality,
          state: address.region,
          zipCode: address.postalCode
        };
      }
      function formatDataForOwnershipType(data, details) {
        if (details.ownershipType === "personal") {
          data.individualOwner = {
            firstName: details.firstName,
            lastName: details.lastName
          };
        } else if (details.ownershipType === "business") {
          data.businessOwner = {
            businessName: details.businessName
          };
        }
      }
      function createGraphQLMutation(type) {
        return "" + "mutation Tokenize" + type + "($input: Tokenize" + type + "Input!) {" + "  tokenize" + type + "(input: $input) {" + "    paymentMethod {" + "      id" + "      details {" + "        ... on UsBankAccountDetails {" + "          last4" + "        }" + "      }" + "    }" + "  }" + "}";
      }

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/us-bank-account.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * usBankAccountInstance.teardown();
       * @example <caption>With callback</caption>
       * usBankAccountInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      USBankAccount.prototype.teardown = function () {
        if (this._plaidScript) {
          document.body.removeChild(this._plaidScript);
        }
        convertMethodsToError(this, methods(USBankAccount.prototype));
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(USBankAccount);
    }, {
      "../lib/analytics": 135,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/errors": 151,
      "../lib/methods": 172,
      "../lib/once": 173,
      "./constants": 224,
      "./errors": 225,
      "@braintree/wrap-promise": 40
    }],
    228: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Vault Manager - deletePaymentMethod Error Codes
       * @description Errors that occur when using the [`deletePaymentMethod` method](./VaultManager.html#deletePaymentMethod).
       * @property {MERCHANT} VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN Occurs when vault manager is initialized with a tokenization key instead of a Client Token.
       * @property {MERCHANT} VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND Occurs when the specified payment method can not be found.
       * @property {UNKNOWN} VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR Occurs when there is an error attempting to delete the payment method.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN: {
          type: BraintreeError.types.MERCHANT,
          code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN",
          message: "A client token with a customer id must be used to delete a payment method nonce."
        },
        VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND: {
          type: BraintreeError.types.MERCHANT,
          code: "VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND"
        },
        VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR"
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    229: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/vault-manager
       * @description Manages customer's payment methods.
       */
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var VaultManager = _dereq_("./vault-manager");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} callback The second argument, `data`, is the {@link VaultManager} instance.
       * @returns {void}
       */
      function create(options) {
        var name = "Vault Manager";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return new VaultManager({
            createPromise: createDeferredClient.create({
              authorization: options.authorization,
              client: options.client,
              debug: options.debug,
              assetsUrl: createAssetsUrl.create(options.authorization),
              name: name
            })
          });
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/basic-component-verification": 138,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./vault-manager": 230,
      "@braintree/wrap-promise": 40
    }],
    230: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../lib/analytics");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var errors = _dereq_("./errors");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var methods = _dereq_("../lib/methods");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var DELETE_PAYMENT_METHOD_MUTATION = "mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {" + "  deletePaymentMethodFromSingleUseToken(input: $input) {" + "    clientMutationId" + "  }" + "}";

      /**
       * @typedef {array} VaultManager~fetchPaymentMethodsPayload The customer's payment methods.
       * @property {object} paymentMethod The payment method object.
       * @property {string} paymentMethod.nonce A nonce that can be sent to your server to transact on the payment method.
       * @property {boolean} paymentMethod.default Whether or not this is the default payment method for the customer.
       * @property {object} paymentMethod.details Any additional details about the payment method. Varies depending on the type of payment method.
       * @property {string} paymentMethod.type A constant indicating the type of payment method.
       * @property {?string} paymentMethod.description Additional description about the payment method.
       * @property {?object} paymentMethod.binData Bin data about the payment method.
       *
       */

      /**
       * @class
       * @param {object} options Options
       * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/vault-manager.create|braintree.vault-manager.create} instead.</strong>
       * @classdesc This class allows you to manage a customer's payment methods on the client.
       */
      function VaultManager(options) {
        this._createPromise = options.createPromise;
      }

      /**
       * Fetches payment methods owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
       * @public
       * @param {object} [options] Options for fetching payment methods.
       * @param {boolean} [options.defaultFirst = false] If `true`, the payment methods will be returned with the default payment method for the customer first. Otherwise, order is not guaranteed.
       * @param {callback} [callback] The second argument is a {@link VaultManager~fetchPaymentMethodsPayload|fetchPaymentMethodsPayload}. This is also what is resolved by the promise if no callback is provided.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * vaultManagerInstance.fetchPaymentMethods(function (err, paymentMethods) {
       *   paymentMethods.forEach(function (paymentMethod) {
       *     // add payment method to UI
       *     // paymentMethod.nonce <- transactable nonce associated with payment method
       *     // paymentMethod.details <- object with additional information about payment method
       *     // paymentMethod.type <- a constant signifying the type
       *   });
       * });
       */
      VaultManager.prototype.fetchPaymentMethods = function (options) {
        var defaultFirst;
        options = options || {};
        defaultFirst = options.defaultFirst === true ? 1 : 0;
        return this._createPromise.then(function (client) {
          return client.request({
            endpoint: "payment_methods",
            method: "get",
            data: {
              defaultFirst: defaultFirst
            }
          });
        }).then(function (paymentMethodsPayload) {
          analytics.sendEvent(this._createPromise, "vault-manager.fetch-payment-methods.succeeded");
          return paymentMethodsPayload.paymentMethods.map(formatPaymentMethodPayload);
        }.bind(this));
      };

      /**
       * Deletes a payment method owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
       * @public
       * @param {string} paymentMethodNonce The payment method nonce that references a vaulted payment method.
       * @param {callback} [callback] No data is returned if the operation is successful.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * vaultManagerInstance.deletePaymentMethod('nonce-to-delete', function (err) {
       *   // handle err if it exists
       * });
       */
      VaultManager.prototype.deletePaymentMethod = function (paymentMethodNonce) {
        return this._createPromise.then(function (client) {
          var usesClientToken = client.getConfiguration().authorizationType === "CLIENT_TOKEN";
          if (!usesClientToken) {
            return Promise.reject(new BraintreeError(errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN));
          }
          return client.request({
            api: "graphQLApi",
            data: {
              query: DELETE_PAYMENT_METHOD_MUTATION,
              variables: {
                input: {
                  singleUseTokenId: paymentMethodNonce
                }
              },
              operationName: "DeletePaymentMethodFromSingleUseToken"
            }
          }).then(function () {
            analytics.sendEvent(client, "vault-manager.delete-payment-method.succeeded");

            // noop to prevent sending back the raw graphql data
          }).catch(function (error) {
            var originalError = error.details.originalError;
            var formattedError;
            analytics.sendEvent(client, "vault-manager.delete-payment-method.failed");
            if (originalError[0] && originalError[0].extensions.errorClass === "NOT_FOUND") {
              formattedError = new BraintreeError({
                type: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.type,
                code: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.code,
                message: "A payment method for payment method nonce `" + paymentMethodNonce + "` could not be found.",
                details: {
                  originalError: originalError
                }
              });
            }
            if (!formattedError) {
              formattedError = new BraintreeError({
                type: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.type,
                code: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.code,
                message: "An unknown error occured when attempting to delete the payment method assocaited with the payment method nonce `" + paymentMethodNonce + "`.",
                details: {
                  originalError: originalError
                }
              });
            }
            return Promise.reject(formattedError);
          });
        });
      };
      function formatPaymentMethodPayload(paymentMethod) {
        var formattedPaymentMethod = {
          nonce: paymentMethod.nonce,
          default: paymentMethod.default,
          details: paymentMethod.details,
          hasSubscription: paymentMethod.hasSubscription,
          type: paymentMethod.type
        };
        if (paymentMethod.description) {
          formattedPaymentMethod.description = paymentMethod.description;
        }
        if (paymentMethod.binData) {
          formattedPaymentMethod.binData = paymentMethod.binData;
        }
        return formattedPaymentMethod;
      }

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/vault-manager.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * vaultManagerInstance.teardown();
       * @example <caption>With callback</caption>
       * vaultManagerInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      VaultManager.prototype.teardown = function () {
        convertMethodsToError(this, methods(VaultManager.prototype));
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(VaultManager);
    }, {
      "../lib/analytics": 135,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/methods": 172,
      "./errors": 228,
      "@braintree/wrap-promise": 40
    }],
    231: [function (_dereq_, module, exports) {
      "use strict";

      var __importDefault = this && this.__importDefault || function (mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      var venmo_desktop_1 = __importDefault(_dereq_("./venmo-desktop"));
      module.exports = function createVenmoDesktop(options) {
        var instance = new venmo_desktop_1.default(options);
        return instance.initialize();
      };
    }, {
      "./venmo-desktop": 233
    }],
    232: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY = exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY = exports.UPDATE_PAYMENT_CONTEXT_QUERY = exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY = exports.CREATE_PAYMENT_CONTEXT_QUERY = exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY = void 0;
      exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY = "mutation CreateVenmoQRCodePaymentContext($input: CreateVenmoQRCodePaymentContextInput!) {\n  createVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n    venmoQRCodePaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
      exports.CREATE_PAYMENT_CONTEXT_QUERY = "mutation CreateVenmoPaymentContext($input: CreateVenmoPaymentContextInput!) {\n  createVenmoPaymentContext(input: $input) {\n    clientMutationId\n    venmoPaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
      exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY = "mutation UpdateVenmoQRCodePaymentContext($input: UpdateVenmoQRCodePaymentContextInput!) {\n  updateVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n  }\n}";
      exports.UPDATE_PAYMENT_CONTEXT_QUERY = "mutation UpdateVenmoPaymentContextStatus($input: UpdateVenmoPaymentContextStatusInput!) {\n  updateVenmoPaymentContextStatus(input: $input) {\n    clientMutationId\n  }\n}";
      exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY = "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoQRCodePaymentContext {\n      status\n      paymentMethodId\n      userName\n    }\n  }\n}";
      exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY = "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoPaymentContext {\n      status\n      paymentMethodId\n      userName\n      payerInfo {\n        firstName\n        lastName\n        phoneNumber\n        email\n        externalId\n        userName\n        billingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n        shippingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n      }\n    }\n  }\n}";
    }, {}],
    233: [function (_dereq_, module, exports) {
      "use strict";

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
        };
        return __assign.apply(this, arguments);
      };
      var __importDefault = this && this.__importDefault || function (mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var framebus_1 = __importDefault(_dereq_("framebus"));
      var iframer_1 = __importDefault(_dereq_("@braintree/iframer"));
      var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
      var events_1 = _dereq_("../shared/events");
      var queries_1 = _dereq_("./queries");
      var VENMO_DESKTOP_POLLING_INTERVAL = 1000; // 1 second
      var VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION = 2000; // 2 seconds
      var VenmoDesktop = /** @class */function () {
        function VenmoDesktop(options) {
          this.isHidden = true;
          this.env = options.environment;
          this.id = uuid_1.default();
          this.profileId = options.profileId;
          this.displayName = options.displayName;
          this.paymentMethodUsage = options.paymentMethodUsage;
          this.shouldUseLegacyQRCodeMutation = !this.paymentMethodUsage;
          var frameUrl = options.url + "#" + this.env + "_" + this.id;
          this.bus = new framebus_1.default({
            channel: this.id,
            verifyDomain: options.verifyDomain,
            targetFrames: []
          });
          this.apiRequest = options.apiRequest;
          this.sendEvent = options.sendEvent;
          this.Promise = options.Promise;
          this.alertBox = document.createElement("div");
          this.alertBox.setAttribute("data-venmo-desktop-id", this.id);
          this.alertBox.setAttribute("role", "alert");
          this.alertBox.style.position = "fixed";
          this.alertBox.style.display = "none";
          this.alertBox.style.height = "1px";
          this.alertBox.style.width = "1px";
          this.alertBox.style.overflow = "hidden";
          this.alertBox.style.zIndex = "0";
          this.iframe = iframer_1.default({
            src: frameUrl,
            name: "venmo-desktop-iframe",
            style: {
              display: "none",
              position: "fixed",
              top: "0",
              bottom: "0",
              right: "0",
              left: "0",
              height: "100%",
              width: "100%",
              zIndex: "9999999"
            },
            title: "Venmo Desktop"
          });
          this.bus.addTargetFrame(this.iframe);
        }
        VenmoDesktop.prototype.initialize = function () {
          var _this = this;
          return new this.Promise(function (resolve) {
            _this.bus.on(events_1.VENMO_DESKTOP_IFRAME_READY, function () {
              resolve(_this);
            });
            _this.bus.on(events_1.VENMO_DESKTOP_REQUEST_NEW_QR_CODE, function () {
              _this.sendEvent("venmo.tokenize.desktop.restarted-from-error-view");
              _this.startPolling();
            });
            document.body.appendChild(_this.iframe);
            document.body.appendChild(_this.alertBox);
          });
        };
        VenmoDesktop.prototype.launchDesktopFlow = function () {
          var _this = this;
          this.isHidden = false;
          var promise = new this.Promise(function (resolve, reject) {
            _this.launchDesktopPromiseRejectFunction = reject;
            var removeListeners = function () {
              /* eslint-disable @typescript-eslint/no-use-before-define */
              _this.bus.off(events_1.VENMO_DESKTOP_CUSTOMER_CANCELED, customerCancelledHandler);
              _this.bus.off(events_1.VENMO_DESKTOP_UNKNOWN_ERROR, unknownErrorHandler);
              /* eslint-enable @typescript-eslint/no-use-before-define */
            };
            var unknownErrorHandler = function (err) {
              removeListeners();
              _this.sendEvent("venmo.tokenize.desktop.unknown-error");
              reject({
                allowUIToHandleError: false,
                reason: "UNKNOWN_ERROR",
                err: err
              });
            };
            var customerCancelledHandler = function () {
              removeListeners();
              _this.updateVenmoDesktopPaymentContext("CANCELED");
              _this.sendEvent("venmo.tokenize.desktop.status-change.canceled-from-modal");
              reject({
                allowUIToHandleError: false,
                reason: "CUSTOMER_CANCELED"
              });
            };
            _this.completedHandler = function (payload) {
              removeListeners();
              resolve(payload);
            };
            _this.bus.on(events_1.VENMO_DESKTOP_CUSTOMER_CANCELED, customerCancelledHandler);
            _this.bus.on(events_1.VENMO_DESKTOP_UNKNOWN_ERROR, unknownErrorHandler);
          });
          this.iframe.style.display = "block";
          this.setAlert("Generating a QR code, get your Venmo app ready");
          this.iframe.focus();
          this.startPolling();
          return promise.then(function (result) {
            delete _this.venmoContextId;
            delete _this.launchDesktopPromiseRejectFunction;
            return result;
          }).catch(function (err) {
            delete _this.venmoContextId;
            delete _this.launchDesktopPromiseRejectFunction;
            return _this.Promise.reject(err);
          });
        };
        VenmoDesktop.prototype.triggerCompleted = function (result) {
          var _this = this;
          if (this.isHidden) {
            return;
          }
          setTimeout(function () {
            if (_this.completedHandler) {
              _this.completedHandler(result);
            }
            delete _this.completedHandler;
          }, VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION);
        };
        VenmoDesktop.prototype.triggerRejected = function (err) {
          if (this.launchDesktopPromiseRejectFunction) {
            this.launchDesktopPromiseRejectFunction(err);
          }
        };
        VenmoDesktop.prototype.hideDesktopFlow = function () {
          this.setAlert("");
          this.iframe.style.display = "none";
          this.bus.emit(events_1.VENMO_DESKTOP_CLOSED_FROM_PARENT);
          this.isHidden = true;
        };
        VenmoDesktop.prototype.displayError = function (message) {
          if (this.isHidden) {
            return;
          }
          this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_ERROR, {
            message: message
          });
          this.setAlert(message);
        };
        VenmoDesktop.prototype.displayQRCode = function (id, merchantId) {
          if (this.isHidden) {
            return;
          }
          this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_QR_CODE, {
            id: id,
            merchantId: merchantId
          });
          this.setAlert("To scan the QR code, open your Venmo app");
        };
        VenmoDesktop.prototype.authorize = function () {
          if (this.isHidden) {
            return;
          }
          this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZE);
          this.setAlert("Venmo account authorized");
        };
        VenmoDesktop.prototype.authorizing = function () {
          if (this.isHidden) {
            return;
          }
          this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZING);
          this.setAlert("Authorize on your Venmo app");
        };
        VenmoDesktop.prototype.startPolling = function () {
          var _this = this;
          return this.createVenmoDesktopPaymentContext().then(function (result) {
            var expiresIn = new Date(result.expiresAt).getTime() - new Date(result.createdAt).getTime();
            var expiredTime = Date.now() + expiresIn;
            _this.displayQRCode(result.id, result.merchantId);
            return _this.pollForStatusChange(result.status, expiredTime);
          }).then(function (result) {
            if (!result) {
              return;
            }
            // since we are manually adding a prepended @ sign
            // we want to make sure that the username does not
            // start giving us the @ sign up front in the future
            var username = result.userName || "";
            username = "@" + username.replace("@", "");
            _this.triggerCompleted({
              paymentMethodNonce: result.paymentMethodId,
              username: username,
              payerInfo: result.payerInfo,
              id: _this.venmoContextId || ""
            });
          }).catch(function (err) {
            if (err.allowUIToHandleError) {
              // noop here and let the UI handle the customer error
              return;
            }
            _this.sendEvent("venmo.tokenize.desktop.unhandled-error");
            _this.triggerRejected(err);
          });
        };
        VenmoDesktop.prototype.pollForStatusChange = function (status, expiredTime) {
          var _this = this;
          if (!this.venmoContextId) {
            return this.Promise.resolve();
          }
          if (Date.now() > expiredTime) {
            return this.updateVenmoDesktopPaymentContext("EXPIRED").then(function () {
              _this.displayError("Something went wrong");
              _this.sendEvent("venmo.tokenize.desktop.status-change.sdk-timeout");
              return _this.Promise.reject({
                allowUIToHandleError: true,
                reason: "TIMEOUT"
              });
            });
          }
          return this.lookupVenmoDesktopPaymentContext().then(function (response) {
            if (!_this.venmoContextId || !response) {
              return _this.Promise.resolve();
            }
            var newStatus = response.status;
            if (newStatus !== status) {
              status = newStatus;
              _this.sendEvent("venmo.tokenize.desktop.status-change." + status.toLowerCase());
              switch (status) {
                case "CREATED":
                  // noop, no need to do anything here
                  // should never be able to get to this point
                  // but we'll keep it in to enumerate the statuses
                  break;
                case "EXPIRED":
                case "FAILED":
                case "CANCELED":
                  var message = status === "CANCELED" ? "The authorization was canceled" : "Something went wrong";
                  _this.displayError(message);
                  // these are all terminal states, so we end it here
                  return _this.Promise.reject({
                    allowUIToHandleError: true,
                    reason: status
                  });
                case "SCANNED":
                  _this.authorizing();
                  break;
                case "APPROVED":
                  _this.authorize();
                  return _this.Promise.resolve(response);
                default:
                // any other statuses are irrelevant to the polling
                // and can just be ignored
              }
            }
            return new _this.Promise(function (resolve, reject) {
              setTimeout(function () {
                _this.pollForStatusChange(status, expiredTime).then(resolve).catch(reject);
              }, VENMO_DESKTOP_POLLING_INTERVAL);
            });
          });
        };
        VenmoDesktop.prototype.teardown = function () {
          this.bus.teardown();
          if (this.iframe.parentNode) {
            this.iframe.parentNode.removeChild(this.iframe);
          }
          if (this.alertBox.parentNode) {
            this.alertBox.parentNode.removeChild(this.alertBox);
          }
        };
        VenmoDesktop.prototype.setAlert = function (message) {
          this.alertBox.style.display = message ? "block" : "none";
          this.alertBox.textContent = message;
        };
        VenmoDesktop.prototype.createPaymentContextFromGraphqlLegacyQRCodeMutation = function (intent) {
          return this.apiRequest(queries_1.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY, {
            input: {
              environment: this.env,
              intent: intent
            }
          }).then(function (response) {
            return response.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
          });
        };
        VenmoDesktop.prototype.createPaymentContextFromGraphQL = function (intent) {
          var input = {
            intent: intent,
            paymentMethodUsage: this.paymentMethodUsage,
            customerClient: "DESKTOP"
          };
          if (this.profileId) {
            input.merchantProfileId = this.profileId;
          }
          if (this.displayName) {
            input.displayName = this.displayName;
          }
          return this.apiRequest(queries_1.CREATE_PAYMENT_CONTEXT_QUERY, {
            input: input
          }).then(function (response) {
            return response.createVenmoPaymentContext.venmoPaymentContext;
          });
        };
        VenmoDesktop.prototype.createVenmoDesktopPaymentContext = function () {
          var _this = this;
          var contextPromise = this.shouldUseLegacyQRCodeMutation ? this.createPaymentContextFromGraphqlLegacyQRCodeMutation("PAY_FROM_APP") : this.createPaymentContextFromGraphQL("PAY_FROM_APP");
          return contextPromise.then(function (context) {
            _this.venmoContextId = context.id;
            var merchantId = _this.profileId || context.merchantId;
            return {
              id: context.id,
              status: context.status,
              merchantId: merchantId,
              createdAt: context.createdAt,
              expiresAt: context.expiresAt
            };
          });
        };
        VenmoDesktop.prototype.updateVenmoDesktopPaymentContext = function (status, additionalOptions) {
          if (additionalOptions === void 0) {
            additionalOptions = {};
          }
          if (!this.venmoContextId) {
            return this.Promise.resolve();
          }
          var data = {
            input: __assign({
              id: this.venmoContextId,
              status: status
            }, additionalOptions)
          };
          var query = this.shouldUseLegacyQRCodeMutation ? queries_1.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY : queries_1.UPDATE_PAYMENT_CONTEXT_QUERY;
          return this.apiRequest(query, data).then(function () {
            // noop so we can resolve without any data to match the type
          });
        };
        VenmoDesktop.prototype.lookupVenmoDesktopPaymentContext = function () {
          if (!this.venmoContextId) {
            return this.Promise.resolve();
          }
          var query = this.shouldUseLegacyQRCodeMutation ? queries_1.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY : queries_1.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;
          return this.apiRequest(query, {
            id: this.venmoContextId
          }).then(function (response) {
            return response.node;
          });
        };
        return VenmoDesktop;
      }();
      exports.default = VenmoDesktop;
    }, {
      "../shared/events": 238,
      "./queries": 232,
      "@braintree/iframer": 32,
      "@braintree/uuid": 36,
      "framebus": 50
    }],
    234: [function (_dereq_, module, exports) {
      "use strict";

      /** @module braintree-web/venmo */
      var analytics = _dereq_("../lib/analytics");
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var errors = _dereq_("./shared/errors");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var Venmo = _dereq_("./venmo");
      var supportsVenmo = _dereq_("./shared/supports-venmo");
      var VERSION = "3.115.2";

      /**
       * @typedef {object} Venmo~lineItem
       * @property {number} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
       * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
       * @property {string} name Item name. Maximum 127 characters.
       * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
       * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
       * @property {?string} description Item description. Maximum 127 characters.
       * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
       * @property {?string} url The URL to product information.
       */

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that support returning from the Venmo app to the same tab.
       * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that are not webviews.
       * @param {boolean} [options.ignoreHistoryChanges=false] When the Venmo app returns to the website, it will modify the hash of the url to include data about the tokenization. By default, the SDK will put the state of the hash back to where it was before the change was made. Pass `true` to handle the hash change instead of the SDK.
       * @param {string} [options.profileId] The Venmo profile ID to be used during payment authorization. Customers will see the business name and logo associated with this Venmo profile, and it will show up in the Venmo app as a "Connected Merchant". Venmo profile IDs can be found in the Braintree Control Panel. Omitting this value will use the default Venmo profile.
       * @param {string} [options.deepLinkReturnUrl] An override for the URL that the Venmo iOS app opens to return from an app switch.
       * @param {boolean} [options.requireManualReturn=false] When `true`, the customer will have to manually switch back to the browser/webview that is presenting Venmo to complete the payment.
       * @param {boolean} [options.useRedirectForIOS=false] Normally, the Venmo flow is launched using `window.open` and the Venmo app intercepts that call and opens the Venmo app instead. If the customer does not have the Venmo app installed, it opens the Venmo website in a new window and instructs the customer to install the app.
       
       * In iOS webviews and Safari View Controllers (a webview-like environment which is indistinguishable from Safari for JavaScript environments), this call to `window.open` will always fail to app switch to Venmo, resulting instead in a white screen. Because of this, an alternate approach is required to launch the Venmo flow.
       *
       * When `useRedirectForIOS` is `true` and the Venmo flow is started in an iOS environment, the Venmo flow will be started by setting `window.location.href` to the Venmo website (which will still be intercepted by the Venmo app and should be the same behavior as if `window.open` was called). However, if the customer does not have the Venmo app installed, the merchant page will instead be replaced with the Venmo website and the customer will need to use the browser's back button to return to the merchant's website. Ensure that your customer's checkout information will not be lost if they are navigated away from the website and return using the browser back button.
       *
       * Due to a bug in iOS's implementation of `window.open` in iOS webviews and Safari View Controllers, if `useRedirectForIOS` is not set to `true` and the flow is launched from an iOS webview or Safari View Controller, the customer will be presented with a blank screen, halting the flow and leaving the customer unable to return to the merchant's website. Setting `useRedirectForIOS` to `true` will allow the flow to continue, but the Venmo app will be unable to return back to the webview/Safari View Controller. It will instead open the merchant's site in a new window in the customer's browser, which means the merchant site must be able to process the Venmo payment. If the SDK is configured with `allowNewBrowserTab = false`, it is unlikely that the website is set up to process the Venmo payment from a new window.
       *
       * If processing the payment from a new window is not possible, use this flag in conjunction with `requireManualReturn` so that the customer may start the flow from a webview/Safari View Controller or their Safari browser and manually return to the place that originated the flow once the Venmo app has authorized the payment and instructed them to do so.
       * @param {string} [options.paymentMethodUsage] The intended usage for the Venmo payment method nonce. Possible options are:
       * * single_use - intended as a one time transaction
       * * multi_use - intended to be vaulted and used for multiple transactions
       * @param {string} [options.displayName] The business name that will be displayed in the Venmo app payment approval screen. Only applicable when used with `paymentMethodUsage` and used by merchants onboarded as PayFast channel partners.
       * @param {boolean} [options.allowDesktop] Used to support desktop users. When enabled, the default mode is to render a scannable QR-code customers scan with their phone's to approve via the mobile app.
       * @param {boolean} [options.allowDesktopWebLogin=false] When `true`, the customer will authorize payment via a window popup that allows them to sign in to their Venmo account. This is used explicitly for customers operating from desktop browsers wanting to avoid the QR Code flow.
       * @param {boolean} [options.mobileWebFallBack] Use this option when you want to use a web-login experience, such as if on mobile and the Venmo app isn't installed.
       * @param {boolean} [options.allowAndroidRecreation=true] This flag is for when your integration uses the [Android PopupBridge](https://github.com/braintree/popup-bridge-android). Setting this flag to false will avoid a page refresh when returning to your page after payment authorization. If not specified, it defaults to true and the Android activity will be recreated, resulting in a page refresh.
       * @param {boolean} [options.collectCustomerBillingAddress] When `true`, the customer's billing address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
       * @param {boolean} [options.collectCustomerShippingAddress] When `true`, the customer's shipping address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
       * @param {boolean} [options.isFinalAmount=false] When `true`, it denotes that the purchase amount (`totalAmount`) is final and will not change.
       * @param {lineItem[]} [options.lineItems] The {@link Venmo~lineItem|line items} belonging to the transaction. It can include up to 249 line items.
       * @param {string} [options.subTotalAmount] The subtotal amount of the transaction, excluding taxes, discounts, and shipping.
       * @param {string} [options.discountAmount] The total discount amount applied on the transaction.
       * @param {string} [options.shippingAmount] Shipping amount to be charged for the transaction.
       * @param {string} [options.taxAmount] The total tax amount applied to the transaction. This value can't be negative or zero.
       * @param {string} [options.totalAmount] The grand total amount of the transaction.
       *
       * Note: This flow currently requires a full page redirect, which means to utilize this flow your page will need to be able to handle the checkout session across different pages.
       * @param {callback} [callback] The second argument, `data`, is the {@link Venmo} instance. If no callback is provided, `create` returns a promise that resolves with the {@link Venmo} instance.
       * @example
       * braintree.venmo.create({
       *   client: clientInstance
       * }).then(function (venmoInstance) {
       *   // venmoInstance is ready to be used.
       * }).catch(function (createErr) {
       *   console.error('Error creating Venmo instance', createErr);
       * });
       * @example <caption>Allow desktop flow to be used</caption>
       * braintree.venmo.create({
       *   client: clientInstance,
       *   allowDesktop: true
       * }).then(function (venmoInstance) {
       *   // venmoInstance is ready to be used.
       * }).catch(function (createErr) {
       *   console.error('Error creating Venmo instance', createErr);
       * });
       * @returns {(Promise|void)} Returns the Venmo instance.
       */
      function create(options) {
        var name = "Venmo";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          var createPromise, instance;
          if (options.profileId && typeof options.profileId !== "string") {
            return Promise.reject(new BraintreeError(errors.VENMO_INVALID_PROFILE_ID));
          }
          if (options.deepLinkReturnUrl && typeof options.deepLinkReturnUrl !== "string") {
            return Promise.reject(new BraintreeError(errors.VENMO_INVALID_DEEP_LINK_RETURN_URL));
          }
          createPromise = createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          }).then(function (client) {
            var configuration = client.getConfiguration();
            options.client = client;
            if (!configuration.gatewayConfiguration.payWithVenmo) {
              return Promise.reject(new BraintreeError(errors.VENMO_NOT_ENABLED));
            }
            return client;
          });
          options.createPromise = createPromise;
          instance = new Venmo(options);
          analytics.sendEvent(createPromise, "venmo.initialized");
          return createPromise.then(function () {
            return instance;
          });
        });
      }

      /**
       * @static
       * @function isBrowserSupported
       * @param {object} [options] browser support options:
       * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications.
       * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control.
       * @example
       * if (braintree.venmo.isBrowserSupported()) {
       *   // set up Venmo
       * }
       * @example <caption>Explicitly require browser support returning to the same tab</caption>
       * if (braintree.venmo.isBrowserSupported({
       *   allowNewBrowserTab: false
       * })) {
       *   // set up Venmo
       * }
       * @example <caption>Explicitly set webviews as disallowed browsers</caption>
       * if (braintree.venmo.isBrowserSupported({
       *   allowWebviews: false
       * })) {
       *   // set up Venmo
       * }
       * @returns {boolean} Whether or not the browser supports Venmo.
       */
      function isBrowserSupported(options) {
        return supportsVenmo.isBrowserSupported(options);
      }
      module.exports = {
        create: wrapPromise(create),
        isBrowserSupported: isBrowserSupported,
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./shared/errors": 237,
      "./shared/supports-venmo": 240,
      "./venmo": 242,
      "@braintree/wrap-promise": 40
    }],
    235: [function (_dereq_, module, exports) {
      "use strict";

      var isAndroid = _dereq_("@braintree/browser-detection/is-android");
      var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
      var isIos = _dereq_("@braintree/browser-detection/is-ios");
      var isIosSafari = _dereq_("@braintree/browser-detection/is-ios-safari");
      var isIosWebview = _dereq_("@braintree/browser-detection/is-ios-webview");
      var isSamsung = _dereq_("@braintree/browser-detection/is-samsung");
      function isAndroidWebview() {
        return isAndroid() && window.navigator.userAgent.toLowerCase().indexOf("wv") > -1;
      }
      function doesNotSupportWindowOpenInIos() {
        if (!isIos()) {
          return false;
        }
        return isIosWebview() || !isIosSafari();
      }
      function isFacebookOwnedBrowserOnAndroid() {
        var ua = window.navigator.userAgent.toLowerCase();

        // Huawei's Facebook useragent does not include Android
        if (ua.indexOf("huawei") > -1 && ua.indexOf("fban") > -1) {
          return true;
        }
        if (!isAndroid()) {
          return false;
        }
        return ua.indexOf("fb_iab") > -1 || ua.indexOf("instagram") > -1;
      }
      function isIosChrome() {
        return isIos() && isChrome();
      }
      module.exports = {
        isAndroid: isAndroid,
        isAndroidWebview: isAndroidWebview,
        isChrome: isChrome,
        isIos: isIos,
        isIosChrome: isIosChrome,
        isSamsung: isSamsung,
        isIosSafari: isIosSafari,
        isIosWebview: isIosWebview,
        isFacebookOwnedBrowserOnAndroid: isFacebookOwnedBrowserOnAndroid,
        doesNotSupportWindowOpenInIos: doesNotSupportWindowOpenInIos
      };
    }, {
      "@braintree/browser-detection/is-android": 20,
      "@braintree/browser-detection/is-chrome": 22,
      "@braintree/browser-detection/is-ios": 27,
      "@braintree/browser-detection/is-ios-safari": 24,
      "@braintree/browser-detection/is-ios-webview": 25,
      "@braintree/browser-detection/is-samsung": 28
    }],
    236: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * Venmo shared constants
       * @typedef {object} Venmo~venmoConstants
       * @ignore
       * @property {string} VENMO_APP_OR_MOBILE_AUTH_URL A deep-linked url that will open the Venmo app if installed, or navigate to a Venmo web-login experience if the Venmo app is not present.
       * @property {string} VENMO_MOBILE_APP_AUTH_ONLY_URL A deep-linked url that leads to a Venmo dead-end page if the Venmo app is not installed (page asks customer to download the app).
       * @property {string} VENMO_WEB_LOGIN_URL A non-deeplinked url that leads to a Venmo login page. For use when explicitly wanting to avoid using the Venmo mobile app via a deep-linked url.
       */
      module.exports = {
        DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY: 500,
        DEFAULT_PROCESS_RESULTS_DELAY: 1000,
        VENMO_APP_OR_MOBILE_AUTH_URL: "https://venmo.com/go/checkout",
        VENMO_MOBILE_APP_AUTH_ONLY_URL: "https://venmo.com/braintree/checkout",
        VENMO_WEB_LOGIN_URL: "https://account.venmo.com/go/web"
      };
    }, {}],
    237: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Venmo - Creation Error Codes
       * @description Errors that occur when [creating the Venmo component](./module-braintree-web_venmo.html#.create).
       * @property {MERCHANT} VENMO_NOT_ENABLED Occurs when Venmo is not enabled on the Braintree control panel.
       * @property {MERCHANT} VENMO_INVALID_PROFILE_ID Occurs when Venmo is initialized with a profile id, but it is invalid.
       * @property {UNKNOWN} VENMO_MOBILE_POLLING_SETUP_FAILED __Deprecated__ No longer returned. Use `VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED` instead.
       * @property {UNKNOWN} VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED Occurs when the request to set up a Venmo Payment Context object fails.
       */

      /**
       * @name BraintreeError.Venmo - tokenize Error Codes
       * @description Errors that occur when using the [`tokenize` method](./Venmo.html#tokenize).
       * @property {CUSTOMER} VENMO_APP_CANCELED Occurs when customer cancels flow from the Venmo app.
       * @property {UNKNOWN} VENMO_APP_FAILED Occurs when tokenization fails.
       * @property {CUSTOMER} VENMO_CANCELED Occurs when customer cancels the flow or Venmo app is not available.
       * @property {CUSTOMER} VENMO_CUSTOMER_CANCELED Occurs when customer cancels the flow.
       * @property {CUSTOMER} VENMO_DESKTOP_CANCELED Occurs when customer cancels the Venmo Desktop flow by closing the modal.
       * @property {UNKNOWN} VENMO_DESKTOP_UNKNOWN_ERROR Occurs when an unknown error causes the Venmo Desktop flow to fail.
       * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR Occurs when an unknown network error causes the mobile polling process to fail.
       * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED Occurs when the polling has expired and the payment cannot be completed.
       * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED Occurs when the polling operation is canceled by the customer.
       * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT Occurs when customer takes too long to complete payment.
       * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_FAILED Occurs if there is an unknown error during the mobile polling process.
       * @property {NETWORK} VENMO_NETWORK_ERROR Occurs when a network error causes a request to fail.
       * @property {MERCHANT} VENMO_TOKENIZATION_CANCELED_BY_MERCHANT Occurs when `cancelTokenization` is called while tokenization is in progress.
       * @property {UNKNOWN} VENMO_TOKENIZATION_FAILED Occurs when there is an unknown error during the web login experience.
       * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_ACTIVE Occurs when `tokenize` is called when the flow is already in progress.
       * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE Occurs when `cancelTokenization` is called when the flow is not in progress.
       * @property {MERCHANT} VENMO_ECD_DISABLED Occurs when the merchant tries to access customer details without enabling Enriched Customer Data.
       */
      var BraintreeError = _dereq_("../../lib/braintree-error");
      module.exports = {
        VENMO_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_NOT_ENABLED",
          message: "Venmo is not enabled for this merchant."
        },
        VENMO_TOKENIZATION_REQUEST_ACTIVE: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_TOKENIZATION_REQUEST_ACTIVE",
          message: "Another tokenization request is active."
        },
        VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE",
          message: "No tokenization in progress."
        },
        VENMO_APP_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "VENMO_APP_FAILED",
          message: "Venmo app encountered a problem."
        },
        VENMO_APP_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_APP_CANCELED",
          message: "Venmo app authorization was canceled."
        },
        VENMO_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_CANCELED",
          message: "User canceled Venmo authorization, or Venmo app is not available."
        },
        VENMO_CUSTOMER_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_CUSTOMER_CANCELED",
          message: "User canceled Venmo authorization."
        },
        VENMO_NETWORK_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "VENMO_NETWORK_ERROR",
          message: "Something went wrong making the request"
        },
        VENMO_DESKTOP_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_DESKTOP_CANCELED",
          message: "User canceled Venmo authorization by closing the Venmo Desktop modal."
        },
        VENMO_TOKENIZATION_CANCELED_BY_MERCHANT: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_TOKENIZATION_CANCELED_BY_MERCHANT",
          message: "The Venmo tokenization was canceled by the merchant."
        },
        VENMO_DESKTOP_UNKNOWN_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "VENMO_DESKTOP_UNKNOWN_ERROR",
          message: "Something went wrong with the Venmo Desktop flow."
        },
        VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED: {
          type: BraintreeError.types.NETWORK,
          code: "VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED",
          message: "Something went wrong creating the Venmo Payment Context."
        },
        VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR: {
          type: BraintreeError.types.UNKNOWN,
          code: "VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR",
          message: "Something went wrong during mobile polling."
        },
        VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED",
          message: "The Venmo authorization request is expired."
        },
        VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED",
          message: "The Venmo authorization was canceled"
        },
        VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT: {
          type: BraintreeError.types.CUSTOMER,
          code: "VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT",
          message: "Customer took too long to authorize Venmo payment."
        },
        VENMO_MOBILE_POLLING_TOKENIZATION_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "VENMO_MOBILE_POLLING_TOKENIZATION_FAILED",
          message: "The Venmo authorization failed."
        },
        VENMO_INVALID_PROFILE_ID: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_INVALID_PROFILE_ID",
          message: "Venmo profile ID is invalid."
        },
        VENMO_INVALID_DEEP_LINK_RETURN_URL: {
          type: BraintreeError.types.MERCHANT,
          code: "VENMO_INVALID_DEEP_LINK_RETURN_URL",
          message: "Venmo deep link return URL is invalid."
        },
        VENMO_TOKENIZATION_FAILED: {
          type: BraintreeError.types.UNKNOWN,
          code: "VENMO_TOKENIZATION_FAILED",
          message: "Venmo encountered a problem"
        },
        VENMO_ECD_DISABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "ECD_DISABLED",
          message: "Cannot collect customer data when ECD is disabled. Enable this feature in the Control Panel to collect this data."
        }
      };
    }, {
      "../../lib/braintree-error": 140
    }],
    238: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.VENMO_DESKTOP_UNKNOWN_ERROR = exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE = exports.VENMO_DESKTOP_CLOSED_FROM_PARENT = exports.VENMO_DESKTOP_IFRAME_READY = exports.VENMO_DESKTOP_DISPLAY_QR_CODE = exports.VENMO_DESKTOP_DISPLAY_ERROR = exports.VENMO_DESKTOP_CUSTOMER_CANCELED = exports.VENMO_DESKTOP_AUTHORIZING = exports.VENMO_DESKTOP_AUTHORIZE = exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT = void 0;
      exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT = "VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT";
      exports.VENMO_DESKTOP_AUTHORIZE = "VENMO_DESKTOP_AUTHORIZE";
      exports.VENMO_DESKTOP_AUTHORIZING = "VENMO_DESKTOP_AUTHORIZING";
      exports.VENMO_DESKTOP_CUSTOMER_CANCELED = "VENMO_DESKTOP_CUSTOMER_CANCELED";
      exports.VENMO_DESKTOP_DISPLAY_ERROR = "VENMO_DESKTOP_DISPLAY_ERROR";
      exports.VENMO_DESKTOP_DISPLAY_QR_CODE = "VENMO_DESKTOP_DISPLAY_QR_CODE";
      exports.VENMO_DESKTOP_IFRAME_READY = "VENMO_DESKTOP_IFRAME_READY";
      exports.VENMO_DESKTOP_CLOSED_FROM_PARENT = "VENMO_DESKTOP_CLOSED_FROM_PARENT";
      exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE = "VENMO_DESKTOP_REQUEST_NEW_QR_CODE";
      exports.VENMO_DESKTOP_UNKNOWN_ERROR = "VENMO_DESKTOP_UNKNOWN_ERROR";
    }, {}],
    239: [function (_dereq_, module, exports) {
      "use strict";

      var venmoConstants = _dereq_("./constants");
      function getVenmoUrl(options) {
        if (options.useAllowDesktopWebLogin) return venmoConstants.VENMO_WEB_LOGIN_URL;
        if (options.mobileWebFallBack) return venmoConstants.VENMO_APP_OR_MOBILE_AUTH_URL;
        return venmoConstants.VENMO_MOBILE_APP_AUTH_ONLY_URL;
      }
      module.exports = getVenmoUrl;
    }, {
      "./constants": 236
    }],
    240: [function (_dereq_, module, exports) {
      "use strict";

      var browserDetection = _dereq_("./browser-detection");
      var inIframe = _dereq_("../../lib/in-iframe");
      function isBrowserSupported(options) {
        var isKnownUnsupportedMobileBrowser, merchantAllowsDesktopBrowsers, merchantAllowsIosChrome, merchantAllowsReturningToNewBrowserTab, merchantAllowsWebviews;
        var isAndroid = browserDetection.isAndroid();
        var isMobileDevice = isAndroid || browserDetection.isIos();
        var isAndroidChrome = isAndroid && browserDetection.isChrome();
        var isMobileDeviceThatSupportsReturnToSameTab = browserDetection.isIosSafari() || isAndroidChrome;
        options = options || {};
        // NEXT_MAJOR_VERSION allowDesktop will default to true, but can be opted out
        merchantAllowsDesktopBrowsers = (options.allowDesktopWebLogin || options.allowDesktop) === true;
        merchantAllowsReturningToNewBrowserTab = options.hasOwnProperty("allowNewBrowserTab") ? options.allowNewBrowserTab : true;
        // NEXT_MAJOR_VERSION webviews are not supported, except for the case where
        // the merchant themselves is presenting venmo in a webview using the deep
        // link url to get back to their app. For the next major version, we should
        // just not have this option and instead require the merchant to determine
        // if the venmo button should be displayed when presenting it in the
        // merchant's app via a webview.
        merchantAllowsWebviews = options.hasOwnProperty("allowWebviews") ? options.allowWebviews : true;
        // Venmo only works on iOS Chrome when the
        // button is not rendered in an iFrame and
        // allowNewBrowserTab is set to true
        merchantAllowsIosChrome = merchantAllowsReturningToNewBrowserTab && !inIframe();
        isKnownUnsupportedMobileBrowser = !merchantAllowsIosChrome && browserDetection.isIosChrome() || browserDetection.isFacebookOwnedBrowserOnAndroid() || browserDetection.isSamsung();
        if (isKnownUnsupportedMobileBrowser) {
          return false;
        }
        if (!merchantAllowsWebviews && (browserDetection.isAndroidWebview() || browserDetection.isIosWebview())) {
          return false;
        }
        if (!isMobileDevice) {
          return merchantAllowsDesktopBrowsers;
        }
        if (!merchantAllowsReturningToNewBrowserTab) {
          return isMobileDeviceThatSupportsReturnToSameTab;
        }
        return isMobileDevice;
      }
      module.exports = {
        isBrowserSupported: isBrowserSupported
      };
    }, {
      "../../lib/in-iframe": 166,
      "./browser-detection": 235
    }],
    241: [function (_dereq_, module, exports) {
      "use strict";

      var frameService = _dereq_("../../lib/frame-service/external");
      var useMin = _dereq_("../../lib/use-min");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var errors = _dereq_("../shared/errors");
      var BraintreeError = _dereq_("../../lib/braintree-error");
      var VERSION = "3.115.2";
      var VENMO_LOGO_SVG = '<svg width="198" height="58" viewBox="0 0 198 58" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0702 13.6572C44.1935 15.4585 44.6999 17.3139 44.6999 19.6576C44.6999 27.1328 38.1277 36.8436 32.7935 43.6625H20.6099L15.7236 15.2939L26.3917 14.3105L28.9751 34.4966C31.389 30.6783 34.3678 24.6779 34.3678 20.587C34.3678 18.3477 33.9727 16.8225 33.3553 15.5666L43.0702 13.6572Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M56.8965 26.1491C58.8596 26.1491 63.8018 25.2772 63.8018 22.5499C63.8018 21.2402 62.8481 20.587 61.7242 20.587C59.7579 20.587 57.1776 22.8763 56.8965 26.1491ZM56.6715 31.5506C56.6715 34.8807 58.5787 36.1873 61.107 36.1873C63.8603 36.1873 66.4966 35.534 69.923 33.8433L68.6324 42.3523C66.2183 43.4976 62.4559 44.2617 58.8039 44.2617C49.5403 44.2617 46.2249 38.8071 46.2249 31.9879C46.2249 23.1496 51.6179 13.765 62.7365 13.765C68.858 13.765 72.2809 17.0949 72.2809 21.7317C72.2815 29.2066 62.4005 31.4965 56.6715 31.5506Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M103.067 20.3142C103.067 21.4052 102.897 22.9875 102.727 24.0216L99.5262 43.6622H89.1385L92.0585 25.658C92.1139 25.1696 92.284 24.1865 92.284 23.6411C92.284 22.3314 91.4414 22.0047 90.4282 22.0047C89.0826 22.0047 87.7337 22.6042 86.8354 23.0418L83.5234 43.6625H73.0772L77.8495 14.257H86.8908L87.0052 16.6041C89.1382 15.2404 91.9469 13.7656 95.932 13.7656C101.212 13.765 103.067 16.3845 103.067 20.3142Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M133.906 16.9841C136.881 14.9131 139.69 13.765 143.563 13.765C148.897 13.765 150.753 16.3845 150.753 20.3142C150.753 21.4052 150.583 22.9875 150.413 24.0216L147.216 43.6622H136.825L139.801 25.2774C139.855 24.786 139.971 24.1865 139.971 23.8063C139.971 22.3317 139.128 22.0047 138.115 22.0047C136.824 22.0047 135.535 22.5501 134.577 23.0418L131.266 43.6625H120.878L123.854 25.2777C123.908 24.7863 124.02 24.1868 124.02 23.8065C124.02 22.332 123.177 22.0049 122.167 22.0049C120.819 22.0049 119.473 22.6045 118.574 23.0421L115.26 43.6628H104.817L109.589 14.2573H118.52L118.8 16.7122C120.878 15.241 123.684 13.7662 127.446 13.7662C130.704 13.765 132.837 15.129 133.906 16.9841Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M171.426 25.5502C171.426 23.1496 170.808 21.513 168.956 21.513C164.857 21.513 164.015 28.55 164.015 32.1498C164.015 34.8807 164.802 36.5709 166.653 36.5709C170.528 36.5709 171.426 29.1497 171.426 25.5502ZM153.458 31.7152C153.458 22.442 158.511 13.765 170.136 13.765C178.896 13.765 182.098 18.7854 182.098 25.7148C182.098 34.8805 177.099 44.3723 165.194 44.3723C156.378 44.3723 153.458 38.7525 153.458 31.7152Z" fill="white"/>\n</svg>';
      var CONTINUE_OR_CANCEL_INSTRUCTIONS = "Tap cancel payment to cancel and return to the business. Continue payment will relaunch the payment window.";
      var POPUP_WIDTH = 400;
      var POPUP_HEIGHT = 570;
      var ELEMENT_IDS = {
        backdrop: "venmo-desktop-web-backdrop",
        backdropHidden: "venmo-desktop-web-backdrop.hidden",
        backdropContainer: "venmo-backdrop-container",
        cancelButton: "venmo-popup-cancel-button",
        continueButton: "venmo-popup-continue-button",
        message: "venmo-message",
        instructions: "venmo-instructions",
        venmoLogo: "venmo-full-logo"
      };
      ExtendedPromise.suppressUnhandledPromiseMessage = true;
      function openPopup(options) {
        var frameServiceInstance = options.frameServiceInstance;
        var venmoUrl = options.venmoUrl;
        var checkForStatusChange = options.checkForStatusChange;
        var cancelTokenization = options.cancelTokenization;
        var checkPaymentContextStatus = options.checkPaymentContextStatus;
        var extendedPromise = new ExtendedPromise();
        document.getElementById(ELEMENT_IDS.continueButton).addEventListener("click", function () {
          frameServiceInstance.focus();
        });
        document.getElementById(ELEMENT_IDS.cancelButton).addEventListener("click", function () {
          frameServiceInstance.close();
          cancelTokenization();
          closeBackdrop();
        });
        frameServiceInstance.open({}, function (frameServiceErr) {
          var retryStartingCount = 1;
          if (frameServiceErr) {
            extendedPromise.reject(frameServiceErr);
          } else {
            checkForStatusChange(retryStartingCount).then(function (data) {
              extendedPromise.resolve(data);
            }).catch(function (statusCheckError) {
              // We add this check here because at this point
              // the status should not be in CREATED status.
              // However, there is an edge case where if a buyer
              // cancels in the popup, the popup might close itself
              // before it can send the graphQL mutation to update its status.
              // In these cases, the status will be stuck in CREATED status, and
              // tokenization would fail, incorrectly throwing a tokenization error
              // instead of informing the merchant that the customer canceled.
              checkPaymentContextStatus().then(function (node) {
                if (node.status === "CREATED") {
                  extendedPromise.reject(new BraintreeError(errors.VENMO_CUSTOMER_CANCELED));
                } else {
                  extendedPromise.reject(statusCheckError);
                }
              });
            });
          }
          frameServiceInstance.close();
          closeBackdrop();
        });
        frameServiceInstance.redirect(venmoUrl);
        return extendedPromise;
      }
      function centeredPopupDimensions() {
        var popupTop = Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
        var popupLeft = Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;
        return {
          top: popupTop,
          left: popupLeft
        };
      }
      function closeBackdrop() {
        document.getElementById("venmo-desktop-web-backdrop").classList.add("hidden");
      }
      function getElementStyles() {
        var backdropStyles = ["#" + ELEMENT_IDS.backdropHidden + " {", "display: none;", "}", "#" + ELEMENT_IDS.backdrop + " {", "z-index: 3141592632;", "cursor: pointer;", "position: fixed;", "top: 0;", "left: 0;", "bottom: 0;", "width: 100%;", "background: rgba(0, 0, 0, 0.8);", "}"];
        var backdropContainerStyles = ["#" + ELEMENT_IDS.backdropContainer + " {", "display: flex;", "align-content: center;", "justify-content: center;", "align-items: center;", "width: 100%;", "height: 100%;", "flex-direction: column;", "}"];
        var cancelButtonStyles = ["#" + ELEMENT_IDS.cancelButton + " {", "height: 24px;", "width: 380px;", "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;", "font-style: normal;", "font-weight: 700;", "font-size: 18px;", "line-height: 24px;", "text-align: center;", "background-color: transparent;", "border: none;", "color: #FFFFFF;", "margin-top: 28px;", "}"];
        var continueButtonStyles = ["#" + ELEMENT_IDS.continueButton + " {", "width: 400px;", "height: 50px;", "background: #0074DE;", "border-radius: 24px;", "border: none;", "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;", "font-style: normal;", "font-weight: 700;", "font-size: 18px;", "color: #FFFFFF;", "margin-top: 44px;", "}"];
        var messageStyles = ["#" + ELEMENT_IDS.message + " {", "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;", "font-style: normal;", "font-weight: 500;", "font-size: 24px;", "line-height: 32px;", "text-align: center;", "color: #FFFFFF;", "margin-top: 32px;", "}"];
        var instructionStyles = ["#" + ELEMENT_IDS.instructions + " {", "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;", "font-style: normal;", "font-weight: 400;", "font-size: 16px;", "line-height: 20px;", "text-align: center;", "color: #FFFFFF;", "margin-top: 16px;", "width: 400px;", "}"];
        var allStyles = backdropStyles.concat(backdropContainerStyles, cancelButtonStyles, continueButtonStyles, messageStyles, instructionStyles);
        return allStyles.join("\n");
      }
      function buildAndStyleElements() {
        var alreadyRenderedBackdrop = document.getElementById(ELEMENT_IDS.backdrop);
        var backdropStylesElement, backdropDiv, backDropContentContainer, venmoLogoDiv, venmoMessageDiv, instructionsDiv, continueButton, cancelButton;
        if (alreadyRenderedBackdrop) {
          alreadyRenderedBackdrop.classList.remove("hidden");
          return;
        }
        backdropStylesElement = document.createElement("style");
        backdropDiv = document.createElement("div");
        backDropContentContainer = document.createElement("div");
        venmoLogoDiv = document.createElement("div");
        venmoMessageDiv = document.createElement("div");
        instructionsDiv = document.createElement("div");
        continueButton = document.createElement("button");
        cancelButton = document.createElement("button");
        backdropStylesElement.id = "venmo-desktop-web__injected-styles";
        backdropStylesElement.innerHTML = getElementStyles();
        backdropDiv.id = ELEMENT_IDS.backdrop;
        backDropContentContainer.id = ELEMENT_IDS.backdropContainer;
        venmoLogoDiv.id = ELEMENT_IDS.venmoLogo;
        venmoLogoDiv.innerHTML = VENMO_LOGO_SVG;
        venmoMessageDiv.id = ELEMENT_IDS.message;
        venmoMessageDiv.innerText = "What would you like to do?";
        instructionsDiv.id = ELEMENT_IDS.instructions;
        instructionsDiv.innerText = CONTINUE_OR_CANCEL_INSTRUCTIONS;
        continueButton.id = ELEMENT_IDS.continueButton;
        continueButton.innerText = "Continue payment";
        cancelButton.id = ELEMENT_IDS.cancelButton;
        cancelButton.innerText = "Cancel payment";
        document.head.appendChild(backdropStylesElement);
        backDropContentContainer.appendChild(venmoLogoDiv);
        backDropContentContainer.appendChild(venmoMessageDiv);
        backDropContentContainer.appendChild(instructionsDiv);
        backDropContentContainer.appendChild(continueButton);
        backDropContentContainer.appendChild(cancelButton);
        backdropDiv.appendChild(backDropContentContainer);
        document.body.appendChild(backdropDiv);
        backdropDiv.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      }

      /**
       * Applies a backdrop over the page, and opens a popup to the supplied url. Uses supplied status and cancel functions to handle the flow.
       * @function runWebLogin
       * @ignore
       * @param {object} options Options for running the web login flow.
       * @param {string} options.venmoUrl Venmo url that is to be used for logging in.
       * @param {Venmo~checkPaymentContextStatusAndProcessResult} options.checkForStatusChange {@link Venmo~checkPaymentContextStatusAndProcessResult} to be invoked in order to check for a payment context status update.
       * @param {Venmo~cancelTokenization} options.cancelTokenization {@link Venmo~cancelTokenization} to be invoked when the appropriate payment context status is retrieved.
       * @param {boolean} options.debug A flag to control whether to use minified assets or not.
       * @returns {Promise} Returns a promise
       */
      function runWebLogin(options) {
        buildAndStyleElements();
        return openPopup(options);
      }

      /**
       * When using frameservice, it needs to be created separately from the action of opening. The setup process includes
       * steps that browsers may consider async or too disconnected from the user action required to open a popup.
       *
       * This function enables us to do that setup at an appropriate time.
       * @function setupDesktopWebLogin
       * @ignore
       * @param {object} options Options use for setting up the Desktop Web Login flow.
       * @param {string} options.assetsUrl Url that points to the hosted Braintree assets.
       * @param {boolean} options.debug A flag to control whether to use minified assets or not.
      
       * @returns {Promise} Returns a promise
       */
      function setupDesktopWebLogin(options) {
        var extendedPromise = new ExtendedPromise();
        var popupName = "venmoDesktopWebLogin";
        var assetsUrl = options.assetsUrl;
        var debug = options.debug || false;
        var popupLocation = centeredPopupDimensions();
        var assetsBaseUrl = assetsUrl + "/web/" + VERSION + "/html";
        frameService.create({
          name: popupName,
          dispatchFrameUrl: assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
          openFrameUrl: assetsBaseUrl + "/venmo-landing-frame" + useMin(debug) + ".html",
          top: popupLocation.top,
          left: popupLocation.left,
          height: POPUP_HEIGHT,
          width: POPUP_WIDTH
        }, function (frameServiceInstance) {
          extendedPromise.resolve(frameServiceInstance);
        });
        return extendedPromise;
      }
      module.exports = {
        runWebLogin: runWebLogin,
        openPopup: openPopup,
        setupDesktopWebLogin: setupDesktopWebLogin,
        POPUP_WIDTH: POPUP_WIDTH,
        POPUP_HEIGHT: POPUP_HEIGHT
      };
    }, {
      "../../lib/braintree-error": 140,
      "../../lib/frame-service/external": 155,
      "../../lib/use-min": 178,
      "../shared/errors": 237,
      "@braintree/extended-promise": 31
    }],
    242: [function (_dereq_, module, exports) {
      "use strict";

      var analytics = _dereq_("../lib/analytics");
      var isBrowserSupported = _dereq_("./shared/supports-venmo");
      var browserDetection = _dereq_("./shared/browser-detection");
      var constants = _dereq_("./shared/constants");
      var errors = _dereq_("./shared/errors");
      var querystring = _dereq_("../lib/querystring");
      var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var inIframe = _dereq_("../lib/in-iframe");
      var ExtendedPromise = _dereq_("@braintree/extended-promise");
      var getVenmoUrl = _dereq_("./shared/get-venmo-url");
      var desktopWebLogin = _dereq_("./shared/web-login-backdrop");
      var snakeCaseToCamelCase = _dereq_("../lib/snake-case-to-camel-case");
      var urlParams = _dereq_("../lib/url-params");

      // NEXT_MAJOR_VERSION the source code for this is actually in a
      // typescript repo called venmo-desktop, once the SDK is migrated
      // to typescript, we can move the TS files out of that separate
      // repo and into the web SDK properly
      var createVenmoDesktop = _dereq_("./external/");
      var graphqlQueries = _dereq_("./external/queries");
      var VERSION = "3.115.2";
      var DEFAULT_MOBILE_POLLING_INTERVAL = 250; // 1/4 second
      var DEFAULT_MOBILE_EXPIRING_THRESHOLD = 300000; // 5 minutes

      ExtendedPromise.suppressUnhandledPromiseMessage = true;

      /**
       * Venmo tokenize payload.
       * @typedef {object} Venmo~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {string} type The payment method type, always `VenmoAccount`.
       * @property {object} details Additional Venmo account details.
       * @property {string} details.username The username of the Venmo account.
       * @property {string} details.paymentContextId The context ID of the Venmo payment. Only available when used with {@link https://braintree.github.io/braintree-web/current/module-braintree-web_venmo.html#.create|`paymentMethodUsage`}.
       */

      /**
       * @class
       * @param {object} options The Venmo {@link module:braintree-web/venmo.create create} options.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/venmo.create|braintree-web.venmo.create} instead.</strong>
       * @classdesc This class represents a Venmo component produced by {@link module:braintree-web/venmo.create|braintree-web/venmo.create}. Instances of this class have methods for tokenizing Venmo payments.
       */
      function Venmo(options) {
        var self = this;
        this._allowDesktopWebLogin = options.allowDesktopWebLogin || false;
        this._mobileWebFallBack = options.mobileWebFallBack || false;
        this._createPromise = options.createPromise;
        this._allowNewBrowserTab = options.allowNewBrowserTab !== false;
        this._allowWebviews = options.allowWebviews !== false;
        this._allowDesktop = options.allowDesktop === true;
        this._useRedirectForIOS = options.useRedirectForIOS === true;
        this._profileId = options.profileId;
        this._displayName = options.displayName;
        this._deepLinkReturnUrl = options.deepLinkReturnUrl;
        this._ignoreHistoryChanges = options.ignoreHistoryChanges;
        this._paymentMethodUsage = (options.paymentMethodUsage || "").toUpperCase();
        this._shouldUseLegacyFlow = !this._paymentMethodUsage;
        this._requireManualReturn = options.requireManualReturn === true;
        this._useDesktopQRFlow = this._allowDesktop && this._isDesktop() && !this._allowDesktopWebLogin;
        this._useAllowDesktopWebLogin = this._allowDesktopWebLogin && this._isDesktop();
        this._cannotHaveReturnUrls = inIframe() || this._requireManualReturn;
        this._allowAndroidRecreation = options.allowAndroidRecreation !== false;
        this._maxRetryCount = 3;
        this._collectCustomerBillingAddress = options.collectCustomerBillingAddress || false;
        this._collectCustomerShippingAddress = options.collectCustomerShippingAddress || false;
        this._isFinalAmount = options.isFinalAmount || false;
        this._lineItems = options.lineItems;
        this._subTotalAmount = options.subTotalAmount;
        this._discountAmount = options.discountAmount;
        this._taxAmount = options.taxAmount;
        this._shippingAmount = options.shippingAmount;
        this._totalAmount = options.totalAmount;
        this._shouldCreateVenmoPaymentContext = this._cannotHaveReturnUrls || !this._shouldUseLegacyFlow;
        analytics.sendEvent(this._createPromise, "venmo.desktop-flow.configured." + String(Boolean(this._allowDesktop)));

        // if the url has a tokenization result, that indicates
        // that it cannot be the desktop flow or the manual return
        // flow. If it's the hash change with paymentMethodUsage
        // flow, we want to skip creating a new payment context, since
        // there is already a pending payment context waiting to be
        // processed. For the hash change flow without paymentMethodUsage,
        // no further actions are needed.
        if (this.hasTokenizationResult()) {
          analytics.sendEvent(this._createPromise, "venmo.appswitch.return-in-new-tab");
        } else if (this._useDesktopQRFlow) {
          this._createPromise = this._createPromise.then(function (client) {
            var config = client.getConfiguration().gatewayConfiguration;
            return createVenmoDesktop({
              url: config.assetsUrl + "/web/" + VERSION + "/html/venmo-desktop-frame.html",
              environment: config.environment === "production" ? "PRODUCTION" : "SANDBOX",
              profileId: self._profileId || config.payWithVenmo.merchantId,
              paymentMethodUsage: self._paymentMethodUsage,
              displayName: self._displayName,
              Promise: Promise,
              apiRequest: function (query, data) {
                return client.request({
                  api: "graphQLApi",
                  data: {
                    query: query,
                    variables: data
                  }
                }).then(function (response) {
                  return response.data;
                });
              },
              sendEvent: function (eventName) {
                analytics.sendEvent(self._createPromise, eventName);
              },
              verifyDomain: isVerifiedDomain
            }).then(function (venmoDesktopInstance) {
              self._venmoDesktopInstance = venmoDesktopInstance;
              analytics.sendEvent(self._createPromise, "venmo.desktop-flow.presented");
              return client;
            }).catch(function () {
              analytics.sendEvent(self._createPromise, "venmo.desktop-flow.setup-failed");
              self._useDesktopQRFlow = false;
              return client;
            });
          });
        } else if (this._shouldCreateVenmoPaymentContext) {
          // these variables are only relevant for the manual return flow
          // and they are only set to make testing easier (so they can
          // be overwritten with smaller values in the tests)
          this._mobilePollingInterval = DEFAULT_MOBILE_POLLING_INTERVAL;
          this._mobilePollingExpiresThreshold = DEFAULT_MOBILE_EXPIRING_THRESHOLD;
          this._createPromise = this._createPromise.then(function (client) {
            var paymentContextPromise, webLoginPromise;
            var analyticsCategory = self._cannotHaveReturnUrls ? "manual-return" : "mobile-payment-context";
            var config = client.getConfiguration();
            webLoginPromise = desktopWebLogin.setupDesktopWebLogin({
              assetsUrl: config.gatewayConfiguration.assetsUrl,
              debug: config.isDebug
            }).then(function (frameServiceInstance) {
              self._frameServiceInstance = frameServiceInstance;
            }).catch(function (desktopWebErr) {
              return desktopWebErr;
            });
            self._mobilePollingContextEnvironment = config.gatewayConfiguration.environment.toUpperCase();
            paymentContextPromise = self._createVenmoPaymentContext(client).then(function () {
              analytics.sendEvent(self._createPromise, "venmo." + analyticsCategory + ".presented");
              return client;
            }).catch(function (err) {
              analytics.sendEvent(self._createPromise, "venmo." + analyticsCategory + ".setup-failed");
              return Promise.reject(new BraintreeError({
                type: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.type,
                code: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.code,
                message: isValidationError(err) ? err.details.originalError[0].message : errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.message,
                details: {
                  originalError: err
                }
              }));
            });
            return ExtendedPromise.all([webLoginPromise, paymentContextPromise]).then(function (results) {
              var paymentContextResult = results[1]; // We only care about the returned value of the paymentContextPromise

              return Promise.resolve(paymentContextResult);
            }).catch(function (promiseErr) {
              // ExtendedPromise.all returns just one error and it's either which fails first/at all.
              return Promise.reject(promiseErr);
            });
          });
        }
      }
      function isValidationError(err) {
        return err.details && err.details.originalError && err.details.originalError[0] && err.details.originalError[0].extensions && err.details.originalError[0].extensions.errorClass === "VALIDATION" && err.details.originalError[0].extensions.errorType === "user_error";
      }
      Venmo.prototype._createVenmoPaymentContext = function (client, cancelIfTokenizationInProgress) {
        var self = this;
        var promise, transactionDetails;
        var configuration = client.getConfiguration();
        var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
        var transactionDetailsPresent = false;
        var customerClientChannel = self._useAllowDesktopWebLogin ? "NATIVE_WEB" : "MOBILE_WEB";
        if (!this._shouldCreateVenmoPaymentContext) {
          return Promise.resolve();
        }
        if (this._shouldUseLegacyFlow) {
          promise = client.request({
            api: "graphQLApi",
            data: {
              query: graphqlQueries.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY,
              variables: {
                input: {
                  environment: this._mobilePollingContextEnvironment,
                  intent: "PAY_FROM_APP"
                }
              }
            }
          }).then(function (response) {
            return response.data.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
          });
        } else {
          // Merchants are not allowed to collect user addresses unless ECD (Enriched Customer Data) is enabled on the BT Control Panel.
          if ((this._collectCustomerBillingAddress || this._collectCustomerShippingAddress) && !venmoConfiguration.enrichedCustomerDataEnabled) {
            return Promise.reject(new BraintreeError(errors.VENMO_ECD_DISABLED));
          }
          if (this._lineItems) {
            this._lineItems.forEach(function (item) {
              item.unitTaxAmount = item.unitTaxAmount || "0";
            });
          }
          transactionDetails = {
            subTotalAmount: this._subTotalAmount,
            discountAmount: this._discountAmount,
            taxAmount: this._taxAmount,
            shippingAmount: this._shippingAmount,
            totalAmount: this._totalAmount,
            lineItems: this._lineItems
          };
          transactionDetailsPresent = Object.keys(transactionDetails).some(function (detail) {
            return transactionDetails[detail] !== undefined; // eslint-disable-line no-undefined
          });
          promise = client.request({
            api: "graphQLApi",
            data: {
              query: graphqlQueries.CREATE_PAYMENT_CONTEXT_QUERY,
              variables: {
                input: {
                  paymentMethodUsage: this._paymentMethodUsage,
                  intent: "CONTINUE",
                  customerClient: customerClientChannel,
                  isFinalAmount: this._isFinalAmount,
                  displayName: this._displayName,
                  paysheetDetails: {
                    collectCustomerBillingAddress: this._collectCustomerBillingAddress,
                    collectCustomerShippingAddress: this._collectCustomerShippingAddress,
                    transactionDetails: transactionDetailsPresent ? transactionDetails : undefined // eslint-disable-line no-undefined
                  }
                }
              }
            }
          }).then(function (response) {
            return response.data.createVenmoPaymentContext.venmoPaymentContext;
          });
        }
        return promise.then(function (context) {
          var expiredTime = new Date(context.expiresAt) - new Date(context.createdAt);
          var refreshIn = expiredTime * 0.6666;

          // prevents multiple setTimeouts from firing from separate calls
          // to create a payment context by canceling the previous one
          // if there is a pending call
          clearTimeout(self._refreshPaymentContextTimeout);
          self._refreshPaymentContextTimeout = setTimeout(function () {
            if (self._tokenizationInProgress) {
              return;
            }
            self._createVenmoPaymentContext(client, true);
          }, refreshIn);
          if (cancelIfTokenizationInProgress && self._tokenizationInProgress) {
            return;
          }
          self._venmoPaymentContextStatus = context.status;
          self._venmoPaymentContextId = context.id;
        });
      };
      Venmo.prototype.appSwitch = function (url) {
        if (this._deepLinkReturnUrl) {
          if (isIosWebviewInDeepLinkReturnUrlFlow()) {
            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.ios-webview");
            // Deep link URLs do not launch iOS apps from a webview when using window.open or PopupBridge.open.
            window.location.href = url;
          } else if (window.popupBridge && typeof window.popupBridge.open === "function") {
            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.popup-bridge");
            window.popupBridge.open(url);
          } else {
            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.webview");
            window.open(url);
          }
        } else {
          analytics.sendEvent(this._createPromise, "venmo.appswitch.start.browser");
          if (browserDetection.doesNotSupportWindowOpenInIos() || this._shouldUseRedirectStrategy()) {
            window.location.href = url;
          } else {
            window.open(url);
          }
        }
      };
      Venmo.prototype.getUrl = function () {
        return this._createPromise.then(function (client) {
          var configuration = client.getConfiguration();
          var params = {};
          var currentUrl = this._deepLinkReturnUrl || window.location.href.replace(window.location.hash, "");
          var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
          var analyticsMetadata = configuration.analyticsMetadata;
          var accessToken = venmoConfiguration.accessToken;
          var braintreeData = {
            _meta: {
              version: analyticsMetadata.sdkVersion,
              integration: analyticsMetadata.integration,
              platform: analyticsMetadata.platform,
              sessionId: analyticsMetadata.sessionId
            }
          };
          this._isDebug = configuration.isDebug;
          this._assetsUrl = configuration.gatewayConfiguration.assetsUrl;
          currentUrl = currentUrl.replace(/#*$/, "");

          /* eslint-disable camelcase */
          if (this._venmoPaymentContextId) {
            if (this._shouldUseLegacyFlow) {
              // NEXT_MAJOR_VERSION stop adding the context id to the access token.
              // the context id is placed here for backwards compatiblity
              // with versions of the venmo app that did not support
              // pulling the resource id off of the query params
              accessToken += "|pcid:" + this._venmoPaymentContextId;
            } else {
              params.resource_id = this._venmoPaymentContextId;
            }
          }
          if (this._shouldIncludeReturnUrls() || this._useAllowDesktopWebLogin) {
            if (this._useAllowDesktopWebLogin) {
              currentUrl = this._assetsUrl + "/web/" + VERSION + "/html/redirect-frame.html";
            }
            params["x-success"] = currentUrl + "#venmoSuccess=1";
            params["x-cancel"] = currentUrl + "#venmoCancel=1";
            params["x-error"] = currentUrl + "#venmoError=1";
          } else {
            params["x-success"] = "NOOP";
            params["x-cancel"] = "NOOP";
            params["x-error"] = "NOOP";
          }
          if (!this._allowAndroidRecreation) {
            params.allowAndroidRecreation = 0;
          } else {
            params.allowAndroidRecreation = 1;
          }
          params.ua = window.navigator.userAgent;
          params.braintree_merchant_id = this._profileId || venmoConfiguration.merchantId;
          params.braintree_access_token = accessToken;
          params.braintree_environment = venmoConfiguration.environment;
          params.braintree_sdk_data = btoa(JSON.stringify(braintreeData));
          return getVenmoUrl({
            useAllowDesktopWebLogin: this._useAllowDesktopWebLogin,
            mobileWebFallBack: this._mobileWebFallBack
          }) + "?" + querystring.stringify(params);
        }.bind(this));
      };

      /**
       * Returns a boolean indicating whether the current browser supports Venmo as a payment method. Please note that iOS Chrome is not supported when the Venmo button is rendered in an iFrame.
       *
       * If `options.allowNewBrowserTab` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for browsers known to support returning from the Venmo app to the same browser tab. Currently, this is limited to iOS Safari and Android Chrome.
       * If `options.allowWebviews` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for mobile browsers that are not webviews.
       * @public
       * @returns {boolean} True if the current browser is supported, false if not.
       */
      Venmo.prototype.isBrowserSupported = function () {
        return isBrowserSupported.isBrowserSupported({
          allowNewBrowserTab: this._allowNewBrowserTab,
          allowWebviews: this._allowWebviews,
          allowDesktop: this._allowDesktop,
          allowDesktopWebLogin: this._allowDesktopWebLogin
        });
      };

      /**
       * Returns a boolean indicating whether a Venmo tokenization result is ready to be processed immediately.
       *
       * This method should be called after initialization to see if the result of Venmo authorization is available. If it returns true, call {@link Venmo#tokenize|tokenize} immediately to process the results.
       *
       * @public
       * @returns {boolean} True if the results of Venmo payment authorization are available and ready to process.
       */
      Venmo.prototype.hasTokenizationResult = function () {
        return this._hasTokenizationResult();
      };

      // a private version that lets us pass in a custom hash
      // when listening on a hashchange event
      Venmo.prototype._hasTokenizationResult = function (hash) {
        var params = getFragmentParameters(hash);
        var paramsFromUrl = urlParams.getUrlParams();
        if (paramsFromUrl.resource_id) {
          this._venmoPaymentContextId = paramsFromUrl.resource_id;
        }
        return typeof (params.venmoSuccess || params.venmoError || params.venmoCancel) !== "undefined";
      };
      Venmo.prototype._shouldIncludeReturnUrls = function () {
        // when a deep link return url is passed, we should always
        // respect it and include the return urls so the venmo app
        // can app switch back to it
        if (this._deepLinkReturnUrl) {
          return true;
        }

        // when the sdk is initialized within an iframe, it's
        // impossible to return back to the correct place automatically
        // without also setting a deepLinkReturnUrl. When the return
        // urls are omitted, the Venmo app prompts the user to return
        // manually.
        return !this._cannotHaveReturnUrls;
      };
      Venmo.prototype._isDesktop = function () {
        return !(browserDetection.isIos() || browserDetection.isAndroid());
      };

      /**
       * Launches the Venmo flow and returns a nonce payload.
       *
       * If {@link Venmo#hasTokenizationResult|hasTokenizationResult} returns true, calling tokenize will immediately process and return the results without initiating the Venmo payment authorization flow.
       *
       * Only one Venmo flow can be active at a time. One way to achieve this is to disable your Venmo button while the flow is open.
       * @public
       * @param {object} [options] Options for tokenization.
       * @param {number} [options.processResultsDelay=500] The amount of time in milliseconds to delay processing the results. In most cases, this value should be left as the default.
       * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Venmo~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Venmo~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * button.addEventListener('click', function () {
       *   // Disable the button so that we don't attempt to open multiple popups.
       *   button.setAttribute('disabled', 'disabled');
       *
       *   // Because tokenize opens a new window, this must be called
       *   // as a result of a user action, such as a button click.
       *   venmoInstance.tokenize().then(function (payload) {
       *     // Submit payload.nonce to your server
       *     // Use payload.username to get the Venmo username and display any UI
       *   }).catch(function (tokenizeError) {
       *     // Handle flow errors or premature flow closure
       *     switch (tokenizeErr.code) {
       *       case 'VENMO_APP_CANCELED':
       *         console.log('User canceled Venmo flow.');
       *         break;
       *       case 'VENMO_CANCELED':
       *         console.log('User canceled Venmo, or Venmo app is not available.');
       *         break;
       *       default:
       *         console.error('Error!', tokenizeErr);
       *     }
       *   }).then(function () {
       *     button.removeAttribute('disabled');
       *   });
       * });
       */
      Venmo.prototype.tokenize = function (options) {
        var self = this;
        var tokenizationPromise;
        options = options || {};
        if (this._tokenizationInProgress === true) {
          return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_ACTIVE));
        }
        this._tokenizationInProgress = true;
        if (this._useDesktopQRFlow) {
          // for the desktop flow, we create a venmo payment
          // context and then present a qr code modal to the
          // customer and they will open up their venmo app
          // and scan it and approve the purchase on their
          // mobile device. The sdk will start polling
          // in order to determine when the status of the
          // payment context has updated and then pass the
          // resulting nonce back to the merchant.
          tokenizationPromise = this._tokenizeForDesktopQRFlow(options);
        } else if (this._useAllowDesktopWebLogin) {
          /**
           * For Desktop Web Login, we open a browser popup to allow for authorization. Once authorized, the redirect urls are used by Venmo, and we query the API for a payment context status update.
           *
           * - Payment context is created on initialization
           * - Popup is opened to Venmo login url.
           *  - The payment is authorized or canceled, and the popup is closed
           * - Once the popup is closed, we query the API for a payment context status update
           *
           * This is an alternate, opt-in flow to be used the Desktop QR Flow is not desired for Pay with Venmo desktop experiences.
           */
          tokenizationPromise = this._tokenizeWebLoginWithRedirect();
        } else if (this._cannotHaveReturnUrls) {
          // in the manual return strategy, we create the payment
          // context on initialization, then continually poll once
          // the app switch begins until we get a response indiciating
          // the payment context was approved by the customer on the
          // Venmo app. The payment context response also includes a
          // nonce. There are 2 cases where we use the manual return
          // strategy:
          // 1. the sdk is instantiated in an iframe, because
          //    the venmo app is unable to redirect automatically
          //    when that is the case so we rely on the customer
          //    to do a manual redirect and continunally poll for
          //    updates on the payment context to get the nonce
          // 2. same deal for when `requireManualReturn` is configured
          tokenizationPromise = this._tokenizeForMobileWithManualReturn();
        } else {
          // the default mobile flow is to app switch to the
          // venmo app, and then have the venmo app switch
          // back to the page with the venmo nonce details
          // encoded into the hash portion of the url. If
          // `paymentMethodUsage` is provided when instantiating
          // the sdk, we also create a payment context and pass
          // the resource id to the Venmo app during the app switch.
          // Once we get a succesful return, we ping the payment
          // context query to get any additional data needed
          // to send back to the merchant.
          tokenizationPromise = this._tokenizeForMobileWithHashChangeListeners(options);
        }
        return tokenizationPromise.then(function (payload) {
          return self._createPromise.then(function (client) {
            return self._createVenmoPaymentContext(client);
          }).then(function () {
            self._tokenizationInProgress = false;
            return formatTokenizePayload(payload);
          });
        }).catch(function (err) {
          return self._createPromise.then(function (client) {
            // We create a new Payment Context because if the last one failed, then presumably we don't want to use it again.
            // On the first pass, we create the payment context at initialization, and since we used that first one we now need to create a new one
            // for the next time someone tries to tokenize.
            return self._createVenmoPaymentContext(client);
          }).then(function () {
            self._tokenizationInProgress = false;
            return Promise.reject(err);
          });
        });
      };

      /**
       * Cancels the venmo tokenization process
       *
       * @public
       * @function Venmo~cancelTokenization
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * venmoTokenizeButton.addEventListener('click', function () {
       *   venmoInstance.tokenize().then(function (payload) {
       *     // handle payload
       *   }).catch(function (err) {
       *     if (err.code === 'VENMO_TOKENIZATION_CANCELED_BY_MERCHANT') {
       *       // tokenization was canceled by calling cancelTokenization
       *     }
       *   });
       * });
       *
       * venmoCancelButton.addEventListener('click', function () {
       *   // Hide the button when the venmo flow is not in progress
       *   venmoCancelButton.style.display = "none";
       *
       *   venmoInstance.cancelTokenization().then(function () {
       *     // done canceling the flow
       *   }).catch(function (err) {
       *     // should only get here if there is no tokenization in progress
       *   });
       * });
       */
      Venmo.prototype.cancelTokenization = function () {
        if (!this._tokenizationInProgress) {
          return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE));
        }
        this._removeVisibilityEventListener();

        // important to reject the tokenization promise first
        // so the tokenize method rejects with this error
        // rather than a customer canceled error in the mobile
        // polling and desktop flows
        if (this._tokenizePromise) {
          this._tokenizePromise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_CANCELED_BY_MERCHANT));
        }
        return Promise.all([this._cancelMobilePaymentContext(), this._cancelVenmoDesktopContext()]);
      };
      Venmo.prototype._tokenizeWebLoginWithRedirect = function () {
        var self = this;
        analytics.sendEvent(self._createPromise, "venmo.tokenize.web-login.start", {
          paypal_context_id: self._venmoPaymentContextId
        });
        this._tokenizePromise = new ExtendedPromise();
        return this.getUrl().then(function (url) {
          desktopWebLogin.runWebLogin({
            checkForStatusChange: self._checkPaymentContextStatusAndProcessResult.bind(self),
            cancelTokenization: self.cancelTokenization.bind(self),
            frameServiceInstance: self._frameServiceInstance,
            venmoUrl: url,
            debug: self._isDebug,
            checkPaymentContextStatus: self._checkPaymentContextStatus.bind(self)
          }).then(function (payload) {
            analytics.sendEvent(self._createPromise, "venmo.tokenize.web-login.success", {
              paypal_context_id: self._venmoPaymentContextId
            });
            self._tokenizePromise.resolve({
              paymentMethodNonce: payload.paymentMethodId,
              username: payload.userName,
              payerInfo: payload.payerInfo,
              id: self._venmoPaymentContextId
            });
          }).catch(function (err) {
            analytics.sendEvent(self._createPromise, "venmo.tokenize.web-login.failure", {
              paypal_context_id: self._venmoPaymentContextId
            });
            self._tokenizePromise.reject(err);
          });
          return self._tokenizePromise;
        });
      };
      Venmo.prototype._queryPaymentContextStatus = function (id) {
        var self = this;
        return this._createPromise.then(function (client) {
          var query = self._shouldUseLegacyFlow ? graphqlQueries.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY : graphqlQueries.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;
          return client.request({
            api: "graphQLApi",
            data: {
              query: query,
              variables: {
                id: id
              }
            }
          });
        }).then(function (response) {
          return response.data.node;
        });
      };

      /**
       * Queries the GraphQL API to get the payment context and process the status. Retries until there is an update to the payment context status.
       * @name Venmo~checkPaymentContextStatusAndProcessResult
       * @ignore
       * @param {number} retryCount The counter for tracking number of retries made against the API.
       * @returns {Promise} Returns a promise
       */
      Venmo.prototype._checkPaymentContextStatusAndProcessResult = function (retryCount) {
        var self = this;
        return self._checkPaymentContextStatus().then(function (node) {
          var resultStatus = node.status;
          if (resultStatus !== self._venmoPaymentContextStatus) {
            self._venmoPaymentContextStatus = resultStatus;
            analytics.sendEvent(self._createPromise, "venmo.tokenize.web-login.status-change", {
              paypal_context_id: self._venmoPaymentContextId
            });
            switch (resultStatus) {
              case "APPROVED":
                return Promise.resolve(node);
              case "CANCELED":
                return Promise.reject(new BraintreeError(errors.VENMO_CUSTOMER_CANCELED));
              case "FAILED":
                return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_FAILED));
              default:
            }
          }
          return new Promise(function (resolve, reject) {
            if (retryCount < self._maxRetryCount) {
              retryCount++;
              return self._checkPaymentContextStatusAndProcessResult(retryCount).then(resolve).catch(reject);
            }
            return reject(new BraintreeError(errors.VENMO_TOKENIZATION_FAILED));
          });
        });
      };
      Venmo.prototype._checkPaymentContextStatus = function () {
        var self = this;
        return self._queryPaymentContextStatus(self._venmoPaymentContextId).catch(function (networkError) {
          return Promise.reject(new BraintreeError({
            type: errors.VENMO_NETWORK_ERROR.type,
            code: errors.VENMO_NETWORK_ERROR.code,
            message: errors.VENMO_NETWORK_ERROR.message,
            details: networkError
          }));
        }).then(function (node) {
          return Promise.resolve(node);
        });
      };
      Venmo.prototype._pollForStatusChange = function () {
        var self = this;
        if (Date.now() > self._mobilePollingContextExpiresIn) {
          return Promise.reject(new BraintreeError(errors.VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT));
        }
        return this._queryPaymentContextStatus(this._venmoPaymentContextId).catch(function (networkError) {
          return Promise.reject(new BraintreeError({
            type: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.type,
            code: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.code,
            message: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.message,
            details: {
              originalError: networkError
            }
          }));
        }).then(function (node) {
          var newStatus = node.status;
          if (newStatus !== self._venmoPaymentContextStatus) {
            self._venmoPaymentContextStatus = newStatus;
            analytics.sendEvent(self._createPromise, "venmo.tokenize.manual-return.status-change." + newStatus.toLowerCase(), {
              paypal_context_id: self._venmoPaymentContextId
            });
            switch (newStatus) {
              case "EXPIRED":
              case "FAILED":
              case "CANCELED":
                return Promise.reject(new BraintreeError(errors["VENMO_MOBILE_POLLING_TOKENIZATION_" + newStatus]));
              case "APPROVED":
                return Promise.resolve(node);
              case "CREATED":
              case "SCANNED":
              default:
              // any other statuses are irrelevant to the polling
              // and can just be ignored
            }
          }
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              self._pollForStatusChange().then(resolve).catch(reject);
            }, self._mobilePollingInterval);
          });
        });
      };
      Venmo.prototype._tokenizeForMobileWithManualReturn = function () {
        var self = this;
        analytics.sendEvent(this._createPromise, "venmo.tokenize.manual-return.start", {
          paypal_context_id: self._venmoPaymentContextId
        });
        this._mobilePollingContextExpiresIn = Date.now() + this._mobilePollingExpiresThreshold;
        this._tokenizePromise = new ExtendedPromise();
        this._pollForStatusChange().then(function (payload) {
          analytics.sendEvent(self._createPromise, "venmo.tokenize.manual-return.success", {
            paypal_context_id: self._venmoPaymentContextId
          });
          self._tokenizePromise.resolve({
            paymentMethodNonce: payload.paymentMethodId,
            username: payload.userName,
            payerInfo: payload.payerInfo,
            id: self._venmoPaymentContextId
          });
        }).catch(function (err) {
          analytics.sendEvent(self._createPromise, "venmo.tokenize.manual-return.failure", {
            paypal_context_id: self._venmoPaymentContextId
          });
          self._tokenizePromise.reject(err);
        });
        return this.getUrl().then(function (url) {
          self.appSwitch(url);
          return self._tokenizePromise;
        });
      };
      Venmo.prototype._shouldUseRedirectStrategy = function () {
        if (!browserDetection.isIos()) {
          return false;
        }
        if (this._mobileWebFallBack === true) {
          return true;
        }
        return this._useRedirectForIOS;
      };
      Venmo.prototype._tokenizeForMobileWithHashChangeListeners = function (options) {
        var self = this;
        var resultProcessingInProgress, visibilityChangeListenerTimeout;
        if (this.hasTokenizationResult()) {
          return this.processHashChangeFlowResults();
        }
        analytics.sendEvent(this._createPromise, "venmo.tokenize.mobile.start");
        this._tokenizePromise = new ExtendedPromise();
        this._previousHash = window.location.hash;
        function completeFlow(hash) {
          var error;
          self.processHashChangeFlowResults(hash).catch(function (err) {
            error = err;
          }).then(function (res) {
            if (!self._ignoreHistoryChanges && window.location.hash !== self._previousHash) {
              window.location.hash = self._previousHash;
            }
            self._removeVisibilityEventListener();
            if (error) {
              self._tokenizePromise.reject(error);
            } else {
              self._tokenizePromise.resolve(res);
            }
            delete self._tokenizePromise;
          });
        }

        // The Venmo SDK app switches back with the results of the
        // tokenization encoded in the hash
        this._onHashChangeListener = function (e) {
          var hash = e.newURL.split("#")[1];
          if (!self._hasTokenizationResult(hash)) {
            return;
          }
          resultProcessingInProgress = true;
          clearTimeout(visibilityChangeListenerTimeout);
          completeFlow(hash);
        };
        window.addEventListener("hashchange", this._onHashChangeListener, false);

        // Subscribe to document visibility change events to detect when app switch
        // has returned. Acts as a fallback for the hashchange listener and catches
        // the cancel case via manual app switch back
        this._visibilityChangeListener = function () {
          var delay = options.processResultsDelay || constants.DEFAULT_PROCESS_RESULTS_DELAY;
          if (!window.document.hidden) {
            if (!resultProcessingInProgress) {
              visibilityChangeListenerTimeout = setTimeout(completeFlow, delay);
            }
          }
        };
        return this.getUrl().then(function (url) {
          self.appSwitch(url);

          // Add a brief delay to ignore visibility change events that occur right before app switch
          setTimeout(function () {
            window.document.addEventListener(documentVisibilityChangeEventName(), self._visibilityChangeListener);
          }, constants.DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY);
          return self._tokenizePromise;
        });
      };
      Venmo.prototype._tokenizeForDesktopQRFlow = function () {
        var self = this;
        analytics.sendEvent(this._createPromise, "venmo.tokenize.desktop.start");
        this._tokenizePromise = new ExtendedPromise();
        this._createPromise.then(function () {
          return self._venmoDesktopInstance.launchDesktopFlow();
        }).then(function (payload) {
          self._venmoDesktopInstance.hideDesktopFlow();
          analytics.sendEvent(self._createPromise, "venmo.tokenize.desktop.success");
          self._tokenizePromise.resolve(payload);
        }).catch(function (err) {
          analytics.sendEvent(self._createPromise, "venmo.tokenize.desktop.failure");
          if (self._venmoDesktopInstance) {
            self._venmoDesktopInstance.hideDesktopFlow();
          }
          if (err && err.reason === "CUSTOMER_CANCELED") {
            self._tokenizePromise.reject(new BraintreeError(errors.VENMO_DESKTOP_CANCELED));
            return;
          }
          self._tokenizePromise.reject(new BraintreeError({
            type: errors.VENMO_DESKTOP_UNKNOWN_ERROR.type,
            code: errors.VENMO_DESKTOP_UNKNOWN_ERROR.code,
            message: errors.VENMO_DESKTOP_UNKNOWN_ERROR.message,
            details: {
              originalError: err
            }
          }));
        });
        return this._tokenizePromise;
      };
      Venmo.prototype._cancelMobilePaymentContext = function () {
        var self = this;
        return this._createPromise.then(function (client) {
          var query;
          if (self._venmoPaymentContextId) {
            query = self._shouldUseLegacyFlow ? graphqlQueries.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY : graphqlQueries.UPDATE_PAYMENT_CONTEXT_QUERY;
            return client.request({
              api: "graphQLApi",
              data: {
                query: query,
                variables: {
                  input: {
                    id: self._venmoPaymentContextId,
                    status: "CANCELED"
                  }
                }
              }
            });
          }
          return Promise.resolve();
        });
      };
      Venmo.prototype._cancelVenmoDesktopContext = function () {
        var self = this;
        return this._createPromise.then(function () {
          if (self._venmoDesktopInstance) {
            self._venmoDesktopInstance.updateVenmoDesktopPaymentContext("CANCELED");
          }
          return Promise.resolve();
        });
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/venmo.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * venmoInstance.teardown();
       * @example <caption>With callback</caption>
       * venmoInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Venmo.prototype.teardown = function () {
        var self = this;
        this._removeVisibilityEventListener();
        return this._createPromise.then(function () {
          if (self._venmoDesktopInstance) {
            self._venmoDesktopInstance.teardown();
          }
          clearTimeout(self._refreshPaymentContextTimeout);
          self._cancelMobilePaymentContext();
          convertMethodsToError(this, methods(Venmo.prototype));
        }.bind(this));
      };
      Venmo.prototype._removeVisibilityEventListener = function () {
        window.removeEventListener("hashchange", this._onHashChangeListener);
        window.document.removeEventListener(documentVisibilityChangeEventName(), this._visibilityChangeListener);
        delete this._visibilityChangeListener;
        delete this._onHashChangeListener;
      };

      /**
       * The hash parameter in this function is optional. If no hash parameter is passed, the `getFragmentParameters` function will default to the hash present in the website's URL instead.
       *
       * There are two scenarios where this method is called:
       *
       * 1. When called within a browser that is capable of returning to the same tab that started the Venmo flow, we set up a listener to detect hash changes in the url. Part of the return to the merchant's website from the Venmo app includes encoding the details of the purchase in the hash of the url. The callback is invoked and the hash is pulled off from the event payload. The reason we pull the hash off of the event payload instead of pulling it directly from the URL is because sometimes a single page app will use the hash parameter for it's routing system, and it's possible to hit a race condition where the routing code has already removed the Venmo specific attributes from the hash before we are able to pull it off the url. Grabbing the hash from the event handler instead ensures we get the Venmo details, no matter what the url is converted to.
       * 2. The other scenario is for browsers that cannot return to the same tab, and instead the Venmo app must open a new tab. Since there is no hash listener to pull the hash from, we pull the hash details directly from the url using the `getFragmentParameters` method.
       *
       * @ignore
       * @param {string} [hash] Optionally provided browser url hash.
       * @returns {Promise} Returns a promise
       */
      Venmo.prototype.processHashChangeFlowResults = function (hash) {
        var self = this;
        var params = getFragmentParameters(hash);

        // NEXT_MAJOR_VERSION only rely on payment context status call and stop relying on the
        // content of the hash

        return new Promise(function (resolve, reject) {
          if (!self._shouldUseLegacyFlow) {
            self._pollForStatusChange().then(function (payload) {
              analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.payment-context-status-query.success", {
                paypal_context_id: self._venmoPaymentContextId
              });
              return resolve({
                paymentMethodNonce: payload.paymentMethodId,
                username: payload.userName,
                payerInfo: payload.payerInfo,
                id: self._venmoPaymentContextId
              });
            }).catch(function (err) {
              if (err.type === errors.VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED.type) {
                // We want to reject in this case because if it the process was canceled, we don't want to take the happy path
                reject(err);
              }
              analytics.sendEvent(self._createPromise, "venmo.process-results.payment-context-status-query-failed", {
                paypal_context_id: self._venmoPaymentContextId
              });
              // If the polling request fails, but not because of cancelization, we will rely on the params provided from the hash
              resolve(params);
            });
          } else if (params.venmoSuccess) {
            analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.success");
            resolve(params);
          } else if (params.venmoError) {
            analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.error");
            reject(new BraintreeError({
              type: errors.VENMO_APP_FAILED.type,
              code: errors.VENMO_APP_FAILED.code,
              message: errors.VENMO_APP_FAILED.message,
              details: {
                originalError: {
                  message: decodeURIComponent(params.errorMessage),
                  code: params.errorCode
                }
              }
            }));
          } else if (params.venmoCancel) {
            analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.cancel");
            reject(new BraintreeError(errors.VENMO_APP_CANCELED));
          } else {
            // User has either manually switched back to browser, or app is not available for app switch
            analytics.sendEvent(self._createPromise, "venmo.appswitch.cancel-or-unavailable");
            reject(new BraintreeError(errors.VENMO_CANCELED));
          }
          self._clearFragmentParameters();
        });
      };
      Venmo.prototype._clearFragmentParameters = function () {
        if (this._ignoreHistoryChanges) {
          return;
        }
        if (typeof window.history.replaceState === "function" && window.location.hash) {
          history.pushState({}, "", window.location.href.slice(0, window.location.href.indexOf("#")));
        }
      };
      function getFragmentParameters(hash) {
        var keyValuesArray = (hash || window.location.hash.substring(1)).split("&");
        var parsedParams = keyValuesArray.reduce(function (toReturn, keyValue) {
          var parts = keyValue.split("=");
          // some Single Page Apps may pre-pend a / to the first value
          // in the hash, assuming it's a route in their app
          // instead of information from Venmo, this removes all
          // non-alphanumeric characters from the keys in the params
          var decodedKey = decodeURIComponent(parts[0]).replace(/\W/g, "");
          var key = snakeCaseToCamelCase(decodedKey);
          var value = decodeURIComponent(parts[1]);
          toReturn[key] = value;
          return toReturn;
        }, {});
        if (parsedParams.resourceId) {
          parsedParams.id = parsedParams.resourceId;
        }
        return parsedParams;
      }
      function formatUserName(username) {
        username = username || "";

        // NEXT_MAJOR_VERSION the web sdks have a prepended @ sign
        // but the ios and android ones do not. This should be standardized
        return "@" + username.replace("@", "");
      }
      function formatTokenizePayload(payload) {
        var formattedPayload = {
          nonce: payload.paymentMethodNonce,
          type: "VenmoAccount",
          details: {
            username: formatUserName(payload.username),
            paymentContextId: payload.id
          }
        };
        if (payload.payerInfo) {
          formattedPayload.details.payerInfo = payload.payerInfo;
          formattedPayload.details.payerInfo.userName = formatUserName(payload.payerInfo.userName);
        }
        return formattedPayload;
      }

      // From https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      function documentVisibilityChangeEventName() {
        var visibilityChange;
        if (typeof window.document.hidden !== "undefined") {
          // Opera 12.10 and Firefox 18 and later support
          visibilityChange = "visibilitychange";
        } else if (typeof window.document.msHidden !== "undefined") {
          visibilityChange = "msvisibilitychange";
        } else if (typeof window.document.webkitHidden !== "undefined") {
          visibilityChange = "webkitvisibilitychange";
        }
        return visibilityChange;
      }
      function isIosWebviewInDeepLinkReturnUrlFlow() {
        // we know it's a webview because this flow only gets
        // used when checking the deep link flow
        // test the platform here to get around custom useragents
        return window.navigator.platform && /iPhone|iPad|iPod/.test(window.navigator.platform);
      }
      module.exports = wrapPromise.wrapPrototype(Venmo);
    }, {
      "../lib/analytics": 135,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/in-iframe": 166,
      "../lib/is-verified-domain": 170,
      "../lib/methods": 172,
      "../lib/querystring": 174,
      "../lib/snake-case-to-camel-case": 176,
      "../lib/url-params": 177,
      "./external/": 231,
      "./external/queries": 232,
      "./shared/browser-detection": 235,
      "./shared/constants": 236,
      "./shared/errors": 237,
      "./shared/get-venmo-url": 239,
      "./shared/supports-venmo": 240,
      "./shared/web-login-backdrop": 241,
      "@braintree/extended-promise": 31,
      "@braintree/wrap-promise": 40
    }],
    243: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Visa Checkout - Creation Error Codes
       * @description Errors that occur when [creating the Visa Checkout component](./module-braintree-web_venmo.html#.create).
       * @property {MERCHANT} VISA_CHECKOUT_NOT_ENABLED Occurs when Visa Checkout is not enabled in the Braintree control panel.
       */

      /**
       * @name BraintreeError.Visa Checkout - createInitOptions Error Codes
       * @description Errors that occur when using the [`createInitOptions` method](./VisaCheckout.html#createInitOptions).
       * @property {MERCHANT} VISA_CHECKOUT_INIT_OPTIONS_REQUIRED Occurs when no options are provided to method.
       */

      /**
       * @name BraintreeError.Visa Checkout - tokenize Error Codes
       * @description Errors that occur when using the [`tokenize` method](./VisaCheckout.html#tokenize).
       * @property {MERCHANT} VISA_CHECKOUT_PAYMENT_REQUIRED Occurs when no payment data is not provided.
       * @property {NETWORK} VISA_CHECKOUT_TOKENIZATION Occurs when tokenization fails.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        VISA_CHECKOUT_NOT_ENABLED: {
          type: BraintreeError.types.MERCHANT,
          code: "VISA_CHECKOUT_NOT_ENABLED",
          message: "Visa Checkout is not enabled for this merchant."
        },
        VISA_CHECKOUT_INIT_OPTIONS_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "VISA_CHECKOUT_INIT_OPTIONS_REQUIRED",
          message: "initOptions requires an object."
        },
        VISA_CHECKOUT_PAYMENT_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "VISA_CHECKOUT_PAYMENT_REQUIRED",
          message: "tokenize requires callid, encKey, and encPaymentData."
        },
        VISA_CHECKOUT_TOKENIZATION: {
          type: BraintreeError.types.NETWORK,
          code: "VISA_CHECKOUT_TOKENIZATION",
          message: "A network error occurred when processing the Visa Checkout payment."
        }
      };
    }, {
      "../lib/braintree-error": 140
    }],
    244: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @module braintree-web/visa-checkout
       * @description Processes Visa Checkout. *This component is currently in beta and is subject to change.*
       */
      var basicComponentVerification = _dereq_("../lib/basic-component-verification");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var createDeferredClient = _dereq_("../lib/create-deferred-client");
      var createAssetsUrl = _dereq_("../lib/create-assets-url");
      var VisaCheckout = _dereq_("./visa-checkout");
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./errors");
      var VERSION = "3.115.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");

      /**
       * @static
       * @function create
       * @param {object} options Creation options:
       * @param {Client} [options.client] A {@link Client} instance.
       * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
       * @param {callback} [callback] The second argument, `data`, is the {@link VisaCheckout} instance. If no callback is provided, `create` returns a promise that resolves with the {@link VisaCheckout} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      function create(options) {
        var name = "Visa Checkout";
        return basicComponentVerification.verify({
          name: name,
          client: options.client,
          authorization: options.authorization
        }).then(function () {
          return createDeferredClient.create({
            authorization: options.authorization,
            client: options.client,
            debug: options.debug,
            assetsUrl: createAssetsUrl.create(options.authorization),
            name: name
          });
        }).then(function (client) {
          options.client = client;
          if (!options.client.getConfiguration().gatewayConfiguration.visaCheckout) {
            return Promise.reject(new BraintreeError(errors.VISA_CHECKOUT_NOT_ENABLED));
          }
          analytics.sendEvent(options.client, "visacheckout.initialized");
          return new VisaCheckout(options);
        });
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/analytics": 135,
      "../lib/basic-component-verification": 138,
      "../lib/braintree-error": 140,
      "../lib/create-assets-url": 145,
      "../lib/create-deferred-client": 147,
      "./errors": 243,
      "./visa-checkout": 245,
      "@braintree/wrap-promise": 40
    }],
    245: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./errors");
      var jsonClone = _dereq_("../lib/json-clone");
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var cardTypeTransformMap = {
        Visa: "VISA",
        MasterCard: "MASTERCARD",
        Discover: "DISCOVER",
        "American Express": "AMEX"
      };

      /**
       * Visa Checkout Address object.
       * @typedef {object} VisaCheckout~Address
       * @property {string} countryCode The customer's country code.
       * @property {string} extendedAddress The customer's extended address.
       * @property {string} firstName The customer's first name.
       * @property {string} lastName The customer's last name.
       * @property {string} locality The customer's locality.
       * @property {string} postalCode The customer's postal code.
       * @property {string} region The customer's region.
       * @property {string} streetAddress The customer's street address.
       * @property {string} phoneNumber The customer's phone number.
       */

      /**
       * Visa Checkout UserData object.
       * @typedef {object} VisaCheckout~UserData
       * @property {string} userEmail The customer's email address.
       * @property {string} userFirstName The customer's first name.
       * @property {string} userLastName The customer's last name.
       * @property {string} userFullName The customer's full name.
       * @property {string} userName The customer's username.
       */

      /**
       * Visa Checkout tokenize payload.
       * @typedef {object} VisaCheckout~tokenizePayload
       * @property {string} nonce The payment method nonce.
       * @property {object} details Additional account details.
       * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
       * @property {string} details.lastFour Last four digits of card number.
       * @property {string} details.lastTwo Last two digits of card number.
       * @property {string} description A human-readable description.
       * @property {string} type The payment method type, always `VisaCheckoutCard`.
       * @property {VisaCheckout~Address} billingAddress The customer's billing address.
       * @property {VisaCheckout~Address} shippingAddress The customer's shipping address.
       * @property {VisaCheckout~UserData} userData Information about the customer.
       * @property {object} binData Information about the card based on the bin.
       * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.countryOfIssuance The country of issuance.
       * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.issuingBank The issuing bank.
       * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
       * @property {string} binData.productId The product id.
       */

      /**
       * @class
       * @param {object} options The Visa Checkout {@link module:braintree-web/visa-checkout.create create} options.
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/visa-checkout.create|braintree-web.visa-checkout.create} instead.</strong>
       * @classdesc This class represents a Visa Checkout component produced by {@link module:braintree-web/visa-checkout.create|braintree-web/visa-checkout.create}. Instances of this class have methods for interacting with Visa Checkout's JavaScript library.
       */
      function VisaCheckout(options) {
        this._client = options.client;
      }
      function transformCardTypes(cardTypes) {
        return cardTypes.reduce(function (acc, type) {
          if (cardTypeTransformMap.hasOwnProperty(type)) {
            return acc.concat(cardTypeTransformMap[type]);
          }
          return acc;
        }, []);
      }

      /**
       * Creates an `initOptions` object from the passed `options`, applying properties that Braintree needs to transact Visa Checkout.
       *
       * Braintree will apply these properties if they do not exist on the given `options`:
       *  - `apikey`
       *  - `externalClientId`
       *  - `settings.payment.cardBrands`
       *
       * Braintree will overwrite `settings.dataLevel = 'FULL'` to access the full payment method.
       * @public
       * @param {object} options The base `initOptions` that will be used to init Visa Checkout.
       * @param {string} [options.apikey] The API key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
       * @param {string} [options.externalClientId] The external client ID key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
       * @param {object} [options.settings] The settings object used to initialize Visa Checkout.
       * @param {string} [options.settings.dataLevel] The data level used to initialize Visa Checkout. Braintree will overwrite this property to 'FULL'.
       * @param {object} [options.settings.payment] The payment object used to initialize Visa Checkout.
       * @param {string[]} [options.settings.payment.cardBrands] The card brands that Visa Checkout will allow the customer to pay with. When not supplied, Braintree will set this property.
       * @returns {object} `initOptions` The `initOptions` that Visa Checkout should be initialized with.
       */
      VisaCheckout.prototype.createInitOptions = function (options) {
        var initOptions;
        var gatewayConfiguration = this._client.getConfiguration().gatewayConfiguration;
        var visaCheckoutConfiguration = gatewayConfiguration.visaCheckout;
        if (!options) {
          throw new BraintreeError(errors.VISA_CHECKOUT_INIT_OPTIONS_REQUIRED);
        }
        initOptions = jsonClone(options);
        initOptions.apikey = initOptions.apikey || visaCheckoutConfiguration.apikey;
        initOptions.encryptionKey = visaCheckoutConfiguration.encryptionKey;
        initOptions.externalClientId = initOptions.externalClientId || visaCheckoutConfiguration.externalClientId;
        initOptions.settings = initOptions.settings || {};
        initOptions.settings.dataLevel = "FULL";
        initOptions.settings.payment = initOptions.settings.payment || {};
        if (!initOptions.settings.payment.cardBrands) {
          initOptions.settings.payment.cardBrands = transformCardTypes(gatewayConfiguration.visaCheckout.supportedCardTypes);
        }
        return initOptions;
      };

      /**
       * Tokenizes the Visa Checkout payload, returning a payment method nonce.
       * @public
       * @param {object} payment The object that Visa Checkout supplies on `payment.success`.
       * @param {string} payment.callid Visa Checkout transaction ID associated with this payment.
       * @param {string} payment.encKey The encrypted key used to decrypt the payment data.
       * @param {string} payment.encPaymentData The encrypted payment data.
       * @param {callback} [callback] The second argument, <code>tokenizePayload</code> is a {@link VisaCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with the {@link VisaCheckout~tokenizePayload|tokenizePayload}.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      VisaCheckout.prototype.tokenize = function (payment) {
        var self = this;
        if (!payment.callid || !payment.encKey || !payment.encPaymentData) {
          return Promise.reject(new BraintreeError(errors.VISA_CHECKOUT_PAYMENT_REQUIRED));
        }
        return this._client.request({
          method: "post",
          endpoint: "payment_methods/visa_checkout_cards",
          data: {
            _meta: {
              source: "visa-checkout"
            },
            visaCheckoutCard: {
              callId: payment.callid,
              encryptedPaymentData: payment.encPaymentData,
              encryptedKey: payment.encKey
            }
          }
        }).then(function (response) {
          analytics.sendEvent(self._client, "visacheckout.tokenize.succeeded");
          return response.visaCheckoutCards[0];
        }).catch(function (err) {
          analytics.sendEvent(self._client, "visacheckout.tokenize.failed");
          return Promise.reject(new BraintreeError({
            type: errors.VISA_CHECKOUT_TOKENIZATION.type,
            code: errors.VISA_CHECKOUT_TOKENIZATION.code,
            message: errors.VISA_CHECKOUT_TOKENIZATION.message,
            details: {
              originalError: err
            }
          }));
        });
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/visa-checkout.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * visaCheckoutInstance.teardown();
       * @example <caption>With callback</caption>
       * visaCheckoutInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      VisaCheckout.prototype.teardown = function () {
        convertMethodsToError(this, methods(VisaCheckout.prototype));
        return Promise.resolve();
      };
      module.exports = wrapPromise.wrapPrototype(VisaCheckout);
    }, {
      "../lib/analytics": 135,
      "../lib/braintree-error": 140,
      "../lib/convert-methods-to-error": 143,
      "../lib/json-clone": 171,
      "../lib/methods": 172,
      "./errors": 243,
      "@braintree/wrap-promise": 40
    }]
  }, {}, [133])(133);
});